import React from 'react'

export const WhatsappIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 32 32">
    <defs />

    <path
      className="a"
      d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.888 2.722.888.817 0 2.15-.515 2.478-1.318.13-.33.244-.73.244-1.088 0-.058 0-.144-.03-.215-.1-.172-2.434-1.39-2.678-1.39zm-2.908 7.593c-1.747 0-3.48-.53-4.942-1.49L7.793 24.41l1.132-3.337a8.955 8.955 0 0 1-1.72-5.272c0-4.955 4.04-8.995 8.997-8.995S25.2 10.845 25.2 15.8c0 4.958-4.04 8.998-8.998 8.998zm0-19.798c-5.96 0-10.8 4.842-10.8 10.8 0 1.964.53 3.898 1.546 5.574L5 27.176l5.974-1.92a10.807 10.807 0 0 0 16.03-9.455c0-5.958-4.842-10.8-10.802-10.8z"
    />
  </svg>
)
export const UserIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20.218" viewBox="0 0 18 20.218">
    <defs>
      <clipPath id="clip-path">
        <rect
          id="Rectángulo_490"
          data-name="Rectángulo 490"
          width="18"
          height="20.218"
          transform="translate(0 0)"
          fill="none"
        />
      </clipPath>
    </defs>
    <g id="Grupo_509" data-name="Grupo 509" transform="translate(0 -0.001)">
      <g
        id="Grupo_509-2"
        data-name="Grupo 509"
        transform="translate(0 0.001)"
        clipPath="url(#clip-path)"
      >
        <path
          id="Trazado_519"
          data-name="Trazado 519"
          d="M12.652,10.01a5.673,5.673,0,1,0-7.3,0A5.9,5.9,0,0,0,0,15.878V17.32a2.9,2.9,0,0,0,2.9,2.9H15.1a2.9,2.9,0,0,0,2.9-2.9V15.878a5.9,5.9,0,0,0-5.348-5.868"
          transform="translate(0 -0.001)"
        />
        <path
          id="Trazado_520"
          data-name="Trazado 520"
          d="M20.527,50.042v1.442a1.664,1.664,0,0,1-1.664,1.664H6.663A1.664,1.664,0,0,1,5,51.483V50.042a4.66,4.66,0,0,1,4.659-4.659h.579a6.032,6.032,0,0,0,5.054,0h.579a4.66,4.66,0,0,1,4.658,4.659"
          transform="translate(-3.763 -34.165)"
          fill="#fff"
        />
        <path
          id="Trazado_521"
          data-name="Trazado 521"
          d="M18.461,9.437A4.437,4.437,0,1,1,22.9,13.873a4.436,4.436,0,0,1-4.437-4.437"
          transform="translate(-13.898 -3.764)"
          fill="#fff"
        />
      </g>
    </g>
  </svg>
)

export const ItineraryIcon = () => (
  <svg
    aria-hidden="true"
    focusable="false"
    data-prefix="far"
    data-icon="clipboard-list-check"
    className="svg-inline--fa fa-clipboard-list-check "
    role="img"
    style={{ width: '21.5px' }}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 384 512"
  >
    <path
      fill="currentColor"
      d="M320 64H280h-9.6C263 27.5 230.7 0 192 0s-71 27.5-78.4 64H104 64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zM80 112v24c0 13.3 10.7 24 24 24h88 88c13.3 0 24-10.7 24-24V112h16c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16H80zm88-32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm3.3 155.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L112 249.4 99.3 236.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l24 24c6.2 6.2 16.4 6.2 22.6 0l48-48zM192 272c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm-32 96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm-48 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    />
  </svg>
)

export const SoatIcon = () => (
  <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.10147 11.0206C7.36849 11.3605 7.58696 11.7489 7.78115 12.1615C8.14527 11.2876 8.75212 10.5351 9.5289 9.97683L9.16479 9.29715L7.10147 11.0206ZM7.00438 14.8802V14.1035C7.00438 11.9673 5.25663 10.2196 3.1205 10.2196H1.37275C1.03291 10.2196 0.790169 9.97683 0.790169 9.63699C0.790169 9.32143 1.03291 9.05441 1.37275 9.05441H3.1205C4.30994 9.05441 5.42655 9.49135 6.27615 10.1953L8.60648 8.25336L8.19382 7.50086H6.81018C6.47034 7.50086 6.2276 7.25811 6.2276 6.91828C6.2276 6.60271 6.47034 6.33569 6.81018 6.33569H8.31519C8.6793 6.33569 8.99487 6.55416 9.16479 6.84545L9.50463 7.47658L10.6455 6.52989C10.7912 6.40852 10.9611 6.33569 11.131 6.33569H11.665C12.0777 6.33569 12.4418 6.69981 12.4418 7.11247V7.88925C12.4418 8.32618 12.0777 8.66602 11.665 8.66602H10.16L11.4951 11.142C11.7864 11.0692 12.102 10.9963 12.4418 10.9963C14.141 10.9963 15.5489 12.4043 15.5489 14.1035C15.5489 15.8269 14.141 17.2106 12.4418 17.2106C10.7183 17.2106 9.33471 15.8269 9.33471 14.1035C9.33471 13.1325 9.77164 12.2829 10.4756 11.7003L10.0872 11.0206C9.16479 11.7246 8.55793 12.8412 8.55793 14.1035V14.8802H7.00438ZM10.4999 14.1035C10.4999 15.1958 11.3495 16.0454 12.4418 16.0454C13.5099 16.0454 14.3838 15.1958 14.3838 14.1035C14.3838 13.0354 13.5099 12.1615 12.4418 12.1615C12.2962 12.1615 12.1748 12.1858 12.0534 12.2101L12.9516 13.8364C13.0972 14.1277 13.0001 14.4676 12.7088 14.6132C12.4175 14.7831 12.0777 14.6618 11.9078 14.3947L11.0339 12.7684C10.6941 13.1082 10.4999 13.5937 10.4999 14.1035ZM4.96534 13.5209C4.7226 12.7441 3.9701 12.1615 3.1205 12.1615C2.02816 12.1615 1.17856 13.0354 1.17856 14.1035C1.17856 15.1958 2.02816 16.0454 3.1205 16.0454C3.9701 16.0454 4.7226 15.4871 4.96534 14.686H3.63026C3.48461 14.8074 3.31469 14.8802 3.1205 14.8802C2.68356 14.8802 2.34372 14.5404 2.34372 14.1035C2.34372 13.6908 2.68356 13.3267 3.1205 13.3267C3.31469 13.3267 3.48461 13.3995 3.63026 13.5209H4.96534ZM3.1205 10.9963C4.21284 10.9963 5.23236 11.6032 5.79067 12.5499C6.34897 13.5209 6.34897 14.7103 5.79067 15.657C5.23236 16.628 4.21284 17.2106 3.1205 17.2106C2.00388 17.2106 0.984363 16.628 0.426055 15.657C-0.132253 14.7103 -0.132253 13.5209 0.426055 12.5499C0.984363 11.6032 2.00388 10.9963 3.1205 10.9963Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.44628 3.50193C5.6662 2.91547 6.21601 2.54893 6.80247 2.54893H8.74512V5.81187C9.15172 5.93343 9.47792 6.21845 9.67123 6.54984L9.67628 6.55849L9.68102 6.5673L10.2699 6.07925L10.2706 6.07873C10.3415 6.01966 10.4199 5.96498 10.5045 5.91783V2.54893H13.4735C13.9133 2.54893 14.3165 2.76886 14.6097 3.09874L17.4687 6.65416H12.9451C12.9987 6.79822 13.0281 6.95271 13.0281 7.11236V7.88914C13.0281 8.0766 12.9906 8.25335 12.9233 8.41354H19.3014C20.9142 8.41354 22.2337 9.73308 22.2337 11.3458V12.5188H21.4273C20.9508 11.1626 19.6313 10.1729 18.1285 10.1729C16.927 10.1729 15.8594 10.7758 15.2221 11.6852C15.7895 12.3355 16.1352 13.1829 16.1352 14.1033C16.1352 14.8448 15.9164 15.5331 15.5414 16.1096C16.1858 16.791 17.1078 17.2104 18.1285 17.2104C19.8512 17.2104 21.3174 15.9642 21.5739 14.2781H22.8202C23.4433 14.2781 23.9931 13.765 23.9931 13.1052V11.3458C23.9931 8.92669 22.1238 6.91073 19.7413 6.69081L16.0026 1.99913C15.3795 1.26605 14.4631 0.789551 13.4735 0.789551H6.80247C5.48293 0.789551 4.31001 1.59593 3.79686 2.84216L2.22074 6.76412C1.29075 7.00523 0.619696 7.82896 0.542172 8.80948C0.748901 8.6004 1.03766 8.46784 1.37262 8.46784H2.64132C2.71395 8.43336 2.79475 8.41354 2.88051 8.41354H7.49792L7.85995 8.11185L7.84644 8.08721H6.81006C6.14633 8.08721 5.64101 7.5819 5.64101 6.91817C5.64101 6.82807 5.65124 6.7396 5.67078 6.65416H4.16339L5.44628 3.50193ZM16.7723 14.8646C16.3325 14.3881 16.2225 13.7283 16.4424 13.1052C16.6623 12.5188 17.1755 12.0789 17.7986 11.969C18.4217 11.8223 19.0448 12.0789 19.448 12.5554C19.8512 13.0319 19.9978 13.6917 19.7779 14.2781C19.558 14.9013 19.0448 15.3411 18.4217 15.4511C17.7986 15.5977 17.1755 15.3411 16.7723 14.8646Z"
      fill="currentColor"
    />
    <path
      d="M0.534668 11.4695C0.808499 11.2023 1.12159 10.9782 1.46254 10.8059H1.37262C1.03835 10.8059 0.744265 10.6778 0.534668 10.4657V11.4695Z"
      fill="currentColor"
    />
    <path
      d="M5.33151 17.051C5.66856 17.1548 6.02736 17.2104 6.39927 17.2104C7.52342 17.2104 8.53832 16.6798 9.17916 15.8425C9.1146 15.7212 9.05661 15.5957 9.00567 15.4666H6.53576C6.46914 15.6328 6.38967 15.7951 6.29732 15.952C6.04595 16.3883 5.71566 16.759 5.33151 17.051Z"
      fill="currentColor"
    />
  </svg>
)

export const LegalUserIcon = ({ size }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    style={{ fontSize: size }}
    width="33.25"
    height="38"
    viewBox="0 0 33.25 38"
  >
    <path
      id="johndoe_mail.com"
      data-name="johndoe@mail.com"
      d="M16.625-14.25a9.5,9.5,0,0,0,9.5-9.5,9.5,9.5,0,0,0-9.5-9.5,9.5,9.5,0,0,0-9.5,9.5A9.5,9.5,0,0,0,16.625-14.25Zm0-16.625A7.136,7.136,0,0,1,23.75-23.75a7.136,7.136,0,0,1-7.125,7.125A7.136,7.136,0,0,1,9.5-23.75,7.136,7.136,0,0,1,16.625-30.875Zm6.821,20.2L20.5-.445,17.983-7.993l1.855-1.855A1.187,1.187,0,0,0,19-11.875H14.25a1.185,1.185,0,0,0-.839,2.026l1.855,1.855L12.751-.445,9.8-10.665A9.957,9.957,0,0,0,0-.712v1.9A3.563,3.563,0,0,0,3.562,4.75H29.687A3.563,3.563,0,0,0,33.25,1.187v-1.9A9.968,9.968,0,0,0,23.446-10.673ZM3.562,2.375A1.191,1.191,0,0,1,2.375,1.187v-1.9a7.627,7.627,0,0,1,5.707-7.34L11.1,2.375Zm10.754,0,2.308-6.932,2.308,6.932ZM30.875,1.187a1.191,1.191,0,0,1-1.187,1.187H22.154L25.16-8.053a7.627,7.627,0,0,1,5.707,7.34v1.9Z"
      transform="translate(0 33.25)"
      fill="#7a7a7a"
    />
  </svg>
)
export const NaturalUserIcon = ({ size }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    style={{ fontSize: size }}
    width="33.25"
    height="38"
    viewBox="0 0 33.25 38"
  >
    <path
      id="johndoe_mail.com"
      data-name="johndoe@mail.com"
      d="M23.275-11.875c-2.13,0-3.154,1.187-6.65,1.187s-4.512-1.187-6.65-1.187A9.978,9.978,0,0,0,0-1.9V1.187A3.563,3.563,0,0,0,3.562,4.75H29.687A3.563,3.563,0,0,0,33.25,1.187V-1.9A9.978,9.978,0,0,0,23.275-11.875Zm7.6,13.062a1.191,1.191,0,0,1-1.187,1.187H3.562A1.191,1.191,0,0,1,2.375,1.187V-1.9a7.605,7.605,0,0,1,7.6-7.6c1.455,0,2.9,1.187,6.65,1.187S21.82-9.5,23.275-9.5a7.605,7.605,0,0,1,7.6,7.6ZM16.625-14.25a9.5,9.5,0,0,0,9.5-9.5,9.5,9.5,0,0,0-9.5-9.5,9.5,9.5,0,0,0-9.5,9.5A9.5,9.5,0,0,0,16.625-14.25Zm0-16.625A7.136,7.136,0,0,1,23.75-23.75a7.136,7.136,0,0,1-7.125,7.125A7.136,7.136,0,0,1,9.5-23.75,7.136,7.136,0,0,1,16.625-30.875Z"
      transform="translate(0 33.25)"
      fill="#7a7a7a"
    />
  </svg>
)
export const LockIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20.246" viewBox="0 0 18 20.246">
    <g id="Grupo_535" data-name="Grupo 535" transform="translate(-558.877 -274)">
      <path
        id="Trazado_5679"
        data-name="Trazado 5679"
        d="M304.264,7.861V6.473a1.387,1.387,0,1,0-2.775,0V7.861ZM296.7,20.246a2.827,2.827,0,0,1-2.824-2.823V10.684A2.828,2.828,0,0,1,296.4,7.876v-1.4a6.473,6.473,0,0,1,12.947,0v1.4a2.827,2.827,0,0,1,2.527,2.808v6.738a2.827,2.827,0,0,1-2.823,2.823Z"
        transform="translate(265 274)"
      />
      <path
        id="Trazado_5680"
        data-name="Trazado 5680"
        d="M314.6,14.545v6.738a1.685,1.685,0,0,1-1.684,1.684H300.562a1.685,1.685,0,0,1-1.684-1.684V14.545a1.685,1.685,0,0,1,1.684-1.684h.842V10.334a5.334,5.334,0,1,1,10.668,0v2.527h.842a1.685,1.685,0,0,1,1.684,1.684m-5.334-4.211a2.527,2.527,0,1,0-5.053,0v2.527h5.053Z"
        transform="translate(261.138 270.139)"
        fill="#fff"
      />
    </g>
  </svg>
)
export const EyeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22.183"
    height="13.157"
    viewBox="0 0 22.183 13.157"
  >
    <defs />
    <g transform="translate(-0.592 -5.846)">
      <g transform="translate(0.592 5.846)">
        <path
          className="a"
          d="M11.262,19C9.885,19,5.372,18.52.709,12.835a.516.516,0,0,1-.022-.626c.186-.26,4.606-6.363,11.238-6.363,6.649,0,10.6,6.125,10.77,6.386a.515.515,0,0,1-.008.563c-.169.253-4.231,6.188-11,6.188A3.256,3.256,0,0,1,11.262,19ZM1.767,12.495c5.032,5.921,9.807,5.467,9.857,5.461,5.476,0,9.126-4.307,10-5.456-.851-1.18-4.408-5.623-9.7-5.623S2.749,11.272,1.767,12.495Z"
          transform="translate(-0.592 -5.846)"
        />
      </g>
      <g transform="translate(7.597 8.338)">
        <path
          className="a"
          d="M12.831,16.916a4.085,4.085,0,1,1,4.085-4.086A4.09,4.09,0,0,1,12.831,16.916Zm0-7.14a3.055,3.055,0,1,0,3.055,3.055A3.058,3.058,0,0,0,12.831,9.776Z"
          transform="translate(-8.745 -8.746)"
        />
      </g>
      <g transform="translate(9.852 10.592)">
        <path
          className="a"
          d="M13.2,15.031A1.831,1.831,0,1,1,15.03,13.2,1.833,1.833,0,0,1,13.2,15.031Zm0-2.631a.8.8,0,1,0,.8.8A.8.8,0,0,0,13.2,12.4Z"
          transform="translate(-11.369 -11.37)"
        />
      </g>
    </g>
  </svg>
)
export const EyeIconHidden = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="12.621" viewBox="0 0 18 12.621">
    <g id="Grupo_549" data-name="Grupo 549" transform="translate(0 0.001)">
      <path
        id="Trazado_5677"
        data-name="Trazado 5677"
        d="M590.915,17.326a9.809,9.809,0,0,0-17.6,0,1.84,1.84,0,0,0,0,1.663,9.809,9.809,0,0,0,17.6,0,1.842,1.842,0,0,0,0-1.663"
        transform="translate(-573.114 -11.85)"
      />
      <path
        id="Trazado_5678"
        data-name="Trazado 5678"
        d="M594.253,22.231a.9.9,0,0,1-.1.408,8.878,8.878,0,0,1-15.945,0,.911.911,0,0,1,0-.818,8.878,8.878,0,0,1,15.945,0,.908.908,0,0,1,.1.41m-8.067,4.034a4.035,4.035,0,0,0,4.033-4.033v0a4.035,4.035,0,1,0-4.035,4.035h0m2.7-4.017a2.721,2.721,0,1,1-2.721-2.721,2.721,2.721,0,0,1,2.721,2.721"
        transform="translate(-577.183 -15.92)"
        fill="#fff"
      />
    </g>
  </svg>
)
export const EyeIconShow = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16.379" viewBox="0 0 20 16.379">
    <g id="Grupo_536" data-name="Grupo 536" transform="translate(-1121.682 -275.206)">
      <path
        id="Trazado_5681"
        data-name="Trazado 5681"
        d="M876.139,14.363l-2.251-1.74a10.282,10.282,0,0,0,1.689-2.388,1.867,1.867,0,0,0,0-1.685,10,10,0,0,0-8.893-5.534,9.692,9.692,0,0,0-4.059.9L859.5,1.5a1.407,1.407,0,0,0-.858-.294,1.391,1.391,0,0,0-1.106.541l-.555.715a1.4,1.4,0,0,0,.248,1.966L859.9,6.493a.927.927,0,0,0-.966.327,10.357,10.357,0,0,0-1.143,1.735,1.866,1.866,0,0,0,0,1.685,10,10,0,0,0,8.892,5.534,9.654,9.654,0,0,0,2.44-.326.947.947,0,0,0,.6-1.363l4.147,3.205a1.408,1.408,0,0,0,.858.294,1.392,1.392,0,0,0,1.106-.541l.555-.715a1.4,1.4,0,0,0-.248-1.966"
        transform="translate(265 274)"
      />
      <path
        id="Trazado_5682"
        data-name="Trazado 5682"
        d="M874.61,40.014a4.059,4.059,0,0,1-4.043-3.766L867.6,33.955a9.44,9.44,0,0,0-1.039,1.573.91.91,0,0,0-.1.412.919.919,0,0,0,.1.414,9.074,9.074,0,0,0,8.049,5.019,8.784,8.784,0,0,0,2.2-.3l-1.468-1.136a4.057,4.057,0,0,1-.736.074"
        transform="translate(257.072 247.455)"
        fill="#fff"
      />
      <path
        id="Trazado_5683"
        data-name="Trazado 5683"
        d="M879.613,19.166l-3.127-2.417a9.337,9.337,0,0,0,2.3-2.888.92.92,0,0,0,0-.826,9.074,9.074,0,0,0-8.049-5.019,8.713,8.713,0,0,0-4.168,1.067l-3.6-2.782a.453.453,0,0,0-.635.08l-.555.715a.453.453,0,0,0,.08.635L878.5,20.6a.453.453,0,0,0,.635-.08l.556-.715a.453.453,0,0,0-.08-.635m-4.8-5.717a3.977,3.977,0,0,1-.393,1.7h0l-1.076-.832a2.738,2.738,0,0,0,.138-.854,2.765,2.765,0,0,0-4.259-2.33l-1.062-.821a4.018,4.018,0,0,1,2.579-.937h0a4.074,4.074,0,0,1,4.072,4.072Z"
        transform="translate(260.947 269.947)"
        fill="#fff"
      />
    </g>
  </svg>
)

export const EditIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16.195"
    height="16.241"
    viewBox="0 0 16.195 16.241"
  >
    <defs />
    <path
      className="a"
      d="M17.58,2.829l-.8-.8a1.294,1.294,0,0,0-1.826-.005L2.873,14.029a1.652,1.652,0,0,0-.254.375s-.054.158-.063.2l-.711,2.259a.844.844,0,0,0,.064.837.58.58,0,0,0,.452.185,1.21,1.21,0,0,0,.345-.056c.632-.189,2.379-.921,2.512-.982a1.088,1.088,0,0,0,.272-.189L17.575,4.654A1.291,1.291,0,0,0,17.58,2.829ZM5.006,16.173a.671.671,0,0,1-.113.073c-.017.008-1.788.748-2.385.927l-.045.013A.7.7,0,0,1,2.49,17.1l.727-2.308c.009-.036.034-.111.034-.12a1.213,1.213,0,0,1,.107-.155l10.1-10.035L15.11,6.133ZM17.09,4.166,15.6,5.649,13.945,4l1.5-1.488a.6.6,0,0,1,.854,0l.8.8A.6.6,0,0,1,17.09,4.166Z"
      transform="translate(-1.76 -1.647)"
    />
  </svg>
)

export const DeleteIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13.358"
    height="15.215"
    viewBox="0 0 13.358 15.215"
  >
    <defs />

    <g transform="translate(-2.658 -1.15)">
      <path
        className="a"
        d="M15.646,2.96H12.012V1.52a.37.37,0,0,0-.37-.37H7.061a.37.37,0,0,0-.37.37V2.96H3.028a.369.369,0,1,0,0,.739H4.073V16a.369.369,0,0,0,.37.369h9.8a.369.369,0,0,0,.37-.369V3.7h1.036a.369.369,0,1,0,0-.739ZM7.43,1.889h3.843V2.96H7.43Zm6.442,13.738H4.812V3.7h9.06Z"
        transform="translate(0 0)"
      />
      <path
        className="a"
        d="M9.34,8.728a.4.4,0,0,0-.4.4v7.419a.4.4,0,1,0,.8,0V9.129A.4.4,0,0,0,9.34,8.728Z"
        transform="translate(-2.431 -3.3)"
      />
      <path
        className="a"
        d="M13.3,8.728a.4.4,0,0,0-.4.4v7.419a.4.4,0,1,0,.8,0V9.129A.4.4,0,0,0,13.3,8.728Z"
        transform="translate(-3.964 -3.3)"
      />
      <path
        className="a"
        d="M16.643,9.129v7.419a.4.4,0,1,0,.8,0V9.129a.4.4,0,1,0-.8,0Z"
        transform="translate(-5.412 -3.3)"
      />
    </g>
  </svg>
)

export const UploadIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="30"
    // style={{ fill: '#000000' }}
    className="MuiSvgIcon-root"
    viewBox="0 0 27 25.35"
  >
    <defs />
    <g transform="translate(-0.835 -1.609)">
      <path
        className="a"
        d="M18.724,16.7a.638.638,0,0,0-.045-.9l-4.445-4.026c-.013-.011-.03-.01-.043-.02a.624.624,0,0,0-.244-.117.511.511,0,0,0-.067-.016.627.627,0,0,0-.316.041c-.006,0-.013,0-.019,0s-.021.023-.036.031a.6.6,0,0,0-.136.082L8.98,15.8a.639.639,0,1,0,.863.942L13.166,13.7V25.66a.639.639,0,0,0,1.278,0V13.69l3.377,3.057A.636.636,0,0,0,18.724,16.7Z"
        transform="translate(0.524 0.66)"
      />
      <path
        className="a"
        d="M23.848,10.008a6.4,6.4,0,0,0,.28-1.878A6.5,6.5,0,0,0,12.28,4.413a5.377,5.377,0,0,0-2.07-.419A5.578,5.578,0,0,0,4.638,9.565c0,.157.006.314.021.472a5.431,5.431,0,0,0,1.61,10.619c.133,0,.4,0,.612-.009l.264,0H10.2a.639.639,0,1,0,0-1.278l-3.057,0-.877.013a4.152,4.152,0,0,1-.777-8.231A.639.639,0,0,0,6,10.4,4.278,4.278,0,0,1,10.21,5.273a4.221,4.221,0,0,1,2.006.523.644.644,0,0,0,.858-.247A5.223,5.223,0,0,1,22.849,8.13a5.184,5.184,0,0,1-.446,2.1.636.636,0,0,0,.03.573.645.645,0,0,0,.478.319,4.143,4.143,0,0,1-.548,8.256l-3.4,0a.639.639,0,1,0,0,1.278l3.442,0a5.421,5.421,0,0,0,1.445-10.649Z"
        transform="translate(0 0)"
      />
    </g>
  </svg>
)

export const ImportUploadIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    style={{ color: '#7A7A7A', width: '65', height: '65' }}
    className="MuiSvgIcon-root"
    viewBox="0 0 27 25.35"
  >
    <defs />
    <g transform="translate(-0.835 -1.609)">
      <path
        className="a"
        d="M18.724,16.7a.638.638,0,0,0-.045-.9l-4.445-4.026c-.013-.011-.03-.01-.043-.02a.624.624,0,0,0-.244-.117.511.511,0,0,0-.067-.016.627.627,0,0,0-.316.041c-.006,0-.013,0-.019,0s-.021.023-.036.031a.6.6,0,0,0-.136.082L8.98,15.8a.639.639,0,1,0,.863.942L13.166,13.7V25.66a.639.639,0,0,0,1.278,0V13.69l3.377,3.057A.636.636,0,0,0,18.724,16.7Z"
        transform="translate(0.524 0.66)"
      />
      <path
        className="a"
        d="M23.848,10.008a6.4,6.4,0,0,0,.28-1.878A6.5,6.5,0,0,0,12.28,4.413a5.377,5.377,0,0,0-2.07-.419A5.578,5.578,0,0,0,4.638,9.565c0,.157.006.314.021.472a5.431,5.431,0,0,0,1.61,10.619c.133,0,.4,0,.612-.009l.264,0H10.2a.639.639,0,1,0,0-1.278l-3.057,0-.877.013a4.152,4.152,0,0,1-.777-8.231A.639.639,0,0,0,6,10.4,4.278,4.278,0,0,1,10.21,5.273a4.221,4.221,0,0,1,2.006.523.644.644,0,0,0,.858-.247A5.223,5.223,0,0,1,22.849,8.13a5.184,5.184,0,0,1-.446,2.1.636.636,0,0,0,.03.573.645.645,0,0,0,.478.319,4.143,4.143,0,0,1-.548,8.256l-3.4,0a.639.639,0,1,0,0,1.278l3.442,0a5.421,5.421,0,0,0,1.445-10.649Z"
        transform="translate(0 0)"
      />
    </g>
  </svg>
)

export const SuccessfulIcon = () => (
  <svg
    width="40"
    height="40"
    style={{ marginTop: '2vh' }}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 27 27"
  >
    <path d="M11.54,17.58a.61.61,0,0,1-.42-.17l-3.4-3.33a.6.6,0,0,1,.84-.86l3,2.92,7.2-7a.6.6,0,1,1,.83.87L12,17.41A.58.58,0,0,1,11.54,17.58Z" />
    <path d="M13.5,26A12.65,12.65,0,1,1,26.15,13.37,12.66,12.66,0,0,1,13.5,26Zm0-24.1A11.45,11.45,0,1,0,25,13.37,11.46,11.46,0,0,0,13.5,1.92Z" />
  </svg>
)

export const DownloadIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="27"
    height="25.35"
    className="MuiSvgIcon-root"
    viewBox="0 0 27 25.35"
    {...props}
  >
    <defs />
    <g transform="translate(-0.835 -1.609)">
      <path
        className="a"
        d="M18.724,16.7a.638.638,0,0,0-.045-.9l-4.445-4.026c-.013-.011-.03-.01-.043-.02a.624.624,0,0,0-.244-.117.511.511,0,0,0-.067-.016.627.627,0,0,0-.316.041c-.006,0-.013,0-.019,0s-.021.023-.036.031a.6.6,0,0,0-.136.082L8.98,15.8a.639.639,0,1,0,.863.942L13.166,13.7V25.66a.639.639,0,0,0,1.278,0V13.69l3.377,3.057A.636.636,0,0,0,18.724,16.7Z"
        transform="translate(0.524 0.66)"
        style={{ transform: 'rotate(180deg)', transformOrigin: '52% 78%' }}
      />
      <path
        className="a"
        d="M23.848,10.008a6.4,6.4,0,0,0,.28-1.878A6.5,6.5,0,0,0,12.28,4.413a5.377,5.377,0,0,0-2.07-.419A5.578,5.578,0,0,0,4.638,9.565c0,.157.006.314.021.472a5.431,5.431,0,0,0,1.61,10.619c.133,0,.4,0,.612-.009l.264,0H10.2a.639.639,0,1,0,0-1.278l-3.057,0-.877.013a4.152,4.152,0,0,1-.777-8.231A.639.639,0,0,0,6,10.4,4.278,4.278,0,0,1,10.21,5.273a4.221,4.221,0,0,1,2.006.523.644.644,0,0,0,.858-.247A5.223,5.223,0,0,1,22.849,8.13a5.184,5.184,0,0,1-.446,2.1.636.636,0,0,0,.03.573.645.645,0,0,0,.478.319,4.143,4.143,0,0,1-.548,8.256l-3.4,0a.639.639,0,1,0,0,1.278l3.442,0a5.421,5.421,0,0,0,1.445-10.649Z"
        transform="translate(0 0)"
      />
    </g>
  </svg>
)

export const CloudDownloadIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="14" viewBox="0 0 20 14" fill="none">
    <path
      d="M11.0625 2.8125C10.375 2.03125 9.375 1.5 8.25 1.5C6.15625 1.5 4.5 3.1875 4.5 5.25V5.28125C4.5 5.90625 4.09375 6.46875 3.5 6.6875C2.3125 7.09375 1.5 8.21875 1.5 9.5C1.5 11.1562 2.84375 12.5 4.5 12.5H15.75H15.8438C15.8438 12.5 15.875 12.5 15.9062 12.5C17.3438 12.4375 18.5 11.2188 18.5 9.75C18.5 8.625 17.8125 7.65625 16.8438 7.25C16.2188 6.96875 15.8438 6.3125 15.9688 5.625C15.9688 5.5 16 5.375 16 5.25C16 4.03125 14.9688 3 13.75 3C13.4062 3 13.0938 3.09375 12.8125 3.21875C12.2188 3.46875 11.5 3.3125 11.0625 2.8125ZM16 14H15.75H14.5H4.5C2 14 0 12 0 9.5C0 7.5625 1.25 5.875 3 5.28125V5.25C3 2.375 5.34375 0 8.25 0C9.8125 0 11.25 0.71875 12.2188 1.84375C12.6875 1.625 13.1875 1.5 13.75 1.5C15.8125 1.5 17.5 3.1875 17.5 5.25C17.5 5.46875 17.4688 5.65625 17.4375 5.875C18.9375 6.53125 20 8.03125 20 9.75C20 12.0312 18.2188 13.875 16 14ZM6.96875 8.78125C6.65625 8.5 6.65625 8.03125 6.96875 7.75C7.25 7.4375 7.71875 7.4375 8.03125 7.75L9.25 8.96875V4.75C9.25 4.34375 9.5625 4 10 4C10.4062 4 10.75 4.34375 10.75 4.75V8.96875L11.9688 7.75C12.25 7.4375 12.7188 7.4375 13 7.75C13.3125 8.03125 13.3125 8.5 13 8.78125L10.5 11.2812C10.2188 11.5938 9.75 11.5938 9.46875 11.2812L6.96875 8.78125Z"
      fill="#F4F7FC"
    />
  </svg>
)

export const CalendarIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22.649"
    height="25.136"
    viewBox="0 0 22.649 25.136"
    style={{ fill: '#acacac' }}
  >
    <defs />
    <path
      className="a"
      d="M24.7,9.638V6.649h0v-1.1a2.6,2.6,0,0,0-2.6-2.6H18.646V1.532a.6.6,0,1,0-1.2,0V2.953H9.32V1.532a.6.6,0,1,0-1.2,0V2.953H4.659a2.6,2.6,0,0,0-2.6,2.6V23.468a2.6,2.6,0,0,0,2.6,2.6H22.108a2.6,2.6,0,0,0,2.6-2.6V9.638Zm-1.2,13.83a1.4,1.4,0,0,1-1.4,1.4H4.659a1.4,1.4,0,0,1-1.4-1.4V9.074h20.25Zm0-15.593H3.258V5.552a1.4,1.4,0,0,1,1.4-1.4H8.121V5.211a.6.6,0,0,0,1.2,0V4.152h8.127V5.211a.6.6,0,0,0,1.2,0V4.152h3.462a1.4,1.4,0,0,1,1.4,1.4Z"
      transform="translate(-2.059 -0.932)"
    />
  </svg>
)
export const MoneyIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="28" viewBox="0 0 32 28">
    <path
      id="Trazado_11200"
      data-name="Trazado 11200"
      d="M21-26a19.472,19.472,0,0,0-7.781,1.463C13.162-24.513,10-23.225,10-21v1.044C4.756-19.737,0-17.787,0-15V-3C0-.237,4.925,2,11,2S22-.237,22-3V-4.025C27.606-4.256,32-6.394,32-9V-21C32-23.312,28.119-26,21-26ZM20-3c0,.869-3.156,3-9,3S2-2.131,2-3V-6.131A17.345,17.345,0,0,0,11-4a17.345,17.345,0,0,0,9-2.131Zm0-6c0,.869-3.156,3-9,3S2-8.131,2-9v-3.131A17.345,17.345,0,0,0,11-10a17.345,17.345,0,0,0,9-2.131Zm-9-3c-5.062,0-9.169-1.344-9.169-3S5.938-18,11-18s9.169,1.344,9.169,3S16.063-12,11-12ZM30-9c0,.819-2.812,2.725-8,2.956V-10.05a16.648,16.648,0,0,0,8-2.081Zm0-6c0,.819-2.819,2.713-8,2.95V-15a2.48,2.48,0,0,0-.256-1.019A16.761,16.761,0,0,0,30-18.131Zm-9-3c-.456,0-.875-.031-1.306-.056a16.937,16.937,0,0,0-7.225-1.875A1.466,1.466,0,0,1,11.838-21c0-1.656,4.106-3,9.169-3s9.169,1.344,9.169,3S26.063-18,21-18Z"
      transform="translate(0 26)"
      fill="#3ad399"
    />
  </svg>
)

export const SearchIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    style={{ fill: '#7A7A7A' }}
    width="20"
    height="20.109"
    viewBox="0 0 20 20.109"
  >
    <defs />
    <path
      className="a"
      d="M23.412,54.235l-3.727-3.624a9.173,9.173,0,1,0-.866.846L22.568,55.1a.605.605,0,0,0,.844-.867ZM4.807,44.412a8.037,8.037,0,1,1,8.037,8.037A8.047,8.047,0,0,1,4.807,44.412Z"
      transform="translate(-3.596 -35.165)"
    />
  </svg>
)

export const PencilIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16.195"
    height="16.241"
    viewBox="0 0 16.195 16.241"
  >
    <defs />
    <path
      className="a"
      d="M17.58,2.829l-.8-.8a1.294,1.294,0,0,0-1.826-.005L2.873,14.029a1.652,1.652,0,0,0-.254.375s-.054.158-.063.2l-.711,2.259a.844.844,0,0,0,.064.837.58.58,0,0,0,.452.185,1.21,1.21,0,0,0,.345-.056c.632-.189,2.379-.921,2.512-.982a1.088,1.088,0,0,0,.272-.189L17.575,4.654A1.291,1.291,0,0,0,17.58,2.829ZM5.006,16.173a.671.671,0,0,1-.113.073c-.017.008-1.788.748-2.385.927l-.045.013A.7.7,0,0,1,2.49,17.1l.727-2.308c.009-.036.034-.111.034-.12a1.213,1.213,0,0,1,.107-.155l10.1-10.035L15.11,6.133ZM17.09,4.166,15.6,5.649,13.945,4l1.5-1.488a.6.6,0,0,1,.854,0l.8.8A.6.6,0,0,1,17.09,4.166Z"
      transform="translate(-1.76 -1.647)"
    />
  </svg>
)

export const DefaultImage = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    style={{ fill: '#acacac' }}
    width="44"
    height="44"
    viewBox="0 0 44 44"
  >
    <defs />
    <g transform="translate(0.431)">
      <circle style={{ fill: '#e8e8e8' }} cx="22" cy="22" r="22" transform="translate(-0.431)" />
      <g transform="translate(14.956 16.618)">
        <path
          d="M16.325,6.631a1.458,1.458,0,1,0,1.458,1.457A1.459,1.459,0,0,0,16.325,6.631Zm0,2.251a.794.794,0,1,1,.794-.794A.794.794,0,0,1,16.325,8.882Z"
          transform="translate(-7.06 -5.314)"
        />
        <path
          d="M13.622,4.253H2.023A1.252,1.252,0,0,0,.772,5.5v7.742A1.253,1.253,0,0,0,2.023,14.5h11.6a1.253,1.253,0,0,0,1.252-1.252V5.5A1.253,1.253,0,0,0,13.622,4.253Zm.588,8.993a.588.588,0,0,1-.588.588H2.023a.588.588,0,0,1-.587-.588V11.59L5.521,8.146l3.688,3.53a.332.332,0,0,0,.42.033L11.948,10.1l2.261,1.675Zm0-2.3L12.152,9.42a.331.331,0,0,0-.388-.006L9.473,11.007,5.765,7.459a.334.334,0,0,0-.444-.014L1.436,10.72V5.5a.588.588,0,0,1,.587-.587h11.6a.588.588,0,0,1,.588.587Z"
          transform="translate(-0.772 -4.253)"
        />
      </g>
    </g>
  </svg>
)

export const ExitIcon = () => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="38"
    viewBox="0 0 27 27"
  >
    <path d="M20.09,19.85a.6.6,0,0,0-.6.6v1.18H11.61V5.53h7.88V6.7a.6.6,0,0,0,1.2,0V4.93a.6.6,0,0,0-.6-.6H11.61V1.75a.61.61,0,0,0-.28-.51.6.6,0,0,0-.58,0L3.86,4.45A.59.59,0,0,0,3.52,5V22.3a.6.6,0,0,0,.36.55l6.89,2.95a.69.69,0,0,0,.24.05.58.58,0,0,0,.33-.1.6.6,0,0,0,.27-.5V22.82h8.48a.59.59,0,0,0,.6-.59V20.45A.6.6,0,0,0,20.09,19.85Zm-9.68,4.49L4.72,21.9V5.37L10.41,2.7Z" />
    <path d="M23.47,13.25a.7.7,0,0,0,0-.29s0,0,0,0,0,0,0,0a.75.75,0,0,0-.07-.12l-3-3.33a.6.6,0,1,0-.89.81l2.13,2.32H15a.6.6,0,0,0,0,1.2h6.55l-2.14,2.37a.6.6,0,0,0,0,.84.59.59,0,0,0,.41.16.6.6,0,0,0,.44-.2l3-3.37s0,0,0,0a.57.57,0,0,0,.11-.22S23.47,13.27,23.47,13.25Z" />
  </svg>
)

export const NotificationIcon = () => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="38"
    viewBox="0 0 27 27"
  >
    <path d="M13.55,25.37A3.53,3.53,0,0,1,10,22H4.51a1.2,1.2,0,0,1-1.08-.25.72.72,0,0,1-.17-.64,1.88,1.88,0,0,1,.58-1.5,5.92,5.92,0,0,0,1.51-3.11V9.36h.1A8.19,8.19,0,0,1,12,2.63a1.78,1.78,0,0,1,3.2,0,8.15,8.15,0,0,1,6.6,8,8.07,8.07,0,0,1-.18,1.68v4a18.88,18.88,0,0,0,1.59,3.32,1.89,1.89,0,0,1,.59,1.45.81.81,0,0,1-.18.69,1.28,1.28,0,0,1-1.16.25H17.08A3.54,3.54,0,0,1,13.55,25.37ZM6,20.82h5.26v1a2.34,2.34,0,0,0,4.67,0v-1h6.65a1.3,1.3,0,0,0-.27-.41,17.16,17.16,0,0,1-1.89-4v-4.3a6.95,6.95,0,0,0-5.76-8.4l-.4-.06-.1-.4a.58.58,0,0,0-.57-.47A.61.61,0,0,0,13,3.3l-.09.4-.4.06A7,7,0,0,0,6.58,10l0,.36v6.19a7.29,7.29,0,0,1-1.81,3.86,1.3,1.3,0,0,0-.27.41Z" />
  </svg>
)

export const VisibilityIcon = () => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    width="22.183"
    height="13.157"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 27 27"
  >
    <path d="M13,21.16c-1.6,0-6.85-.56-12.28-7.18a.62.62,0,0,1,0-.73c.22-.3,5.36-7.4,13.08-7.4S26.12,13,26.32,13.28a.61.61,0,0,1,0,.65c-.2.3-4.93,7.21-12.81,7.21C13.47,21.14,13.3,21.16,13,21.16ZM2,13.58c5.86,6.9,11.41,6.37,11.47,6.36,6.37,0,10.62-5,11.64-6.35-1-1.37-5.13-6.54-11.29-6.54S3.1,12.16,2,13.58Z" />
    <path d="M13.5,18.25a4.75,4.75,0,1,1,4.75-4.75A4.75,4.75,0,0,1,13.5,18.25Zm0-8.3a3.56,3.56,0,1,0,3.55,3.55A3.56,3.56,0,0,0,13.5,10Z" />
    <path d="M13.5,15.63a2.13,2.13,0,1,1,2.13-2.13A2.14,2.14,0,0,1,13.5,15.63Zm0-3.06a.93.93,0,1,0,.93.93A.93.93,0,0,0,13.5,12.57Z" />
  </svg>
)

export const RegisterStoreImage = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1321.668"
    height="641.625"
    viewBox="0 0 1321.668 641.625"
  >
    <path
      d="M239.612,350.76c28.129,63.535-7.753,136.7-49.989,191.785-14.136,18.474-29.743,37.841-31.7,61.013-2.363,28.345,16.831,54.4,39.6,71.431,41.53,31.04,98.249,40.637,147.676,24.973,42.712-13.531,78.622-44.1,121.709-56.416,72.051-20.635,148.425,13.574,210.13,56.2,43.677,30.132,90.453,66.849,143.108,60.393,37.049-4.539,68.492-30.55,89.833-61.171,10.3-14.785,19.266-31.357,34.268-41.328,8.92-5.937,19.4-9.078,29.872-11.326,95.669-20.448,197.2,29.454,291.605,3.79,63.765-17.292,114.6-67.728,146.22-125.758s46.372-123.553,58.664-188.471c8.733-46.113,15.981-95.929-4.092-138.338-21.241-44.9-70.408-72.123-119.821-77.224s-98.969,8.978-144.491,28.835c-56.877,24.872-112.63,59.687-174.709,59.8-42.28.086-82.6-16.139-123.02-28.518-67.584-20.679-137.862-30.953-207.9-40.435-67.051-9.078-134.764-17.523-202.218-12.162-47.727,3.79-89.876,22.033-136.191,30.478-30.189,5.5-60.523,1.441-90.15,10.664-36.487,11.413-74.011,37.856-76.028,79.5C190.084,288.119,224.7,317.054,239.612,350.76Z"
      transform="translate(-157.723 -119.26)"
      fill="#6064FF"
      opacity="0.1"
    />
  </svg>
)

export const LoginIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1321.668 909.264">
    <defs>
      <linearGradient id="a" x1="0.495" y1="1.014" x2="0.495" gradientUnits="objectBoundingBox">
        <stop offset="0" stopColor="gray" stopOpacity="0.251" />
        <stop offset="0.54" stopColor="gray" stopOpacity="0.122" />
        <stop offset="1" stopColor="gray" stopOpacity="0.102" />
      </linearGradient>
      <linearGradient id="c" x1="0.5" y1="1" x2="0.5" y2="0" />
      <linearGradient id="d" x1="0.5" y1="1" x2="0.5" y2="0" />
      <linearGradient id="b" x1="0.5" y1="1" x2="0.5" y2="0" />
    </defs>
    <g transform="translate(225.079 -209.187)">
      <path
        d="M239.612,350.76c28.129,63.535-7.753,136.7-49.989,191.785-14.136,18.474-29.743,37.841-31.7,61.013-2.363,28.345,16.831,54.4,39.6,71.431,41.53,31.04,98.249,40.637,147.676,24.973,42.712-13.531,78.622-44.1,121.709-56.416,72.051-20.635,148.425,13.574,210.13,56.2,43.677,30.132,90.453,66.849,143.108,60.393,37.049-4.539,68.492-30.55,89.833-61.171,10.3-14.785,19.266-31.357,34.268-41.328,8.92-5.937,19.4-9.078,29.872-11.326,95.669-20.448,197.2,29.454,291.605,3.79,63.765-17.292,114.6-67.728,146.22-125.758s46.372-123.553,58.664-188.471c8.733-46.113,15.981-95.929-4.092-138.338-21.241-44.9-70.408-72.123-119.821-77.224s-98.969,8.978-144.491,28.835c-56.877,24.872-112.63,59.687-174.709,59.8-42.28.086-82.6-16.139-123.02-28.518-67.584-20.679-137.862-30.953-207.9-40.435-67.051-9.078-134.764-17.523-202.218-12.162-47.727,3.79-89.876,22.033-136.191,30.478-30.189,5.5-60.523,1.441-90.15,10.664-36.487,11.413-74.011,37.856-76.028,79.5C190.084,288.119,224.7,317.054,239.612,350.76Z"
        transform="translate(-382.802 89.927)"
        fill="#6064FF"
        opacity="0.1"
      />
      <g transform="translate(11.748 589.592)">
        <path
          d="M265.74,486.89a.883.883,0,0,0,1.043.138A3.552,3.552,0,0,1,265.74,486.89Z"
          transform="translate(-104.446 -239.303)"
          fill="url(#a)"
        />
        <path
          d="M403.232,328.613c-2.064-.6-5.011-1.571-8.554-2.809a44.858,44.858,0,0,0,7.924-15.962l-.3.115c.1-.355.206-.7.3-1.066-6.8,2.764-14.322-1.915-19.115-7.924s-8.027-13.462-13.279-18.989a60.784,60.784,0,0,0-7.041-6.066c-1.548-1.147-3.211-2.442-5.1-2.5-3.062-.092-5.458,2.913-8.405,3.8a11.467,11.467,0,0,1-5.86-.218c-7.6-1.743-14.907-4.965-22.67-5.814a26.569,26.569,0,0,0-12.3,1.387c-3.9,1.479-5.676,4.426-8.829,6.788-3.44,2.534-10.16,2.477-14.162,2.924a101.48,101.48,0,0,1-14.632.608,34.251,34.251,0,0,0-8.417.31c-5.814,1.273-10.481,5.894-14.838,10.32a7.649,7.649,0,0,0-2.454,3.841,4.852,4.852,0,0,0,0,1.273,8.268,8.268,0,0,0,.585,3.383,44.722,44.722,0,0,0,5.63,11.2c1.777,2.546,3.853,4.942,4.862,7.958a15.446,15.446,0,0,1,.745,4.587,33.36,33.36,0,0,1-.516,4.931,61.924,61.924,0,0,1-3.773,13.13,23.85,23.85,0,0,0-2.2,6.88,10.962,10.962,0,0,0,0,1.468c-.287,7.568,7.35,13.015,8.829,20.537a12.272,12.272,0,0,1,.218,1.892c-.161,4.69-2.832,9.277-6.777,11.1.344.138.7.252,1.055.367a9.562,9.562,0,0,1-1.055.573,21.392,21.392,0,0,0,2.2.711,51.144,51.144,0,0,0-11.134,13.76c-13.267,24.7-103.122,73.078-103.122,73.078l1.33.757-1.078.7c-7.775,5.172-26.018,20.25-9.529,39.32,0,0,12.877-20.319,21.9-28.977.4-.39.8-.745,1.147-1.078a2.638,2.638,0,0,1,.344,2.087l59.077-33.2s21-14.7,26.855-18.014a48.333,48.333,0,0,1,13.313-5.733l-.688.287a26.969,26.969,0,0,1,6.777-.963c10.458.161,21.787,7.82,25.514,38.15,5,40.616,2.683,47.943,1.078,48.941a2.944,2.944,0,0,1-.585-.1,1,1,0,0,0,.161.115,3.071,3.071,0,0,1-.642-.115.917.917,0,0,0,.872.206.814.814,0,0,0,.654-.08h0a6.8,6.8,0,0,0,.791,0,8.429,8.429,0,0,1-.08,1.147c-.08,0-.47.218,0,.241h0c-.126,2.293-.115,4.782,0,7.385-5.194.287-10.389.6-14.907.871l.4-2.144.183-.963c3.99-.321,7.775-1.491,8.222-4.724.975-7.109-8.784-10.9-17.086-11.375s-58.091,2.844-58.091,2.844-7.465,9.667,16.214,12.614q1.055.55,2.19,1.147c9.277,5.286,21.856,15.022,27.887,19.815l.837.665-2.706,2.2c14.643,3.314,28.8,59.272,36.614,84.855s24.895,24.654,39.056,20.858c13.267-3.555,14.907-42.083,15.125-46.922v-.493l23.6,29.149,1.789,2.213q1.032.539,2.041,1.009c17.865,8.5,37.6-7.8,31.993-26.374-5.676-18.725-14.483-46.418-20.354-58.126-4.919-9.8-11.272-26.087-15.125-36.281a12.24,12.24,0,0,0,1.456-.7s-.092-.459-.241-1.3l.241-.126s-5.733-29.493-5.986-50.454V461.7c4.266-.975,6.972-1.353,6.972-1.353l.08-.917-.493.1,2.374-27.165s8.715-18.542,2.041-26.259a16.215,16.215,0,0,1-3.91-8.027c-1.147-7.1,0-18.943,15.538-28.782,23.92-15.171,33.254-27.52,33.254-27.52S417.875,332.925,403.232,328.613Zm-47.507,18.852V334.909c4.438-.218,8.967.3,13.428,0a33.98,33.98,0,0,0,6.479-1.089l1.078.745a118.108,118.108,0,0,1-20.984,12.9ZM287.9,544.282c1.754,1.216,3.52,2.477,5.252,3.75,1.078,6.192,2.03,10.561,2.1,10.871A85.842,85.842,0,0,0,287.9,544.282Z"
          transform="translate(-125.08 -270.975)"
          fill="url(#b)"
        />
        <path
          d="M307.118,500.32l-1.032,5.607-.791,4.289-1.445,7.843-14.013,9.8s-1.261-1.078-3.348-2.786c-5.733-4.724-17.808-14.311-26.672-19.494a29.815,29.815,0,0,0-7.327-3.383Z"
          transform="translate(-106.39 -237.333)"
          fill="#ffbdc6"
        />
        <path
          d="M307.12,500.32l-1.032,5.607a43.571,43.571,0,0,1-9.242-.47l-32.692.47c-1.548-.092-2.993-.218-4.346-.355a29.817,29.817,0,0,0-7.327-3.383Z"
          transform="translate(-106.392 -237.333)"
          opacity="0.1"
        />
        <path
          d="M298.3,505.982s16.352,2.8,17.281-4.208-8.405-10.7-16.329-11.226-55.591,2.821-55.591,2.821-8.405,11.2,21.948,13.072Z"
          transform="translate(-107.842 -238.775)"
          fill="#7679b4"
        />
        <path
          d="M307.118,500.32l-1.032,5.607-.791,4.289-1.445,7.843-14.013,9.8s-1.261-1.078-3.348-2.786c-5.733-4.724-17.808-14.311-26.672-19.494a29.815,29.815,0,0,0-7.327-3.383Z"
          transform="translate(-106.39 -237.333)"
          opacity="0.1"
        />
        <path
          d="M307.12,500.32l-1.032,5.607a43.571,43.571,0,0,1-9.242-.47l-32.692.47c-1.548-.092-2.993-.218-4.346-.355a29.817,29.817,0,0,0-7.327-3.383Z"
          transform="translate(-106.392 -237.333)"
          opacity="0.1"
        />
        <path
          d="M298.3,505.982s16.352,2.8,17.281-4.208-8.405-10.7-16.329-11.226-55.591,2.821-55.591,2.821-8.405,11.2,21.948,13.072Z"
          transform="translate(-107.842 -238.775)"
          opacity="0.1"
        />
        <rect width="85.463" height="101.344" transform="translate(140.711 36.94)" fill="#a66477" />
        <rect width="85.463" height="101.344" transform="translate(140.711 36.94)" opacity="0.1" />
        <path
          d="M164.594,455.577c-1.41.355-3.2,1.709-5.206,3.681-8.635,8.531-20.95,28.541-20.95,28.541-15.778-18.783,1.686-33.632,9.173-38.735,1.812-1.238,3.027-1.9,3.027-1.9Z"
          transform="translate(-124.058 -245.131)"
          fill="#ffbdc6"
        />
        <path
          d="M305.116,331.09s4.208,29.424,18.68,36.43-18.68,20.078-18.68,20.078l-45.306-16.81s25.686-8.405,20.549-33.162Z"
          transform="translate(-105.316 -262.157)"
          fill="#ffbdc6"
        />
        <path
          d="M263.988,485.45l-1.032,5.607-.791,4.289-1.445,7.843-14.013,9.8s-1.261-1.078-3.348-2.786c-5.733-4.724-17.808-14.311-26.672-19.494a29.813,29.813,0,0,0-7.327-3.383Z"
          transform="translate(-112.717 -239.515)"
          fill="#ffbdc6"
        />
        <path
          d="M263.99,485.45l-1.032,5.607a43.575,43.575,0,0,1-9.242-.47l-32.692.47c-1.548-.092-2.993-.218-4.346-.355a29.812,29.812,0,0,0-7.327-3.383Z"
          transform="translate(-112.718 -239.515)"
          opacity="0.1"
        />
        <path
          d="M255.128,491.1s16.352,2.8,17.281-4.208-8.405-10.744-16.352-11.2-55.58,2.8-55.58,2.8-8.405,11.2,21.948,13.072Z"
          transform="translate(-114.176 -240.953)"
          fill="#7679b4"
        />
        <path
          d="M257.776,494.133l-1.445,7.843-14.013,9.8s-1.261-1.078-3.348-2.786L257.5,493.8Z"
          transform="translate(-108.373 -238.29)"
          opacity="0.1"
        />
        <path
          d="M350.465,603.708q-.963-.47-1.949-1l-1.709-2.179L324.24,571.864v.5c-.149,4.759-1.777,42.714-14.46,46.211-13.542,3.738-29.894,4.667-37.359-20.549S251.4,517.706,237.39,514.438l20.778-17.051s13.76,16.054,19.379,31.511c-.206-.986-9.712-45.374-1.869-53.218H343.86s10.5,29.974,17.751,44.835c5.619,11.536,14.047,38.8,19.494,57.254C386.494,596.025,367.665,612.078,350.465,603.708Z"
          transform="translate(-108.605 -240.948)"
          fill="#7679b4"
        />
        <path
          d="M344.074,491.361c-10.515,6.227-56.75,3.692-71.817,2.683l-4.094-.3c-.447,0,.069-.252.069-.252l.424-4.243,11.2-28.484L339.877,426c-1.215,3.658-1.628,9.265-1.525,15.7C338.65,462.316,344.074,491.361,344.074,491.361Z"
          transform="translate(-104.118 -248.235)"
          opacity="0.1"
        />
        <path
          d="M344.137,490.148c-10.515,6.227-56.75,3.692-71.817,2.683l-4.094-.3h-.677l.745-.2,3.692-.975,7.935-31.763,60.018-34.79c-1.215,3.658-1.628,9.265-1.525,15.7C338.713,461.091,344.137,490.148,344.137,490.148Z"
          transform="translate(-104.181 -248.41)"
          fill="#f2f1f2"
        />
        <path
          d="M338.327,440.475c-12.2,2.809-39.056,11.077-49.376,30.961-6.88,13.279-12.614,18.978-16.707,21.363l-4.094-.3.069-.252,3.692-.975,7.935-31.763,60.018-34.79C338.625,428.481,338.224,434.043,338.327,440.475Z"
          transform="translate(-104.093 -248.423)"
          opacity="0.1"
        />
        <path
          d="M148.6,447.17l14.013,8.405c-1.41.355-3.2,1.709-5.206,3.681-1.147-3.44-8.508-8.164-11.834-10.183C147.382,447.835,148.6,447.17,148.6,447.17Z"
          transform="translate(-122.074 -245.13)"
          opacity="0.1"
        />
        <path
          d="M266.126,484.356a.837.837,0,0,1-.986-.126A3.371,3.371,0,0,0,266.126,484.356Z"
          transform="translate(-104.534 -239.693)"
          opacity="0.1"
        />
        <path
          d="M315.358,370.363s-12.614,1.4-21.489-7.935c0,0-37.359,10.744-49.973,35.031s-98.546,71.92-98.546,71.92,14.907,8.405,13.542,12.614L215.4,449.3s20.078-14.483,25.686-17.751,36.43-23.347,42.966,31.293,0,48.161,0,48.161,9.346,3.268,22.934-22.934,55.58-32.222,55.58-32.222l2.293-27.52s8.336-18.255,1.949-25.869a16.168,16.168,0,0,1-3.738-7.9c-1.066-6.995,0-18.657,14.907-28.346,22.934-14.907,31.763-27.085,31.763-27.085s.47-8.875-13.542-13.072-70.991-27.085-70.991-27.085l-1.869,7.935,44.835,31.763s-22.418,18.209-40.134,17.751C327.971,356.339,331.239,369.893,315.358,370.363Z"
          transform="translate(-122.106 -266.869)"
          fill="#565388"
        />
        <path
          d="M304.729,343.727a91.735,91.735,0,0,1-2.58-11.467l-24.757,6.582a27.291,27.291,0,0,1-.562,14.276,26.626,26.626,0,0,0,27.9-9.4Z"
          transform="translate(-102.82 -261.986)"
          opacity="0.1"
        />
        <circle
          cx="26.626"
          cy="26.626"
          r="26.626"
          transform="translate(154.723 37.399)"
          fill="#ffbdc6"
        />
        <path
          d="M304.84,274.03c7.385.837,14.414,4.013,21.684,5.733a10.71,10.71,0,0,0,5.607.218c2.821-.871,5.114-3.83,8.027-3.738,1.8,0,3.44,1.284,4.885,2.465a58.608,58.608,0,0,1,6.731,5.974c5.011,5.447,8.13,12.786,12.705,18.7s11.788,10.527,18.29,7.809c-4.415,17.2-18.909,30.353-34.573,31.419-6.249.424-12.614-.871-18.7.963a16.373,16.373,0,0,1-4.724,1.147c-3.44,0-6.284-3.2-8.463-6.307-5.091-7.316-9.174-15.618-14.907-22.28-1.892-2.2-4.128-4.3-6.8-4.7s-5.137.871-7.522,2.11c-3.933,2.041-7.958,4.151-11.008,7.637s-4.977,8.7-3.715,13.428c.677,2.546,2.236,4.839,2.293,7.511,0,4.243-3.692,7.35-4.438,11.467a44.256,44.256,0,0,0-.184,5.229c-.333,5.665-4.025,10.32-7.9,13.863-1.5,1.387-3.176,2.867-3.612,5.011-.3,1.456,0,3-.195,4.484-.562,3.681-4.231,5.538-7.476,6.02a21.673,21.673,0,0,1-11.215-1.33c4.587-2.144,7.327-8.256,6.272-13.76-1.445-7.58-9.059-13.015-8.417-20.744a24,24,0,0,1,2.11-6.823,62.437,62.437,0,0,0,3.6-12.935,21.913,21.913,0,0,0-.218-10.32c-.975-2.97-2.958-5.332-4.656-7.843a44.513,44.513,0,0,1-5.389-11.043,7.741,7.741,0,0,1-.516-3.646,7.557,7.557,0,0,1,2.293-3.784c4.174-4.369,8.646-8.921,14.2-10.183a31.832,31.832,0,0,1,8.027-.31,94.308,94.308,0,0,0,14-.6c3.83-.447,10.32-.39,13.554-2.89,3.016-2.293,4.724-5.217,8.451-6.685A24.734,24.734,0,0,1,304.84,274.03Z"
          transform="translate(-109.34 -270.562)"
          opacity="0.1"
        />
        <path
          d="M308.48,513.76s15.411,30.353,10.744,39.7"
          transform="translate(-98.177 -235.362)"
          opacity="0.1"
        />
        <path
          d="M335.761,589.031l-22.567-28.667v.5s-1.307-9.265,2.993-6.146c9.414,6.811,24.482,17.98,24.8,19.906S337.939,584.284,335.761,589.031Z"
          transform="translate(-97.513 -229.447)"
          opacity="0.1"
        />
        <g transform="translate(23.714 32.021)" opacity="0.1">
          <path
            d="M305.544,349.048s1.9,7.889-4.254,11.834c9.483-1.628,9.9-9,9.609-12.212a29.88,29.88,0,0,1-5.355.378Z"
            transform="translate(-122.946 -291.599)"
          />
          <path
            d="M150.909,459.294s85.933-47.633,98.546-71.92c9.047-17.43,30.846-27.876,42.427-32.394-8.451,2.832-36.889,13.691-47.576,34.263-12.614,24.287-98.546,71.92-98.546,71.92Z"
            transform="translate(-145.76 -290.674)"
          />
          <path
            d="M322.314,352.645c14.62-4.587,28.6-15.9,28.6-15.9l-44.835-31.763,1.021-4.357-4.289-1.72-1.869,7.935L345.775,338.6A108.189,108.189,0,0,1,322.314,352.645Z"
            transform="translate(-122.997 -298.9)"
          />
          <path
            d="M319.83,440.314a111.1,111.1,0,0,1,17.579-4.438l.08-.906a118.972,118.972,0,0,0-17.659,5.344Z"
            transform="translate(-120.226 -278.94)"
          />
          <path
            d="M277.288,493.277h-.413a.837.837,0,0,1-.986-.126,3.442,3.442,0,0,0,.986.126c1.537-.894,3.841-7.866-.986-48.23-5.16-43.093-25.411-39.71-36.5-34.756,11.329-3.119,26.924-.424,31.362,36.625,4.828,40.363,2.523,47.347.986,48.23a10.32,10.32,0,0,0,5.55-1.869Z"
            transform="translate(-132.026 -282.974)"
          />
          <path
            d="M267.726,483.956a3.437,3.437,0,0,1-.986-.126.837.837,0,0,0,.986.126Z"
            transform="translate(-128.014 -271.773)"
          />
        </g>
        <path
          d="M304.84,273.24c7.385.837,14.414,4.013,21.684,5.733a10.711,10.711,0,0,0,5.607.218c2.821-.872,5.114-3.83,8.027-3.738,1.8,0,3.44,1.284,4.885,2.465a58.614,58.614,0,0,1,6.731,5.974c5.011,5.447,8.13,12.786,12.705,18.7s11.788,10.527,18.29,7.809c-4.415,17.2-18.909,30.353-34.573,31.419-6.249.424-12.614-.872-18.7.963a16.374,16.374,0,0,1-4.724,1.147c-3.44,0-6.284-3.2-8.463-6.307-5.091-7.316-9.174-15.618-14.907-22.28-1.892-2.2-4.128-4.3-6.8-4.7s-5.137.872-7.522,2.11c-3.933,2.041-7.958,4.151-11.008,7.637s-4.977,8.7-3.715,13.428c.677,2.546,2.236,4.839,2.293,7.511,0,4.243-3.692,7.35-4.438,11.467a44.256,44.256,0,0,0-.184,5.229c-.333,5.665-4.025,10.32-7.9,13.863-1.5,1.387-3.176,2.867-3.612,5.011-.3,1.456,0,3-.195,4.484-.562,3.681-4.231,5.538-7.476,6.02a21.673,21.673,0,0,1-11.215-1.33c4.587-2.144,7.327-8.256,6.272-13.76-1.445-7.58-9.059-13.015-8.417-20.744a24,24,0,0,1,2.11-6.823,62.439,62.439,0,0,0,3.6-12.935,21.913,21.913,0,0,0-.218-10.32c-.975-2.97-2.958-5.332-4.656-7.843a44.514,44.514,0,0,1-5.389-11.043,7.74,7.74,0,0,1-.516-3.646,7.557,7.557,0,0,1,2.293-3.784c4.174-4.369,8.646-8.921,14.2-10.183a31.831,31.831,0,0,1,8.027-.31,94.3,94.3,0,0,0,14-.6c3.83-.447,10.32-.39,13.554-2.89,3.016-2.293,4.724-5.217,8.451-6.685A24.735,24.735,0,0,1,304.84,273.24Z"
          transform="translate(-109.34 -270.677)"
          fill="#a66477"
        />
      </g>
      <g transform="translate(774.958 548.311)">
        <path
          d="M989.69,224.917h0v-.424a.968.968,0,0,0-.069-.436h-.183v-.952c-.459-10.63-15.159-33.254-21.053-26.649-5.16,5.8,2.626,20.48,6.593,27.085l.355.6-.195-.126s-16.409,48.941-18.347,50.844-15.446,40.386-33.254,44.721c-3.52.837-6.444,1.594-8.9,2.293l.195-.654c1.147-3.75,2.557-7.293,3.13-11.467s0-9.231-2.11-11.26c-1.032-1.009-2.293-1.147-3.142-2.752a12.7,12.7,0,0,1-.872-4.415l-1.514-18.553,1.055-.321c6.376-2.041,12.556-6.88,13.279-13.393a6.876,6.876,0,0,1-.677.218,11.6,11.6,0,0,0,.195-1.147c-5.355,2.11-10.32-3.44-15.48-5.928-8.5-4.163-18.209-.241-26.982.711-9.942,1.089-19.379-3.039-29.539-2.293-5.527.424-11.673,4.174-11.375,9.621.172,2.993,2.293,5.527,3.165,8.394,2.2,6.937-2.695,13.9-6.983,19.815-2.821,3.887-5.527,8.623-6.009,13.187-9.873-10.32-20.549-22.246-21.787-26.729l-28.564-48.941s-.677.722-1.766,1.789c-.172-.527-.378-1.147-.608-1.766-3.646-10.217-13.967-34.974-27.05-30.433s5.424,29.917,13.474,40.031l1.147,1.4a3.623,3.623,0,0,1-2.041-.092l31.855,54.64s5.791,10.458,11.1,13.3c0,0,39.572,49.892,40.054,59.869s17.8,36.591,17.8,36.591,5.791,43.242-4.346,50.844h1.674q-.722.705-1.479,1.548c-7.511,8.325-17.109,26.167-3.99,56.509,19.3,44.721,22.2,62.242,22.2,62.242s-36.694,1.9-43.918,3.325c-6.4,1.261-31.27,2.144-36.958,2.293-2.03-2.362-8.027-7.591-16.122,0-10.137,9.506-17.372,41.281-17.372,41.281s-3.864,25.663,9.173,19c0,0,15.446-21.386,19.78-22.337,2.156-.47,4.438-3.646,6.181-6.708l.092.057h0c.1,0,.527-.229,1.215-.5h0c3.211-1.273,12.052-4.335,19.024-2.809,3.818.837,20.193,1.032,37.359.986-3.876,9.288-10.825,33.254-10.825,33.254s-2.9,22.349,6.731,21.432c6.88-.677,17.43-18.255,22.934-28.289,3.99-2.924,15.423-13.4,23.874-12.614l56.945-21.856s13.508-7.6,6.272-32.784c-5.734-20.021-22.051-61-28.5-76.977h0l-.195-.413c-1.56-3.864-2.5-6.158-2.5-6.158h0a94.243,94.243,0,0,1-5.172-22.6c-.057-.608-.1-1.227-.149-1.835a10.136,10.136,0,0,0,2.236-1.3s-5.309-53.688,0-59.4h0l.092-.1h0v-.069h0l.092-.115h0l.206-.264h0l.252-.321h0c.287-.378.631-.849,1.021-1.422h0c3.039-4.449,8.7-14.609,7.075-26.6h0q-.1-.78-.252-1.571h0a32.763,32.763,0,0,0-3.3-9.311,25.825,25.825,0,0,1-.424-3.681v-3.257a11.023,11.023,0,0,1,.172-1.651v-.206a2.056,2.056,0,0,1,.1-.631v-.264a3,3,0,0,1,.138-.619v-.218c.069-.275.138-.55.229-.826v-.138q.1-.344.229-.677l.1-.264.229-.55.115-.275c.092-.206.195-.413.3-.619l.08-.172q.206-.378.436-.745l.126-.195.378-.539.183-.241.4-.482.183-.206c.206-.218.413-.436.642-.642,6.272-5.733,34.263-47.989,34.263-47.989s6.754-9.506,6.754-15.675C978.957,276.8,990.894,237.015,989.69,224.917ZM914.547,580.1c-.688-6.513-1.376-14.586-2.007-22.934l10.917,17.017S922.425,579.37,914.547,580.1Z"
          transform="translate(-746.655 -195)"
          fill="url(#c)"
        />
        <path
          d="M798.118,528.324s-6.536-10.32-16.352-.929-16.81,40.627-16.81,40.627-3.738,25.227,8.875,18.68c0,0,14.907-21.019,19.15-21.948s8.875-12.614,8.875-12.614Z"
          transform="translate(-744.046 -146.821)"
          fill="#493545"
        />
        <path
          d="M858,549.969s-8.875-4.208-11.673-.929S834.18,585,834.18,585s-2.8,21.489,6.536,20.549S866.4,570.965,866.4,570.965Z"
          transform="translate(-733.874 -143.25)"
          fill="#493545"
        />
        <path
          d="M858,549.969s-8.875-4.208-11.673-.929S834.18,585,834.18,585s-2.8,21.489,6.536,20.549S866.4,570.965,866.4,570.965Z"
          transform="translate(-733.874 -143.25)"
          opacity="0.05"
        />
        <path
          d="M886.33,501.579l20.078,31.293s-1.4,7.006-13.542,5.607L851.3,564.635s-3.612,31.844,7.935,28.954c1.869-.47,14.907-14.013,24.287-13.072l55.121-21.489s13.072-7.476,6.066-32.222-30.169-82.126-30.169-82.126l-36.614,20.48Z"
          transform="translate(-731.384 -158.375)"
          fill="#3e3d77"
        />
        <path
          d="M886.33,501.579l20.078,31.293s-1.4,7.006-13.542,5.607L851.3,564.635s-3.612,31.844,7.935,28.954c1.869-.47,14.907-14.013,24.287-13.072l55.121-21.489s13.072-7.476,6.066-32.222-30.169-82.126-30.169-82.126l-36.614,20.48Z"
          transform="translate(-731.384 -158.375)"
          opacity="0.05"
        />
        <path
          d="M908.107,552.123c2.8,17.751-13.072,19.15-13.072,19.15s-71.462,1.4-79.867-.47-19.62,3.268-19.62,3.268c-14.483-8.875-2.8-30.823-2.8-30.823s29.894-.929,36.9-2.293,42.5-3.3,42.5-3.3-2.8-17.281-21.489-61.176c-12.694-29.814-3.44-47.358,3.864-55.534a30.752,30.752,0,0,1,6.41-5.642l57.449,2.8a74.5,74.5,0,0,0,.321,8.68,92.451,92.451,0,0,0,7.625,28.667c-3.268,0-24.287,19.62-24.287,19.62S905.3,534.383,908.107,552.123Z"
          transform="translate(-740.547 -162.685)"
          fill="#3e3d77"
        />
        <path
          d="M796.946,545.112s29.894-.929,36.9-2.293,42.5-3.268,42.5-3.268-2.8-17.281-21.489-61.176c-12.694-29.814-3.44-47.358,3.864-55.534a30.755,30.755,0,0,1,6.41-5.642l53.229,2.592v-1.663l-57.449-2.8a30.755,30.755,0,0,0-6.41,5.642c-7.27,8.187-16.558,25.72-3.864,55.534,18.737,43.861,21.512,61.141,21.512,61.141s-35.547,1.869-42.5,3.268-36.9,2.293-36.9,2.293-11.673,21.959,2.8,30.869c0,0,.436-.206,1.147-.5C787.073,563.677,796.946,545.112,796.946,545.112Z"
          transform="translate(-740.546 -162.681)"
          opacity="0.1"
        />
        <rect width="28.954" height="73.319" transform="translate(112.909 81.197)" fill="#493545" />
        <rect width="28.954" height="73.319" transform="translate(112.909 81.197)" opacity="0.1" />
        <path
          d="M886.492,258.016c1,.275,2.121.31,2.8,1.686a10.319,10.319,0,0,1,.677,3.44l1.823,22.659a12.613,12.613,0,0,0,.849,4.335c.768,1.537,2.041,1.72,3.039,2.706,2.007,2,2.592,6.995,2.041,11.066s-1.938,7.557-3.027,11.238c-1.56,5.275-2.592,11.2-4.782,15.652s-6.169,6.88-8.738,3.142-2.225-11.283-2.706-17.464c-.8-10.32-4.828-19.218-5.1-29.607-.229-8.405,2.03-16.249,3.44-24.218,1.009-5.47,1.066-12.109,2.534-17.028C880.563,251.468,882.9,257.03,886.492,258.016Z"
          transform="translate(-728.071 -187.575)"
          fill="#493545"
        />
        <path
          d="M886.492,258.016c1,.275,2.121.31,2.8,1.686a10.319,10.319,0,0,1,.677,3.44l1.823,22.659a12.613,12.613,0,0,0,.849,4.335c.768,1.537,2.041,1.72,3.039,2.706,2.007,2,2.592,6.995,2.041,11.066s-1.938,7.557-3.027,11.238c-1.56,5.275-2.592,11.2-4.782,15.652s-6.169,6.88-8.738,3.142-2.225-11.283-2.706-17.464c-.8-10.32-4.828-19.218-5.1-29.607-.229-8.405,2.03-16.249,3.44-24.218,1.009-5.47,1.066-12.109,2.534-17.028C880.563,251.468,882.9,257.03,886.492,258.016Z"
          transform="translate(-728.071 -187.575)"
          opacity="0.1"
        />
        <path
          d="M782.007,232.769l-11.2,9.345s-1.33-1.559-3.314-4.082c-7.786-9.942-25.686-34.882-13.038-39.343s22.647,19.861,26.179,29.906C781.525,231.14,782.007,232.769,782.007,232.769Z"
          transform="translate(-746.156 -194.538)"
          fill="#c77485"
        />
        <path
          d="M957,229.465c-4.667,7.006-11.2,0-11.2,0s-.837-1.25-2.018-3.268c-3.841-6.5-11.375-20.916-6.387-26.626,5.734-6.525,19.941,15.744,20.377,26.19A6.214,6.214,0,0,1,957,229.465Z"
          transform="translate(-718.919 -194.502)"
          fill="#c77485"
        />
        <path
          d="M854.08,292.482s9.345,29.894,6.536,38.758,20.09,19.184,20.09,19.184h26.156s9.346-19.15,7.006-24.757-22.418-9.8-22.418-9.8-11.673,0-11.2-31.293Z"
          transform="translate(-730.897 -181.861)"
          fill="#c77485"
        />
        <path
          d="M779.777,228.874l-11.2,9.345s-1.33-1.559-3.314-4.082c4.071-.722,10.389-6.662,13.152-9.437C779.3,227.246,779.777,228.874,779.777,228.874Z"
          transform="translate(-743.926 -190.644)"
          opacity="0.1"
        />
        <path
          d="M955.971,225.968c-4.667,7.006-11.2,0-11.2,0s-.837-1.25-2.018-3.268l.149-.47c3.027,2.167,12.442.321,13.841,0a6.215,6.215,0,0,1-.768,3.738Z"
          transform="translate(-717.89 -191.006)"
          opacity="0.1"
        />
        <path
          d="M910.214,426.77c-14.448,6.593-61.394-5.149-64.214-5.848a30.754,30.754,0,0,1,6.41-5.642l57.449,2.8a74.548,74.548,0,0,0,.355,8.692Z"
          transform="translate(-732.082 -162.688)"
          opacity="0.1"
        />
        <path
          d="M873.3,327.188s-11.2,3.738-27.085-10.744c0,0-35.547-35.031-37.841-43.436l-27.521-48.161S769.178,237.459,764.5,235.59L795.323,289.3s5.607,10.32,10.744,13.072c0,0,38.3,49.044,38.758,58.848s17.258,36.063,17.258,36.063,5.607,42.5-4.208,49.973c0,0,54.64,14.013,66.313,4.667,0,0-5.137-52.748,0-58.378,0,0,15.882-18.68,5.137-39.228,0,0-2.293-11.2,3.738-16.81s33.162-47.175,33.162-47.175,6.536-9.345,6.536-15.411c0,0,12.143-41.1,10.32-51.842,0,0-10.745,2.293-14.013,0,0,0-15.882,48.161-17.751,49.973s-14.907,39.7-32.222,43.907-20.078,6.066-20.078,6.066,33.621,21.019,17.281,30.353S873.3,327.188,873.3,327.188Z"
          transform="translate(-744.037 -190.881)"
          fill="#ffaac4"
        />
        <path
          d="M881.323,299.437a89.239,89.239,0,0,1-.677-13.267l-26.156,7.935a35.287,35.287,0,0,1,1.64,5.366c2.993,1.319,7.029,4.438,10.5,4.438a23.817,23.817,0,0,0,14.689-4.472Z"
          transform="translate(-730.837 -181.627)"
          opacity="0.1"
        />
        <circle
          cx="24.287"
          cy="24.287"
          r="24.287"
          transform="translate(111.04 72.321)"
          fill="#c77485"
        />
        <path
          d="M842.1,246.662c-5.344.413-11.306,4.105-11.008,9.46.161,2.947,2.179,5.435,3.062,8.256,2.121,6.823-2.6,13.669-6.754,19.494s-8.027,13.542-4.472,19.712a48.617,48.617,0,0,0,3.28,4.277c4.392,5.928,4.334,13.932,6.284,21.053a36.935,36.935,0,0,0,43.391,26.374,23.094,23.094,0,0,1-4.874-15.618c.264-4.082,1.583-8.348,0-12.121-2.041-4.851-8.027-6.765-11.111-11.008s-2.878-10.125-1.388-15.182,4.071-9.747,5.309-14.907a44.879,44.879,0,0,1,1.147-4.461c2.156-6.123,8.6-9.678,14.907-11.2s12.935-1.617,19.092-3.624S911.109,260.457,911.82,254c-5.183,2.076-9.988-3.337-14.987-5.825-8.233-4.082-17.625-.241-26.11.7C861.056,249.953,851.882,245.951,842.1,246.662Z"
          transform="translate(-735.671 -187.47)"
          opacity="0.1"
        />
        <path
          d="M841.691,245.852c-5.344.413-11.306,4.105-11.008,9.46.161,2.947,2.179,5.435,3.062,8.256,2.121,6.823-2.6,13.669-6.754,19.494s-8.027,13.542-4.472,19.712a48.6,48.6,0,0,0,3.279,4.277c4.392,5.928,4.335,13.932,6.284,21.053a36.935,36.935,0,0,0,43.391,26.374A23.1,23.1,0,0,1,870.6,338.86c.264-4.082,1.582-8.348,0-12.12-2.041-4.85-8.027-6.765-11.111-11.008s-2.878-10.125-1.388-15.182,4.071-9.747,5.309-14.907a44.892,44.892,0,0,1,1.147-4.461c2.156-6.123,8.6-9.678,14.907-11.2s12.935-1.617,19.092-3.624,12.143-6.708,12.854-13.164c-5.183,2.076-9.988-3.337-14.987-5.825-8.233-4.082-17.625-.241-26.11.7C860.669,249.132,851.53,245.084,841.691,245.852Z"
          transform="translate(-735.731 -187.589)"
          fill="#493545"
        />
        <path
          d="M885.65,326.3s9.724,8.68,11.639,12.51"
          transform="translate(-726.266 -175.74)"
          opacity="0.1"
        />
        <path
          d="M908.72,371.51s-12.143,0-17.751,1.4-19.15,0-19.15,0"
          transform="translate(-728.295 -169.108)"
          opacity="0.1"
        />
        <g transform="translate(20.451 32.164)" opacity="0.1">
          <path
            d="M899.061,340.563a11.678,11.678,0,0,1-3.36,1.284,12.843,12.843,0,0,0,8.967-1.284c16.352-9.345-17.281-30.353-17.281-30.353H881.78S915.412,331.229,899.061,340.563Z"
            transform="translate(-747.285 -210.265)"
          />
          <path
            d="M955.948,223.9a4.886,4.886,0,0,0-.115-.849,54.875,54.875,0,0,1-5.814.883,25.754,25.754,0,0,0,5.928-.034Z"
            transform="translate(-737.275 -223.05)"
          />
          <path
            d="M863.495,445.614c9.8-7.476,4.208-49.973,4.208-49.973s-16.81-26.156-17.281-35.96-38.758-58.848-38.758-58.848c-5.137-2.8-10.745-13.072-10.745-13.072s-31.763-51.842-36.43-53.711l30.823,53.711s5.607,10.32,10.744,13.072c0,0,38.3,49.044,38.758,58.848s17.269,35.995,17.269,35.995,5.607,42.5-4.208,49.973c0,0,33.586,8.612,53.722,7.832C891.417,452.769,863.495,445.614,863.495,445.614Z"
            transform="translate(-764.49 -221.436)"
          />
          <path
            d="M859.78,314.235l-.275-.355a7.387,7.387,0,0,1-.975.218C858.966,314.155,859.379,314.2,859.78,314.235Z"
            transform="translate(-750.696 -209.726)"
          />
        </g>
        <g transform="translate(179.703 32.107)" opacity="0.1">
          <path
            d="M962.076,223l-.287.057C961.3,237.4,951.343,271.1,951.343,271.1c0,6.066-6.536,15.411-6.536,15.411s-27.085,41.567-33.162,47.175-3.738,16.81-3.738,16.81l.057.115c-.183-3.773.275-9.621,4.14-13.2,6.066-5.607,33.162-47.175,33.162-47.175S951.8,280.9,951.8,274.83C951.8,274.9,963.945,233.8,962.076,223Z"
            transform="translate(-902.769 -223)"
          />
          <path
            d="M903.37,371.819c.7,3.968.229-.229.47,3.738,0,0,11.467-13.451,8.336-30.078C913.117,360.341,903.37,371.819,903.37,371.819Z"
            transform="translate(-903.37 -205.034)"
          />
        </g>
      </g>
      <g transform="translate(660.813 811.099)">
        <path
          d="M726.362,770.642s-21.2-71.986,3.974-124.96a113.691,113.691,0,0,0,9.2-71.331,191.2,191.2,0,0,0-10.1-33.482"
          transform="translate(-677.403 -492.572)"
          fill="none"
          stroke="#535461"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
        <path
          d="M746.646,522.523c0,8.822-16.013,34.4-16.013,34.4s-16.013-25.577-16.013-34.4a16.013,16.013,0,0,1,31.939,0Z"
          transform="translate(-678.951 -507.692)"
          fill="#6064FF"
        />
        <path
          d="M764.809,559.466c-4.789,7.41-32.1,20.191-32.1,20.191s.495-30.148,5.284-37.558a16.013,16.013,0,1,1,26.815,17.367Z"
          transform="translate(-670.707 -495.781)"
          fill="#6064FF"
        />
        <path
          d="M765.849,618.467c-7.875,3.974-37.849,1.223-37.849,1.223s15.649-25.781,23.525-29.755a16.013,16.013,0,1,1,14.325,28.532Z"
          transform="translate(-672.853 -471.266)"
          fill="#6064FF"
        />
        <path
          d="M755.225,660.843c-7.089,5.241-37.165,7.613-37.165,7.613s11.063-28.052,18.167-33.307a16.013,16.013,0,0,1,18.924,25.679Z"
          transform="translate(-677.383 -450.668)"
          fill="#6064FF"
        />
        <path
          d="M711.446,575.339c6.332,6.143,35.811,12.519,35.811,12.519s-7.279-29.275-13.553-35.432a16.013,16.013,0,1,0-22.258,22.913Z"
          transform="translate(-682.997 -489.745)"
          fill="#6064FF"
        />
        <path
          d="M700.622,626.566c7.875,3.974,37.849,1.223,37.849,1.223s-15.649-25.781-23.525-29.755a16.013,16.013,0,0,0-14.383,28.518Z"
          transform="translate(-688.899 -467.079)"
          fill="#6064FF"
        />
        <path
          d="M695.449,676.883c7.089,5.241,37.165,7.613,37.165,7.613s-11.063-28.052-18.167-33.307a16.013,16.013,0,0,0-18.924,25.679Z"
          transform="translate(-690.118 -443.358)"
          fill="#6064FF"
        />
        <path
          d="M746.646,522.523c0,8.822-16.013,34.4-16.013,34.4s-16.013-25.577-16.013-34.4a16.013,16.013,0,0,1,31.939,0Z"
          transform="translate(-678.951 -507.692)"
          fill="#6064FF"
          opacity="0.1"
        />
        <path
          d="M764.809,559.466c-4.789,7.41-32.1,20.191-32.1,20.191s.495-30.148,5.284-37.558a16.013,16.013,0,1,1,26.815,17.367Z"
          transform="translate(-670.707 -495.781)"
          fill="#6064FF"
          opacity="0.1"
        />
        <path
          d="M765.849,618.467c-7.875,3.974-37.849,1.223-37.849,1.223s15.649-25.781,23.525-29.755a16.013,16.013,0,1,1,14.325,28.532Z"
          transform="translate(-672.853 -471.266)"
          fill="#6064FF"
          opacity="0.1"
        />
        <path
          d="M755.225,660.843c-7.089,5.241-37.165,7.613-37.165,7.613s11.063-28.052,18.167-33.307a16.013,16.013,0,0,1,18.924,25.679Z"
          transform="translate(-677.383 -450.668)"
          fill="#6064FF"
          opacity="0.1"
        />
        <path
          d="M711.446,575.339c6.332,6.143,35.811,12.519,35.811,12.519s-7.279-29.275-13.553-35.432a16.013,16.013,0,1,0-22.258,22.913Z"
          transform="translate(-682.997 -489.745)"
          fill="#6064FF"
          opacity="0.1"
        />
        <path
          d="M700.622,626.566c7.875,3.974,37.849,1.223,37.849,1.223s-15.649-25.781-23.525-29.755a16.013,16.013,0,0,0-14.383,28.518Z"
          transform="translate(-688.899 -467.079)"
          fill="#6064FF"
          opacity="0.1"
        />
        <path
          d="M695.449,676.883c7.089,5.241,37.165,7.613,37.165,7.613s-11.063-28.052-18.167-33.307a16.013,16.013,0,0,0-18.924,25.679Z"
          transform="translate(-690.118 -443.358)"
          fill="#6064FF"
          opacity="0.1"
        />
      </g>
      <g transform="translate(291.357 850.813)">
        <path
          d="M726.041,761.789s-20.379-69.212,3.821-120.145a109.311,109.311,0,0,0,8.846-68.582,183.832,183.832,0,0,0-9.714-32.192"
          transform="translate(-678.968 -494.433)"
          fill="none"
          stroke="#535461"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
        <path
          d="M745.412,521.952c0,8.482-15.4,33.073-15.4,33.073s-15.4-24.592-15.4-33.073a15.4,15.4,0,0,1,30.708,0Z"
          transform="translate(-680.325 -507.692)"
          fill="#6064FF"
        />
        <path
          d="M763.572,558.479c-4.6,7.124-30.862,19.413-30.862,19.413s.476-28.986,5.081-36.111a15.4,15.4,0,1,1,25.781,16.7Z"
          transform="translate(-673.096 -497.247)"
          fill="#6064FF"
        />
        <path
          d="M764.391,617.278C756.819,621.1,728,618.454,728,618.454s15.046-24.788,22.618-28.609a15.4,15.4,0,1,1,13.773,27.433Z"
          transform="translate(-674.978 -475.749)"
          fill="#6064FF"
        />
        <path
          d="M753.793,659.763c-6.816,5.039-35.733,7.32-35.733,7.32s10.637-26.971,17.467-32.024a15.4,15.4,0,0,1,18.2,24.69Z"
          transform="translate(-678.951 -457.686)"
          fill="#6064FF"
        />
        <path
          d="M711.226,574.25c6.088,5.906,34.431,12.037,34.431,12.037s-7-28.147-13.031-34.067a15.4,15.4,0,1,0-21.4,22.03Z"
          transform="translate(-683.874 -491.954)"
          fill="#6064FF"
        />
        <path
          d="M700.32,625.42c7.572,3.821,36.391,1.176,36.391,1.176s-15.046-24.788-22.618-28.609a15.4,15.4,0,0,0-13.828,27.419Z"
          transform="translate(-689.049 -472.078)"
          fill="#6064FF"
        />
        <path
          d="M695.244,675.8c6.816,5.039,35.733,7.32,35.733,7.32s-10.637-26.971-17.467-32.024a15.4,15.4,0,0,0-18.2,24.69Z"
          transform="translate(-690.118 -451.276)"
          fill="#6064FF"
        />
        <path
          d="M745.412,521.952c0,8.482-15.4,33.073-15.4,33.073s-15.4-24.592-15.4-33.073a15.4,15.4,0,0,1,30.708,0Z"
          transform="translate(-680.325 -507.692)"
          fill="#6064FF"
          opacity="0.1"
        />
        <path
          d="M763.572,558.479c-4.6,7.124-30.862,19.413-30.862,19.413s.476-28.986,5.081-36.111a15.4,15.4,0,1,1,25.781,16.7Z"
          transform="translate(-673.096 -497.247)"
          fill="#6064FF"
          opacity="0.1"
        />
        <path
          d="M764.391,617.278C756.819,621.1,728,618.454,728,618.454s15.046-24.788,22.618-28.609a15.4,15.4,0,1,1,13.773,27.433Z"
          transform="translate(-674.978 -475.749)"
          fill="#6064FF"
          opacity="0.1"
        />
        <path
          d="M753.793,659.763c-6.816,5.039-35.733,7.32-35.733,7.32s10.637-26.971,17.467-32.024a15.4,15.4,0,0,1,18.2,24.69Z"
          transform="translate(-678.951 -457.686)"
          fill="#6064FF"
          opacity="0.1"
        />
        <path
          d="M711.226,574.25c6.088,5.906,34.431,12.037,34.431,12.037s-7-28.147-13.031-34.067a15.4,15.4,0,1,0-21.4,22.03Z"
          transform="translate(-683.874 -491.954)"
          fill="#6064FF"
          opacity="0.1"
        />
        <path
          d="M700.32,625.42c7.572,3.821,36.391,1.176,36.391,1.176s-15.046-24.788-22.618-28.609a15.4,15.4,0,0,0-13.828,27.419Z"
          transform="translate(-689.049 -472.078)"
          fill="#6064FF"
          opacity="0.1"
        />
        <path
          d="M695.244,675.8c6.816,5.039,35.733,7.32,35.733,7.32s-10.637-26.971-17.467-32.024a15.4,15.4,0,0,0-18.2,24.69Z"
          transform="translate(-690.118 -451.276)"
          fill="#6064FF"
          opacity="0.1"
        />
      </g>
      <path
        d="M923.169,152.076H904.375a13.168,13.168,0,1,0,0-26.306H751.987a13.168,13.168,0,0,0,0,26.306h18.794a13.168,13.168,0,0,0,0,26.306H744.476a13.168,13.168,0,1,0,0,26.306H896.744a13.168,13.168,0,1,0,0-26.306h26.425a13.168,13.168,0,0,0,0-26.306Z"
        transform="translate(120.494 160.667)"
        fill="#fff"
        opacity="0.5"
      />
      <path
        d="M547.515,166.583h-9.344a6.549,6.549,0,1,0,0-13.078H462.477a6.549,6.549,0,0,0,0,13.078h9.344a6.549,6.549,0,1,0,0,13.078H458.743a6.549,6.549,0,1,0,0,13.078h75.693a6.549,6.549,0,1,0,0-13.078h13.078a6.549,6.549,0,0,0,0-13.078Z"
        transform="translate(117.416 299.251)"
        fill="#fff"
        opacity="0.5"
      />
      <path
        d="M396.34,206.743H380.875a10.835,10.835,0,1,0,0-21.646h-125.3a10.835,10.835,0,0,0,0,21.646h15.465a10.835,10.835,0,0,0,0,21.646H249.4a10.835,10.835,0,0,0,0,21.646h125.3a10.835,10.835,0,1,0,0-21.646H396.34a10.835,10.835,0,0,0,0-21.646Z"
        transform="translate(-165.757 191.443)"
        fill="#fff"
        opacity="0.5"
      />
      <g transform="translate(390.365 486.332)">
        <path
          d="M768.571,329.466c-4.9-12.763-17.521-42.76-25.835-36.809-10.5,7.522,10.5,40.753,10.5,40.753.6,6.1-11.215,18.794-17.544,25.124v-.791a2.758,2.758,0,0,1-.275.688l-.527-.287a3.439,3.439,0,0,1-.745,1.365,13.4,13.4,0,0,0-.057-1.365c-1.215,5.149-22.429,11.673-22.429,11.673H710.1c-5.894,0-21.237-1.33-28.346-12.705a62.908,62.908,0,0,0-13.909-16.226,11.846,11.846,0,0,0-6.594-2.5c-19.643-1.261-35.547-11.2-38.724-13.325l-.585-.4-.126.367c-.745-1.066-1.468-2.2-2.144-3.371h0l-.344-.631a28.8,28.8,0,0,0,15.882-25.617v-.6a19.619,19.619,0,0,0,2.638-9.827v-3.44l4.484-3.99c2.053-1.823,4.174-3.75,5.217-6.261a7.419,7.419,0,0,0,.55-3.211,5.561,5.561,0,0,0-2.11-4.977c-3.44-2.374-9.174,0-11.662-3.3-1.147-1.491-.94-3.52-1.5-5.275-1.147-3.566-5.275-5.493-9.093-5.55s-7.476,1.33-11.146,2.374a65.442,65.442,0,0,1-23.736,2.225,15.5,15.5,0,0,0-6.5.229,8.956,8.956,0,0,0-5.275,6.135,14.417,14.417,0,0,0-.5,3.142,19.769,19.769,0,0,0-4.977,13.084v8.818a19.758,19.758,0,0,0,4.759,12.831,28.667,28.667,0,0,0,12.006,20.916v.7l.149.092a47.413,47.413,0,0,1-1.261,8.107v-.585s-16.054,8.543-33.254,8.749H552.1a12.808,12.808,0,0,0-9.174,3.44c-5.091,4.793-14.012,12.373-19.494,12.373-1.147,0-30.089,5.653-34.882,6.593l-8.956-8.772-.275.516-.527-.516a21.78,21.78,0,0,0-2.913.424c-4.587-5.435-13.76-18.072-15.882-35.031,0,0,19.8-22.555,12.522-43.574-6.215-17.911-23.335,20.48-28.2,32.05a9.242,9.242,0,0,0-.3,6.364l16.088,51.853a24.321,24.321,0,0,0-1.273,12.614h-.184l11.719,15.033s8.818,3.761,22.613,3.692A79.052,79.052,0,0,0,522.5,387.19h2.718l-.516.195h13.955l8.875,26.844c-.3,2.442-4.587,36.533-8.027,44.159a19.159,19.159,0,0,0-1.353,8.027,61.279,61.279,0,0,0,2.557,15.538l7.775-.287-.3.608c-6.582,13.5-17.579,37.543-24.08,60.018l-11.318,22.934,8.485,102.858h.344l.654.1h0c.917.138,2.293.344,4.105.573l-.665,1.147-18.7,30.961s-13.336,27.3,16.168,22.154c0,0,10.905-3.165,15.354-21.787l19.4-18.2s.906-12.086-4.587-16.914c-.344-5.584-1.216-21.89.126-25.812,1.617-4.747-6.88-59.341-6.88-59.341s30.708-63.7,49.308-65.281a10.194,10.194,0,0,1,4.025.528c15.285,4.977,33.8,41.934,39.251,53.436h0l.252.528v.1l.206.447v.126l.183.39v.1l.161.355v.08l.138.287v.115l.1.218v.092l.069.161v.2h0l.057.138,2.419,71.611h0l.241.126h.115l-.206,1.479-1.055,7.4s13.336,28.094,12.522,31.649,8.887,17.808,22.624,13.852,5.562-26.259,5.562-26.259l-13.233-27.268-.585-1.215a26.012,26.012,0,0,0,3.715-2.763s-4.036-29.275,0-35.6,5.252-35.215,5.252-35.215-2.832-19.78-7.683-28.484l-20.319-72.528c6.089,5.665,10.825,7.878,14.781,7.729h.654a9.873,9.873,0,0,0,4.977-1.238,14.03,14.03,0,0,0,2.293-1.617,3.631,3.631,0,0,0,.378-.378h0c5.653-4.747-6.467-23.347-13.336-34.4-6.616-10.664,2.5-39.641,3.188-41.8a10.934,10.934,0,0,1,1.961-1.147,12.1,12.1,0,0,1,4.495-.975c6.582.229,14.678,4.013,24.7,5.917A116.53,116.53,0,0,0,714.9,403.5h.413c2.809,0,5.355-.057,7.419-.138a12.534,12.534,0,0,0,5.389-1.456h0a16.271,16.271,0,0,0,3.83-3.1l17.59-19.872-.459.218a9.885,9.885,0,0,0,0-6.995l18.588-32.107a12.212,12.212,0,0,0,.906-10.584Z"
          transform="translate(-443.598 -248.979)"
          fill="url(#d)"
        />
        <path
          d="M551.539,627.574l-18.725,17.946c-4.289,18.347-14.827,21.455-14.827,21.455-28.472,5.068-15.606-21.787-15.606-21.787l18.06-30.559,2.225-3.773s12.877-3.9,21.455-1.56a7.34,7.34,0,0,1,2.924,1.582C552.422,615.545,551.539,627.574,551.539,627.574Z"
          transform="translate(-435.4 -196.234)"
          fill="#444176"
        />
        <path
          d="M649.908,646.621c-13.267,3.9-22.624-10.137-21.787-13.657S616,601.8,616,601.8l1.009-7.293.94-6.754,21.787,1.559,2.052,4.312,12.774,26.89S663.175,642.722,649.908,646.621Z"
          transform="translate(-418.309 -199.285)"
          fill="#444176"
        />
        <path
          d="M544.568,613.936c-2.053,3.52-18.691,1.743-26.8.642l2.225-3.773s12.877-3.9,21.455-1.559a7.34,7.34,0,0,1,2.924,1.582C544.488,612.732,544.568,613.936,544.568,613.936Z"
          transform="translate(-432.718 -196.242)"
          opacity="0.1"
        />
        <path
          d="M641.686,593.6c-11.157,7.43-23.037,1.812-24.826.883l.94-6.754,21.787,1.559Z"
          transform="translate(-418.182 -199.288)"
          opacity="0.1"
        />
        <path
          d="M660.853,578.121c-3.9,6.238,0,35.112,0,35.112-12.877,11.708-28.082,3.119-28.082,3.119l-2.293-70.6s-25.353-58.126-43.3-56.566-47.588,64.364-47.588,64.364,8.187,53.826,6.628,58.481,0,27.3,0,27.3c-2.729,4.678-31.2,0-31.2,0L506.83,537.907,517.7,515.271c6.249-22.154,16.868-45.867,23.22-59.169,3.153-6.616,5.263-10.653,5.263-10.653l20.755-4.323,67.368-13.967,24.207,88.111c4.679,8.577,7.408,28.082,7.408,28.082S664.752,571.883,660.853,578.121Z"
          transform="translate(-434.322 -222.842)"
          fill="#565387"
        />
        <g transform="translate(72.462 204.272)" opacity="0.1">
          <path
            d="M628.233,608.422l-2.293-70.6s-25.353-58.126-43.3-56.566a9.772,9.772,0,0,0-2.351.527c17.5,5.814,39.412,56.039,39.412,56.039l2.293,70.6a27.521,27.521,0,0,0,15.515,2.832,27.6,27.6,0,0,1-9.277-2.832Z"
            transform="translate(-496.008 -419.184)"
          />
          <path
            d="M521.215,639.372l-8.187-101.424,10.916-22.67c6.25-22.154,16.868-45.867,23.22-59.169,3.153-6.616,5.263-10.653,5.263-10.653l20.755-4.323,61.5-12.786-.333-1.227-67.4,14.013-20.755,4.323s-2.11,4.036-5.263,10.653c-6.376,13.3-16.971,37.061-23.22,59.169L506.79,537.9l8.187,101.424s15.549,2.557,24.768,2A184.248,184.248,0,0,1,521.215,639.372Z"
            transform="translate(-506.79 -427.12)"
          />
        </g>
        <path
          d="M480.484,338.21s-22.234,1.147-19.115,24.574l6.238.78,9.357-10.137,4.678-8.577V342.9Z"
          transform="translate(-441.035 -235.889)"
          fill="#ced2df"
        />
        <path
          d="M480.484,338.21s-22.234,1.147-19.115,24.574l6.238.78,9.357-10.137,4.678-8.577V342.9Z"
          transform="translate(-441.035 -235.889)"
          opacity="0.1"
        />
        <path
          d="M693.855,345.69s18.347,9.747,13.657,21.065l-5.848,2.293-7.8-4.289-1.147-10.137.78-7.018Z"
          transform="translate(-407.055 -234.792)"
          fill="#ced2df"
        />
        <path
          d="M693.855,345.69s18.347,9.747,13.657,21.065l-5.848,2.293-7.8-4.289-1.147-10.137.78-7.018Z"
          transform="translate(-407.055 -234.792)"
          opacity="0.1"
        />
        <rect
          width="63.974"
          height="48.367"
          rx="21.09"
          transform="translate(129.211 10.253)"
          fill="#88455e"
        />
        <path
          d="M482.19,351.979l-13.657,21.787-1.147-3.876-18.553-60.453a9.3,9.3,0,0,1,.287-6.272c4.69-11.4,21.225-49.308,27.222-31.591,7.018,20.64-12.1,42.909-12.1,42.909,2.179,18.072,12.327,31.167,16.317,35.708C481.571,351.372,482.19,351.979,482.19,351.979Z"
          transform="translate(-442.89 -246.345)"
          fill="#ec8c9c"
        />
        <path
          d="M691.16,358.134s21.455-20.285,20.64-28.472c0,0-20.285-32.761-10.137-40.134,8.027-5.871,20.216,23.714,24.94,36.293a12.269,12.269,0,0,1-.814,10.32l-25.64,45.4Z"
          transform="translate(-407.284 -243.142)"
          fill="#ec8c9c"
        />
        <path
          d="M571.237,299.946s3.9,24.963-7.408,34.332,32.383,9.311,32.383,9.311l15.606-14.437s-17.946-16.776-12.487-29.252Z"
          transform="translate(-426.236 -241.509)"
          fill="#ec8c9c"
        />
        <path
          d="M573.49,324.969s16.776,12.487,33.541-1.559l27.3,56.566-1.56,69.042s-56.566,29.252-79.97,11.318-3.9-27.3-3.9-27.3l-5.458-53.046,5.848-34.332s10.527-16.386,11.318-16.386S573.49,324.969,573.49,324.969Z"
          transform="translate(-429.268 -238.06)"
          opacity="0.1"
        />
        <path
          d="M573.488,324.289s16.776,12.51,33.552-1.559l27.3,56.566-1.56,69.042s-56.566,29.252-79.97,11.318-3.9-27.3-3.9-27.3l-5.458-53.046,5.848-34.332s10.527-16.386,11.318-16.386S573.488,324.289,573.488,324.289Z"
          transform="translate(-429.267 -238.16)"
          fill="#ebf1f6"
        />
        <path
          d="M585.139,319s-15.9,9.059-33.174,8.612a12.224,12.224,0,0,0-8.818,3.371c-4.919,4.724-13.531,12.2-18.863,12.2-1.147,0-34.332,6.628-34.332,6.628l-8.772-8.772s-13.072,25.548-19.31,24.379l11.318,14.827s21.455,9.357,49.537-1.949h16.386l8.577,26.523s-4.289,35.891-7.8,43.689,1.147,23.014,1.147,23.014l30.811-1.147s1.56-15.217,3.9-17.2-8.187-69.042-8.187-69.042-7.018-37.841,18.725-51.486Z"
          transform="translate(-440.917 -238.707)"
          opacity="0.1"
        />
        <path
          d="M562.567,439.38a101.84,101.84,0,0,0-2.42,14.07l-23.587.894c3.153-6.616,5.263-10.653,5.263-10.653Z"
          transform="translate(-429.961 -221.049)"
          opacity="0.1"
        />
        <path
          d="M479.764,341.33l-13.657,21.787-1.147-3.876c5.011-4.977,10.882-15.377,13.221-19.712A23.107,23.107,0,0,0,479.764,341.33Z"
          transform="translate(-440.464 -235.696)"
          opacity="0.1"
        />
        <path
          d="M585.243,319s-16.7,9.059-33.953,8.612a12.223,12.223,0,0,0-8.818,3.371c-4.919,4.724-13.531,12.2-18.863,12.2-1.147,0-34.332,6.628-34.332,6.628l-8.807-8.784s-13.072,25.548-19.31,24.379l11.318,14.827s21.455,9.357,49.537-1.949H538.4l8.577,26.511s-4.289,35.891-7.8,43.689,1.147,23.014,1.147,23.014l30.812-1.147s1.559-15.217,3.9-17.2-8.187-69.042-8.187-69.042-7.018-37.841,18.725-51.486Z"
          transform="translate(-441.022 -238.707)"
          fill="#ced2df"
        />
        <path
          d="M599.318,316.94s15.916,12.132,37.164,13.531a11.3,11.3,0,0,1,6.364,2.465,61.6,61.6,0,0,1,13.428,16.054c8.577,14.047,29.642,12.487,29.642,12.487s20.48-6.433,21.649-11.467c0,0,.585,27.52,13.462,20.87L704.091,390.4a11.948,11.948,0,0,1-8.543,4.117c-6.364.252-17.418.333-26.752-1.479-14.047-2.729-24.184-9.357-31.591-3.509,0,0-9.747,30.422-3.119,41.35s18.347,29.252,12.877,33.942-12.1,4.289-23.014-7.018-12.1-30.422-12.1-30.422l2.729-49.147s-10.527-37.061-20.64-44.469Z"
          transform="translate(-421.544 -239.01)"
          opacity="0.1"
        />
        <path
          d="M722.382,370.339l-16.982,19.6a11.937,11.937,0,0,1-4.094,3.05h0a11.892,11.892,0,0,1-4.426,1.043c-6.364.264-17.418.344-26.752-1.479-13.141-2.557-22.865-8.52-30.135-4.5a10.652,10.652,0,0,0-1.468.975s-9.747,30.422-3.119,41.35,18.347,29.252,12.877,33.942a12.613,12.613,0,0,1-3.05,1.984c-4.908,2.213-11,.3-19.964-9-10.917-11.318-12.1-30.422-12.1-30.422l2.729-49.147s-10.527-37.061-20.64-44.469l4.461-16c3.073,2.087,18.416,11.891,37.382,13.141a11.3,11.3,0,0,1,6.364,2.465,61.646,61.646,0,0,1,13.428,16.054c8.577,14.047,29.642,12.487,29.642,12.487a113.832,113.832,0,0,0,14.758-5.871h0c2.993-1.468,5.63-3.073,6.88-4.587a3.44,3.44,0,0,0,.745-1.376S709.516,376.967,722.382,370.339Z"
          transform="translate(-421.351 -238.961)"
          opacity="0.1"
        />
        <path
          d="M721.706,370.776,704.735,390.4a11.936,11.936,0,0,1-3.3,2.66h0a11.9,11.9,0,0,1-5.206,1.433c-6.364.264-17.418.344-26.752-1.479-12.671-2.465-22.177-8.107-29.344-4.885a10.606,10.606,0,0,0-2.293,1.365s-9.747,30.422-3.119,41.35,18.347,29.252,12.877,33.942a13.531,13.531,0,0,1-2.293,1.594c-5.045,2.786-11.283,1.147-20.744-8.612-10.917-11.318-12.1-30.422-12.1-30.422l2.729-49.147s-10.527-37.061-20.64-44.469l4.679-16.776.562.39c3.073,2.087,18.416,11.891,37.382,13.141a11.3,11.3,0,0,1,6.364,2.465A61.648,61.648,0,0,1,656.964,349c8.577,14.047,29.642,12.487,29.642,12.487a113.848,113.848,0,0,0,14.758-5.871h0c3.543-1.812,6.433-3.8,6.88-5.607V351C708.588,355.731,710.308,376.635,721.706,370.776Z"
          transform="translate(-421.455 -239.008)"
          fill="#ced2df"
        />
        <path
          d="M598.517,300.45H569.85a70.145,70.145,0,0,1,.539,13.76,29.47,29.47,0,0,0,30.3,2.179C597.932,311.3,596.258,305.518,598.517,300.45Z"
          transform="translate(-425.078 -241.428)"
          opacity="0.1"
        />
        <circle
          cx="28.472"
          cy="28.472"
          r="28.472"
          transform="translate(133.695 20.596)"
          fill="#ec8c9c"
        />
        <path
          d="M582.713,292.456c3.176-.378,6.353-1.5,9.483-.871,2.844.573,5.263,2.534,8.107,3.13,5.481,1.147,10.572-2.89,14.712-6.651l8.944-8.141c1.984-1.8,4.025-3.692,5.045-6.169s.665-5.733-1.514-7.293c-3.268-2.293-8.9,0-11.26-3.257-1.066-1.468-.906-3.44-1.456-5.194-1.147-3.509-5.091-5.424-8.784-5.47s-7.224,1.307-10.756,2.293a61.922,61.922,0,0,1-22.934,2.19,14.654,14.654,0,0,0-6.272.218,8.772,8.772,0,0,0-5.091,6.043c-1.766,6.238,1.25,16.294,4.277,21.879S576.67,293.2,582.713,292.456Z"
          transform="translate(-426.462 -248.456)"
          opacity="0.1"
        />
        <path
          d="M582.713,291.776c3.176-.378,6.353-1.5,9.483-.871,2.844.573,5.263,2.534,8.107,3.13,5.481,1.147,10.572-2.89,14.712-6.651l8.944-8.141c1.984-1.8,4.025-3.692,5.045-6.169s.665-5.733-1.514-7.293c-3.268-2.293-8.9,0-11.26-3.257-1.066-1.468-.906-3.44-1.456-5.194-1.147-3.509-5.091-5.424-8.784-5.47s-7.224,1.307-10.756,2.293a61.921,61.921,0,0,1-22.934,2.19,14.654,14.654,0,0,0-6.272.218,8.772,8.772,0,0,0-5.091,6.043c-1.766,6.238,1.25,16.294,4.277,21.879S576.67,292.464,582.713,291.776Z"
          transform="translate(-426.462 -248.556)"
          fill="#88455e"
        />
        <path
          d="M536.55,394s6.238.78,9.357,4.678,8.577,5.068,8.577,5.068"
          transform="translate(-429.963 -227.706)"
          opacity="0.1"
        />
        <path
          d="M487.588,349.09s5.091,11.364,1.949,12.51-1.949,9.357-1.949,9.357"
          transform="translate(-437.177 -234.294)"
          opacity="0.1"
        />
        <g transform="translate(51.81 80.476)" opacity="0.1">
          <path
            d="M489.135,348.479s33.151-6.628,34.3-6.628c5.344,0,13.944-7.476,18.863-12.2a12.04,12.04,0,0,1,5.344-2.97h-.424a12.223,12.223,0,0,0-8.818,3.371c-4.919,4.724-13.531,12.2-18.863,12.2-.929,0-22.143,4.208-30.754,5.917Z"
            transform="translate(-488.78 -318.058)"
          />
          <path
            d="M572.661,320.616V319.16a82.771,82.771,0,0,1-25.411,8.13,78.525,78.525,0,0,0,25.411-6.674Z"
            transform="translate(-480.203 -319.16)"
          />
          <path
            d="M536.133,463.746s-4.679-15.217-1.147-23.014,7.8-43.689,7.8-43.689L534.23,370.52H517.8l-1,.39h13.474l8.543,26.534s-4.289,35.891-7.8,43.689,1.147,23.014,1.147,23.014L562.977,463v-.241Z"
            transform="translate(-484.67 -311.626)"
          />
        </g>
        <g transform="translate(191.396 131.79)" opacity="0.1">
          <path
            d="M645.645,444.938a13.531,13.531,0,0,1-2.293,1.594c-5.045,2.786-11.283,1.147-20.744-8.612-8.669-8.979-11.192-22.934-11.868-28.22l-.229,4.036s1.147,19.115,12.1,30.422c9.46,9.793,15.7,11.4,20.744,8.612a13.527,13.527,0,0,0,2.293-1.594c1.64-1.41,1.732-4.059.872-7.362A3.613,3.613,0,0,1,645.645,444.938Z"
            transform="translate(-610.51 -357.193)"
          />
          <path
            d="M711.3,364.472l-11.043,12.763a11.935,11.935,0,0,1-3.3,2.66h0a11.9,11.9,0,0,1-5.206,1.433c-6.364.264-17.418.344-26.752-1.479-12.671-2.465-22.177-8.107-29.344-4.885a10.605,10.605,0,0,0-2.293,1.365s-6.3,19.654-5.332,33.036c.745-12.51,5.332-26.8,5.332-26.8a10.6,10.6,0,0,1,2.293-1.365c7.178-3.222,16.673,2.419,29.344,4.885,9.334,1.812,20.377,1.732,26.752,1.479a11.9,11.9,0,0,0,5.206-1.433h0a11.935,11.935,0,0,0,3.3-2.626l16.982-19.6a6.685,6.685,0,0,1-5.94.562Z"
            transform="translate(-607.956 -363.91)"
          />
        </g>
      </g>
    </g>
  </svg>
)

export const SendIcon = () => (
  <svg
    width="16.195"
    height="16.241"
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 27 27"
  >
    <path d="M26,3.47a.6.6,0,0,0-.63-.09L1.15,13.89a.59.59,0,0,0-.36.58.6.6,0,0,0,.43.54l8.63,2.56v5.5a.59.59,0,0,0,.35.54.57.57,0,0,0,.25.06.62.62,0,0,0,.39-.14l5-4.18L21.35,21l.17,0a.61.61,0,0,0,.3-.08.62.62,0,0,0,.29-.38L26.19,4.07A.59.59,0,0,0,26,3.47ZM11.05,21.79V17.92l3.43,1Zm10-2.15-9.36-2.77L21.67,9a.59.59,0,0,0,.09-.84.6.6,0,0,0-.84-.1l-10.6,8.42L3.14,14.33,24.74,5Z" />
  </svg>
)

export const CancelIcon = () => (
  <svg
    width="16.195"
    height="16.241"
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 27 27"
  >
    <path d="M14.3,13.57l9.78-9.78a.57.57,0,0,0,0-.8.56.56,0,0,0-.79,0L13.5,12.78,3.71,3a.56.56,0,0,0-.79,0,.57.57,0,0,0,0,.8l9.78,9.78L2.92,23.36a.57.57,0,0,0,0,.8.54.54,0,0,0,.39.16.55.55,0,0,0,.4-.16l9.79-9.79,9.79,9.79a.54.54,0,0,0,.39.16.55.55,0,0,0,.4-.16.57.57,0,0,0,0-.8Z" />
  </svg>
)

export const ImageNotPhoto = () => (
  <svg
    id="Layer_1"
    width="16.195"
    height="16.241"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 27 27"
  >
    <path d="M17.5,6.63a2.63,2.63,0,1,0,2.63,2.63A2.63,2.63,0,0,0,17.5,6.63Zm0,4.07a1.44,1.44,0,1,1,1.43-1.44A1.44,1.44,0,0,1,17.5,10.7Z" />
    <path d="M24,4.25H3A2.26,2.26,0,0,0,.77,6.51v14A2.26,2.26,0,0,0,3,22.75H24a2.26,2.26,0,0,0,2.26-2.26v-14A2.26,2.26,0,0,0,24,4.25ZM25,20.49A1.07,1.07,0,0,1,24,21.55H3A1.07,1.07,0,0,1,2,20.49v-3l7.38-6.22L16,17.65a.61.61,0,0,0,.76.06L21,14.8l4.08,3Zm0-4.16-3.71-2.75a.6.6,0,0,0-.7,0l-4.14,2.88L9.79,10A.62.62,0,0,0,9,10L2,15.93V6.51A1.07,1.07,0,0,1,3,5.45H24A1.07,1.07,0,0,1,25,6.51Z" />
  </svg>
)

export const HomeIcon = () => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    width="28"
    height="30"
    style={{ fill: 'white' }}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 27 27"
  >
    <path d="M26,11.52,24.25,10a.6.6,0,0,0-.4-.34L13.84.87a.6.6,0,0,0-.79,0L3.13,9.6a.61.61,0,0,0-.42.38L1,11.52a.61.61,0,0,0,0,.85.6.6,0,0,0,.85.05l.92-.81V25.68a.6.6,0,0,0,.6.6H10.9a.6.6,0,0,0,.6-.6V19.13h3.88v6.55a.6.6,0,0,0,.6.6h7.71a.6.6,0,0,0,.6-.6V11.58l1,.85a.62.62,0,0,0,.85-.06A.6.6,0,0,0,26,11.52ZM23.09,25.08H16.58V18.53a.6.6,0,0,0-.6-.6H10.9a.6.6,0,0,0-.6.6v6.55H3.87V10.56l9.58-8.44,9.64,8.42Z" />
  </svg>
)

export const ReturnIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 50 50" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M36.6429 0C39.3214 0 41.7857 1.60714 42.8571 4.17857L47.3571 14.1429C47.7857 15 48 15.9643 48 16.9286V19.7782C47.544 19.3717 46.9496 19.1199 46.3125 19.1199H44.625C43.9292 19.1199 43.312 19.3959 42.8571 19.833V18.8571H5.14286V41.1429C5.14286 42.1071 5.89286 42.8571 6.85714 42.8571H29.2797C29.383 42.872 29.4885 42.8799 29.5957 42.8799C29.7096 42.8799 29.8222 42.8722 29.9328 42.8571H41.1429C42 42.8571 42.8571 42.1071 42.8571 41.1429V36.9134C45.047 36.6631 46.9463 35.3506 48 33.4931V41.1429C48 45 44.8929 48 41.1429 48H6.85714C3 48 0 45 0 41.1429V16.9286C0 15.9643 0.107143 15 0.535714 14.1429L5.03571 4.17857C6.10714 1.60714 8.57143 0 11.25 0H36.6429ZM36.6429 5.14286H26.5714V13.7143H41.5714L38.25 6.21429C37.9286 5.57143 37.2857 5.14286 36.6429 5.14286ZM6.32143 13.7143H21.4286V5.14286H11.25C10.6071 5.14286 9.96429 5.57143 9.64286 6.21429L6.32143 13.7143Z"
      fill="black"
      className="MuiSvgIcon-root"
    />
    <path
      d="M21.199 34.3272L28.4844 41.6333L28.4898 41.6382C28.8169 41.9116 29.2036 42.0799 29.5957 42.0799C30.4802 42.0799 31.205 41.4129 31.205 40.5192V36.1568H42.0938C45.3545 36.1568 48.08 33.477 48.08 30.1538V21.6922C48.08 20.7492 47.2534 19.9199 46.3125 19.9199H44.625C43.6298 19.9199 42.8575 20.7509 42.8575 21.6922V30.1538C42.8575 30.5826 42.4745 30.9199 42.0938 30.9199H31.205V26.6105C31.205 25.7204 30.4839 24.9968 29.5957 24.9968C29.2025 24.9968 28.8137 25.1661 28.4844 25.4963L21.2071 32.7944C21.0322 32.9698 20.92 33.2554 20.92 33.5384C20.92 33.8781 21.034 34.1065 21.199 34.3272Z"
      fill="black"
      className="MuiSvgIcon-root"
    />
  </svg>
)

export const OrderIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19.588"
    height="22.022"
    viewBox="0 0 19.588 22.022"
  >
    <g id="pedidos" transform="translate(-559.899 -562.997)">
      <path
        id="Trazado_5670"
        data-name="Trazado 5670"
        d="M314.487,292.7A3.711,3.711,0,0,0,310.78,289H298.606A3.711,3.711,0,0,0,294.9,292.7v1.217a1.273,1.273,0,0,1,0,1.217v12.174a3.711,3.711,0,0,0,3.707,3.707H310.78a3.711,3.711,0,0,0,3.707-3.707V295.138a1.274,1.274,0,0,1,0-1.217Z"
        transform="translate(265 274)"
      />
      <path
        id="Trazado_5671"
        data-name="Trazado 5671"
        d="M316.942,296.432v1.217H299.9v-1.217A2.434,2.434,0,0,1,302.334,294h12.174a2.436,2.436,0,0,1,2.435,2.435M299.9,298.866h17.043V311.04a2.434,2.434,0,0,1-2.435,2.435H302.334a2.435,2.435,0,0,1-2.435-2.435Zm3.652,3.652a.61.61,0,0,0,.609.608h8.521a.609.609,0,1,0,0-1.217H304.16a.61.61,0,0,0-.609.609m0,3.652a.61.61,0,0,0,.609.609h8.521a.609.609,0,1,0,0-1.217H304.16a.61.61,0,0,0-.609.608m0,3.652a.611.611,0,0,0,.609.609h3.652a.609.609,0,0,0,0-1.217H304.16a.611.611,0,0,0-.609.609"
        transform="translate(261.272 270.272)"
        fill="#fff"
      />
    </g>
  </svg>
)

export const ChevronLeftIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" {...props}>
    <path d="M5.85938 13.4621L0.273438 7.52461C0.117188 7.32929 0 7.09492 0 6.86054C0 6.66523 0.117188 6.43086 0.273438 6.23554L5.85938 0.298044C6.21094 -0.0925806 6.79688 -0.0925806 7.1875 0.258982C7.57812 0.610544 7.57812 1.19648 7.22656 1.58711L2.1875 6.89961L7.22656 12.173C7.57812 12.5637 7.57812 13.1496 7.1875 13.5012C6.79688 13.8527 6.21094 13.8527 5.85938 13.4621Z" />
  </svg>
)

export const ProductIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21">
    <g id="Grupo_529" data-name="Grupo 529" transform="translate(-845.006 -564.802)">
      <path
        id="Trazado_5668"
        data-name="Trazado 5668"
        d="M600.82,298a1.266,1.266,0,0,0,.052-1.225l-2.092-4.187a3.236,3.236,0,0,0-2.9-1.789h-4.712a1.267,1.267,0,0,1-1.319,0h-4.713a3.227,3.227,0,0,0-2.9,1.794l-2.091,4.183a3.043,3.043,0,0,1-.133,1.885V307.9a3.909,3.909,0,0,0,3.9,3.9H597.1a3.909,3.909,0,0,0,3.9-3.9v-9.234a1.261,1.261,0,0,0-.185-.66"
        transform="translate(265 274)"
      />
      <path
        id="Trazado_5669"
        data-name="Trazado 5669"
        d="M587.1,296.9a1.978,1.978,0,0,1,1.77-1.093h4.713v5.276h-8.574Zm16.376,14.736a2.641,2.641,0,0,1-2.638,2.638H587.644a2.639,2.639,0,0,1-2.638-2.638V302.4h18.468ZM594.9,301.078V295.8h4.712a1.985,1.985,0,0,1,1.772,1.093l2.09,4.183Z"
        transform="translate(261.266 270.266)"
        fill="#fff"
      />
    </g>
  </svg>
)

export const SetupIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22.773" height="24" viewBox="0 0 22.773 24">
    <g id="configurar" transform="translate(-1134.606 -564.252)">
      <path
        id="Trazado_5666"
        data-name="Trazado 5666"
        d="M880.955,314.252a11.913,11.913,0,0,1-1.953-.164c-.038-.006-.075-.014-.112-.024a2.293,2.293,0,0,1-1.688-1.705l-.388-1.775a9.511,9.511,0,0,1-.949-.55l-1.722.551a2.294,2.294,0,0,1-.693.108,2.211,2.211,0,0,1-1.705-.792,12.4,12.4,0,0,1-1.04-1.472l-.207-.357a11.84,11.84,0,0,1-.752-1.63,2.217,2.217,0,0,1,.6-2.418l1.344-1.224c-.011-.183-.016-.366-.016-.548s.005-.365.016-.548l-1.34-1.221a2.225,2.225,0,0,1-.6-2.421,11.786,11.786,0,0,1,.742-1.612l.206-.357a12.247,12.247,0,0,1,1.047-1.482,2.208,2.208,0,0,1,1.709-.8,2.281,2.281,0,0,1,.693.109l1.722.549a9.373,9.373,0,0,1,.951-.551l.387-1.769a2.222,2.222,0,0,1,1.8-1.734,12.122,12.122,0,0,1,3.981,0,2.221,2.221,0,0,1,1.8,1.732l.39,1.78a10.36,10.36,0,0,1,.944.543l1.728-.551a2.269,2.269,0,0,1,.692-.109,2.215,2.215,0,0,1,1.7.79,12.173,12.173,0,0,1,1.043,1.473s.216.372.22.38a11.962,11.962,0,0,1,.736,1.609,2.212,2.212,0,0,1-.594,2.412L890.3,301.7q.016.276.017.548c0,.181-.006.364-.017.548l1.341,1.22a2.223,2.223,0,0,1,.6,2.433,11.967,11.967,0,0,1-.732,1.6l-.211.365a12.375,12.375,0,0,1-1.042,1.479,2.229,2.229,0,0,1-1.714.8,2.27,2.27,0,0,1-.689-.107l-1.73-.553a10.692,10.692,0,0,1-.943.542l-.39,1.78a2.3,2.3,0,0,1-1.689,1.71c-.037.009-.074.017-.112.024a12.21,12.21,0,0,1-2.028.164"
        transform="translate(265 274)"
      />
      <path
        id="Trazado_5667"
        data-name="Trazado 5667"
        d="M894.241,301.7a.95.95,0,0,1-.264,1.03l-1.814,1.65a7.96,7.96,0,0,1,0,2.128l1.814,1.65a.951.951,0,0,1,.264,1.03,10.613,10.613,0,0,1-.657,1.437l-.2.339a11.025,11.025,0,0,1-.925,1.311.958.958,0,0,1-1.026.285l-2.333-.745a9.165,9.165,0,0,1-1.843,1.068l-.524,2.392a1,1,0,0,1-.762.745,10.921,10.921,0,0,1-1.818.147,10.689,10.689,0,0,1-1.742-.147,1,1,0,0,1-.762-.745l-.523-2.392a8.233,8.233,0,0,1-1.843-1.068l-2.331.745a.956.956,0,0,1-1.026-.285,10.966,10.966,0,0,1-.926-1.311l-.2-.339a10.459,10.459,0,0,1-.661-1.437.952.952,0,0,1,.266-1.03l1.812-1.65a8.083,8.083,0,0,1,0-2.128l-1.812-1.65a.949.949,0,0,1-.266-1.03,10.5,10.5,0,0,1,.661-1.436l.2-.339a10.836,10.836,0,0,1,.926-1.309.951.951,0,0,1,1.026-.285l2.331.744a8.067,8.067,0,0,1,1.843-1.067l.523-2.392a.95.95,0,0,1,.762-.746,10.844,10.844,0,0,1,3.56,0,.95.95,0,0,1,.762.746l.524,2.392a8.959,8.959,0,0,1,1.843,1.067l2.333-.744a.954.954,0,0,1,1.026.285,10.864,10.864,0,0,1,.925,1.309l.2.339a10.625,10.625,0,0,1,.657,1.436M884.194,308.8a3.369,3.369,0,1,0-3.351-3.388,3.358,3.358,0,0,0,3.351,3.388"
        transform="translate(261.799 270.803)"
        fill="#fff"
      />
    </g>
  </svg>
)
export const CheckCorrect = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="69.75" height="69.75" viewBox="0 0 69.75 69.75">
    <path
      id="Trazado_5678"
      data-name="Trazado 5678"
      d="M36-61.875A34.875,34.875,0,0,0,1.125-27,34.875,34.875,0,0,0,36,7.875,34.875,34.875,0,0,0,70.875-27,34.875,34.875,0,0,0,36-61.875Zm0,65.25A30.373,30.373,0,0,1,5.625-27,30.373,30.373,0,0,1,36-57.375,30.373,30.373,0,0,1,66.375-27,30.373,30.373,0,0,1,36,3.375ZM55.917-35.291a1.687,1.687,0,0,0,.01-2.386l-1.188-1.2a1.687,1.687,0,0,0-2.386-.009l-22.984,22.8-9.7-9.778a1.688,1.688,0,0,0-2.386-.01l-1.2,1.188a1.687,1.687,0,0,0-.01,2.386L28.15-10.125a1.688,1.688,0,0,0,2.386.01Z"
      transform="translate(-1.125 61.875)"
      fill="#3ad399"
    />
  </svg>
)
export const LogoSellerCenterForm = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="248" height="46.196" viewBox="0 0 248 46.196">
    <g id="logo" transform="translate(-188.483 -266.745)">
      <rect
        id="Rectángulo_97"
        data-name="Rectángulo 97"
        width="5.625"
        height="21.297"
        transform="translate(188.483 271.099)"
        fill="#0d0c0e"
      />
      <path
        id="Trazado_457"
        data-name="Trazado 457"
        d="M218.16,280.435V289.9a8.348,8.348,0,1,1-16.7,0v-9.468h5.624V289.9a2.723,2.723,0,1,0,5.447,0v-9.468Z"
        transform="translate(-5.264 -5.552)"
        fill="#0d0c0e"
      />
      <path
        id="Trazado_458"
        data-name="Trazado 458"
        d="M251.045,291.063H239.306a3.193,3.193,0,0,0,2.746,1.425,3.229,3.229,0,0,0,2.4-1.024l3.977,3.992a8.992,8.992,0,1,1,2.612-6.352Zm-6.263-3.918a3.364,3.364,0,0,0-5.476,0Z"
        transform="translate(-18.07 -5.42)"
        fill="#0d0c0e"
      />
      <path
        id="Trazado_459"
        data-name="Trazado 459"
        d="M284.8,280.329v17.245a9.019,9.019,0,0,1-8.993,9.009v-5.639a3.37,3.37,0,0,0,3.369-3.37v-.089a9.008,9.008,0,1,1,0-16.68v-.475ZM275.8,292.513a3.37,3.37,0,1,0-2.389-.98,3.283,3.283,0,0,0,2.389.98"
        transform="translate(-31.757 -5.43)"
        fill="#0d0c0e"
      />
      <path
        id="Trazado_460"
        data-name="Trazado 460"
        d="M303.215,295.5a8.975,8.975,0,1,1,6.367,2.641,8.674,8.674,0,0,1-6.367-2.641m3.977-8.741a3.206,3.206,0,0,0-.995,2.374,3.4,3.4,0,0,0,3.384,3.384,3.213,3.213,0,0,0,2.374-.995,3.259,3.259,0,0,0,.995-2.39,3.4,3.4,0,0,0-3.368-3.368,3.257,3.257,0,0,0-2.39.994"
        transform="translate(-45.455 -5.43)"
        fill="#0d0c0e"
      />
      <path
        id="Trazado_461"
        data-name="Trazado 461"
        d="M343.382,280.161a9,9,0,0,1,0,18A9.034,9.034,0,0,1,340,297.51v5.357h-5.624V280.339H340v.475a9.035,9.035,0,0,1,3.384-.653m0,12.362a3.369,3.369,0,1,0-2.39-.98,3.285,3.285,0,0,0,2.39.98"
        transform="translate(-59.162 -5.44)"
        fill="#0d0c0e"
      />
      <path
        id="Trazado_462"
        data-name="Trazado 462"
        d="M386.152,280.263V297.8h-5.624v-.371a8.922,8.922,0,0,1-3.369.653,9,9,0,0,1,0-18,8.922,8.922,0,0,1,3.369.653v-.475Zm-8.993,12.2a3.212,3.212,0,0,0,2.374-.994,3.262,3.262,0,0,0,.995-2.39,3.4,3.4,0,0,0-3.369-3.369,3.26,3.26,0,0,0-2.39.995,3.212,3.212,0,0,0-.994,2.374,3.394,3.394,0,0,0,3.384,3.384"
        transform="translate(-72.859 -5.41)"
        fill="#0d0c0e"
      />
      <path
        id="Trazado_463"
        data-name="Trazado 463"
        d="M485.978,303.233a3.243,3.243,0,1,1,.95,2.3,3.13,3.13,0,0,1-.95-2.3"
        transform="translate(-120.641 -13.479)"
        fill="#0d0c0e"
      />
      <path
        id="Trazado_464"
        data-name="Trazado 464"
        d="M509.165,293.013a3.227,3.227,0,0,0,2.4-1.024l3.977,3.992a9,9,0,1,1-.044-12.733l-3.977,3.977a3.369,3.369,0,0,0-4.749.029,3.211,3.211,0,0,0-.994,2.375,3.395,3.395,0,0,0,3.384,3.384"
        transform="translate(-126.391 -5.633)"
        fill="#0d0c0e"
      />
      <path
        id="Trazado_465"
        data-name="Trazado 465"
        d="M527.538,296a8.976,8.976,0,1,1,6.367,2.641A8.676,8.676,0,0,1,527.538,296m3.977-8.741a3.209,3.209,0,0,0-.994,2.375,3.395,3.395,0,0,0,3.384,3.384,3.211,3.211,0,0,0,2.374-.995,3.261,3.261,0,0,0,.995-2.389,3.4,3.4,0,0,0-3.369-3.369,3.26,3.26,0,0,0-2.39.994"
        transform="translate(-136.423 -5.633)"
        fill="#0d0c0e"
      />
      <path
        id="Trazado_466"
        data-name="Trazado 466"
        d="M578.36,280.56a8.361,8.361,0,0,1,8.355,8.356v9.379h-5.624v-9.379a2.723,2.723,0,1,0-5.447,0v9.379H570.02v-9.379a2.723,2.723,0,1,0-5.447,0v9.379h-5.624V280.753h5.624v.267a8.359,8.359,0,0,1,2.731-.46,8.08,8.08,0,0,1,5.535,2.107,8.027,8.027,0,0,1,5.521-2.107"
        transform="translate(-150.232 -5.602)"
        fill="#0d0c0e"
      />
      <path
        id="Trazado_467"
        data-name="Trazado 467"
        d="M464.122,305.17h0c-.195.049-.394.092-.591.128a1.195,1.195,0,0,0-.47,2.15,1.181,1.181,0,0,0,.684.218,1.257,1.257,0,0,0,.221-.02c.245-.046.492-.1.734-.16a1.194,1.194,0,1,0-.577-2.317"
        transform="translate(-111.142 -15.568)"
        fill="#0d0c0e"
      />
      <path
        id="Trazado_468"
        data-name="Trazado 468"
        d="M476.633,280.749a1.189,1.189,0,0,0-.011.914c.075.187.144.378.208.569a1.182,1.182,0,0,0,.445.6,1.194,1.194,0,0,0,1.822-1.35c-.078-.237-.165-.474-.257-.706a1.194,1.194,0,0,0-2.206-.027"
        transform="translate(-116.812 -5.385)"
        fill="#0d0c0e"
      />
      <path
        id="Trazado_469"
        data-name="Trazado 469"
        d="M469.635,302.774h0c-.168.111-.341.218-.515.319a1.2,1.2,0,0,0-.438,1.631,1.183,1.183,0,0,0,.347.38,1.2,1.2,0,0,0,1.284.058c.216-.124.432-.257.64-.395a1.194,1.194,0,0,0-1.317-1.992"
        transform="translate(-113.562 -14.531)"
        fill="#0d0c0e"
      />
      <path
        id="Trazado_470"
        data-name="Trazado 470"
        d="M480.25,287.395a1.194,1.194,0,1,0-2.386.094c.008.2.01.4,0,.6a1.2,1.2,0,0,0,1.168,1.22h.027a1.193,1.193,0,0,0,1.193-1.168c.005-.25,0-.5-.007-.751"
        transform="translate(-117.35 -7.909)"
        fill="#0d0c0e"
      />
      <path
        id="Trazado_471"
        data-name="Trazado 471"
        d="M475.747,298.452h0a1.194,1.194,0,0,0-1.672.238c-.121.161-.248.32-.378.473a1.2,1.2,0,0,0,.134,1.682l.089.068a1.187,1.187,0,0,0,1.6-.2c.161-.19.319-.388.469-.587a1.2,1.2,0,0,0-.238-1.672"
        transform="translate(-115.545 -12.761)"
        fill="#0d0c0e"
      />
      <path
        id="Trazado_472"
        data-name="Trazado 472"
        d="M478.422,292.605a1.195,1.195,0,0,0-1.5.782c-.06.192-.127.385-.2.574a1.194,1.194,0,0,0,.428,1.4,1.2,1.2,0,0,0,.688.218,1.194,1.194,0,0,0,1.115-.769c.089-.233.171-.471.246-.709a1.2,1.2,0,0,0-.782-1.5"
        transform="translate(-116.858 -10.464)"
        fill="#0d0c0e"
      />
      <path
        id="Trazado_473"
        data-name="Trazado 473"
        d="M442.387,274.23l3.3-.3a1.665,1.665,0,0,0,1.471-2.128l-.886-3.195a1.394,1.394,0,0,0-2.569-.433l-.158.229a13.226,13.226,0,0,0-8.675-1.468c-.322.056-.639.123-.985.21l-.065.016a13,13,0,0,0-7.247,4.842l-.067.084q-.091.124-.18.25c-.1.138-.192.279-.31.465a13.148,13.148,0,0,0-1.879,4.692h-8.67v4.7h5.445a6.238,6.238,0,0,1-2.314,2.9,6.343,6.343,0,1,1-3.613-11.566,6.206,6.206,0,0,1,3.9,1.335l4.787-4.787a13.1,13.1,0,1,0,.587,19.058,13.915,13.915,0,0,0,1.717-2.078,13.2,13.2,0,0,0,1.8,2.251l.064.064a13.474,13.474,0,0,0,1.676,1.4,13.111,13.111,0,0,0,5.272,2.206,2.094,2.094,0,1,0,.739-4.123,8.969,8.969,0,0,1-2.167-.679l-.077-.04c-.159-.074-.317-.154-.491-.249a9.235,9.235,0,0,1-.863-.539,9.04,9.04,0,0,1-2.181-12.582A9.09,9.09,0,0,1,432,272.534a8.975,8.975,0,0,1,9.148-.657l-.072.1a1.422,1.422,0,0,0-.118,1.577,1.443,1.443,0,0,0,1.43.672"
        transform="translate(-86.543 0)"
        fill="#0d0c0e"
      />
      <path
        id="Trazado_474"
        data-name="Trazado 474"
        d="M194.17,329.017a.3.3,0,0,1,.119.123.2.2,0,0,1-.014.181l-.8,1.141a.186.186,0,0,1-.112.093.21.21,0,0,1-.145-.04,1.817,1.817,0,0,0-.514-.271,1.845,1.845,0,0,0-.594-.095,1.719,1.719,0,0,0-1.283.551,1.852,1.852,0,0,0-.37.6,2.063,2.063,0,0,0,0,1.461,1.83,1.83,0,0,0,.37.594,1.744,1.744,0,0,0,.566.4,1.722,1.722,0,0,0,.718.147,1.853,1.853,0,0,0,1.117-.37.221.221,0,0,1,.143-.043l.114.086.813,1.169a.188.188,0,0,1,.014.176.3.3,0,0,1-.119.118,3.737,3.737,0,0,1-.962.464,3.544,3.544,0,0,1-1.086.165A3.645,3.645,0,0,1,189,333.872a3.541,3.541,0,0,1-.366-.866,3.643,3.643,0,0,1,.366-2.8,3.678,3.678,0,0,1,.568-.74,3.528,3.528,0,0,1,.735-.568,3.73,3.73,0,0,1,.867-.366,3.68,3.68,0,0,1,2.044.029,3.7,3.7,0,0,1,.953.459"
        transform="translate(-0.011 -25.002)"
        fill="#0d0c0e"
      />
      <path
        id="Trazado_475"
        data-name="Trazado 475"
        d="M203.293,333.251a3.157,3.157,0,0,1,.112-.842,3.073,3.073,0,0,1,.8-1.375,3.017,3.017,0,0,1,.63-.483,3.182,3.182,0,0,1,1.588-.418,3.1,3.1,0,0,1,2.2.9,3.125,3.125,0,0,1,.665.988,3.072,3.072,0,0,1,.246,1.229,3.107,3.107,0,0,1-.112.839,3.152,3.152,0,0,1-.314.748,3.08,3.08,0,0,1-1.115,1.115,3.1,3.1,0,0,1-1.573.42,3.192,3.192,0,0,1-.839-.109,3.1,3.1,0,0,1-.749-.311,3.093,3.093,0,0,1-1.115-1.115,3.176,3.176,0,0,1-.313-.748,3.131,3.131,0,0,1-.112-.839m1.735,0a1.742,1.742,0,0,0,.1.587,1.421,1.421,0,0,0,.276.473,1.3,1.3,0,0,0,.432.316,1.358,1.358,0,0,0,.573.116,1.3,1.3,0,0,0,.558-.116,1.268,1.268,0,0,0,.423-.316,1.4,1.4,0,0,0,.266-.473,1.882,1.882,0,0,0,0-1.167,1.494,1.494,0,0,0-.266-.485,1.246,1.246,0,0,0-.981-.451,1.315,1.315,0,0,0-.573.121,1.294,1.294,0,0,0-.432.33,1.514,1.514,0,0,0-.276.485,1.73,1.73,0,0,0-.1.58"
        transform="translate(-6.006 -25.705)"
        fill="#0d0c0e"
      />
      <path
        id="Trazado_476"
        data-name="Trazado 476"
        d="M219.2,330.317l.131-.067.13-.014h.718a.331.331,0,0,1,.147.031l.1.083.069.118.05.138.1.417a1.479,1.479,0,0,1,.2-.3,1.459,1.459,0,0,1,.338-.285,2.013,2.013,0,0,1,.487-.211,2.4,2.4,0,0,1,.663-.083,2.265,2.265,0,0,1,.544.059,1.666,1.666,0,0,1,.447.175,1.7,1.7,0,0,1,.369.285,2.692,2.692,0,0,1,.313.386,1.494,1.494,0,0,1,.269-.309,2.2,2.2,0,0,1,.426-.294,2.64,2.64,0,0,1,.551-.218,2.384,2.384,0,0,1,.647-.086,2.035,2.035,0,0,1,.946.209,1.925,1.925,0,0,1,.672.568,2.5,2.5,0,0,1,.4.842,3.852,3.852,0,0,1,.133,1.028V335.9a.41.41,0,0,1-.078.273.308.308,0,0,1-.25.093h-1.1a.425.425,0,0,1-.28-.069.36.36,0,0,1-.077-.269V332.79a1.1,1.1,0,0,0-.064-.38.961.961,0,0,0-.178-.307.792.792,0,0,0-.278-.2.883.883,0,0,0-.364-.073.837.837,0,0,0-.342.071.911.911,0,0,0-.285.2.948.948,0,0,0-.2.3,1.009,1.009,0,0,0-.074.392V335.9a.41.41,0,0,1-.078.273.307.307,0,0,1-.25.093h-1.1a.425.425,0,0,1-.28-.069.36.36,0,0,1-.076-.269V332.79a1.19,1.19,0,0,0-.059-.38.926.926,0,0,0-.171-.307.776.776,0,0,0-.271-.2.89.89,0,0,0-.694-.005.979.979,0,0,0-.295.195,1.108,1.108,0,0,0-.219.3,1.02,1.02,0,0,0-.1.389v3.138a.437.437,0,0,1-.031.161.252.252,0,0,1-.093.124l-.117.052-.125.015h-1.075a.335.335,0,0,1-.385-.366v-5.315a.348.348,0,0,1,.04-.166l.112-.119Z"
        transform="translate(-12.406 -25.709)"
        fill="#0d0c0e"
      />
      <path
        id="Trazado_477"
        data-name="Trazado 477"
        d="M239.933,330.285l.128-.067.128-.014h.718a.347.347,0,0,1,.15.029l.1.079.064.114.05.14.2.575c.089-.114.178-.231.268-.35a1.774,1.774,0,0,1,.321-.323,1.631,1.631,0,0,1,.442-.24,1.809,1.809,0,0,1,.627-.1,2.967,2.967,0,0,1,1.2.24,2.853,2.853,0,0,1,.946.661,3.049,3.049,0,0,1,.621.988,3.491,3.491,0,0,1,0,2.455,3.045,3.045,0,0,1-.621.991,2.887,2.887,0,0,1-.946.663,2.938,2.938,0,0,1-1.2.242,1.7,1.7,0,0,1-.532-.074,1.558,1.558,0,0,1-.4-.192,1.839,1.839,0,0,1-.307-.261q-.133-.143-.262-.285v2.215a.363.363,0,0,1-.085.243.333.333,0,0,1-.266.1h-1.088l-.124-.024-.124-.067-.1-.107-.038-.145v-7.22a.309.309,0,0,1,.036-.156Zm4.44,2.966a1.67,1.67,0,0,0-.1-.577,1.48,1.48,0,0,0-.281-.478,1.331,1.331,0,0,0-.432-.323,1.281,1.281,0,0,0-.556-.119,1.463,1.463,0,0,0-.568.111,1.521,1.521,0,0,0-.471.3,1.569,1.569,0,0,0-.328.454,1.428,1.428,0,0,0-.14.556v.071a1.476,1.476,0,0,0,.118.59,1.5,1.5,0,0,0,.323.477,1.529,1.529,0,0,0,.48.32,1.454,1.454,0,0,0,.584.119,1.282,1.282,0,0,0,.556-.119,1.324,1.324,0,0,0,.432-.32,1.44,1.44,0,0,0,.281-.477,1.718,1.718,0,0,0,.1-.59"
        transform="translate(-20.814 -25.705)"
        fill="#0d0c0e"
      />
      <path
        id="Trazado_478"
        data-name="Trazado 478"
        d="M255.711,330.58a.351.351,0,0,1,.033-.157l.088-.109.124-.064.135-.021h.717a.258.258,0,0,1,.19.071.6.6,0,0,1,.121.181,1.69,1.69,0,0,1,.088.242,2.223,2.223,0,0,0,.09.257c.1-.1.189-.208.282-.309a2.152,2.152,0,0,1,.3-.271,1.487,1.487,0,0,1,.354-.192,1.219,1.219,0,0,1,.44-.074,2.535,2.535,0,0,1,.458.037,1.979,1.979,0,0,1,.383.112,2.232,2.232,0,0,1,.358.188c.119.076.248.165.388.266a.335.335,0,0,1,.2.28.5.5,0,0,1-.081.243l-.433.736a.377.377,0,0,1-.318.186.534.534,0,0,1-.214-.052,1.479,1.479,0,0,0-.416-.3,1.141,1.141,0,0,0-.482-.1.926.926,0,0,0-.326.052.866.866,0,0,0-.254.147,1.319,1.319,0,0,0-.214.228q-.1.133-.2.294V335.9a.385.385,0,0,1-.088.273.39.39,0,0,1-.292.093h-1.069a.326.326,0,0,1-.371-.366Z"
        transform="translate(-27.262 -25.706)"
        fill="#0d0c0e"
      />
      <path
        id="Trazado_479"
        data-name="Trazado 479"
        d="M274.457,335.913a.433.433,0,0,1-.028.155l-.1.116-.123.066-.124.015h-.936a.424.424,0,0,1-.162-.026l-.1-.074-.064-.116c-.017-.046-.036-.1-.055-.15l-.062-.214a2.815,2.815,0,0,1-.293.252,2.217,2.217,0,0,1-.361.221,2.3,2.3,0,0,1-.423.157,1.85,1.85,0,0,1-.468.059,3.124,3.124,0,0,1-.829-.109,3.078,3.078,0,0,1-.741-.311,3.038,3.038,0,0,1-.625-.485,3.1,3.1,0,0,1-.794-1.378,3.2,3.2,0,0,1-.109-.839,3.112,3.112,0,0,1,.9-2.217,3.074,3.074,0,0,1,2.2-.9,2.152,2.152,0,0,1,.549.067,2.115,2.115,0,0,1,.466.18,1.858,1.858,0,0,1,.383.274,2.166,2.166,0,0,1,.3.344l.138-.432c.031-.08.058-.143.078-.193l.067-.109.087-.048a.681.681,0,0,1,.148-.012h.708l.124.014.123.067.1.118a.4.4,0,0,1,.028.152Zm-4.682-2.662a1.74,1.74,0,0,0,.1.587,1.405,1.405,0,0,0,.278.473,1.32,1.32,0,0,0,1,.432,1.489,1.489,0,0,0,.592-.116,1.522,1.522,0,0,0,.475-.316,1.453,1.453,0,0,0,.317-.473,1.548,1.548,0,0,0,0-1.167,1.543,1.543,0,0,0-.317-.485,1.5,1.5,0,0,0-.475-.33,1.443,1.443,0,0,0-.592-.121,1.291,1.291,0,0,0-.564.121,1.324,1.324,0,0,0-.435.33,1.5,1.5,0,0,0-.278.485,1.728,1.728,0,0,0-.1.58"
        transform="translate(-32.272 -25.705)"
        fill="#0d0c0e"
      />
      <path
        id="Trazado_480"
        data-name="Trazado 480"
        d="M292.5,330.746a.37.37,0,0,1,0-.325q.074-.136.325-.136h1.175a.271.271,0,0
         ,1,.195.074.47.47,0,0,1,.114.183l1.345,3.826,1.317-3.826a.382.382,0,0,1,.133-.2.408.408,0,0,1,.223-.052h1.221a.5.5,0,0,1,.209.036l.107.095.021.133-.038.145-.394.977q-.214.531-.445,1.1t-.468,1.165q-.238.591-.464,1.162t-.435,1.1q-.21.525-.382.965t-.3.772q-.127.333-.194.514l.014-.024a.415.415,0,0,1-.119.207.3.3,0,0,1-.209.078h-1.1a.4.4,0,0,1-.292-.084.342.342,0,0,1-.078-.244l.017-.1.026-.043.746-1.939Z"
        transform="translate(-42.164 -25.767)"
        fill="#0d0c0e"
      />
      <path
        id="Trazado_481"
        data-name="Trazado 481"
        d="M313.8,335.913a.423.423,0,0,1-.029.155l-.1.116-.124.066-.124.015H312.5a.424.424,0,0,1-.162-.026l-.1-.074-.064-.116c-.017-.046-.036-.1-.055-.15l-.062-.214a2.864,2.864,0,0,1-.292.252,2.224,2.224,0,0,1-.362.221,2.3,2.3,0,0,1-.423.157,1.845,1.845,0,0,1-.468.059,3.125,3.125,0,0,1-.83-.109,3.084,3.084,0,0,1-2.16-2.175,3.179,3.179,0,0,1-.109-.839,3.108,3.108,0,0,1,.9-2.217,3.074,3.074,0,0,1,2.2-.9,2.147,2.147,0,0,1,.549.067,2.116,2.116,0,0,1,.466.18,1.842,1.842,0,0,1,.383.274,2.171,2.171,0,0,1,.3.344l.138-.432c.032-.08.058-.143.079-.193l.067-.109.088-.048a.674.674,0,0,1,.147-.012h.708l.124.014.124.067.1.118a.388.388,0,0,1,.029.152Zm-4.682-2.662a1.741,1.741,0,0,0,.1.587,1.4,1.4,0,0,0,.278.473,1.318,1.318,0,0,0,1,.432,1.487,1.487,0,0,0,.592-.116,1.532,1.532,0,0,0,.476-.316,1.441,1.441,0,0,0,.316-.473,1.548,1.548,0,0,0,0-1.167,1.531,1.531,0,0,0-.316-.485,1.51,1.51,0,0,0-.476-.33,1.44,1.44,0,0,0-.592-.121,1.291,1.291,0,0,0-.564.121,1.315,1.315,0,0,0-.435.33,1.487,1.487,0,0,0-.278.485,1.729,1.729,0,0,0-.1.58"
        transform="translate(-48.228 -25.705)"
        fill="#0d0c0e"
      />
      <path
        id="Trazado_482"
        data-name="Trazado 482"
        d="M323.906,338a.22.22,0,0,1,.052-.152.2.2,0,0,1,.158-.057h1.258a.229.229,0,0,1,.15.057.188.188,0,0,1,.07.152v1.15a.231.231,0,0,1-.055.152.2.2,0,0,1-.164.067h-1.258q-.21,0-.21-.219Z"
        transform="translate(-54.917 -28.811)"
        fill="#0d0c0e"
      />
      <path
        id="Trazado_483"
        data-name="Trazado 483"
        d="M363.057,335.913a.422.422,0,0,1-.029.155l-.1.116-.123.066-.124.015h-.936a.421.421,0,0,1-.161-.026l-.1-.074-.064-.116q-.027-.07-.055-.15l-.062-.214a2.8,2.8,0,0,1-.292.252,2.174,2.174,0,0,1-.362.221,2.267,2.267,0,0,1-.423.157,1.843,1.843,0,0,1-.468.059,3.116,3.116,0,0,1-.829-.109,3.04,3.04,0,0,1-1.366-.8,3.073,3.073,0,0,1-.794-1.378,3.151,3.151,0,0,1-.111-.839,3.116,3.116,0,0,1,.9-2.217,3.071,3.071,0,0,1,2.195-.9,2.153,2.153,0,0,1,.55.067,2.126,2.126,0,0,1,.466.18,1.838,1.838,0,0,1,.382.274,2.2,2.2,0,0,1,.3.344l.138-.432c.031-.08.057-.143.078-.193l.067-.109.087-.048a.681.681,0,0,1,.148-.012h.708l.124.014.123.067.1.118a.387.387,0,0,1,.029.152Zm-4.682-2.662a1.756,1.756,0,0,0,.1.587,1.406,1.406,0,0,0,.278.473,1.32,1.32,0,0,0,1,.432,1.487,1.487,0,0,0,.592-.116,1.512,1.512,0,0,0,.474-.316,1.433,1.433,0,0,0,.317-.473,1.548,1.548,0,0,0,0-1.167,1.522,1.522,0,0,0-.317-.485,1.491,1.491,0,0,0-.474-.33,1.441,1.441,0,0,0-.592-.121,1.293,1.293,0,0,0-.564.121,1.325,1.325,0,0,0-.435.33,1.5,1.5,0,0,0-.278.485,1.744,1.744,0,0,0-.1.58"
        transform="translate(-68.201 -25.705)"
        fill="#0d0c0e"
      />
      <path
        id="Trazado_484"
        data-name="Trazado 484"
        d="M377.365,336.05a.9.9,0,0,0,.043-.21c.005-.076.009-.155.009-.238v-.064l0-.036,0-.035V335.4c-.092.1-.186.195-.281.29a1.934,1.934,0,0,1-.316.255,1.62,1.62,0,0,1-.392.18,1.709,1.709,0,0,1-.509.069,3.168,3.168,0,0,1-1.188-.219,2.843,2.843,0,0,1-.946-.61,2.756,2.756,0,0,1-.622-.939,3.141,3.141,0,0,1-.224-1.2,3.294,3.294,0,0,1,.224-1.219,3.027,3.027,0,0,1,.622-.989,2.9,2.9,0,0,1,.946-.66,2.93,2.93,0,0,1,1.188-.24,2.042,2.042,0,0,1,.537.067,1.859,1.859,0,0,1,.444.183,1.959,1.959,0,0,1,.369.273,3.563,3.563,0,0,1,.31.333l.132-.423.053-.147.061-.112.1-.069a.426.426,0,0,1,.155-.023h.708l.133.023.122.067.087.109a.331.331,0,0,1,.033.152v4.839a3.385,3.385,0,0,1-.243,1.321,2.768,2.768,0,0,1-1.659,1.588,3.594,3.594,0,0,1-1.235.209,3.692,3.692,0,0,1-.552-.045,4.118,4.118,0,0,1-.587-.136,3.483,3.483,0,0,1-.566-.231,2.31,2.31,0,0,1-.482-.325l-.122-.131a.318.318,0,0,1-.05-.174.459.459,0,0,1,.09-.252l.452-.622.124-.107.123-.036a.489.489,0,0,1,.262.115.939.939,0,0,0,.273.183,1.848,1.848,0,0,0,.319.109,1.969,1.969,0,0,0,.323.052c.106.008.2.013.288.013a1.854,1.854,0,0,0,.448-.058,1.753,1.753,0,0,0,.434-.168,1.5,1.5,0,0,0,.357-.273.861.861,0,0,0,.212-.37m-2.719-2.824a1.76,1.76,0,0,0,.1.592,1.4,1.4,0,0,0,.278.473,1.3,1.3,0,0,0,.435.313,1.357,1.357,0,0,0,.564.114,1.542,1.542,0,0,0,.572-.106,1.467,1.467,0,0,0,.468-.3,1.491,1.491,0,0,0,.321-.446,1.467,1.467,0,0,0,.136-.556v-.157a1.464,1.464,0,0,0-.136-.549,1.572,1.572,0,0,0-.321-.456,1.512,1.512,0,0,0-.468-.314,1.429,1.429,0,0,0-.572-.116,1.289,1.289,0,0,0-.564.121,1.356,1.356,0,0,0-.435.325,1.452,1.452,0,0,0-.278.48,1.729,1.729,0,0,0-.1.58"
        transform="translate(-74.799 -25.699)"
        fill="#0d0c0e"
      />
      <path
        id="Trazado_485"
        data-name="Trazado 485"
        d="M395.1,335.913a.424.424,0,0,1-.029.155l-.1.116-.124.066-.124.015H393.8a.424.424,0,0,1-.162-.026l-.1-.074-.064-.116c-.017-.046-.036-.1-.055-.15l-.062-.214a2.864,2.864,0,0,1-.292.252,2.224,2.224,0,0,1-.362.221,2.3,2.3,0,0,1-.423.157,1.845,1.845,0,0,1-.468.059,3.125,3.125,0,0,1-.83-.109,3.087,3.087,0,0,1-.741-.311,3.056,3.056,0,0,1-.625-.485,3.089,3.089,0,0,1-.794-1.378,3.179,3.179,0,0,1-.109-.839,3.108,3.108,0,0,1,.9-2.217,3.074,3.074,0,0,1,2.2-.9,2.147,2.147,0,0,1,.549.067,2.116,2.116,0,0,1,.466.18,1.841,1.841,0,0,1,.383.274,2.166,2.166,0,0,1,.3.344l.138-.432c.031-.08.058-.143.078-.193l.067-.109.088-.048a.675.675,0,0,1,.147-.012h.708l.124.014.124.067.1.118a.389.389,0,0,1,.029.152Zm-4.682-2.662a1.743,1.743,0,0,0,.1.587,1.4,1.4,0,0,0,.278.473,1.318,1.318,0,0,0,1,.432,1.486,1.486,0,0,0,.591-.116,1.531,1.531,0,0,0,.476-.316,1.44,1.44,0,0,0,.316-.473,1.548,1.548,0,0,0,0-1.167,1.53,1.53,0,0,0-.316-.485,1.509,1.509,0,0,0-.476-.33,1.44,1.44,0,0,0-.591-.121,1.291,1.291,0,0,0-.564.121,1.315,1.315,0,0,0-.435.33,1.487,1.487,0,0,0-.278.485,1.731,1.731,0,0,0-.1.58"
        transform="translate(-81.197 -25.705)"
        fill="#0d0c0e"
      />
      <path
        id="Trazado_486"
        data-name="Trazado 486"
        d="M417.523,334.407l.126-.06.093-.011a.32.32,0,0,1,.147.033.4.4,0,0,1,.138.142l.532.8.045.085.021.076a.242.242,0,0,1-.069.178.888.888,0,0,1-.15.121,3.57,3.57,0,0,1-.853.435,2.919,2.919,0,0,1-.981.164,3.1,3.1,0,0,1-.825-.109,3.038,3.038,0,0,1-.739-.311,3.235,3.235,0,0,1-.628-.485,2.97,2.97,0,0,1-.485-.63,3.247,3.247,0,0,1-.311-.748,3.215,3.215,0,0,1,0-1.681,3.2,3.2,0,0,1,.311-.748,3,3,0,0,1,.485-.627,3.086,3.086,0,0,1,2.191-.9,3.2,3.2,0,0,1,.958.137,2.955,2.955,0,0,1,.825.409l-.014-.014a.563.563,0,0,1,.166.145.337.337,0,0,1,.062.206.329.329,0,0,1-.057.176l-.423.718a.383.383,0,0,1-.323.232l-.1-.021-.138-.074a2.2,2.2,0,0,0-.449-.225,1.487,1.487,0,0,0-.511-.088,1.252,1.252,0,0,0-.551.121,1.3,1.3,0,0,0-.43.331,1.541,1.541,0,0,0-.278.485,1.682,1.682,0,0,0-.1.579,1.7,1.7,0,0,0,.1.587,1.451,1.451,0,0,0,.278.473,1.309,1.309,0,0,0,.43.316,1.291,1.291,0,0,0,.551.116,1.354,1.354,0,0,0,.509-.095,2.268,2.268,0,0,0,.451-.243"
        transform="translate(-91.238 -25.706)"
        fill="#0d0c0e"
      />
      <path
        id="Trazado_487"
        data-name="Trazado 487"
        d="M432.957,336.25l-.131.067-.13.015h-.718a.323.323,0,0,1-.147-.032l-.1-.083-.071-.118-.048-.137-.1-.465a1.173,1.173,0,0,1-.237.31,1.939,1.939,0,0,1-.411.3,2.606,2.606,0,0,1-.564.227,2.537,2.537,0,0,1-.694.09,2.116,2.116,0,0,1-.96-.209,2.066,2.066,0,0,1-.706-.57,2.511,2.511,0,0,1-.435-.844,3.508,3.508,0,0,1-.147-1.029V330.66a.412.412,0,0,1,.079-.273.308.308,0,0,1,.249-.093h1.1a.425.425,0,0,1,.28.07.359.359,0,0,1,.076.269v3.1a.964.964,0,0,0,.079.388,1.091,1.091,0,0,0,.211.324.99.99,0,0,0,.311.221.91.91,0,0,0,.378.081,1.353,1.353,0,0,0,.37-.057,1.2,1.2,0,0,0,.371-.179,1.012,1.012,0,0,0,.285-.311.874.874,0,0,0,.114-.457v-3.092a.459.459,0,0,1,.03-.162.258.258,0,0,1,.093-.124l.117-.052.126-.015H432.7a.335.335,0,0,1,.385.367v5.319a.35.35,0,0,1-.04.166l-.112.119Z"
        transform="translate(-96.867 -25.77)"
        fill="#0d0c0e"
      />
      <path
        id="Trazado_488"
        data-name="Trazado 488"
        d="M448.69,335.913a.436.436,0,0,1-.028.155l-.1.116-.123.066-.124.015h-.936a.424.424,0,0,1-.162-.026l-.1-.074-.065-.116c-.017-.046-.035-.1-.054-.15l-.062-.214a2.879,2.879,0,0,1-.292.252,2.217,2.217,0,0,1-.361.221,2.3,2.3,0,0,1-.423.157,1.85,1.85,0,0,1-.468.059,3.123,3.123,0,0,1-.829-.109,3.077,3.077,0,0,1-.741-.311,3.027,3.027,0,0,1-.625-.485,3.1,3.1,0,0,1-.794-1.378,3.2,3.2,0,0,1-.109-.839,3.112,3.112,0,0,1,.9-2.217,3.043,3.043,0,0,1,.983-.661,3.076,3.076,0,0,1,1.212-.24,2.152,2.152,0,0,1,.549.067,2.117,2.117,0,0,1,.466.18,1.837,1.837,0,0,1,.382.274,2.145,2.145,0,0,1,.3.344l.138-.432c.031-.08.058-.143.078-.193l.067-.109.087-.048a.681.681,0,0,1,.148-.012h.708l.124.014.123.067.1.118a.4.4,0,0,1,.028.152Zm-4.682-2.662a1.742,1.742,0,0,0,.1.587,1.405,1.405,0,0,0,.278.473,1.32,1.32,0,0,0,1,.432,1.491,1.491,0,0,0,.592-.116,1.521,1.521,0,0,0,.475-.316,1.44,1.44,0,0,0,.316-.473,1.547,1.547,0,0,0,0-1.167,1.529,1.529,0,0,0-.316-.485,1.5,1.5,0,0,0-.475-.33,1.445,1.445,0,0,0-.592-.121,1.291,1.291,0,0,0-.564.121,1.324,1.324,0,0,0-.435.33,1.5,1.5,0,0,0-.278.485,1.73,1.73,0,0,0-.1.58"
        transform="translate(-102.927 -25.705)"
        fill="#0d0c0e"
      />
      <path
        id="Trazado_489"
        data-name="Trazado 489"
        d="M458.788,330.317l.131-.067.131-.014h.718a.331.331,0,0,1,.147.031l.1.083.069.118.05.138.1.417a1.122,1.122,0,0,1,.231-.3,1.775,1.775,0,0,1,.394-.285,2.576,2.576,0,0,1,.545-.211,2.682,2.682,0,0,1,.689-.083,2.122,2.122,0,0,1,1.69.777,2.512,2.512,0,0,1,.451.842,3.354,3.354,0,0,1,.155,1.028V335.9a.41.41,0,0,1-.078.273.307.307,0,0,1-.25.093h-1.1a.425.425,0,0,1-.28-.069.359.359,0,0,1-.076-.269v-3.094a.847.847,0,0,0-.093-.388,1.139,1.139,0,0,0-.245-.323,1.173,1.173,0,0,0-.345-.221,1,1,0,0,0-.392-.081.878.878,0,0,0-.35.076,1.159,1.159,0,0,0-.328.212,1.213,1.213,0,0,0-.251.318.925.925,0,0,0-.117.4v3.09a.451.451,0,0,1-.031.161.255.255,0,0,1-.093.124l-.117.052-.126.015h-1.074a.335.335,0,0,1-.385-.366v-5.315a.348.348,0,0,1,.04-.166l.112-.119Z"
        transform="translate(-109.564 -25.709)"
        fill="#0d0c0e"
      />
      <path
        id="Trazado_490"
        data-name="Trazado 490"
        d="M478.084,334.51a3.026,3.026,0,0,1-.292.255,2.407,2.407,0,0,1-.357.225,2.122,2.122,0,0,1-.413.162,1.767,1.767,0,0,1-.468.061,2.891,2.891,0,0,1-1.191-.242,2.852,2.852,0,0,1-.936-.663,3.036,3.036,0,0,1-.613-.991,3.518,3.518,0,0,1,0-2.455,3.042,3.042,0,0,1,.613-.988,2.821,2.821,0,0,1,.936-.661,2.92,2.92,0,0,1,1.191-.24,2.331,2.331,0,0,1,.478.046,1.676,1.676,0,0,1,.394.13,1.711,1.711,0,0,1,.328.2,2.6,2.6,0,0,1,.283.262v-1.983a.378.378,0,0,1,.092-.257.355.355,0,0,1,.278-.1h1.069l.131.026.126.074.093.114.036.147v7.106q0,.367-.385.366h-.932a.372.372,0,0,1-.147-.024l-.088-.069-.064-.114c-.019-.046-.043-.1-.071-.159ZM475.3,332.09a1.743,1.743,0,0,0,.1.587,1.4,1.4,0,0,0,.278.473,1.317,1.317,0,0,0,1,.432,1.5,1.5,0,0,0,.573-.109,1.456,1.456,0,0,0,.468-.3,1.5,1.5,0,0,0,.457-1.015v-.067a1.5,1.5,0,0,0-.114-.58,1.531,1.531,0,0,0-.316-.485,1.5,1.5,0,0,0-.476-.33,1.441,1.441,0,0,0-.592-.121,1.292,1.292,0,0,0-.564.121,1.317,1.317,0,0,0-.435.33,1.488,1.488,0,0,0-.278.485,1.729,1.729,0,0,0-.1.58"
        transform="translate(-115.618 -24.544)"
        fill="#0d0c0e"
      />
      <path
        id="Trazado_491"
        data-name="Trazado 491"
        d="M489.647,333.251a3.157,3.157,0,0,1,.112-.842,3.074,3.074,0,0,1,.8-1.375,3.016,3.016,0,0,1,.629-.483,3.182,3.182,0,0,1,1.588-.418,3.1,3.1,0,0,1,2.2.9,3.124,3.124,0,0,1,.665.988,3.072,3.072,0,0,1,.246,1.229,3.133,3.133,0,0,1-.112.839,3.184,3.184,0,0,1-.315.748,3.079,3.079,0,0,1-1.115,1.115,3.092,3.092,0,0,1-1.573.42,3.193,3.193,0,0,1-.839-.109,3.1,3.1,0,0,1-.749-.311,3.093,3.093,0,0,1-1.115-1.115,3.174,3.174,0,0,1-.313-.748,3.13,3.13,0,0,1-.112-.839m1.735,0a1.726,1.726,0,0,0,.1.587,1.41,1.41,0,0,0,.275.473,1.3,1.3,0,0,0,.432.316,1.359,1.359,0,0,0,.573.116,1.3,1.3,0,0,0,.558-.116,1.263,1.263,0,0,0,.423-.316,1.4,1.4,0,0,0,.266-.473,1.882,1.882,0,0,0,0-1.167,1.5,1.5,0,0,0-.266-.485,1.246,1.246,0,0,0-.982-.451,1.317,1.317,0,0,0-.573.121,1.294,1.294,0,0,0-.432.33,1.5,1.5,0,0,0-.275.485,1.714,1.714,0,0,0-.1.58"
        transform="translate(-122.129 -25.705)"
        fill="#0d0c0e"
      />
      <path
        id="Trazado_492"
        data-name="Trazado 492"
        d="M520,330.285l.088.114a.317.317,0,0,1,.035.156v7.206a.277.277,0,0,1-.038.145l-.095.107-.124.067-.124.023h-1.088a.331.331,0,0,1-.268-.1.367.367,0,0,1-.084-.243v-2.2q-.127.143-.283.285a2.451,2.451,0,0,1-.34.261,1.817,1.817,0,0,1-.4.192,1.457,1.457,0,0,1-.47.074,2.936,2.936,0,0,1-1.2-.242,2.9,2.9,0,0,1-.946-.663,3.044,3.044,0,0,1-.62-.991,3.483,3.483,0,0,1,0-2.455,3.049,3.049,0,0,1,.62-.988,2.868,2.868,0,0,1,.946-.661,2.964,2.964,0,0,1,1.2-.24,1.443,1.443,0,0,1,.53.1,2.113,2.113,0,0,1,.452.24,2.487,2.487,0,0,1,.376.323c.112.119.213.236.3.35l.2-.575a.8.8,0,0,1,.109-.257.272.272,0,0,1,.242-.1h.723l.128.014Zm-4.449,2.966a1.678,1.678,0,0,0,.1.59,1.475,1.475,0,0,0,.282.477,1.332,1.332,0,0,0,.435.32,1.3,1.3,0,0,0,.558.119,1.453,1.453,0,0,0,.585-.119,1.525,1.525,0,0,0,.48-.32,1.493,1.493,0,0,0,.443-1.067v-.071a1.437,1.437,0,0,0-.14-.556,1.531,1.531,0,0,0-.33-.454,1.564,1.564,0,0,0-.471-.3,1.447,1.447,0,0,0-.566-.111,1.3,1.3,0,0,0-.558.119,1.338,1.338,0,0,0-.435.323,1.517,1.517,0,0,0-.282.478,1.63,1.63,0,0,0-.1.577"
        transform="translate(-131.931 -25.705)"
        fill="#0d0c0e"
      />
      <path
        id="Trazado_493"
        data-name="Trazado 493"
        d="M535.644,336.25l-.131.067-.13.015h-.718a.322.322,0,0,1-.147-.032l-.1-.083-.071-.118-.048-.137-.1-.465a1.181,1.181,0,0,1-.238.31,1.942,1.942,0,0,1-.411.3,2.6,2.6,0,0,1-.564.227,2.537,2.537,0,0,1-.694.09,2.116,2.116,0,0,1-.96-.209,2.064,2.064,0,0,1-.706-.57,2.509,2.509,0,0,1-.435-.844,3.509,3.509,0,0,1-.147-1.029V330.66a.412.412,0,0,1,.079-.273.308.308,0,0,1,.249-.093h1.1a.424.424,0,0,1,.28.07.359.359,0,0,1,.076.269v3.1a.965.965,0,0,0,.079.388,1.084,1.084,0,0,0,.212.324.983.983,0,0,0,.311.221.911.911,0,0,0,.378.081,1.357,1.357,0,0,0,.371-.057,1.208,1.208,0,0,0,.37-.179,1.012,1.012,0,0,0,.285-.311.874.874,0,0,0,.114-.457v-3.092a.458.458,0,0,1,.03-.162.258.258,0,0,1,.093-.124l.117-.052.125-.015h1.075a.335.335,0,0,1,.385.367v5.319a.349.349,0,0,1-.04.166l-.112.119Z"
        transform="translate(-138.509 -25.77)"
        fill="#0d0c0e"
      />
      <path
        id="Trazado_494"
        data-name="Trazado 494"
        d="M545.28,326.622a.385.385,0,0,1,.086-.283.37.37,0,0,1,.266-.083h1.1a.412.412,0,0,1,.268.083.346.346,0,0,1,.1.283v.927l-.026.124-.073.128-.117.1a.3.3,0,0,1-.154.041h-1.1c-.235,0-.352-.132-.352-.395Zm0,2.405a.41.41,0,0,1,.086-.262.317.317,0,0,1,.266-.11h1.089l.124.026.124.076.1.117a.282.282,0,0,1,.04.152v5.3a.354.354,0,0,1-.1.273.4.4,0,0,1-.285.093h-1.089q-.352,0-.352-.366Z"
        transform="translate(-144.689 -24.133)"
        fill="#0d0c0e"
      />
      <path
        id="Trazado_495"
        data-name="Trazado 495"
        d="M558.891,335.543a3.15,3.15,0,0,1-.941.6,2.863,2.863,0,0,1-1.108.216,3.234,3.234,0,0,1-2.248-.9,3.142,3.142,0,0,1-.693-.991,2.98,2.98,0,0,1-.257-1.241,3.223,3.223,0,0,1,.392-1.545,3.115,3.115,0,0,1,.457-.63,2.881,2.881,0,0,1,.6-.492,2.954,2.954,0,0,1,.722-.319,2.91,2.91,0,0,1,.822-.114,2.824,2.824,0,0,1,.766.1,3,3,0,0,1,.7.294,3.079,3.079,0,0,1,.6.457,3.132,3.132,0,0,1,.466.582,2.877,2.877,0,0,1,.3.675,2.571,2.571,0,0,1,.107.739c0,.165,0,.3-.008.4a.458.458,0,0,1-.074.249.355.355,0,0,1-.222.128,2.152,2.152,0,0,1-.453.036h-3.422a1.181,1.181,0,0,0,.192.508,1.216,1.216,0,0,0,.336.325,1.329,1.329,0,0,0,.4.174,1.717,1.717,0,0,0,.4.052,1.811,1.811,0,0,0,.352-.036,2.5,2.5,0,0,0,.349-.1,1.9,1.9,0,0,0,.309-.137,1.056,1.056,0,0,0,.226-.164l.131-.093.116-.031.126.043a.955.955,0,0,1,.146.124l.5.57.067.112.014.1a.262.262,0,0,1-.052.164Zm-2.286-3.96a.907.907,0,0,0-.359.074,1.33,1.33,0,0,0-.325.2,1.654,1.654,0,0,0-.274.28,1.809,1.809,0,0,0-.2.318h2.429a2.85,2.85,0,0,0-.216-.342,1.485,1.485,0,0,0-.266-.276,1.164,1.164,0,0,0-.342-.185,1.355,1.355,0,0,0-.449-.067"
        transform="translate(-148.081 -25.706)"
        fill="#0d0c0e"
      />
      <path
        id="Trazado_496"
        data-name="Trazado 496"
        d="M568.979,330.58a.351.351,0,0,1,.033-.157l.088-.109.124-.064.135-.021h.718a.259.259,0,0,1,.19.071.618.618,0,0,1,.121.181,1.771,1.771,0,0,1,.088.242,2.335,2.335,0,0,0,.09.257c.1-.1.19-.208.284-.309a2.081,2.081,0,0,1,.3-.271,1.476,1.476,0,0,1,.354-.192,1.212,1.212,0,0,1,.44-.074,2.539,2.539,0,0,1,.458.037,1.984,1.984,0,0,1,.382.112,2.235,2.235,0,0,1,.359.188c.118.076.248.165.387.266a.337.337,0,0,1,.2.28.5.5,0,0,1-.081.243l-.433.736a.377.377,0,0,1-.319.186.533.533,0,0,1-.213-.052,1.507,1.507,0,0,0-.417-.3,1.141,1.141,0,0,0-.483-.1.922.922,0,0,0-.325.052.848.848,0,0,0-.254.147,1.3,1.3,0,0,0-.215.228c-.065.089-.133.187-.2.294V335.9a.385.385,0,0,1-.087.273.391.391,0,0,1-.292.093h-1.069a.325.325,0,0,1-.37-.366Z"
        transform="translate(-154.3 -25.706)"
        fill="#0d0c0e"
      />
      <path
        id="Trazado_497"
        data-name="Trazado 497"
        d="M587.725,335.913a.423.423,0,0,1-.028.155l-.1.116-.124.066-.124.015h-.936a.424.424,0,0,1-.162-.026l-.1-.074-.064-.116c-.017-.046-.036-.1-.055-.15l-.062-.214a2.852,2.852,0,0,1-.292.252,2.226,2.226,0,0,1-.362.221,2.3,2.3,0,0,1-.423.157,1.847,1.847,0,0,1-.468.059,3.126,3.126,0,0,1-.83-.109,3.086,3.086,0,0,1-.741-.311,3.053,3.053,0,0,1-.625-.485,3.088,3.088,0,0,1-.794-1.378,3.18,3.18,0,0,1-.109-.839,3.107,3.107,0,0,1,.9-2.217,3.074,3.074,0,0,1,2.2-.9,2.149,2.149,0,0,1,.549.067,2.116,2.116,0,0,1,.466.18,1.839,1.839,0,0,1,.383.274,2.171,2.171,0,0,1,.3.344l.138-.432c.031-.08.058-.143.078-.193l.066-.109.088-.048a.674.674,0,0,1,.147-.012h.708l.124.014.124.067.1.118a.389.389,0,0,1,.028.152Zm-4.682-2.662a1.743,1.743,0,0,0,.1.587,1.4,1.4,0,0,0,.278.473,1.318,1.318,0,0,0,1,.432,1.487,1.487,0,0,0,.591-.116,1.53,1.53,0,0,0,.476-.316,1.441,1.441,0,0,0,.316-.473,1.549,1.549,0,0,0,0-1.167,1.531,1.531,0,0,0-.316-.485,1.508,1.508,0,0,0-.476-.33,1.44,1.44,0,0,0-.591-.121,1.292,1.292,0,0,0-.564.121,1.317,1.317,0,0,0-.435.33,1.489,1.489,0,0,0-.278.485,1.731,1.731,0,0,0-.1.58"
        transform="translate(-159.309 -25.705)"
        fill="#0d0c0e"
      />
      <path
        id="Trazado_498"
        data-name="Trazado 498"
        d="M598.432,334.369a1.368,1.368,0,0,0,.278.216,2.1,2.1,0,0,0,.287.143,1.817,1.817,0,0,0,.243.078.837.837,0,0,0,.143.024c.06,0,.137,0,.231-.008a1.225,1.225,0,0,0,.268-.042.555.555,0,0,0,.221-.117.287.287,0,0,0,.093-.228.373.373,0,0,0-.052-.211.427.427,0,0,0-.152-.133,1.256,1.256,0,0,0-.245-.1c-.1-.029-.2-.061-.325-.1a3.922,3.922,0,0,1-.941-.366,2.107,2.107,0,0,1-.587-.477,1.569,1.569,0,0,1-.3-.568,2.376,2.376,0,0,1-.085-.641,1.618,1.618,0,0,1,.157-.717,1.574,1.574,0,0,1,.447-.554,2.092,2.092,0,0,1,.694-.356,2.992,2.992,0,0,1,.9-.126,2.951,2.951,0,0,1,.561.05,2.189,2.189,0,0,1,.5.157,2.429,2.429,0,0,1,.464.275,3.67,3.67,0,0,1,.449.4.3.3,0,0,1,.083.178.246.246,0,0,1-.107.178q-.186.153-.354.3t-.349.328l-.114.059-.109,0-.1-.048-.086-.081a.833.833,0,0,0-.38-.25,1.4,1.4,0,0,0-.4-.064.721.721,0,0,0-.37.081.248.248,0,0,0-.128.247.266.266,0,0,0,.093.193.666.666,0,0,0,.2.112,1.911,1.911,0,0,0,.257.069c.09.017.173.037.249.059a7.492,7.492,0,0,1,.785.3,2.391,2.391,0,0,1,.618.4,1.644,1.644,0,0,1,.407.563,1.978,1.978,0,0,1,.144.8,1.841,1.841,0,0,1-.187.842,1.8,1.8,0,0,1-.516.622,2.352,2.352,0,0,1-.777.385,3.4,3.4,0,0,1-.967.133,3.519,3.519,0,0,1-.6-.052,2.824,2.824,0,0,1-.589-.169,2.692,2.692,0,0,1-.542-.3,2.116,2.116,0,0,1-.456-.444l-.078-.141-.024-.144.029-.131.083-.1.613-.613a.216.216,0,0,1,.2-.067.677.677,0,0,1,.226.162"
        transform="translate(-165.776 -25.686)"
        fill="#0d0c0e"
      />
      <path
        id="Trazado_499"
        data-name="Trazado 499"
        d="M342.91,328.765a.232.232,0,0,1,.052-.16.2.2,0,0,1,.158-.059h3.05a2.084,2.084,0,0,1,.62.091,2.106,2.106,0,0,1,.534.25,2.188,2.188,0,0,1,.439.383,2.426,2.426,0,0,1,.332.479,2.369,2.369,0,0,1,.207.542,2.328,2.328,0,0,1,.072.576,2.354,2.354,0,0,1-.155.839,2.308,2.308,0,0,1-.441.73,2.231,2.231,0,0,1-.688.518,2.012,2.012,0,0,1-.888.2h-1.446v2.272q0,.205-.22.205H343.12a.223.223,0,0,1-.153-.05.193.193,0,0,1-.057-.155Zm3.594,2.091a.877.877,0,0,0-.05-.286.782.782,0,0,0-.146-.256.755.755,0,0,0-.231-.184.647.647,0,0,0-.308-.072h-1.012v1.594h1.012a.688.688,0,0,0,.31-.069.727.727,0,0,0,.232-.18.808.808,0,0,0,.143-.253.907.907,0,0,0,.05-.3"
        transform="translate(-62.624 -25.062)"
        fill="#0d0c0e"
      />
    </g>
  </svg>
)
export const LogoSellerCenter = () => (
  <svg
    style={{ fill: '#FFFFFF', width: '70%', marginLeft: '5%', marginTop: '3%', height: '100%' }}
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 1080 326"
    xmlSpace="preserve"
  >
    <g>
      <g>
        <g>
          <g>
            <g>
              <path
                className="st0"
                d="M459.7,93c-30.3,0-55,21.7-55,50.6c0,30.5,24.4,50.6,55,50.6c30.3,0,54.7-20.5,54.7-50.6
						C514.4,113.9,490,93,459.7,93z M459.7,162.1c-11.5,0-18.2-7.9-18.2-18.6c0-10.7,6.7-18.6,18.2-18.6c11.3,0,18,7.9,18,18.6
						C477.7,154.2,471,162.1,459.7,162.1z"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M585.3,93.3c-11.1,0-21.1,3.3-29,9.8l-1.5-7.6h-30l0.2,30.6v102.4h35.7v-49.1c3.8,9.7,17,15,28,15
						c26.7,0,44.9-21.7,44.9-50.6S612,93.3,585.3,93.3z M579,162.5c-11.5,0-18.4-8.2-18.4-18.6c0-10.4,6.9-18.6,18.4-18.6
						c11.1,0,17.8,7.9,17.8,18.6C596.7,154.5,590.1,162.5,579,162.5z"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M689.6,91.9c-14,0-25.4,2.3-35.9,7.4l-0.7,0.4v29.7l1.8-0.8c10.3-4.4,20.5-6.7,30.3-6.7
						c14.8,0,14.8,4,14.8,5.9c0,4-5.7,6.3-18.9,7.8c-25.2,2.7-37.4,12.6-37.4,30.3c0,17.5,12.2,28.4,31.7,28.4
						c19.2,0,27.3-7.2,31.3-15.1l-0.1,12.4h28.7l0-60.7C735.3,105.4,719.5,91.9,689.6,91.9z M685.7,168.9c-2.8,0-7.6-0.8-7.6-5.9
						c0-3.9,1.8-6.1,11.5-7.2c3.4-0.4,7.2-1.1,10.3-2.9C699.8,162.5,694.1,168.9,685.7,168.9z"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M275.8,125.6c0-16.7-12.1-32.6-41.8-32.6c-32,0-55.6,22.1-55.6,53.1c0,30.3,21.3,48.1,55,48.1
						c20.3,0,32.6-3.1,37-6.2v-28.9c-5.4,3.9-14.2,8.2-28.4,8.4c-17.9,0.2-26.7-8.5-27.8-19.1c4.8,5.6,14.6,9,26.7,9.2
						C261,157.6,275.8,146.3,275.8,125.6z M214.8,136.2c2.9-9.8,11.3-14.8,19-14.8c5.2,0,7.7,1.9,7.7,5.6
						C241.6,133.3,232.8,136.4,214.8,136.2z"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M362.6,102.8c-7.5-6.5-17.1-9.8-27.8-9.8c-27,0-48.3,20.7-48.3,49.3c0,29.5,19,47.6,46,47.6
						c10.2,0,19.2-3.8,26.1-10c-0.6,10-8.1,19.8-28.8,19.8c-8.7,0-18.5-1.2-28.8-5.9v31c9.2,3.7,22.3,5.2,33.8,5.2
						c36.1,0,59.6-22.4,59.6-55.4V95.5h-29.9L362.6,102.8z M341.4,159.6c-11.3,0-18-7.5-18-17.3c0-9.8,7.3-17.3,18-17.3
						s18,7.5,18,17.3C359.4,152.1,352.1,159.6,341.4,159.6z"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M919.8,93c-30.3,0-55,21.7-55,50.6c0,30.5,24.4,50.6,55,50.6c30.3,0,54.7-20.5,54.7-50.6
						C974.6,113.9,950.1,93,919.8,93z M919.8,162.1c-11.5,0-18.2-7.9-18.2-18.6c0-10.7,6.7-18.6,18.2-18.6c11.3,0,18,7.9,18,18.6
						C937.8,154.2,931.1,162.1,919.8,162.1z"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M823.8,102.8c-7.5-6.5-17.1-9.8-27.8-9.8c-27,0-48.3,20.7-48.3,49.3c0,29.5,19,47.6,46,47.6
						c10.2,0,19.2-3.8,26.1-10c-0.6,10-8.1,19.8-28.8,19.8c-8.7,0-18.5-1.2-28.8-5.9v31c9.2,3.7,22.3,5.2,33.8,5.2
						c36.1,0,59.6-22.4,59.6-55.4V95.5h-29.9L823.8,102.8z M802.6,159.6c-11.3,0-18-7.5-18-17.3c0-9.8,7.3-17.3,18-17.3
						s18,7.5,18,17.3C820.6,152.1,813.3,159.6,802.6,159.6z"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M131.3,95.5V147c0,11.5-7.7,15.6-15,15.6c-8.7,0-14.1-6-14.1-15.6V95.5H67.5v58.6
						c0,25.7,10.4,39.9,36,39.9c20.5,0,29.1-9.2,32.1-16.9l0,14.5h30.5l0-96.1H131.3z"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M44.1,154.7V54.3H8.4v105.5c0,45.4,41.2,34.6,46.5,33.3v-30.4C47.2,163.5,44.1,160.1,44.1,154.7z"
              />
            </g>
          </g>
        </g>
        <g>
          <path
            className="st0"
            d="M1071.5,109.3c-8.3-15.7-69.8-12.2-65.4,5.9c3.3,13.5,33.8,9.8,41.8,6.6c0,0,0.5,9-20.9,9
				c-38.2-0.1-29-22.7-29-22.7s2.7-8.6,19.1-13.1c8.8-2.4,32.1-4.8,44.6-1.5c2.2,0.6,4.2-1.5,3.5-3.6c-7.7-25.1-25-73.2-38.9-65.2
				c-1.9,1.1-6.3,5.1-1,17.1c5.3,11.9,13.1,31.7,6.1,33.1c-5,0.9-9.9-6.8-12.4-10c-4.4-5.6-6.7-9.1-11.2-14.9c-3-4-8.7-9.3-13.5-11
				c-4.3-1.5-9.6-1.7-12.2,2.3c-3.2,5.4,1.8,10.1,5.1,13.9c4.5,5.2,7.5,9.4,11,14.7c2.7,4.1,5,8.4,7,12.8c0,0-14.4-1.5-13.8,13
				c0,0-13.6,0.7-12,14.1c0.7,5.5,3,11,5.4,16c3.6,7.4,8.2,14.3,14,20.2c6.2,6.3,14,11.3,22.7,13.2c12.5,2.7,24.9-1.2,35.5-7.8
				c7.1-4.4,13.4-10.5,16.1-18.6C1075.7,125.1,1075.2,116.2,1071.5,109.3z"
          />
        </g>
      </g>
      <g>
        <path
          className="st0"
          d="M15,283.6l-0.9-11.3c4.3,3,10.3,4.9,15.6,4.9c5.5,0,8.4-1.5,8.4-4.4c0-2.6-2.2-3.9-9.4-5.4
			c-9.7-2-14.7-6.7-14.7-13.7c0-9,7-14.6,18.4-14.6c5,0,10,0.9,13.2,2.4l0.9,10.8c-4.3-2.4-9-3.7-14.1-3.7c-4.4,0-6.9,1.3-6.9,3.5
			c0,2.2,1.6,3,8.6,4.7c11.1,2.7,15.3,6.8,15.3,14.8c0,9-7.7,15-19.1,15C25,286.7,19.8,285.6,15,283.6z"
        />
        <path
          className="st0"
          d="M91,272.2H68.7c0.9,3.1,3.6,5.2,8.7,5.2c6.6,0,9.9-1.8,12.6-3.6l-1.5,9.7c-2.6,1.7-7.5,2.9-12.8,2.9
			c-10.9,0-18-6.7-18-17.1c0-9.8,7.4-17.1,17-17.1c10.2,0,16.5,7,16.5,16.7C91.1,270.5,91,271.5,91,272.2z M68.9,265.5h11.4
			c-0.5-2.6-2.7-4.4-5.4-4.4C71.9,261,69.9,262.6,68.9,265.5z"
        />
        <path className="st0" d="M101.1,285.8v-46.4l11.3-0.6v47H101.1z" />
        <path className="st0" d="M124.3,285.8v-46.4l11.3-0.6v47H124.3z" />
        <path
          className="st0"
          d="M178.9,272.2h-22.3c0.9,3.1,3.6,5.2,8.7,5.2c6.6,0,9.9-1.8,12.6-3.6l-1.5,9.7c-2.6,1.7-7.5,2.9-12.8,2.9
			c-10.9,0-18-6.7-18-17.1c0-9.8,7.4-17.1,17-17.1c10.2,0,16.5,7,16.5,16.7C179,270.5,178.9,271.5,178.9,272.2z M156.8,265.5h11.4
			c-0.5-2.6-2.7-4.4-5.4-4.4C159.8,261,157.8,262.6,156.8,265.5z"
        />
        <path
          className="st0"
          d="M210.7,252.2l-0.5,10.7c-0.7-0.1-1.3-0.2-2.3-0.2c-4.4,0-7.5,2.6-7.5,8.8v14.3h-11.3v-22.6l-0.9-10.2
			l10.2-0.7l0.7,5.7c1.3-3.5,4.9-5.9,9.4-5.9C209.6,252,209.8,252,210.7,252.2z"
        />
        <path
          className="st0"
          d="M234.3,269.3c0-9.7,7.9-17.2,18.1-17.2c2.9,0,5.3,0.3,8.3,1.1L262,264c-2.5-1.3-5.1-2-7.8-2
			c-4.9,0-8.4,2.6-8.4,7.2c0,4.7,3.5,7.2,8.4,7.2c2.9,0,5.5-0.6,7.9-1.9l-1.2,10.8c-2.5,0.8-4.9,1.2-8.4,1.2
			C242.3,286.7,234.3,279.2,234.3,269.3z"
        />
        <path
          className="st0"
          d="M303.3,272.2h-22.3c0.9,3.1,3.6,5.2,8.7,5.2c6.6,0,9.9-1.8,12.6-3.6l-1.5,9.7c-2.6,1.7-7.5,2.9-12.8,2.9
			c-10.9,0-18-6.7-18-17.1c0-9.8,7.4-17.1,17-17.1c10.2,0,16.5,7,16.5,16.7C303.5,270.5,303.4,271.5,303.3,272.2z M281.3,265.5h11.4
			c-0.5-2.6-2.7-4.4-5.4-4.4C284.3,261,282.2,262.6,281.3,265.5z"
        />
        <path
          className="st0"
          d="M347.4,266.8v19h-11.3V268c0-3.4-2.2-5.8-5.5-5.8c-3.3,0-5.7,2.3-5.7,5.8v17.8h-11.3v-22.6l-0.7-10.1
			l10.4-0.9l0.4,4.1c2-2.6,5.4-4.3,10.2-4.3C342.1,252,347.4,257.8,347.4,266.8z"
        />
        <path
          className="st0"
          d="M372.8,271.3c0,3.6,1.9,5.4,5.2,5.4c2.2,0,4-0.6,5.4-1.5l-0.7,9.9c-1.5,0.7-4.2,1.6-7.9,1.6
			c-8.4,0-13.3-4.9-13.3-13.5V262h-6.1v-8l6.1-1.7v-7.1l11.3-1.4v9.2h10.9l-0.7,9.1h-10.2V271.3z"
        />
        <path
          className="st0"
          d="M424.4,272.2h-22.3c0.9,3.1,3.6,5.2,8.7,5.2c6.6,0,9.9-1.8,12.6-3.6l-1.5,9.7c-2.6,1.7-7.5,2.9-12.8,2.9
			c-10.9,0-18-6.7-18-17.1c0-9.8,7.4-17.1,17-17.1c10.2,0,16.5,7,16.5,16.7C424.6,270.5,424.5,271.5,424.4,272.2z M402.4,265.5h11.4
			c-0.5-2.6-2.7-4.4-5.4-4.4C405.4,261,403.3,262.6,402.4,265.5z"
        />
        <path
          className="st0"
          d="M456.3,252.2l-0.5,10.7c-0.7-0.1-1.3-0.2-2.3-0.2c-4.4,0-7.5,2.6-7.5,8.8v14.3h-11.3v-22.6l-0.9-10.2
			l10.2-0.7l0.7,5.7c1.3-3.5,4.9-5.9,9.4-5.9C455.2,252,455.3,252,456.3,252.2z"
        />
      </g>
    </g>
  </svg>
)

export const LogoSellerCenterWhite = ({ width }) => (
  <svg
    style={{ fill: '#FFFFFF' }}
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 1080 326"
    xmlSpace="preserve"
  >
    <g>
      <g>
        <g>
          <g>
            <g>
              <path
                className="st0"
                d="M459.7,93c-30.3,0-55,21.7-55,50.6c0,30.5,24.4,50.6,55,50.6c30.3,0,54.7-20.5,54.7-50.6
						C514.4,113.9,490,93,459.7,93z M459.7,162.1c-11.5,0-18.2-7.9-18.2-18.6c0-10.7,6.7-18.6,18.2-18.6c11.3,0,18,7.9,18,18.6
						C477.7,154.2,471,162.1,459.7,162.1z"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M585.3,93.3c-11.1,0-21.1,3.3-29,9.8l-1.5-7.6h-30l0.2,30.6v102.4h35.7v-49.1c3.8,9.7,17,15,28,15
						c26.7,0,44.9-21.7,44.9-50.6S612,93.3,585.3,93.3z M579,162.5c-11.5,0-18.4-8.2-18.4-18.6c0-10.4,6.9-18.6,18.4-18.6
						c11.1,0,17.8,7.9,17.8,18.6C596.7,154.5,590.1,162.5,579,162.5z"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M689.6,91.9c-14,0-25.4,2.3-35.9,7.4l-0.7,0.4v29.7l1.8-0.8c10.3-4.4,20.5-6.7,30.3-6.7
						c14.8,0,14.8,4,14.8,5.9c0,4-5.7,6.3-18.9,7.8c-25.2,2.7-37.4,12.6-37.4,30.3c0,17.5,12.2,28.4,31.7,28.4
						c19.2,0,27.3-7.2,31.3-15.1l-0.1,12.4h28.7l0-60.7C735.3,105.4,719.5,91.9,689.6,91.9z M685.7,168.9c-2.8,0-7.6-0.8-7.6-5.9
						c0-3.9,1.8-6.1,11.5-7.2c3.4-0.4,7.2-1.1,10.3-2.9C699.8,162.5,694.1,168.9,685.7,168.9z"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M275.8,125.6c0-16.7-12.1-32.6-41.8-32.6c-32,0-55.6,22.1-55.6,53.1c0,30.3,21.3,48.1,55,48.1
						c20.3,0,32.6-3.1,37-6.2v-28.9c-5.4,3.9-14.2,8.2-28.4,8.4c-17.9,0.2-26.7-8.5-27.8-19.1c4.8,5.6,14.6,9,26.7,9.2
						C261,157.6,275.8,146.3,275.8,125.6z M214.8,136.2c2.9-9.8,11.3-14.8,19-14.8c5.2,0,7.7,1.9,7.7,5.6
						C241.6,133.3,232.8,136.4,214.8,136.2z"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M362.6,102.8c-7.5-6.5-17.1-9.8-27.8-9.8c-27,0-48.3,20.7-48.3,49.3c0,29.5,19,47.6,46,47.6
						c10.2,0,19.2-3.8,26.1-10c-0.6,10-8.1,19.8-28.8,19.8c-8.7,0-18.5-1.2-28.8-5.9v31c9.2,3.7,22.3,5.2,33.8,5.2
						c36.1,0,59.6-22.4,59.6-55.4V95.5h-29.9L362.6,102.8z M341.4,159.6c-11.3,0-18-7.5-18-17.3c0-9.8,7.3-17.3,18-17.3
						s18,7.5,18,17.3C359.4,152.1,352.1,159.6,341.4,159.6z"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M919.8,93c-30.3,0-55,21.7-55,50.6c0,30.5,24.4,50.6,55,50.6c30.3,0,54.7-20.5,54.7-50.6
						C974.6,113.9,950.1,93,919.8,93z M919.8,162.1c-11.5,0-18.2-7.9-18.2-18.6c0-10.7,6.7-18.6,18.2-18.6c11.3,0,18,7.9,18,18.6
						C937.8,154.2,931.1,162.1,919.8,162.1z"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M823.8,102.8c-7.5-6.5-17.1-9.8-27.8-9.8c-27,0-48.3,20.7-48.3,49.3c0,29.5,19,47.6,46,47.6
						c10.2,0,19.2-3.8,26.1-10c-0.6,10-8.1,19.8-28.8,19.8c-8.7,0-18.5-1.2-28.8-5.9v31c9.2,3.7,22.3,5.2,33.8,5.2
						c36.1,0,59.6-22.4,59.6-55.4V95.5h-29.9L823.8,102.8z M802.6,159.6c-11.3,0-18-7.5-18-17.3c0-9.8,7.3-17.3,18-17.3
						s18,7.5,18,17.3C820.6,152.1,813.3,159.6,802.6,159.6z"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M131.3,95.5V147c0,11.5-7.7,15.6-15,15.6c-8.7,0-14.1-6-14.1-15.6V95.5H67.5v58.6
						c0,25.7,10.4,39.9,36,39.9c20.5,0,29.1-9.2,32.1-16.9l0,14.5h30.5l0-96.1H131.3z"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M44.1,154.7V54.3H8.4v105.5c0,45.4,41.2,34.6,46.5,33.3v-30.4C47.2,163.5,44.1,160.1,44.1,154.7z"
              />
            </g>
          </g>
        </g>
        <g>
          <path
            className="st0"
            d="M1071.5,109.3c-8.3-15.7-69.8-12.2-65.4,5.9c3.3,13.5,33.8,9.8,41.8,6.6c0,0,0.5,9-20.9,9
				c-38.2-0.1-29-22.7-29-22.7s2.7-8.6,19.1-13.1c8.8-2.4,32.1-4.8,44.6-1.5c2.2,0.6,4.2-1.5,3.5-3.6c-7.7-25.1-25-73.2-38.9-65.2
				c-1.9,1.1-6.3,5.1-1,17.1c5.3,11.9,13.1,31.7,6.1,33.1c-5,0.9-9.9-6.8-12.4-10c-4.4-5.6-6.7-9.1-11.2-14.9c-3-4-8.7-9.3-13.5-11
				c-4.3-1.5-9.6-1.7-12.2,2.3c-3.2,5.4,1.8,10.1,5.1,13.9c4.5,5.2,7.5,9.4,11,14.7c2.7,4.1,5,8.4,7,12.8c0,0-14.4-1.5-13.8,13
				c0,0-13.6,0.7-12,14.1c0.7,5.5,3,11,5.4,16c3.6,7.4,8.2,14.3,14,20.2c6.2,6.3,14,11.3,22.7,13.2c12.5,2.7,24.9-1.2,35.5-7.8
				c7.1-4.4,13.4-10.5,16.1-18.6C1075.7,125.1,1075.2,116.2,1071.5,109.3z"
          />
        </g>
      </g>
      <g>
        <path
          className="st0"
          d="M15,283.6l-0.9-11.3c4.3,3,10.3,4.9,15.6,4.9c5.5,0,8.4-1.5,8.4-4.4c0-2.6-2.2-3.9-9.4-5.4
			c-9.7-2-14.7-6.7-14.7-13.7c0-9,7-14.6,18.4-14.6c5,0,10,0.9,13.2,2.4l0.9,10.8c-4.3-2.4-9-3.7-14.1-3.7c-4.4,0-6.9,1.3-6.9,3.5
			c0,2.2,1.6,3,8.6,4.7c11.1,2.7,15.3,6.8,15.3,14.8c0,9-7.7,15-19.1,15C25,286.7,19.8,285.6,15,283.6z"
        />
        <path
          className="st0"
          d="M91,272.2H68.7c0.9,3.1,3.6,5.2,8.7,5.2c6.6,0,9.9-1.8,12.6-3.6l-1.5,9.7c-2.6,1.7-7.5,2.9-12.8,2.9
			c-10.9,0-18-6.7-18-17.1c0-9.8,7.4-17.1,17-17.1c10.2,0,16.5,7,16.5,16.7C91.1,270.5,91,271.5,91,272.2z M68.9,265.5h11.4
			c-0.5-2.6-2.7-4.4-5.4-4.4C71.9,261,69.9,262.6,68.9,265.5z"
        />
        <path className="st0" d="M101.1,285.8v-46.4l11.3-0.6v47H101.1z" />
        <path className="st0" d="M124.3,285.8v-46.4l11.3-0.6v47H124.3z" />
        <path
          className="st0"
          d="M178.9,272.2h-22.3c0.9,3.1,3.6,5.2,8.7,5.2c6.6,0,9.9-1.8,12.6-3.6l-1.5,9.7c-2.6,1.7-7.5,2.9-12.8,2.9
			c-10.9,0-18-6.7-18-17.1c0-9.8,7.4-17.1,17-17.1c10.2,0,16.5,7,16.5,16.7C179,270.5,178.9,271.5,178.9,272.2z M156.8,265.5h11.4
			c-0.5-2.6-2.7-4.4-5.4-4.4C159.8,261,157.8,262.6,156.8,265.5z"
        />
        <path
          className="st0"
          d="M210.7,252.2l-0.5,10.7c-0.7-0.1-1.3-0.2-2.3-0.2c-4.4,0-7.5,2.6-7.5,8.8v14.3h-11.3v-22.6l-0.9-10.2
			l10.2-0.7l0.7,5.7c1.3-3.5,4.9-5.9,9.4-5.9C209.6,252,209.8,252,210.7,252.2z"
        />
        <path
          className="st0"
          d="M234.3,269.3c0-9.7,7.9-17.2,18.1-17.2c2.9,0,5.3,0.3,8.3,1.1L262,264c-2.5-1.3-5.1-2-7.8-2
			c-4.9,0-8.4,2.6-8.4,7.2c0,4.7,3.5,7.2,8.4,7.2c2.9,0,5.5-0.6,7.9-1.9l-1.2,10.8c-2.5,0.8-4.9,1.2-8.4,1.2
			C242.3,286.7,234.3,279.2,234.3,269.3z"
        />
        <path
          className="st0"
          d="M303.3,272.2h-22.3c0.9,3.1,3.6,5.2,8.7,5.2c6.6,0,9.9-1.8,12.6-3.6l-1.5,9.7c-2.6,1.7-7.5,2.9-12.8,2.9
			c-10.9,0-18-6.7-18-17.1c0-9.8,7.4-17.1,17-17.1c10.2,0,16.5,7,16.5,16.7C303.5,270.5,303.4,271.5,303.3,272.2z M281.3,265.5h11.4
			c-0.5-2.6-2.7-4.4-5.4-4.4C284.3,261,282.2,262.6,281.3,265.5z"
        />
        <path
          className="st0"
          d="M347.4,266.8v19h-11.3V268c0-3.4-2.2-5.8-5.5-5.8c-3.3,0-5.7,2.3-5.7,5.8v17.8h-11.3v-22.6l-0.7-10.1
			l10.4-0.9l0.4,4.1c2-2.6,5.4-4.3,10.2-4.3C342.1,252,347.4,257.8,347.4,266.8z"
        />
        <path
          className="st0"
          d="M372.8,271.3c0,3.6,1.9,5.4,5.2,5.4c2.2,0,4-0.6,5.4-1.5l-0.7,9.9c-1.5,0.7-4.2,1.6-7.9,1.6
			c-8.4,0-13.3-4.9-13.3-13.5V262h-6.1v-8l6.1-1.7v-7.1l11.3-1.4v9.2h10.9l-0.7,9.1h-10.2V271.3z"
        />
        <path
          className="st0"
          d="M424.4,272.2h-22.3c0.9,3.1,3.6,5.2,8.7,5.2c6.6,0,9.9-1.8,12.6-3.6l-1.5,9.7c-2.6,1.7-7.5,2.9-12.8,2.9
			c-10.9,0-18-6.7-18-17.1c0-9.8,7.4-17.1,17-17.1c10.2,0,16.5,7,16.5,16.7C424.6,270.5,424.5,271.5,424.4,272.2z M402.4,265.5h11.4
			c-0.5-2.6-2.7-4.4-5.4-4.4C405.4,261,403.3,262.6,402.4,265.5z"
        />
        <path
          className="st0"
          d="M456.3,252.2l-0.5,10.7c-0.7-0.1-1.3-0.2-2.3-0.2c-4.4,0-7.5,2.6-7.5,8.8v14.3h-11.3v-22.6l-0.9-10.2
			l10.2-0.7l0.7,5.7c1.3-3.5,4.9-5.9,9.4-5.9C455.2,252,455.3,252,456.3,252.2z"
        />
      </g>
    </g>
  </svg>
)
export const AddIcon = () => (
  <svg
    width="28"
    height="30"
    style={{ fill: '#000000' }}
    className="MuiSvgIcon-root"
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 27 27"
  >
    <path d="M13.5,1.15A12.35,12.35,0,1,0,25.85,13.5,12.36,12.36,0,0,0,13.5,1.15Zm0,23.5A11.15,11.15,0,1,1,24.65,13.5,11.16,11.16,0,0,1,13.5,24.65Z" />
    <path d="M19.71,13H14.1V7.36a.6.6,0,1,0-1.2,0V13H7.29a.6.6,0,0,0,0,1.2H12.9v5.62a.6.6,0,0,0,1.2,0V14.17h5.61a.6.6,0,0,0,0-1.2Z" />
  </svg>
)
export const AddIconBrans = () => (
  <svg
    width="28"
    height="30"
    className="MuiSvgIcon-root"
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 27 27"
  >
    <path d="M13.5,1.15A12.35,12.35,0,1,0,25.85,13.5,12.36,12.36,0,0,0,13.5,1.15Zm0,23.5A11.15,11.15,0,1,1,24.65,13.5,11.16,11.16,0,0,1,13.5,24.65Z" />
    <path d="M19.71,13H14.1V7.36a.6.6,0,1,0-1.2,0V13H7.29a.6.6,0,0,0,0,1.2H12.9v5.62a.6.6,0,0,0,1.2,0V14.17h5.61a.6.6,0,0,0,0-1.2Z" />
  </svg>
)

export const ReportIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="22.828" viewBox="0 0 24 22.828">
    <g id="informes" transform="translate(-1419.134 -565.127)">
      <path
        id="Trazado_5664"
        data-name="Trazado 5664"
        d="M1177.645,303.087a2,2,0,0,0-1.062-.63,1.989,1.989,0,0,0,.379-1.169,10.172,10.172,0,0,0-10.161-10.161,2.009,2.009,0,0,1-3.12,1.336,2.186,2.186,0,0,0-.279.019,10.79,10.79,0,1,0,7.769,19.48,1.96,1.96,0,0,0,.754-1.081l.111.11a1.96,1.96,0,0,0,1.4.574,2.057,2.057,0,0,0,1.281-.448c.028-.022.055-.046.082-.07a10.824,10.824,0,0,0,3.322-6.406,1.967,1.967,0,0,0-.473-1.553"
        transform="translate(265 274)"
      />
      <path
        id="Trazado_5665"
        data-name="Trazado 5665"
        d="M1159.134,306.781a9.4,9.4,0,0,1,8.072-9.312.606.606,0,0,1,.7.6v9.337l6.13,6.13a.6.6,0,0,1-.059.909,9.4,9.4,0,0,1-14.844-7.665m10.654-10a.616.616,0,0,1,.626-.649,8.774,8.774,0,0,1,8.773,8.773.639.639,0,0,1-.65.627h-8.75Zm9.964,10.631a.6.6,0,0,1,.6.666,9.389,9.389,0,0,1-2.894,5.574.632.632,0,0,1-.83-.024l-6.216-6.216Z"
        transform="translate(261.387 270.387)"
        fill="#fff"
      />
    </g>
  </svg>
)
export const bonusesIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25.688" height="21.77" viewBox="0 0 25.688 21.77">
    <g id="bonos" transform="translate(-379 -349)">
      <path
        id="Trazado_5689"
        data-name="Trazado 5689"
        d="M6.995,21.77a3.552,3.552,0,0,1-3.321-2.257L2.6,16.812a1.246,1.246,0,0,1,.7-1.618.5.5,0,1,0-.365-.923,1.245,1.245,0,0,1-1.617-.7l-1.069-2.7A3.57,3.57,0,0,1,2.258,6.238L17.382.251a3.569,3.569,0,0,1,4.633,2.006l1.069,2.7a1.246,1.246,0,0,1-.7,1.617.5.5,0,0,0,.184.959A.488.488,0,0,0,22.75,7.5a1.246,1.246,0,0,1,1.617.7l1.069,2.7a3.573,3.573,0,0,1-2.006,4.633L8.307,21.519a3.556,3.556,0,0,1-1.313.251"
        transform="translate(379 349)"
      />
      <path
        id="Trazado_5690"
        data-name="Trazado 5690"
        d="M21.6,5.164a2.325,2.325,0,0,1,3.016,1.305l1.069,2.7a1.743,1.743,0,0,0,1.283,3.241l1.069,2.7a2.326,2.326,0,0,1-1.305,3.016L11.606,24.114A2.325,2.325,0,0,1,8.59,22.809l-1.069-2.7a1.743,1.743,0,0,0-1.283-3.241l-1.069-2.7a2.324,2.324,0,0,1,1.305-3.016ZM11.4,20.445a1.161,1.161,0,0,0,1.508.653l10.8-4.276a1.16,1.16,0,0,0,.653-1.508L21.8,8.832a1.161,1.161,0,0,0-1.508-.652L9.49,12.456a1.16,1.16,0,0,0-.652,1.508ZM9.918,13.536,20.72,9.26l2.566,6.482-10.8,4.276Z"
        transform="translate(375.243 345.246)"
        fill="#fff"
      />
    </g>
  </svg>
)
export const CategoriesIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="30"
    className="MuiSvgIcon-root"
    id="Layer_1"
    data-name="Layer 1"
    viewBox="0 0 27 27"
  >
    <path d="M10.8,12.55H4.22a1.81,1.81,0,0,1-1.81-1.81V4.17A1.82,1.82,0,0,1,4.22,2.35H10.8a1.82,1.82,0,0,1,1.81,1.82v6.57A1.81,1.81,0,0,1,10.8,12.55Zm-6.58-9a.62.62,0,0,0-.61.62v6.57a.61.61,0,0,0,.61.61H10.8a.61.61,0,0,0,.61-.61V4.17a.61.61,0,0,0-.61-.62Z" />
    <path d="M10.8,23.89H4.22a1.81,1.81,0,0,1-1.81-1.81V15.5a1.82,1.82,0,0,1,1.81-1.81H10.8a1.82,1.82,0,0,1,1.81,1.81v6.58A1.81,1.81,0,0,1,10.8,23.89Zm-6.58-9a.62.62,0,0,0-.61.61v6.58a.61.61,0,0,0,.61.61H10.8a.61.61,0,0,0,.61-.61V15.5a.61.61,0,0,0-.61-.61Z" />
    <path d="M19.16,24.35a5.56,5.56,0,1,1,5.56-5.56A5.56,5.56,0,0,1,19.16,24.35Zm0-9.92a4.36,4.36,0,1,0,4.36,4.36A4.36,4.36,0,0,0,19.16,14.43Z" />
    <path d="M22.45,12.55H15.87a1.81,1.81,0,0,1-1.81-1.81V4.17a1.82,1.82,0,0,1,1.81-1.82h6.58a1.82,1.82,0,0,1,1.81,1.82v6.57A1.81,1.81,0,0,1,22.45,12.55Zm-6.58-9a.61.61,0,0,0-.61.62v6.57a.61.61,0,0,0,.61.61h6.58a.61.61,0,0,0,.61-.61V4.17a.62.62,0,0,0-.61-.62Z" />
  </svg>
)

export const paymentsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="30"
    className="MuiSvgIcon-root"
    id="Layer_1"
    data-name="Layer 1"
    viewBox="0 0 27 27"
  >
    <path d="M13.5,25.22c-15.2.25-15.2-23.69,0-23.44,15.2-.25,15.2,23.69,0,23.44Zm0-22C.2,3.06.2,23.94,13.5,23.75,26.8,23.94,26.8,3.06,13.5,3.25Z" />
    <path d="M13.5,20.67a.52.52,0,0,1-.4-.2,1.38,1.38,0,0,1-.18-1.17l0-.15-.15,0a2.93,2.93,0,0,1-2.35-3.05c0-.39.16-.57.32-.64.86-.37.78.71.78.71a1.93,1.93,0,0,0,2,1.89h0a1.88,1.88,0,0,0,1.93-2,1.88,1.88,0,0,0-1.9-2h-.12a3,3,0,0,1-3-2.84A3,3,0,0,1,12.8,7.87l.14,0,0-.14a1.39,1.39,0,0,1,.18-1.17.5.5,0,0,1,.8,0,1.38,1.38,0,0,1,.18,1.17l0,.15.15,0a2.93,2.93,0,0,1,2.35,3.05c0,.39-.16.59-.32.64-.77.21-.78-.71-.78-.71-.32-1.67-1.23-1.93-1.74-1.93A2.48,2.48,0,0,0,11.49,11c0,.45.06,1.54,2,1.92h.12a3,3,0,0,1,3,2.84,3,3,0,0,1-2.36,3.37l-.14,0,0,.14a1.39,1.39,0,0,1-.18,1.17.52.52,0,0,1-.4.2Z" />
  </svg>
)

export const paymentLinkIcon = () => (
  <svg
    className="svg-inline--fa fa-paperclip"
    aria-hidden="true"
    focusable="false"
    width="20"
    height="22"
    data-prefix="far"
    data-icon="paperclip"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    data-fa-i2svg=""
  >
    <path
      fill="currentColor"
      d="M375 73c-26-26-68.1-26-94.1 0L89 265C45.3 308.6 45.3 379.4 89 423s114.4 43.6 158.1 0L399 271c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L281 457c-62.4 62.4-163.5 62.4-225.9 0S-7.4 293.4 55 231L247 39C291.7-5.7 364.3-5.7 409 39s44.7 117.2 0 161.9L225.2 384.7c-31.6 31.6-83.6 28.7-111.5-6.2c-23.8-29.8-21.5-72.8 5.5-99.8L271 127c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L153.2 312.7c-9.7 9.7-10.6 25.1-2 35.8c10 12.5 28.7 13.6 40 2.2L375 167c26-26 26-68.1 0-94.1z"
    />
  </svg>
)

export const configNotiIcon = () => (
  <svg
    width="28"
    height="30"
    id="Contenido"
    version="1.1"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defts>
      <style type="text/css">
        {`.iconNoti{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;} 
        .iconNotiTwo{fill:#fff;stroke:#000000;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:10;}`}
      </style>
    </defts>
    <rect
      x="19.233"
      y="10.557"
      width="4.333"
      height="2.476"
      style={{ fill: 'rgb(255, 255, 255)', stroke: 'rgb(255, 255, 255)' }}
    />
    <polyline
      className="iconNoti"
      points="19,3 19,9 25,9 19,3 7,3 7,29 25,29 25,25.3 "
      style={{ fill: 'rgb(255, 255, 255)' }}
    />
    <path
      className="iconNoti"
      d="M 28.094 17.333 C 26.994 17.533 26.094 17.333 25.694 16.633 C 25.294 15.933 25.594 14.933 26.294 14.133 C 25.394 13.233 24.394 12.633 23.194 12.333 C 22.894 13.333 22.194 14.133 21.394 14.133 C 20.594 14.133 19.894 13.433 19.594 12.333 C 18.394 12.633 17.294 13.233 16.494 14.133 C 17.194 14.933 17.494 15.933 17.094 16.633 C 16.694 17.333 15.694 17.533 14.694 17.333 C 14.394 17.933 14.294 18.533 14.294 19.133 C 14.294 19.733 14.394 20.333 14.494 20.933 C 15.594 20.733 16.494 20.933 16.894 21.633 C 17.294 22.333 16.994 23.333 16.294 24.133 C 17.194 25.033 18.194 25.633 19.394 25.933 C 19.694 24.933 20.394 24.133 21.194 24.133 C 21.994 24.133 22.694 24.833 22.994 25.933 C 24.194 25.633 25.294 25.033 26.094 24.133 C 25.394 23.333 25.094 22.333 25.494 21.633 C 25.894 20.933 26.894 20.733 27.894 20.933 C 28.094 20.333 28.094 19.733 28.094 19.133 C 28.094 18.533 28.194 17.933 28.094 17.333 Z"
      style={{ fill: 'rgb(255, 255, 255)', strokeDashoffset: '-2px' }}
    />
    <circle
      className="iconNoti"
      cx="21.336"
      cy="19.133"
      r="2"
      style={{ fill: 'rgb(255, 255, 255)' }}
    />
    <line className="iconNoti" x1="25" x2="25" y1="9" y2="12" />
  </svg>
)
export const CommissionsIcon = () => (
  <svg
    id="Contenido"
    xmlns="http://www.w3.org/2000/svg"
    height="30"
    width="28"
    viewBox="60 60 100 100"
  >
    <defs>
      <style>{'.cls-1 {fill: #fff;}'}</style>
    </defs>
    <path d="M58.86,144.69v-14.7c0-4.11,3.35-7.59,7.31-7.59l6.74,.11,5.71-4.63c4.04-3.27,9.32-5.14,14.5-5.14h13c-3.28-.71-5.87-3.28-6.62-6.54-.36-.12-.73-.25-1.11-.39l-.69-.25c-2.16-.77-3.97-2.43-4.95-4.56-.97-2.11-1.08-4.52-.28-6.62,.52-1.37,1.37-2.56,2.44-3.48-3.06-3.4-3.42-7.37-2.9-10.67,.01-.08,.03-.17,.05-.25,.9-4.23,3.58-7.62,7.46-9.55,.9-3.84,4.34-6.7,8.45-6.7s7.48,2.8,8.42,6.58c4.47,1.59,6.84,6.51,5.29,11-.43,1.25-1.13,2.35-2.01,3.25,2.86,2.48,4.86,6.2,3.98,11.87-.68,4.36-3.24,7.86-7.23,9.83-.77,3.23-3.35,5.77-6.6,6.48h7.96c2.91,0,5.66,1.27,7.55,3.49,1.73,2.03,2.55,4.66,2.32,7.31l11.72-8.63c1.92-1.42,4.2-2.18,6.59-2.18,3.52,0,6.87,1.69,8.96,4.53,1.8,2.45,2.51,5.42,1.99,8.38-.51,2.94-2.17,5.5-4.69,7.23l-20.62,15.19c-3.57,2.63-7.98,4.08-12.42,4.08h-53.01c-4.03,0-7.31-3.34-7.31-7.45Z" />
    <path
      className="cls-1"
      d="M149.39,128.72l-20.69,15.24c-2.72,2-6.08,3.1-9.45,3.1h-53.01c-1.2,0-2.31-1.1-2.31-2.45v-14.7c0-1.33,1.11-2.59,2.31-2.59l8.48,.14,7.12-5.78c3.22-2.6,7.35-4.02,11.35-4.02h24.64c2.99,0,5.34,2.66,4.84,5.73-.4,2.41-2.8,4.08-5.11,4.08h-11.98c-1.2,0-2.31,1.11-2.31,2.45s.97,2.45,2.31,2.45h18.47l18.33-13.5c2.72-2.02,6.56-1.43,8.57,1.3,2.01,2.73,1.42,6.56-1.56,8.56Zm-37.72-34.38c.12-.73,.2-1.16-4.65-2.55l-1-.29c-2.79-.83-10.18-3-9.01-10.58,.77-3.66,3.48-6.11,7.34-6.99v-1.61c0-2.03,1.64-3.68,3.67-3.68s3.68,1.65,3.68,3.68v1.72c.9,.21,1.87,.47,3.04,.88,1.92,.66,2.93,2.76,2.27,4.68-.66,1.92-2.76,2.93-4.67,2.27-1.27-.44-2.25-.71-3.01-.83-2.59-.41-4.76,.1-4.93,1.13-.11,.63-.34,1.12,3.69,2.27l.81,.28c3.91,1.12,11.2,3.2,9.87,10.87-.49,3.66-3.19,6.13-7.06,7v1.59c0,2.03-1.65,3.68-3.68,3.68s-3.67-1.65-3.67-3.68v-1.88c-1.46-.34-2.9-.8-4.2-1.27l-.71-.25c-1.91-.68-2.91-2.92-2.23-4.69,.67-1.78,2.77-2.91,4.69-2.1l.75,.26c1.35,.49,2.88,1.04,4.04,1.21,2.63,.43,4.79-.08,4.97-1.12Z"
    />
  </svg>
)

export const StroesIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="31"
    height="33"
    className="MuiSvgIcon-root"
    id="Layer_1"
    data-name="Layer 1"
    viewBox="0 0 27 27"
  >
    <path d="M25.13,8.29c-.13-.63-1.36-5-1.42-5.23a2,2,0,0,0-1.93-1.33H5A1.84,1.84,0,0,0,3.19,3.22L1.87,9.08a4.32,4.32,0,0,0,.51,3.07,4.31,4.31,0,0,0,.51.62v11.9a.6.6,0,0,0,.6.6H23.4a.6.6,0,0,0,.6-.6V12.85c.1-.11.2-.19.29-.31A5.91,5.91,0,0,0,25.13,8.29ZM16.5,10.08a2.84,2.84,0,0,1-2.94,2.79,2.88,2.88,0,0,1-3.08-2.38V2.93h6ZM3,9.35,4.36,3.48A.64.64,0,0,1,5,2.93H9.28v7.33s0,0,0,.05A3.49,3.49,0,0,1,8,12.41a3.1,3.1,0,0,1-2.44.37A3.19,3.19,0,0,1,3.4,11.51,3.11,3.11,0,0,1,3,9.35ZM15.75,24.07H11.08V17.9h4.67Zm1.2,0V17.3a.6.6,0,0,0-.6-.6H10.48a.6.6,0,0,0-.6.6v6.77H4.09V13.55A5.82,5.82,0,0,0,5.37,14a4.2,4.2,0,0,0,3.36-.58,4.08,4.08,0,0,0,1.12-1.25,4.12,4.12,0,0,0,3.71,1.94,3.84,3.84,0,0,0,3.58-2,4.05,4.05,0,0,0,3.68,2l.5,0a4.54,4.54,0,0,0,1.48-.38V24.07Zm6.38-12.25a2.75,2.75,0,0,1-2.11,1,3.09,3.09,0,0,1-3.52-2.81V2.93h4.05a.85.85,0,0,1,.81.48c.35,1.26,1.29,4.64,1.4,5.13A4.76,4.76,0,0,1,23.33,11.82Z" />
  </svg>
)

export const Error404Image = () => (
  <svg xmlns="http://www.w3.org/2000/svg" style={{ margin: '2rem' }} viewBox="0 0 1065.54 448.492">
    <g id="_404" data-name="404" transform="translate(-430.498 -231.51)">
      <path
        id="Trazado_496"
        data-name="Trazado 496"
        d="M390.1-225.75q0-103.544,40.033-163.142t129.129-59.6q89.1,0,129.129,59.6T728.42-225.75Q728.42-121,688.387-61.4T559.258-1.806q-89.1,0-129.129-59.6T390.1-225.75Zm237.188,0q0-60.8-13.244-93.611T559.258-352.17q-41.538,0-54.782,32.809T491.232-225.75q0,40.936,4.816,67.725t19.565,43.344q14.749,16.555,43.645,16.555T602.9-114.681q14.749-16.555,19.565-43.344T627.284-225.75ZM740.46-78.26v-83.076l190.232-272.1h114.982v266.084h49.364v89.1h-49.364V0H942.732V-78.26Zm209.5-242L848.82-167.356H949.956Z"
        transform="translate(401 680)"
        fill="#f7f7f7"
      />
      <g id="picture-404" transform="translate(64.064 -49.869)">
        <path
          id="Trazado_484"
          data-name="Trazado 484"
          d="M548.5,466.718a9.073,9.073,0,0,0-8.773-10.8l-7.661-19.266-12.843,1.8,11.2,27.055a9.122,9.122,0,0,0,18.076,1.208Z"
          transform="translate(239.714 74.054)"
          fill="#febdc6"
        />
        <path
          id="Trazado_485"
          data-name="Trazado 485"
          d="M520.333,436.45l-3.98-9.49-24.8-47.2,1.348-87.345.259-.034c15.868-2.1,26.6,71.017,27.054,74.131l15.668,53.586,3.73,11.811Z"
          transform="translate(244.218 97.552)"
          fill="#f35b69"
        />
        <path
          id="Trazado_486"
          data-name="Trazado 486"
          d="M296.518,475.613h12.057l5.736-46.506h-17.8Z"
          transform="translate(429.93 242.571)"
          fill="#febdc6"
        />
        <path
          id="Trazado_487"
          data-name="Trazado 487"
          d="M476.741,679.778h23.746a15.133,15.133,0,0,1,15.132,15.131v.492H476.742Z"
          transform="translate(246.63 34.469)"
          fill="#2f2e41"
        />
        <path
          id="Trazado_488"
          data-name="Trazado 488"
          d="M164.1,455.294l9.893,6.893,31.3-34.875-14.6-10.174Z"
          transform="translate(451.49 244.519)"
          fill="#febdc6"
        />
        <path
          id="Trazado_489"
          data-name="Trazado 489"
          d="M345.93,656.579l19.482,13.575h0a15.133,15.133,0,0,1,3.763,21.066l-.281.4L337,669.4Z"
          transform="translate(269.383 38.246)"
          fill="#2f2e41"
        />
        <path
          id="Trazado_490"
          data-name="Trazado 490"
          d="M454.319,635.233,453.8,547.99l-7.586-54.857-14.144,48.242-.027.04-51.256,74.413-19.944-10.105.109-.26c1.219-2.9,29.939-70.988,37.659-70.988a4.169,4.169,0,0,0,3.552-1.561c2.266-3.026.421-9.446.4-9.51-2.21-9.164,3.347-12.284,4.453-12.806l2.977-61.447.309.021,80.7,5.66-3.385,76.825-7.283,100.656-.25.028Z"
          transform="translate(265.501 72.019)"
          fill="#2f2e41"
        />
        <path
          id="Trazado_491"
          data-name="Trazado 491"
          d="M500.835,442.092l-.349-.028-86.786-7,.214-28.715,4.248-74.977.024-.052,17.3-37.555,12.262-5.553,17.891-.941.044.011,16.327,4.045,16.985,121.926Z"
          transform="translate(256.895 98.376)"
          fill="#f35b69"
        />
        <circle
          id="Elipse_98"
          data-name="Elipse 98"
          cx="22.85"
          cy="22.85"
          r="22.85"
          transform="translate(683.364 346.887) rotate(-28.663)"
          fill="#febdc6"
        />
        <path
          id="Trazado_492"
          data-name="Trazado 492"
          d="M437.965,252.168v-8.9s-7.18-8.456.718-10.586c0,0,2.154-21.3,20.821-11.36,0,0,25.847-4.26,22.975,10.65,0,0,6.462-3.893,4.308,6.048l-4.166,16.012s2.012-10.577-4.45-12l-3.59-2.13s-10.052,9.94-25.129-2.13c0,0-6.462-1.542-5.744,4.848S437.965,252.168,437.965,252.168Z"
          transform="translate(253.43 109.545)"
          fill="#2f2e41"
        />
        <path
          id="Trazado_493"
          data-name="Trazado 493"
          d="M456.566,441.409A9.073,9.073,0,0,0,446,432.362L435,414.784l-12.312,4.076,15.874,24.606a9.122,9.122,0,0,0,18-2.056Z"
          transform="translate(255.431 77.615)"
          fill="#febdc6"
        />
        <path
          id="Trazado_494"
          data-name="Trazado 494"
          d="M425.368,416.307l-19.889-40.381.018-.1c.08-.447,8.086-44.9,14.21-61.241,6.162-16.443,14.6-19.745,14.953-19.877l.178-.066L442.4,301.9l-10.476,69.927,11.293,33.725Z"
          transform="translate(258.233 97.176)"
          fill="#f35b69"
        />
      </g>
      <path
        id="Trazado_495"
        data-name="Trazado 495"
        d="M29.5-78.26v-83.076L219.73-433.44H334.712v266.084h49.364v89.1H334.712V0H231.77V-78.26Zm209.5-242L137.858-167.356H238.994Z"
        transform="translate(401 680)"
        fill="#f7f7f7"
      />
    </g>
  </svg>
)

export const Error500Image = () => (
  <svg xmlns="http://www.w3.org/2000/svg" style={{ margin: '2rem' }} viewBox="0 0 1050.874 497.819">
    <g id="_500" data-name="500" transform="translate(-455.16 -272.218)">
      <path
        id="Trazado_497"
        data-name="Trazado 497"
        d="M-219.365-349.181H-406.877v82.938q12.02-13.222,33.656-21.636a128.224,128.224,0,0,1,46.878-8.414q45.075,0,74.824,20.434a120.262,120.262,0,0,1,43.572,52.888q13.823,32.454,13.823,70.317,0,70.317-39.666,111.486T-345.575,0q-48.08,0-83.539-16.528T-483.805-62.5q-19.232-29.449-21.035-67.913h100.367a54.076,54.076,0,0,0,17.429,30.951q13.823,12.321,37.863,12.321,28.247,0,42.07-18.03t13.823-48.08q0-29.449-14.424-45.075t-42.07-15.626q-20.434,0-33.656,9.917A46.244,46.244,0,0,0-400.867-177.9h-99.165V-439.331h280.667Zm49.883,123.806q0-103.372,39.967-162.871T-.6-447.745q88.948,0,128.914,59.5T168.28-225.375q0,104.574-39.967,164.073T-.6-1.8q-88.948,0-128.915-59.5T-169.482-225.375Zm236.794,0q0-60.7-13.222-93.456T-.6-351.585q-41.469,0-54.691,32.754t-13.222,93.456q0,40.868,4.808,67.613t19.533,43.272Q-29.449-97.963-.6-97.963t43.572-16.527Q57.7-131.018,62.5-157.762T67.312-225.375Z"
        transform="translate(960 745)"
        fill="#f7f7f7"
      />
      <g id="picture-500" transform="translate(826.496 69.842)">
        <path
          id="Trazado_499"
          data-name="Trazado 499"
          d="M315.856,539.506a7.684,7.684,0,0,0,4.117-11.04l18.007-20.527L323.923,506l-14.945,19.79a7.726,7.726,0,0,0,6.877,13.716Z"
          transform="translate(-91.404 -58.444)"
          fill="#febdc6"
        />
        <path
          id="Trazado_500"
          data-name="Trazado 500"
          d="M112.958,679.262H100.4L94.425,630.82H112.96Z"
          transform="translate(133.209 -16.279)"
          fill="#febdc6"
        />
        <path
          id="Trazado_501"
          data-name="Trazado 501"
          d="M339.162,798.836l-40.495,0v-.512a15.762,15.762,0,0,1,15.761-15.761h24.735Z"
          transform="translate(-89.792 -123.678)"
          fill="#2f2e41"
        />
        <path
          id="Trazado_502"
          data-name="Trazado 502"
          d="M194.815,666.18,182.822,669.9l-20.071-44.49,17.7-5.5Z"
          transform="translate(117.093 -13.708)"
          fill="#febdc6"
        />
        <path
          id="Trazado_503"
          data-name="Trazado 503"
          d="M430.027,783.349l-38.674,12.007-.152-.489a15.763,15.763,0,0,1,10.379-19.727h0l23.621-7.333Z"
          transform="translate(-111.45 -120.198)"
          fill="#2f2e41"
        />
        <path
          id="Path_973"
          data-name="Path 973"
          d="M329.143,495.657l-18.6,21.3,14.561,1.31Z"
          transform="translate(-92.593 -56.005)"
          fill="#93b3df"
        />
        <path
          id="Path_975"
          data-name="Path 975"
          d="M323.09,530.925s-6.461,3.23-7.268,17.767,2.423,52.5,2.423,52.5-3.23,16.959,0,32.3-3.23,71.064.808,71.064,25.034,2.423,25.842,0,1.615-38.763,1.615-38.763,6.461-18.574,0-29.877c0,0,22.558,39.389,37.148,69.45,3.193,6.579,27.457-.808,23.42-8.076s-13.728-40.379-13.728-40.379-7.268-24.227-20.189-34.726l6.461-51.685s13.729-34.726,5.655-39.571S323.09,530.925,323.09,530.925Z"
          transform="translate(-93.807 -63.816)"
          fill="#2f2e41"
        />
        <circle
          id="Ellipse_182"
          data-name="Ellipse 182"
          cx="20.997"
          cy="20.997"
          r="20.997"
          transform="translate(232.513 293.48)"
          fill="#febdc6"
        />
        <path
          id="Path_976"
          data-name="Path 976"
          d="M371.442,361.435l-26.1,15.344s-9.995,5.629-13.728,15.344c-3.98,10.354-1.667,24.932,0,28.265,3.23,6.461-1.355,22.612-1.355,22.612l-4.038,37.148s-14.536,13.728-3.23,15.344,31.495-.808,43.609,0,25.842,2.423,21.8-5.655-8.883-13.729-4.038-29.877c3.792-12.639,3.627-59.894,3.377-79.851a16.065,16.065,0,0,0-7.8-13.576Z"
          transform="translate(-94.513 -24.345)"
          fill="#93b3df"
        />
        <path
          id="Path_980"
          data-name="Path 980"
          d="M364.679,394.727l2.422,49.262-23.479,47.546-3.982-1.515L363.868,445.6Z"
          transform="translate(-99.456 -32.198)"
          opacity="0.1"
          style={{ isolation: 'isolate' }}
        />
        <path
          id="Path_982"
          data-name="Path 982"
          d="M398.8,471.187v-5.655L371.35,510.758Z"
          transform="translate(-106.936 -48.899)"
          opacity="0.1"
          style={{ isolation: 'isolate' }}
        />
        <path
          id="Path_983"
          data-name="Path 983"
          d="M335.5,302.581l-3.468-1.388s7.259-7.99,17.356-7.3l-2.84-3.127s6.942-2.779,13.254,4.516c3.318,3.835,7.156,8.344,9.552,13.421h3.717l-1.551,3.416,5.43,3.416-5.574-.611a18.9,18.9,0,0,1-.527,8.848l.153,2.7s-6.464-10-6.464-11.389v3.474s-3.471-3.127-3.471-5.211l-1.893,2.432-.947-3.821-11.676,3.821,1.892-3.128-7.259,1.042,2.84-3.821s-8.2,4.516-8.52,8.338-4.417,8.685-4.417,8.685l-1.893-3.474S326.352,307.793,335.5,302.581Z"
          transform="translate(-96.893 -7.555)"
          fill="#2f2e41"
        />
        <path
          id="Trazado_504"
          data-name="Trazado 504"
          d="M351.774,542.037a7.684,7.684,0,0,0,2.092-11.6l14.077-23.4-14.177.587L342.571,529.76a7.725,7.725,0,0,0,9.2,12.277Z"
          transform="translate(-99.582 -58.691)"
          fill="#febdc6"
        />
        <path
          id="Path_981"
          data-name="Path 981"
          d="M384.495,374.8l6.056-1.211s18.17,13.325,12.517,39.974-30.687,67.028-30.687,67.028-5.655,7.268-7.268,8.883-4.845,0-3.23,2.423-2.423,4.038-2.423,4.038-17.767,0-16.151-6.461,29.073-52.5,29.073-52.5l-4.038-42.8S365.112,373.186,384.495,374.8Z"
          transform="translate(-100.297 -27.212)"
          fill="#93b3df"
        />
      </g>
      <path
        id="Trazado_498"
        data-name="Trazado 498"
        d="M-168.881-225.375q0-103.372,39.967-162.871T0-447.745q88.948,0,128.914,59.5t39.967,162.871q0,104.574-39.967,164.073T0-1.8q-88.948,0-128.915-59.5T-168.881-225.375Zm236.794,0q0-60.7-13.222-93.456T0-351.585q-41.469,0-54.691,32.754t-13.222,93.456q0,40.868,4.808,67.613t19.533,43.272Q-28.848-97.963,0-97.963t43.572-16.527Q58.3-131.018,63.105-157.762T67.913-225.375Z"
        transform="matrix(0.985, -0.174, 0.174, 0.985, 1340.031, 742.486)"
        fill="#f7f7f7"
      />
    </g>
  </svg>
)
export const FlagIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="38.25" height="34" viewBox="0 0 38.25 34">
    <path
      id="texto-2"
      d="M36.656-17.046c-1.992.412-7.677.83-17.312-4.223-5.777-3.035-10.5-3.44-13.945-3a3.2,3.2,0,0,0,.976-2.291A3.188,3.188,0,0,0,3.187-29.75,3.188,3.188,0,0,0,0-26.562a3.192,3.192,0,0,0,2.125,2.995V3.719a.533.533,0,0,0,.531.531H3.719a.533.533,0,0,0,.531-.531V-1.567a23.454,23.454,0,0,1,11.92-4,59.16,59.16,0,0,0,9.157-1.248,24.287,24.287,0,0,0,12.617-8.082A1.332,1.332,0,0,0,36.656-17.046ZM3.187-27.625A1.066,1.066,0,0,1,4.25-26.562,1.066,1.066,0,0,1,3.187-25.5a1.066,1.066,0,0,1-1.062-1.062A1.066,1.066,0,0,1,3.187-27.625ZM24.9-8.892a58.242,58.242,0,0,1-8.832,1.209A25.5,25.5,0,0,0,4.25-4.084v-17.85c3.134-.7,7.936-.7,14.1,2.543,7.9,4.144,13.434,4.808,16.568,4.675A22.45,22.45,0,0,1,24.9-8.892Z"
      transform="translate(0 29.75)"
      fill="#0d0c0e"
    />
  </svg>
)
export const BoxIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path
      id="box"
      d="M18.3214 0C19.6607 0 20.8929 0.803571 21.4286 2.08929L23.6786 7.07143C23.8929 7.5 24 7.98214 24 8.46429V20.5714C24 22.5 22.4464 24 20.5714 24H3.42857C1.5 24 0 22.5 0 20.5714V8.46429C0 7.98214 0.0535714 7.5 0.267857 7.07143L2.51786 2.08929C3.05357 0.803571 4.28571 0 5.625 0H18.3214ZM18.3214 2.57143H13.2857V6.85714H20.7857L19.125 3.10714C18.9643 2.78571 18.6429 2.57143 18.3214 2.57143ZM21.4286 9.42857H2.57143V20.5714C2.57143 21.0536 2.94643 21.4286 3.42857 21.4286H20.5714C21 21.4286 21.4286 21.0536 21.4286 20.5714V9.42857ZM3.16071 6.85714H10.7143V2.57143H5.625C5.30357 2.57143 4.98214 2.78571 4.82143 3.10714L3.16071 6.85714Z"
      fill="#383838"
    />
  </svg>
)
export const CheckIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 15 15">
    <path
      id="checkIcon"
      d="M7.94644 13.9608L15.3977 5.8186C15.8664 5.34182 15.8674 4.51417 15.4007 4.03587C14.9654 3.52867 14.2163 3.52971 13.7823 4.03899L7.12148 11.2864L4.21788 8.11351C3.78388 7.60403 3.03465 7.60292 2.59928 8.11018C2.13256 8.58848 2.13357 9.41613 2.60232 9.89291L6.325 13.9608C6.75995 14.4714 7.5115 14.4714 7.94644 13.9608Z"
      fill="white"
    />
  </svg>
)

export const CloseIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 15 15">
    <path
      id="closeIcon"
      d="M13.3393 11.3109C13.8869 11.8176 13.8869 12.7042 13.3393 13.2108C13.0866 13.4642 12.7496 13.5908 12.4126 13.5908C12.0335 13.5908 11.6966 13.4642 11.4438 13.2108L7.02106 8.77769L2.55616 13.2108C2.30343 13.4642 1.96646 13.5908 1.62949 13.5908C1.25039 13.5908 0.913417 13.4642 0.660686 13.2108C0.113104 12.7042 0.113104 11.8176 0.660686 11.3109L5.08346 6.83554L0.660686 2.40239C0.113104 1.89575 0.113104 1.00912 0.660686 0.50247C1.16615 -0.0463963 2.0507 -0.0463963 2.55616 0.50247L7.02106 4.93562L11.4438 0.50247C11.9493 -0.0463963 12.8339 -0.0463963 13.3393 0.50247C13.8869 1.00912 13.8869 1.89575 13.3393 2.40239L8.91654 6.87776L13.3393 11.3109Z"
      fill="white"
    />
  </svg>
)
export const EmailTextFieldIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="15" viewBox="0 0 20 15">
    <path
      id="Trazado_538"
      data-name="Trazado 538"
      d="M18.125-15H1.875A1.875,1.875,0,0,0,0-13.125v11.25A1.875,1.875,0,0,0,1.875,0h16.25A1.875,1.875,0,0,0,20-1.875v-11.25A1.875,1.875,0,0,0,18.125-15ZM1.875-13.75h16.25a.627.627,0,0,1,.625.625v1.617c-.855.723-2.078,1.719-5.883,4.738C12.207-6.246,10.906-4.984,10-5c-.906.016-2.211-1.246-2.867-1.77-3.8-3.02-5.027-4.016-5.883-4.738v-1.617A.627.627,0,0,1,1.875-13.75Zm16.25,12.5H1.875a.627.627,0,0,1-.625-.625V-9.883c.891.73,2.3,1.859,5.105,4.09C7.156-5.152,8.57-3.742,10-3.75c1.422.012,2.824-1.387,3.645-2.043,2.809-2.23,4.215-3.359,5.105-4.09v8.008A.627.627,0,0,1,18.125-1.25Z"
      transform="translate(0 15)"
      fill="#acacac"
    />
  </svg>
)
export const DobleHandIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="47.507"
    height="28.515"
    viewBox="0 0 47.507 28.515"
  >
    <path
      id="texto-2"
      d="M1.187-9.515A1.191,1.191,0,0,0,2.375-10.7,1.191,1.191,0,0,0,1.187-11.89,1.191,1.191,0,0,0,0-10.7,1.186,1.186,0,0,0,1.187-9.515ZM46.906-23.75l-8.424.015-3.8-3.7a3.532,3.532,0,0,0-2.516-1.046h-7.5a3.527,3.527,0,0,0-2.1.742,3.573,3.573,0,0,0-2.175-.764H15.237a3.562,3.562,0,0,0-2.516,1.046L9.01-23.75H.594A.6.6,0,0,0,0-23.156v1.187a.6.6,0,0,0,.594.594H4.75V-7.132H.594A.6.6,0,0,0,0-6.539v1.187a.6.6,0,0,0,.594.594H4.75A2.366,2.366,0,0,0,7.118-7.11H9.582L15.63-1.321a5.954,5.954,0,0,0,7.5-.015l.534.46a3.918,3.918,0,0,0,2.486.883A3.946,3.946,0,0,0,29.22-1.447l1.625-2A3.564,3.564,0,0,0,35.3-4.334L36-5.2a3.559,3.559,0,0,0,.779-1.907H40.39a2.371,2.371,0,0,0,2.368,2.353h4.156a.6.6,0,0,0,.594-.594V-6.539a.6.6,0,0,0-.594-.594H42.757V-21.36l4.156-.015a.6.6,0,0,0,.594-.594v-1.187A.6.6,0,0,0,46.906-23.75ZM34.155-6.709l-.705.868a1.186,1.186,0,0,1-1.67.171L30.459-6.739l-3.08,3.785A1.57,1.57,0,0,1,25.2-2.7L22.926-4.639l-.772.95a3.564,3.564,0,0,1-4.943.586l-6.672-6.39H7.125v-11.89H9.99l4.4-4.4a1.192,1.192,0,0,1,.839-.349h5.158c.067.163.022.052.082.215l-4.379,4.023a5.086,5.086,0,0,0-.312,7.192,5.13,5.13,0,0,0,7.192.312l1.692-1.551,9.322,7.563A1.2,1.2,0,0,1,34.155-6.709Zm6.22-2.783H36.13a3.765,3.765,0,0,0-.653-.727l-9.047-7.348L28.537-19.5a1.186,1.186,0,0,0,.074-1.677,1.193,1.193,0,0,0-1.677-.074L21.36-16.15a2.8,2.8,0,0,1-3.837-.163,2.72,2.72,0,0,1,.163-3.837l6.168-5.655a1.194,1.194,0,0,1,.8-.312h7.5a1.185,1.185,0,0,1,.846.356L37.5-21.375h2.872Zm5.937-2.39a1.191,1.191,0,0,0-1.187,1.187,1.191,1.191,0,0,0,1.188,1.187A1.191,1.191,0,0,0,47.5-10.695,1.186,1.186,0,0,0,46.312-11.882Z"
      transform="translate(0 28.507)"
      fill="#0d0c0e"
    />
  </svg>
)
export const PercentIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36">
    <path
      id="texto-2"
      d="M24.585-19.29l-.8-.8a.563.563,0,0,0-.8,0L11.414-8.506a.563.563,0,0,0,0,.8l.8.8a.563.563,0,0,0,.8,0l11.58-11.58A.562.562,0,0,0,24.585-19.29ZM16.875-18A3.379,3.379,0,0,0,13.5-21.375,3.379,3.379,0,0,0,10.125-18,3.379,3.379,0,0,0,13.5-14.625,3.379,3.379,0,0,0,16.875-18Zm-4.5,0A1.127,1.127,0,0,1,13.5-19.125,1.127,1.127,0,0,1,14.625-18,1.127,1.127,0,0,1,13.5-16.875,1.127,1.127,0,0,1,12.375-18ZM22.5-12.375A3.379,3.379,0,0,0,19.125-9,3.379,3.379,0,0,0,22.5-5.625,3.379,3.379,0,0,0,25.875-9,3.379,3.379,0,0,0,22.5-12.375Zm0,4.5A1.127,1.127,0,0,1,21.375-9,1.127,1.127,0,0,1,22.5-10.125,1.127,1.127,0,0,1,23.625-9,1.127,1.127,0,0,1,22.5-7.875ZM36-13.5a6.96,6.96,0,0,0-3.487-6.012,6.96,6.96,0,0,0-1.786-6.715,6.96,6.96,0,0,0-6.715-1.786A6.96,6.96,0,0,0,18-31.5a6.96,6.96,0,0,0-6.012,3.487,6.96,6.96,0,0,0-6.715,1.786,6.96,6.96,0,0,0-1.786,6.715A6.96,6.96,0,0,0,0-13.5,6.96,6.96,0,0,0,3.487-7.488,6.96,6.96,0,0,0,5.273-.773a6.918,6.918,0,0,0,6.715,1.786A6.969,6.969,0,0,0,18,4.5a6.969,6.969,0,0,0,6.012-3.487A6.91,6.91,0,0,0,30.726-.773a6.96,6.96,0,0,0,1.786-6.715A6.96,6.96,0,0,0,36-13.5ZM29.594-8.7c.373.83,2.074,3.8-.457,6.335-2.032,2.032-4.043,1.5-6.335.457-.323.851-1.216,4.155-4.8,4.155-3.663,0-4.549-3.48-4.8-4.155C10.905-.865,8.888-.345,6.862-2.362,4.275-4.943,6.1-8.023,6.405-8.7,5.555-9.021,2.25-9.914,2.25-13.5c0-3.663,3.48-4.549,4.155-4.8-.373-.83-2.074-3.8.457-6.335,2.588-2.594,5.681-.752,6.335-.457.323-.851,1.216-4.155,4.8-4.155,3.663,0,4.549,3.48,4.8,4.155.83-.373,3.8-2.074,6.335.457,2.587,2.58.766,5.66.457,6.335.851.323,4.155,1.216,4.155,4.8C33.75-9.837,30.269-8.951,29.594-8.7Z"
      transform="translate(0 31.5)"
      fill="#0d0c0e"
    />
  </svg>
)
export const LikeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36">
    <path
      id="texto-2"
      d="M34.921-11.413A5.642,5.642,0,0,0,36-14.944a5.2,5.2,0,0,0-5.114-5.1H25.954a10.226,10.226,0,0,0,1.455-4.909c0-4.107-1.638-6.545-5.829-6.545-2.109,0-2.892,2.666-3.293,4.727a5.983,5.983,0,0,1-1.162,3.09c-1.657,1.657-4.187,5.683-5.708,6.5a2.881,2.881,0,0,1-.565.156A2.247,2.247,0,0,0,9-18H2.25A2.25,2.25,0,0,0,0-15.75v18A2.25,2.25,0,0,0,2.25,4.5H9a2.25,2.25,0,0,0,2.25-2.25V1.635c2.285,0,7.08,2.865,12.477,2.864.387,0,2.647,0,2.884,0,4.168,0,6.487-2.523,6.352-6.314a5.838,5.838,0,0,0,1.281-4.718A6.573,6.573,0,0,0,34.921-11.413ZM2.25,2.25v-18H9v18ZM32.064-12.069c1.124.819,1.124,4.194-.394,4.969a3.362,3.362,0,0,1-1.056,4.359C31.2.953,29.28,2.223,26.591,2.249c-.233,0-2.619,0-2.864,0C18.6,2.249,14.253-.615,11.25-.615V-14.933c2.651,0,5.084-4.777,7.466-7.159,2.148-2.148,1.432-5.727,2.864-7.159,3.58,0,3.58,2.5,3.58,4.3,0,2.966-2.148,4.3-2.148,7.159h7.875a2.957,2.957,0,0,1,2.864,2.864C33.757-13.5,33.187-12.375,32.064-12.069ZM7.312-1.125A1.687,1.687,0,0,0,5.625-2.812,1.687,1.687,0,0,0,3.937-1.125,1.687,1.687,0,0,0,5.625.562,1.687,1.687,0,0,0,7.312-1.125Z"
      transform="translate(0 31.5)"
      fill="#0d0c0e"
    />
  </svg>
)

export const SpeedIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="47.25" height="36.75" viewBox="0 0 47.25 36.75">
    <path
      id="vende-con.lp"
      d="M9.844-10.5a1.968,1.968,0,0,0-1.969-1.969A1.968,1.968,0,0,0,5.906-10.5,1.968,1.968,0,0,0,7.875-8.531,1.968,1.968,0,0,0,9.844-10.5ZM23.625-24.281a1.968,1.968,0,0,0,1.969-1.969,1.968,1.968,0,0,0-1.969-1.969,1.968,1.968,0,0,0-1.969,1.969A1.968,1.968,0,0,0,23.625-24.281Zm11.156,4.594a1.968,1.968,0,0,0,1.969-1.969,1.968,1.968,0,0,0-1.969-1.969,1.968,1.968,0,0,0-1.969,1.969A1.968,1.968,0,0,0,34.781-19.687Zm5.888,8.973a1.318,1.318,0,0,0-1.509-1.08L28.416-10a5.245,5.245,0,0,0-4.791-3.121,5.25,5.25,0,0,0-5.25,5.25,5.25,5.25,0,0,0,5.25,5.25,5.231,5.231,0,0,0,5.2-4.786L39.59-9.2A1.312,1.312,0,0,0,40.669-10.715ZM26.25-7.875A2.625,2.625,0,0,1,23.625-5.25,2.625,2.625,0,0,1,21-7.875,2.625,2.625,0,0,1,23.625-10.5,2.625,2.625,0,0,1,26.25-7.875ZM12.469-23.625A1.968,1.968,0,0,0,10.5-21.656a1.968,1.968,0,0,0,1.969,1.969,1.968,1.968,0,0,0,1.969-1.969A1.968,1.968,0,0,0,12.469-23.625ZM47.25-10.5A23.625,23.625,0,0,0,23.625-34.125,23.625,23.625,0,0,0,0-10.5,23.5,23.5,0,0,0,3.2,1.378,2.6,2.6,0,0,0,5.455,2.625h36.34a2.6,2.6,0,0,0,2.251-1.247A23.5,23.5,0,0,0,47.25-10.5Zm-2.625,0A20.768,20.768,0,0,1,41.795,0L5.471.056A20.973,20.973,0,0,1,2.625-10.5a21.024,21.024,0,0,1,21-21A21.024,21.024,0,0,1,44.625-10.5Z"
      transform="translate(0 34.125)"
      fill="#0d0c0e"
    />
  </svg>
)
export const CreditCardIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="47.25" height="36.75" viewBox="0 0 47.25 36.75">
    <path
      id="vende-con.lp"
      d="M43.312-34.125H3.937A3.939,3.939,0,0,0,0-30.187V-1.312A3.939,3.939,0,0,0,3.937,2.625H43.312A3.939,3.939,0,0,0,47.25-1.312V-30.187A3.939,3.939,0,0,0,43.312-34.125ZM3.937-31.5H43.312a1.316,1.316,0,0,1,1.313,1.312v3.937h-42v-3.937A1.316,1.316,0,0,1,3.937-31.5ZM43.312,0H3.937A1.316,1.316,0,0,1,2.625-1.312V-18.375h42V-1.312A1.316,1.316,0,0,1,43.312,0ZM15.75-6.891a.987.987,0,0,0-.984-.984H8.859a.987.987,0,0,0-.984.984v.656a.987.987,0,0,0,.984.984h5.906a.987.987,0,0,0,.984-.984Zm15.75,0a.987.987,0,0,0-.984-.984H19.359a.987.987,0,0,0-.984.984v.656a.987.987,0,0,0,.984.984H30.516a.987.987,0,0,0,.984-.984Z"
      transform="translate(0 34.125)"
      fill="#0d0c0e"
    />
  </svg>
)
export const IdentificationIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="47.25" height="42" viewBox="0 0 47.25 42">
    <path
      id="vende-con.lp"
      d="M23.625-19.687a6.561,6.561,0,0,0-6.562,6.562,6.561,6.561,0,0,0,6.562,6.562,6.561,6.561,0,0,0,6.562-6.562A6.561,6.561,0,0,0,23.625-19.687Zm0,10.5a3.939,3.939,0,0,1-3.937-3.937,3.939,3.939,0,0,1,3.937-3.937,3.939,3.939,0,0,1,3.937,3.937A3.939,3.939,0,0,1,23.625-9.187ZM42-31.5H28.875v-2.625A2.622,2.622,0,0,0,26.25-36.75H21a2.622,2.622,0,0,0-2.625,2.625V-31.5H5.25A5.255,5.255,0,0,0,0-26.25V0A5.255,5.255,0,0,0,5.25,5.25H42A5.255,5.255,0,0,0,47.25,0V-26.25A5.255,5.255,0,0,0,42-31.5ZM21-34.125h5.25v7.875H21ZM31.5,2.625H15.75V.828a3.637,3.637,0,0,1,.623-2.051,3.415,3.415,0,0,1,2.871-1.411c1.3,0,1.928.656,4.38.656s3.084-.656,4.38-.656a3.405,3.405,0,0,1,2.871,1.411A3.637,3.637,0,0,1,31.5.828ZM44.625,0A2.633,2.633,0,0,1,42,2.625H34.125V.828a6.268,6.268,0,0,0-1.066-3.511A6.018,6.018,0,0,0,28.014-5.25c-1.821,0-2.28.656-4.38.656s-2.559-.656-4.38-.656a6.018,6.018,0,0,0-5.045,2.568A6.287,6.287,0,0,0,13.141.828v1.8H5.25A2.633,2.633,0,0,1,2.625,0V-26.25A2.633,2.633,0,0,1,5.25-28.875H18.375v5.25h10.5v-5.25H42a2.633,2.633,0,0,1,2.625,2.625Z"
      transform="translate(0 36.75)"
      fill="#0d0c0e"
    />
  </svg>
)
export const LoopIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="42" height="41.728" viewBox="0 0 42 41.728">
    <path
      id="vende-con.lp"
      d="M42-15.75a13.056,13.056,0,0,0-2.656-7.907.986.986,0,0,0-1.483-.1l-.468.468a.986.986,0,0,0-.091,1.287,10.443,10.443,0,0,1,2.073,6.256,10.512,10.512,0,0,1-10.5,10.5H9.075l5.595-5.595a.984.984,0,0,0,0-1.392l-.464-.464a.984.984,0,0,0-1.392,0L4.746-4.634a.984.984,0,0,0,0,1.392l8.067,8.067a.984.984,0,0,0,1.392,0l.464-.464a.984.984,0,0,0,0-1.392L9.075-2.625h19.8A13.14,13.14,0,0,0,42-15.75ZM4.7-9.494A10.443,10.443,0,0,1,2.625-15.75a10.512,10.512,0,0,1,10.5-10.5h19.8L27.33-20.655a.984.984,0,0,0,0,1.392l.464.464a.984.984,0,0,0,1.392,0l8.067-8.067a.984.984,0,0,0,0-1.392l-8.067-8.067a.984.984,0,0,0-1.392,0l-.464.464a.984.984,0,0,0,0,1.392l5.595,5.595h-19.8A13.14,13.14,0,0,0,0-15.75,13.056,13.056,0,0,0,2.656-7.843a.986.986,0,0,0,1.483.1l.468-.468A.986.986,0,0,0,4.7-9.494Z"
      transform="translate(0 36.614)"
      fill="#0d0c0e"
    />
  </svg>
)
export const SistecreditoIconWhite = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="152.65"
    height="36.861"
    viewBox="0 0 319.969 76.063"
  >
    <g transform="translate(-526.226 -216.028)">
      <g transform="translate(0 9)">
        <path
          d="M500.63,418.816V411.1h-8.459v-8.032l-6.07,1.311a8.675,8.675,0,0,1-1.28,3.2,8.468,8.468,0,0,1-5.527,3.832c-.124.027-.246.041-.37.064v7.342h3.987v13.319q0,4.745,2.772,7.173t8.2,2.429a25.562,25.562,0,0,0,3.259-.257,18.988,18.988,0,0,0,3.2-.657v-7.487a15.018,15.018,0,0,1-2.115.485,14.072,14.072,0,0,1-2.058.143,4.564,4.564,0,0,1-3.115-.828,3.754,3.754,0,0,1-.885-2.83v-11.49Z"
          transform="translate(118.584 -196.04)"
          fill="#fff"
        />
        <path
          d="M437.865,403.068a5.117,5.117,0,0,0,10.221,0Z"
          transform="translate(118.195 -196.04)"
          fill="#fff"
        />
        <path
          d="M408.31,437.893l4.4-6.23a26.353,26.353,0,0,0,5.2,2.486,14.719,14.719,0,0,0,4.628.772,8.336,8.336,0,0,0,3.63-.658,1.975,1.975,0,0,0,1.345-1.742,1.668,1.668,0,0,0-.744-1.4,5.355,5.355,0,0,0-2.343-.772l-6-.914a12.306,12.306,0,0,1-6.859-3,8,8,0,0,1-2.4-6.03,8.529,8.529,0,0,1,3.485-7.2q3.487-2.629,9.546-2.629a23.662,23.662,0,0,1,6.544.942,23.376,23.376,0,0,1,6.087,2.716l-4.4,5.944a21.561,21.561,0,0,0-4.688-2.087,15.686,15.686,0,0,0-4.457-.656,5.9,5.9,0,0,0-2.858.6,1.782,1.782,0,0,0-1.087,1.573,1.676,1.676,0,0,0,.8,1.457,6.936,6.936,0,0,0,2.744.829l6,.916a12.171,12.171,0,0,1,6.889,2.944A7.75,7.75,0,0,1,436.2,431.6a8.34,8.34,0,0,1-1.03,4.059,10.258,10.258,0,0,1-2.828,3.259,13.7,13.7,0,0,1-4.315,2.143,18.453,18.453,0,0,1-5.431.771,30.378,30.378,0,0,1-7.973-1,18.739,18.739,0,0,1-6.316-2.944"
          transform="translate(117.916 -195.969)"
          fill="#fff"
        />
        <path
          d="M449.7,437.893l4.4-6.23a26.354,26.354,0,0,0,5.2,2.486,14.719,14.719,0,0,0,4.628.772,8.336,8.336,0,0,0,3.63-.658,1.975,1.975,0,0,0,1.345-1.742,1.668,1.668,0,0,0-.744-1.4,5.355,5.355,0,0,0-2.343-.772l-6-.914a12.306,12.306,0,0,1-6.859-3,8,8,0,0,1-2.4-6.03,8.529,8.529,0,0,1,3.485-7.2q3.487-2.629,9.546-2.629a23.662,23.662,0,0,1,6.544.942,23.377,23.377,0,0,1,6.087,2.716l-4.4,5.944a21.561,21.561,0,0,0-4.688-2.087,15.686,15.686,0,0,0-4.457-.656,5.9,5.9,0,0,0-2.858.6,1.783,1.783,0,0,0-1.087,1.573,1.676,1.676,0,0,0,.8,1.457,6.936,6.936,0,0,0,2.744.829l6,.916a12.171,12.171,0,0,1,6.889,2.944,7.75,7.75,0,0,1,2.429,5.858,8.34,8.34,0,0,1-1.03,4.059,10.258,10.258,0,0,1-2.828,3.259,13.7,13.7,0,0,1-4.315,2.143,18.453,18.453,0,0,1-5.431.771,30.378,30.378,0,0,1-7.973-1,18.739,18.739,0,0,1-6.316-2.944"
          transform="translate(118.309 -195.969)"
          fill="#fff"
        />
        <path
          d="M531.113,437.264a19.413,19.413,0,0,1-5.859,3.488,19.84,19.84,0,0,1-6.773,1.086,17.37,17.37,0,0,1-6.458-1.2,15.578,15.578,0,0,1-8.717-8.316,14.914,14.914,0,0,1-1.285-6.145,15.537,15.537,0,0,1,1.228-6.145,15.714,15.714,0,0,1,3.344-5,15.316,15.316,0,0,1,5-3.315,16,16,0,0,1,6.2-1.2,14.762,14.762,0,0,1,10.947,4.686,15.564,15.564,0,0,1,3.172,5.231,18.7,18.7,0,0,1,1.144,6.6v2.286H511.508a7.985,7.985,0,0,0,2.858,3.457,7.838,7.838,0,0,0,4.573,1.343,9.377,9.377,0,0,0,3.429-.6A7.462,7.462,0,0,0,525,431.835Zm-13.488-19.2a6.337,6.337,0,0,0-3.944,1.258,6.707,6.707,0,0,0-2.344,3.544h12.632a7.3,7.3,0,0,0-2.43-3.487,6.19,6.19,0,0,0-3.915-1.315"
          transform="translate(118.803 -195.97)"
          fill="#fff"
        />
        <rect width="9.26" height="30.236" transform="translate(556.543 215.06)" fill="#fff" />
      </g>
      <g transform="translate(0 9)">
        <path
          d="M691.906,418.816V411.1h-8.459v-8.032l-6.07,1.311a8.674,8.674,0,0,1-1.28,3.2,8.467,8.467,0,0,1-5.527,3.832c-.124.027-.246.041-.37.064v7.342h3.987v13.319q0,4.745,2.772,7.173t8.2,2.429a25.566,25.566,0,0,0,3.259-.257,18.989,18.989,0,0,0,3.2-.657v-7.487a15.018,15.018,0,0,1-2.115.485,14.071,14.071,0,0,1-2.058.143,4.564,4.564,0,0,1-3.115-.828,3.754,3.754,0,0,1-.885-2.83v-11.49Z"
          transform="translate(120.393 -196.04)"
          fill="#fff"
        />
        <path
          d="M596.753,403.1a5.117,5.117,0,0,0,10.221,0Z"
          transform="translate(119.699 -196.04)"
          fill="#fff"
        />
        <path
          d="M655.723,403.1a5.117,5.117,0,0,0,10.221,0Z"
          transform="translate(120.256 -196.04)"
          fill="#fff"
        />
        <path
          d="M551.319,433.835a7.676,7.676,0,0,0,3.487-.8,10.518,10.518,0,0,0,3.087-2.459l5.486,5.718a15.641,15.641,0,0,1-5.6,4.085,16.993,16.993,0,0,1-6.916,1.459,16.558,16.558,0,0,1-6.316-1.2,15.425,15.425,0,0,1-9.687-14.46,15.673,15.673,0,0,1,1.227-6.2A15.149,15.149,0,0,1,539.459,415a16.311,16.311,0,0,1,11.4-4.544,17.406,17.406,0,0,1,7.087,1.485,16.425,16.425,0,0,1,5.717,4.117l-5.659,5.887a11.785,11.785,0,0,0-3.257-2.63,7.849,7.849,0,0,0-3.659-.857,6.492,6.492,0,0,0-5,2.23,7.849,7.849,0,0,0-2.029,5.486,7.624,7.624,0,0,0,2.086,5.458,6.841,6.841,0,0,0,5.172,2.2"
          transform="translate(119.113 -195.97)"
          fill="#fff"
        />
        <path
          d="M565.6,441.268V411.031h9.26v3.029a10.514,10.514,0,0,1,3.487-2.744,10.078,10.078,0,0,1,4.459-.972,17.01,17.01,0,0,1,2.115.2,3.4,3.4,0,0,1,1.371.544v8.059a11.347,11.347,0,0,0-2.057-.658,10.627,10.627,0,0,0-2.343-.257,8.173,8.173,0,0,0-4.03,1.03,8.315,8.315,0,0,0-3,2.8v19.206Z"
          transform="translate(119.404 -195.971)"
          fill="#fff"
        />
        <path
          d="M615.534,437.264a19.413,19.413,0,0,1-5.859,3.488,19.84,19.84,0,0,1-6.773,1.086,17.371,17.371,0,0,1-6.459-1.2,15.578,15.578,0,0,1-8.717-8.316,14.913,14.913,0,0,1-1.285-6.145,15.535,15.535,0,0,1,1.227-6.145,15.713,15.713,0,0,1,3.344-5,15.317,15.317,0,0,1,5-3.315,16,16,0,0,1,6.2-1.2,14.762,14.762,0,0,1,10.947,4.686,15.563,15.563,0,0,1,3.172,5.231,18.7,18.7,0,0,1,1.144,6.6v2.286H595.93a7.986,7.986,0,0,0,2.858,3.457,7.838,7.838,0,0,0,4.573,1.343,9.377,9.377,0,0,0,3.429-.6,7.462,7.462,0,0,0,2.629-1.685Zm-13.488-19.2a6.337,6.337,0,0,0-3.944,1.258,6.7,6.7,0,0,0-2.344,3.544h12.632a7.3,7.3,0,0,0-2.43-3.487,6.19,6.19,0,0,0-3.915-1.315"
          transform="translate(119.602 -195.97)"
          fill="#fff"
        />
        <path
          d="M642.832,441.336v-2.229A14.538,14.538,0,0,1,639,441.05a13.457,13.457,0,0,1-4.286.685,15.267,15.267,0,0,1-6.029-1.2,15.1,15.1,0,0,1-4.917-3.315,15.68,15.68,0,0,1-3.287-4.944,15.42,15.42,0,0,1-1.2-6.087,15.1,15.1,0,0,1,1.228-6.087,15.307,15.307,0,0,1,8.344-8.2,16.309,16.309,0,0,1,10.2-.684,15.335,15.335,0,0,1,3.658,1.486v-7.6l9.26-2v38.234Zm-14.461-15.147a7.223,7.223,0,0,0,2.315,5.458,7.869,7.869,0,0,0,5.63,2.2,10.062,10.062,0,0,0,3.544-.6,8.362,8.362,0,0,0,2.858-1.8V420.873a8.974,8.974,0,0,0-2.858-1.715,9.916,9.916,0,0,0-3.544-.629,7.841,7.841,0,0,0-5.658,2.2,7.27,7.27,0,0,0-2.286,5.458"
          transform="translate(119.912 -196.04)"
          fill="#fff"
        />
        <rect width="9.26" height="30.236" transform="translate(776.459 215.06)" fill="#fff" />
        <path
          d="M720.015,419.652a1.388,1.388,0,0,0-1.827.715l-1.8,4.106a8.782,8.782,0,0,1,.167,1.7,7.544,7.544,0,0,1-2.143,5.429,7.252,7.252,0,0,1-10.461,0,8.022,8.022,0,0,1,0-10.916,7.249,7.249,0,0,1,10.461,0,7.736,7.736,0,0,1,1.1,1.457l1.084-2.477a3.125,3.125,0,0,1,4.117-1.609l3.329,1.458a15.691,15.691,0,0,0-3.227-4.488,16.433,16.433,0,0,0-5.2-3.343,17.446,17.446,0,0,0-12.861,0,16.427,16.427,0,0,0-5.2,3.343,15.775,15.775,0,0,0-3.487,5,15.331,15.331,0,0,0,0,12.288,15.743,15.743,0,0,0,3.487,5,15.969,15.969,0,0,0,5.2,3.316,17.828,17.828,0,0,0,12.861,0,15.975,15.975,0,0,0,5.2-3.316,15.725,15.725,0,0,0,3.486-5,14.915,14.915,0,0,0,1.287-6.144,15.1,15.1,0,0,0-.641-4.366Z"
          transform="translate(120.607 -195.97)"
          fill="#fff"
        />
      </g>
      <path
        d="M3.7-16.606V.315H1.357V-16.09ZM5.482-5.661a6.166,6.166,0,0,1,.48-2.426,6.028,6.028,0,0,1,1.324-1.969,6.261,6.261,0,0,1,1.98-1.312,6.166,6.166,0,0,1,2.426-.48,6.166,6.166,0,0,1,2.426.48,6.122,6.122,0,0,1,1.969,1.312A6.122,6.122,0,0,1,17.4-8.087a6.166,6.166,0,0,1,.48,2.426,6.225,6.225,0,0,1-.48,2.449,6.122,6.122,0,0,1-1.312,1.969A6.122,6.122,0,0,1,14.118.069a6.166,6.166,0,0,1-2.426.48A6.166,6.166,0,0,1,9.267.069a6.261,6.261,0,0,1-1.98-1.312A6.028,6.028,0,0,1,5.962-3.212,6.225,6.225,0,0,1,5.482-5.661Zm6.211,4.148A3.644,3.644,0,0,0,14.446-2.72a4.132,4.132,0,0,0,1.137-2.941,4.091,4.091,0,0,0-1.137-2.93,3.66,3.66,0,0,0-2.754-1.2,3.7,3.7,0,0,0-2.766,1.2,4.068,4.068,0,0,0-1.148,2.93A4.132,4.132,0,0,0,8.915-2.72,3.669,3.669,0,0,0,11.693-1.513ZM24.091.315V-16.09l2.344-.516v6.187a4.771,4.771,0,0,1,1.605-1.066,5.255,5.255,0,0,1,1.98-.363,4.561,4.561,0,0,1,3.351,1.3,4.529,4.529,0,0,1,1.312,3.363v7.5H32.34v-7.1A2.993,2.993,0,0,0,31.532-9a2.9,2.9,0,0,0-2.144-.809,3.61,3.61,0,0,0-1.7.4,3.33,3.33,0,0,0-1.254,1.148V.315ZM40.707.526A4.8,4.8,0,0,1,37.543-.481a3.245,3.245,0,0,1-1.219-2.625,3.152,3.152,0,0,1,1.289-2.66,5.753,5.753,0,0,1,3.539-.973,8.031,8.031,0,0,1,1.687.176,9.391,9.391,0,0,1,1.57.48V-7.348a2.344,2.344,0,0,0-.75-1.9A3.257,3.257,0,0,0,41.5-9.88a6.419,6.419,0,0,0-1.711.246,12.853,12.853,0,0,0-1.992.762l-.867-1.758a13.414,13.414,0,0,1,2.531-.926,9.916,9.916,0,0,1,2.367-.293,5.3,5.3,0,0,1,3.6,1.113,3.958,3.958,0,0,1,1.277,3.152v7.9h-2.3V-.716A5.573,5.573,0,0,1,42.7.222,6.265,6.265,0,0,1,40.707.526Zm-2.133-3.68a1.665,1.665,0,0,0,.738,1.406,3.2,3.2,0,0,0,1.934.539,5.177,5.177,0,0,0,1.734-.281,4.273,4.273,0,0,0,1.43-.844V-4.4a5.584,5.584,0,0,0-1.43-.551,7.187,7.187,0,0,0-1.641-.176,3.387,3.387,0,0,0-2.016.539A1.678,1.678,0,0,0,38.575-3.153ZM54.652-1.536A4.021,4.021,0,0,0,56.34-1.9a5.249,5.249,0,0,0,1.523-1.09l1.406,1.523A6.894,6.894,0,0,1,57.113,0a6.366,6.366,0,0,1-2.555.527,6.081,6.081,0,0,1-2.414-.48,6.115,6.115,0,0,1-1.945-1.3,6.082,6.082,0,0,1-1.3-1.957,6.225,6.225,0,0,1-.48-2.449,6.166,6.166,0,0,1,.48-2.426,6.221,6.221,0,0,1,1.3-1.969,6.019,6.019,0,0,1,1.945-1.312,6.081,6.081,0,0,1,2.414-.48,6.7,6.7,0,0,1,2.6.527,6.754,6.754,0,0,1,2.2,1.465L57.887-8.262a4.84,4.84,0,0,0-1.523-1.113,4.172,4.172,0,0,0-1.758-.387,3.623,3.623,0,0,0-2.742,1.2,4.085,4.085,0,0,0-1.125,2.906A4.08,4.08,0,0,0,51.875-2.72,3.7,3.7,0,0,0,54.652-1.536ZM70.1-1.044A7.522,7.522,0,0,1,67.941.14,7.526,7.526,0,0,1,65.48.526a6.311,6.311,0,0,1-2.461-.48,6.329,6.329,0,0,1-1.992-1.3A5.9,5.9,0,0,1,59.7-3.212a6.225,6.225,0,0,1-.48-2.449,6.213,6.213,0,0,1,.469-2.414,6.157,6.157,0,0,1,1.266-1.945,5.907,5.907,0,0,1,1.9-1.3A5.8,5.8,0,0,1,65.2-11.8a5.5,5.5,0,0,1,2.285.48,5.523,5.523,0,0,1,1.828,1.312,6.236,6.236,0,0,1,1.207,1.98,6.747,6.747,0,0,1,.445,2.461v.68H61.543A3.962,3.962,0,0,0,62.9-2.438a3.952,3.952,0,0,0,2.672.973,4.963,4.963,0,0,0,1.664-.281A4.12,4.12,0,0,0,68.6-2.52ZM65.152-9.833a3.388,3.388,0,0,0-2.332.891,3.936,3.936,0,0,0-1.254,2.3h7.078a4.079,4.079,0,0,0-1.23-2.273A3.2,3.2,0,0,0,65.152-9.833ZM72.746.315V-11.614h2.344v1.125a4.612,4.612,0,0,1,1.5-1.008,4.767,4.767,0,0,1,1.852-.352,4.407,4.407,0,0,1,2.156.527A3.977,3.977,0,0,1,82.12-9.856a4.8,4.8,0,0,1,1.746-1.488,5.087,5.087,0,0,1,2.285-.5,4.279,4.279,0,0,1,3.223,1.3,4.644,4.644,0,0,1,1.254,3.363v7.5H88.284v-7.1A3.161,3.161,0,0,0,87.546-9a2.579,2.579,0,0,0-2-.809,3.129,3.129,0,0,0-1.57.4,3.55,3.55,0,0,0-1.219,1.2,4.61,4.61,0,0,1,.07.5q.023.27.023.527v7.5h-2.32v-7.1A3.161,3.161,0,0,0,79.788-9a2.579,2.579,0,0,0-2-.809,3.18,3.18,0,0,0-1.523.363,3.3,3.3,0,0,0-1.172,1.09V.315ZM92.339-5.661a6.166,6.166,0,0,1,.48-2.426,6.028,6.028,0,0,1,1.324-1.969,6.261,6.261,0,0,1,1.98-1.312,6.166,6.166,0,0,1,2.426-.48,6.166,6.166,0,0,1,2.426.48,6.122,6.122,0,0,1,1.969,1.312,6.122,6.122,0,0,1,1.312,1.969,6.166,6.166,0,0,1,.48,2.426,6.225,6.225,0,0,1-.48,2.449,6.122,6.122,0,0,1-1.312,1.969A6.122,6.122,0,0,1,100.975.069,6.166,6.166,0,0,1,98.55.55a6.166,6.166,0,0,1-2.426-.48,6.261,6.261,0,0,1-1.98-1.312,6.028,6.028,0,0,1-1.324-1.969A6.225,6.225,0,0,1,92.339-5.661ZM98.55-1.513A3.644,3.644,0,0,0,101.3-2.72a4.132,4.132,0,0,0,1.137-2.941,4.091,4.091,0,0,0-1.137-2.93,3.66,3.66,0,0,0-2.754-1.2,3.7,3.7,0,0,0-2.766,1.2,4.068,4.068,0,0,0-1.148,2.93A4.132,4.132,0,0,0,95.772-2.72,3.669,3.669,0,0,0,98.55-1.513Zm6.82.281,1.266-1.547a7.882,7.882,0,0,0,1.91,1.113,5.318,5.318,0,0,0,1.98.387,3.876,3.876,0,0,0,2.062-.492,1.472,1.472,0,0,0,.8-1.289,1.224,1.224,0,0,0-.469-1.008,3.02,3.02,0,0,0-1.453-.516l-2.156-.3a4.89,4.89,0,0,1-2.66-1.09,2.868,2.868,0,0,1-.9-2.215,3.146,3.146,0,0,1,1.289-2.613,5.367,5.367,0,0,1,3.375-1,8.215,8.215,0,0,1,2.5.375,8.726,8.726,0,0,1,2.309,1.148l-1.2,1.547a7.62,7.62,0,0,0-1.91-.949,6.144,6.144,0,0,0-1.863-.293,3.037,3.037,0,0,0-1.734.445,1.358,1.358,0,0,0-.656,1.172,1.164,1.164,0,0,0,.457,1,3.523,3.523,0,0,0,1.512.5l2.156.3a4.969,4.969,0,0,1,2.684,1.1,2.869,2.869,0,0,1,.926,2.226,3,3,0,0,1-.387,1.488,3.711,3.711,0,0,1-1.055,1.184,5.447,5.447,0,0,1-1.582.785A6.415,6.415,0,0,1,110.6.526,9.17,9.17,0,0,1,107.7.081,6.625,6.625,0,0,1,105.37-1.231Zm16.007,6.4V-11.614h2.32v1.148a5,5,0,0,1,1.664-1,5.8,5.8,0,0,1,1.992-.34,5.856,5.856,0,0,1,2.367.48,6.045,6.045,0,0,1,1.91,1.3,6.054,6.054,0,0,1,1.277,1.945,6.213,6.213,0,0,1,.469,2.414,6.3,6.3,0,0,1-.469,2.426,6.023,6.023,0,0,1-1.277,1.957A5.977,5.977,0,0,1,129.7.022a6.023,6.023,0,0,1-2.391.48A6.071,6.071,0,0,1,125.4.2a5.785,5.785,0,0,1-1.676-.867V5.167Zm5.672-14.929a4.673,4.673,0,0,0-1.875.375,3.965,3.965,0,0,0-1.453,1.055v5.39a3.853,3.853,0,0,0,1.441,1.031,4.757,4.757,0,0,0,1.887.375,3.879,3.879,0,0,0,2.871-1.172,4,4,0,0,0,1.16-2.93,4.014,4.014,0,0,0-1.172-2.941A3.871,3.871,0,0,0,127.049-9.762Zm7.664,4.1a6.166,6.166,0,0,1,.48-2.426,6.028,6.028,0,0,1,1.324-1.969,6.261,6.261,0,0,1,1.98-1.312,6.166,6.166,0,0,1,2.426-.48,6.166,6.166,0,0,1,2.426.48,6.122,6.122,0,0,1,1.969,1.312,6.122,6.122,0,0,1,1.312,1.969,6.166,6.166,0,0,1,.48,2.426,6.225,6.225,0,0,1-.48,2.449,6.122,6.122,0,0,1-1.312,1.969A6.122,6.122,0,0,1,143.349.069a6.166,6.166,0,0,1-2.426.48A6.166,6.166,0,0,1,138.5.069a6.261,6.261,0,0,1-1.98-1.312,6.028,6.028,0,0,1-1.324-1.969A6.225,6.225,0,0,1,134.713-5.661Zm6.211,4.148a3.644,3.644,0,0,0,2.754-1.207,4.132,4.132,0,0,0,1.137-2.941,4.091,4.091,0,0,0-1.137-2.93,3.66,3.66,0,0,0-2.754-1.2,3.7,3.7,0,0,0-2.766,1.2,4.068,4.068,0,0,0-1.148,2.93,4.132,4.132,0,0,0,1.137,2.941A3.669,3.669,0,0,0,140.923-1.513Zm6.82.281,1.266-1.547a7.882,7.882,0,0,0,1.91,1.113,5.318,5.318,0,0,0,1.98.387,3.876,3.876,0,0,0,2.062-.492,1.472,1.472,0,0,0,.8-1.289,1.224,1.224,0,0,0-.469-1.008,3.02,3.02,0,0,0-1.453-.516l-2.156-.3a4.89,4.89,0,0,1-2.66-1.09,2.868,2.868,0,0,1-.9-2.215,3.146,3.146,0,0,1,1.289-2.613,5.367,5.367,0,0,1,3.375-1,8.215,8.215,0,0,1,2.5.375,8.726,8.726,0,0,1,2.309,1.148l-1.2,1.547a7.62,7.62,0,0,0-1.91-.949,6.144,6.144,0,0,0-1.863-.293,3.037,3.037,0,0,0-1.734.445,1.358,1.358,0,0,0-.656,1.172,1.164,1.164,0,0,0,.457,1,3.524,3.524,0,0,0,1.512.5l2.156.3a4.969,4.969,0,0,1,2.684,1.1,2.869,2.869,0,0,1,.926,2.226,3,3,0,0,1-.387,1.488,3.711,3.711,0,0,1-1.055,1.184,5.446,5.446,0,0,1-1.582.785,6.415,6.415,0,0,1-1.969.293,9.17,9.17,0,0,1-2.894-.445A6.625,6.625,0,0,1,147.743-1.231Zm12.726-12.3a1.357,1.357,0,0,1-1.008-.434,1.414,1.414,0,0,1-.422-1.02,1.414,1.414,0,0,1,.422-1.02,1.357,1.357,0,0,1,1.008-.434,1.4,1.4,0,0,1,1.02.434,1.4,1.4,0,0,1,.434,1.02,1.4,1.4,0,0,1-.434,1.02A1.4,1.4,0,0,1,160.47-13.536Zm1.172,1.922V.315H159.3V-11.614Zm14.32,5.953a6.3,6.3,0,0,1-.469,2.426,6.024,6.024,0,0,1-1.277,1.957,5.977,5.977,0,0,1-1.934,1.3,6.023,6.023,0,0,1-2.391.48,6.037,6.037,0,0,1-1.922-.3,5.83,5.83,0,0,1-1.687-.891V.315h-2.32V-16.09l2.344-.516v6.117a5.213,5.213,0,0,1,1.664-.973,5.732,5.732,0,0,1,1.969-.34,5.856,5.856,0,0,1,2.367.48,6.045,6.045,0,0,1,1.91,1.3,6.056,6.056,0,0,1,1.277,1.945A6.213,6.213,0,0,1,175.961-5.661Zm-6.328-4.1a4.673,4.673,0,0,0-1.875.375,3.965,3.965,0,0,0-1.453,1.055v5.39a3.853,3.853,0,0,0,1.441,1.031,4.757,4.757,0,0,0,1.887.375A3.879,3.879,0,0,0,172.5-2.708a4,4,0,0,0,1.16-2.93,4.014,4.014,0,0,0-1.172-2.941A3.871,3.871,0,0,0,169.633-9.762Zm10.453-6.844V.315h-2.344V-16.09ZM192.742-1.044A7.522,7.522,0,0,1,190.586.14a7.526,7.526,0,0,1-2.461.387,6.311,6.311,0,0,1-2.461-.48,6.329,6.329,0,0,1-1.992-1.3,5.9,5.9,0,0,1-1.324-1.957,6.226,6.226,0,0,1-.48-2.449,6.213,6.213,0,0,1,.469-2.414A6.157,6.157,0,0,1,183.6-10.02a5.907,5.907,0,0,1,1.9-1.3,5.8,5.8,0,0,1,2.344-.48,5.5,5.5,0,0,1,2.285.48,5.524,5.524,0,0,1,1.828,1.312,6.236,6.236,0,0,1,1.207,1.98,6.747,6.747,0,0,1,.445,2.461v.68h-9.422a3.962,3.962,0,0,0,1.359,2.449,3.952,3.952,0,0,0,2.672.973,4.963,4.963,0,0,0,1.664-.281,4.12,4.12,0,0,0,1.359-.773ZM187.8-9.833a3.388,3.388,0,0,0-2.332.891,3.936,3.936,0,0,0-1.254,2.3h7.078a4.079,4.079,0,0,0-1.23-2.273A3.2,3.2,0,0,0,187.8-9.833Z"
        transform="translate(588.615 286.924)"
        fill="#fff"
      />
    </g>
  </svg>
)
export const LuegopagoIconLogin = () => (
  <svg
    id="Grupo_546"
    data-name="Grupo 546"
    xmlns="http://www.w3.org/2000/svg"
    width="381.11"
    height="120.983"
    viewBox="0 0 381.11 120.983"
  >
    <defs>
      <clipPath id="clip-path">
        <rect
          id="Rectángulo_501"
          data-name="Rectángulo 501"
          width="381.11"
          height="120.983"
          fill="none"
        />
      </clipPath>
    </defs>
    <g id="Grupo_545" data-name="Grupo 545" clipPath="url(#clip-path)">
      <path
        id="Trazado_5700"
        data-name="Trazado 5700"
        d="M124.675,120.983a10.858,10.858,0,0,1-5.425-1.369A6.034,6.034,0,0,1,115.8,120.7h-3.661a6.022,6.022,0,0,1-1.822-.282,6.006,6.006,0,0,1-1.816.282H104.84a6,6,0,0,1-2.851-.717,15.684,15.684,0,0,1-5.422.926,12.642,12.642,0,0,1-5.577-1.247,5.972,5.972,0,0,1-1.395.643,14.5,14.5,0,0,1-4.545.673,11.868,11.868,0,0,1-9.759-4.912l-2.447,2.447A6.047,6.047,0,0,1,68.2,120.7H64.542a6,6,0,0,1-2.851-.717,15.68,15.68,0,0,1-5.421.926,12.633,12.633,0,0,1-5.644-1.276,6.029,6.029,0,0,1-3.416,1.067H43.548a5.988,5.988,0,0,1-1.926-.318,5.975,5.975,0,0,1-1.92.318H36.04A5.993,5.993,0,0,1,33.207,120a15.671,15.671,0,0,1-5.394.916,12.312,12.312,0,0,1-7.058-2.125,13.373,13.373,0,0,1-7.61,2.195,18.463,18.463,0,0,1-7.376-1.492,6.016,6.016,0,0,1-3.621-5.079l-.278-3.661a6.027,6.027,0,0,1,.561-3.016,10.13,10.13,0,0,1-.6-3.465,10.256,10.256,0,0,1,3.284-7.642L10.041,91.7a9.941,9.941,0,0,1,.719-.7q.14-.158.279-.3C4.116,88.751,0,82.679,0,73.9V39.733a6.046,6.046,0,0,1,2.187-4.642l4.722-4.722a6.06,6.06,0,0,1,.8-.793,6.123,6.123,0,0,1,.794-.8l4.8-4.8c.1-.11.2-.221.308-.33s.228-.221.344-.322l4.8-4.8a5.825,5.825,0,0,1,.625-.637,5.807,5.807,0,0,1,.635-.624l4.734-4.733a5.819,5.819,0,0,1,.54-.562A6.033,6.033,0,0,1,29.84,9.893H41.407a6.039,6.039,0,0,1,6.033,6.033v7.507a6.056,6.056,0,0,1,1.54-.2H60.223a6.024,6.024,0,0,1,4.691,2.243c.057-.056.115-.111.175-.166a6.03,6.03,0,0,1,4.553-2.078H80.886a6.044,6.044,0,0,1,5.906,4.8,24.638,24.638,0,0,1,16.1-5.623c9.021,0,13.863,3.552,16.446,7.076l.363-.363c.048-.048.106-.1.166-.161a21.38,21.38,0,0,1,15.638-6.552,20.451,20.451,0,0,1,7.265,1.284,6.03,6.03,0,0,1,2.341-.473h9.674a6.044,6.044,0,0,1,5.8,4.38,25.549,25.549,0,0,1,30.1-.568l1.567-1.574c.085-.086.169-.164.25-.236.064-.072.132-.145.206-.221a6.076,6.076,0,0,1,4.28-1.782h9.724a6.026,6.026,0,0,1,2.5.542,21.7,21.7,0,0,1,7.4-1.252,21.281,21.281,0,0,1,15.185,6.317l1.65-1.645a5.866,5.866,0,0,1,.558-.576,6.027,6.027,0,0,1,1.936-1.469l.241-.115a31.944,31.944,0,0,1,14.227-2.969c8.2,0,14.392,2.8,17.8,7.872l.562-.562c.139-.143.282-.283.424-.422l0,0a21.391,21.391,0,0,1,15.629-6.53,20.451,20.451,0,0,1,7.265,1.284,6.03,6.03,0,0,1,2.341-.473h9.674a6.045,6.045,0,0,1,5.738,4.166,24.952,24.952,0,0,1,15.09-4.978c.27,0,.544,0,.824.014l3.081-3.081a8.051,8.051,0,0,1,.581-.58l4.9-4.9a7.768,7.768,0,0,1,.584-.588c.172-.187.35-.364.532-.529l4.878-4.878c.162-.182.337-.359.53-.538A8.505,8.505,0,0,1,347.264,4.6a11.508,11.508,0,0,1,3.7.639q.329.112.66.251l2.329-2.329c.157-.173.323-.341.5-.507A8.149,8.149,0,0,1,356.362,1.1,8.018,8.018,0,0,1,360.427,0c5.915,0,9.519,6.065,12,11.349a115.792,115.792,0,0,1,5.341,14.316,6.96,6.96,0,0,1,.206,3.254,9.215,9.215,0,0,1,1.408,1.984,15.771,15.771,0,0,1-3.348,18.842c-.153.158-.308.315-.47.47l-5,5c-.093.1-.19.19-.288.282l-.032.032c-.216.229-.439.455-.672.678l-5.06,5.059c-.165.17-.312.319-.463.464l-5,5c-.192.2-.393.392-.6.585-.232.247-.47.492-.72.731l-5,5a21.086,21.086,0,0,1-4.012,3.221,22.97,22.97,0,0,1-12.035,3.713,18.53,18.53,0,0,1-3.941-.422,19.7,19.7,0,0,1-6.73-2.918l-.869.87c-.271.282-.562.565-.9.88l-.018.02c-.132.146-.267.291-.409.429l-4.984,4.984a24.2,24.2,0,0,1-17.7,7.2,25.686,25.686,0,0,1-13.311-3.567l-1.453,1.453c-.271.284-.552.558-.839.828-.167.176-.324.338-.487.5l-4.988,4.989c-4.586,4.8-11.342,7.437-19.031,7.437-2.983,0-8.667-.277-13.217-2.13a6.007,6.007,0,0,1-3.756-5.587V89.6a6,6,0,0,1-2.669.619h-9.295a6.032,6.032,0,0,1-2.267-.446,21.718,21.718,0,0,1-7.845,1.317c-5.868,0-10.671-2.3-13.508-6.193l-.243.243a19.532,19.532,0,0,1-9.3,5.37l-3.145,3.145a267.513,267.513,0,0,0-1.592,1.592l-4.721,4.721a6.046,6.046,0,0,1-4.642,2.187H173.252a6,6,0,0,1-3.431-1.073q-.13.128-.268.249a5.812,5.812,0,0,1-.636.624l-4.8,4.8c-.095.109-.2.22-.306.328s-.227.22-.343.32l-4.8,4.8a242.015,242.015,0,0,0-1.592,1.591l-4.721,4.721a6.048,6.048,0,0,1-4.642,2.187h-3.661a6,6,0,0,1-2.851-.717,15.68,15.68,0,0,1-5.421.926,12.674,12.674,0,0,1-5.564-1.237,4.44,4.44,0,0,1-.4.212,11.958,11.958,0,0,1-5.14,1.095"
        fill="#fff"
      />
      <path
        id="Trazado_5701"
        data-name="Trazado 5701"
        d="M159.614,114.3a2.011,2.011,0,0,0,.772-1.491l.162-3.475a2.01,2.01,0,0,0-1.7-2.081,5.124,5.124,0,0,0-1-.07,5.733,5.733,0,0,0-2.164.414,2,2,0,0,0-1.124-.345c-.047,0-.095,0-.143,0l-3.29.231a2.007,2.007,0,0,0-1.385.7c-.036.042-1.241,1.232-1.339,1.34a7.207,7.207,0,0,0-5.454-2.274,7.463,7.463,0,0,0-5.555,2.428c-.119.11-.239.219-.351.336l.031-.387a2.011,2.011,0,0,0-2-2.169h-1.534v-.955a2.01,2.01,0,0,0-2.264-1.995l-3.072.389a18.166,18.166,0,0,0,1.636-1.514l5.055-5.056a17.98,17.98,0,0,0,4.206-6.4,21.51,21.51,0,0,0,29.821.075l4.136-4.137c.055-.053.115-.1.17-.156V107.1a2.011,2.011,0,0,0,2.011,2.011H186.8a2,2,0,0,0,1.629-.841l5.056-5.056a2,2,0,0,0,.841-1.629v-3.6a13.613,13.613,0,0,0,1.533.094,15.69,15.69,0,0,0,11.479-4.789l4.485-4.477c.859,5.665,5.421,9.228,12.13,9.228a15.5,15.5,0,0,0,8.308-2,2.011,2.011,0,0,0,1.805,1.124h9.295a2.009,2.009,0,0,0,1.422-.589l5.009-5.017a15,15,0,0,0,1.987,1.8,1.982,1.982,0,0,0-.408.416c-.182.127-1.32,1.442-1.32,2.1v10.037a2.012,2.012,0,0,0,1.252,1.863c4.061,1.654,9.535,1.833,11.7,1.833,6.8,0,12.4-2.284,16.152-6.224l5.055-5.056a17.946,17.946,0,0,0,4.109-6.149,21.552,21.552,0,0,0,29.615-.2l5.055-5.055a17.609,17.609,0,0,0,3.86-5.535c.125.132.247.267.374.4a16.975,16.975,0,0,0,8.355,4.814,14.5,14.5,0,0,0,3.083.33h0a18.97,18.97,0,0,0,9.909-3.1,16.955,16.955,0,0,0,3.27-2.626l5.056-5.055a12.278,12.278,0,0,0,3.259-4.915,11.919,11.919,0,0,0-.651-9.192,6.412,6.412,0,0,0-2.965-2.674c.032-.036.064-.07.094-.108a2.893,2.893,0,0,0,.973-3.15,111.758,111.758,0,0,0-5.136-13.782c-2.932-6.249-5.509-9.036-8.356-9.036a4.041,4.041,0,0,0-2.049.562,4.207,4.207,0,0,0-1.04.875l-5.056,5.056-.017.014a9.185,9.185,0,0,0-2.6-1.486,7.516,7.516,0,0,0-2.4-.424,4.5,4.5,0,0,0-3.547,1.537l-5.056,5.055a4.224,4.224,0,0,0-.79.908c-.015.022-.028.044-.042.067-1.675,2.835.429,5.205,1.559,6.478.108.121.214.24.314.357a39.154,39.154,0,0,1,3.388,4.547c.237.365.464.753.691,1.141-.009.011-1.593,1.572-1.682,1.665a5.185,5.185,0,0,0-.947,1.4c-.125.117-.974.964-1.046,1.036a20.164,20.164,0,0,0-15.17-6.377,20.432,20.432,0,0,0-14.516,5.784l-4.3,4.3V58.52A2.011,2.011,0,0,0,287.8,56.51h-9.675a2.009,2.009,0,0,0-1.636.846,2.078,2.078,0,0,0-.259.221,16.073,16.073,0,0,0-7.711-1.879A17.4,17.4,0,0,0,255.79,60.99l-5.277,5.27c-1.422-7.069-7.118-10.918-16.419-10.918a28.09,28.09,0,0,0-12.5,2.577l-.242.115a2,2,0,0,0-.762.642l-5.46,5.44A17.572,17.572,0,0,0,192.24,57.7,2.012,2.012,0,0,0,190.4,56.51h-9.724a2.011,2.011,0,0,0-1.427.594l-4.689,4.71a21.178,21.178,0,0,0-29.715-.059L140.486,66.1V58.52a2.011,2.011,0,0,0-2.011-2.011H128.8a2.008,2.008,0,0,0-1.636.846,1.986,1.986,0,0,0-.259.221A16.077,16.077,0,0,0,119.2,55.7a17.408,17.408,0,0,0-12.5,5.077l-4.857,4.852c-1.1-5.03-5.5-9.928-15.254-9.928a20.25,20.25,0,0,0-14.9,5.983l-5.057,5.056-.042.042,0-8.246a2.011,2.011,0,0,0-2.011-2.01H53.329a2,2,0,0,0-1.629.841c-.178.127-5.642,5.635-5.779,6.031V58.533a2.011,2.011,0,0,0-2.011-2.011H32.667a2,2,0,0,0-1.629.841c-.177.127-3.854,3.811-3.933,3.889V45.193a2.011,2.011,0,0,0-2.011-2.011H13.527a2,2,0,0,0-1.629.841L6.841,49.079A2.005,2.005,0,0,0,6,50.709V84.872c0,8.547,4.428,13.449,12.149,13.449a22.326,22.326,0,0,0,5.293-.686l.1-.023a2,2,0,0,0,1.16-.786l3.321-3.3c2.268,2.943,5.863,4.439,10.789,4.439a15.159,15.159,0,0,0,8.469-2.158,2.011,2.011,0,0,0,1.9,1.368h9.886a2.015,2.015,0,0,0,1.422-.589l4.6-4.6c.007-.007.013-.016.019-.023,3.41,3.845,8.839,6.01,15.76,6.01,6.233,0,11.023-.869,13.143-2.384l5.374-5.348a15,15,0,0,0,3.075,3.121,8.374,8.374,0,0,0-.867.876,2,2,0,0,0-.861,1.638v10.037a2.006,2.006,0,0,0,.867,1.647,7.383,7.383,0,0,0-3.36,2.069c-.161.145-.741.73-.875.871l-.13-1.162a2.009,2.009,0,0,0-1.446-1.709,11.153,11.153,0,0,0-3.24-.448,7.953,7.953,0,0,0-5.9,2.524l-5.056,5.056a7.431,7.431,0,0,0-2.436,5.53,7.677,7.677,0,0,0,7.872,7.641,10.515,10.515,0,0,0,3.338-.487,2.005,2.005,0,0,0,1.022-.743c.178-.127,1.154-1.109,1.254-1.222a7.893,7.893,0,0,0,5.9,2.382,10.122,10.122,0,0,0,5.24-1.273,7.362,7.362,0,0,0,.994-.98c.01-.007.019-.015.028-.022v.056a2.011,2.011,0,0,0,2.011,2.011h3.661a4.762,4.762,0,0,0,1.876-1.05,2.007,2.007,0,0,0,1.761,1.05h3.661a2.006,2.006,0,0,0,1.63-.841c.177-.128,1.664-1.622,1.781-1.77a5.968,5.968,0,0,0,5.466,2.888,8,8,0,0,0,3.412-.7,19.8,19.8,0,0,0,1.838-1.682,7.919,7.919,0,0,0,5.85,2.317,10.12,10.12,0,0,0,5.24-1.273,7.363,7.363,0,0,0,.994-.98c.01-.007.019-.015.028-.022v.056a2.011,2.011,0,0,0,2.011,2.011h3.661a2.005,2.005,0,0,0,1.629-.841l5.055-5.056a2,2,0,0,0,.841-1.629V116.69c.009-.011,2.4-2.386,2.4-2.386M124.4,107.64a2631702951238.072,2631702951238.072,0,0,1-.919.919,2.012,2.012,0,0,0-.275.237,5.842,5.842,0,0,0-.805-.627,20.874,20.874,0,0,0,2.564-1.131c-.039.045-.071.1-.106.143a2.009,2.009,0,0,0-.46.46m-14.986,1.769a1.97,1.97,0,0,0-.174.168c-.06-.067-.114-.14-.176-.2.117.012.235.025.351.036"
        transform="translate(-1.978 -10.976)"
        fill="#ff40fc"
      />
      <path
        id="Trazado_5702"
        data-name="Trazado 5702"
        d="M77.766,156a2,2,0,0,0,.841-1.629v-3.443c.009-.011.016-.025.025-.037l2.375-2.349a2.011,2.011,0,0,0,.772-1.491l.162-3.475a2.009,2.009,0,0,0-1.7-2.081,5.125,5.125,0,0,0-1-.07,5.727,5.727,0,0,0-2.164.414,2.006,2.006,0,0,0-1.124-.345c-.048,0-.1,0-.143,0l-3.29.231a2.009,2.009,0,0,0-1.385.7c-.036.042-1.241,1.232-1.339,1.34a7.207,7.207,0,0,0-5.454-2.274,7.464,7.464,0,0,0-5.577,2.44c-.16.147-1.074,1.066-1.148,1.141v-5.926a2.01,2.01,0,0,0-2.01-2.011c-.034,0-.068,0-.1,0l-3.661.186a2,2,0,0,0-1.526.839,2.019,2.019,0,0,0-.334.308,1.981,1.981,0,0,0-1.885-1.335c-.034,0-.068,0-.1,0l-3.661.186a2,2,0,0,0-1.516.826l-3.943,3.9a7.955,7.955,0,0,0-2.991-.562,7.46,7.46,0,0,0-5.566,2.43l-1.839,1.839-.04.036a5.377,5.377,0,0,0-.542-.587c.009-.012.015-.025.024-.038a2.008,2.008,0,0,0,.859-1.806l-.278-3.5a2.009,2.009,0,0,0-1.154-1.662,12.873,12.873,0,0,0-5.137-.977,8.371,8.371,0,0,0-6.382,2.462l-5.056,5.056a6.209,6.209,0,0,0-2.042,4.735,5.819,5.819,0,0,0,1.4,3.84c-.027.033-.055.064-.079.1a2,2,0,0,0-.46.46,2.009,2.009,0,0,0-.828,1.778l.278,3.661a2.011,2.011,0,0,0,1.207,1.693,14.468,14.468,0,0,0,5.78,1.162,8.685,8.685,0,0,0,6.539-2.531c.162-.146,1.153-1.136,1.263-1.25a7.576,7.576,0,0,0,6.867,3.711,10.123,10.123,0,0,0,5.24-1.273,2,2,0,0,0,.534-.52,2.009,2.009,0,0,0,.442-.437v.011a2.011,2.011,0,0,0,2.011,2.011h3.66a1.989,1.989,0,0,0,1.62-.838,2.007,2.007,0,0,0,.394-.378,2,2,0,0,0,1.833,1.216h3.661a2.006,2.006,0,0,0,1.629-.841c.177-.128,1.418-1.412,1.438-1.428a7.859,7.859,0,0,0,5.992,2.477,10.124,10.124,0,0,0,5.241-1.273,7.4,7.4,0,0,0,.993-.98c.01-.007.018-.015.027-.022v.056A2.011,2.011,0,0,0,67.42,161.9h3.661a2.006,2.006,0,0,0,1.63-.841Z"
        transform="translate(-2.878 -45.218)"
        fill="#ff40fc"
      />
      <path
        id="Trazado_5703"
        data-name="Trazado 5703"
        d="M169.037,104.881a2.011,2.011,0,0,0,.772-1.491l.162-3.475a2.01,2.01,0,0,0-1.7-2.081,5.125,5.125,0,0,0-1-.07,5.733,5.733,0,0,0-2.164.414,2,2,0,0,0-1.124-.345c-.047,0-.095,0-.143,0l-3.29.231a2.007,2.007,0,0,0-1.385.7c-.036.042-1.241,1.232-1.339,1.34a7.207,7.207,0,0,0-5.454-2.274,7.463,7.463,0,0,0-5.555,2.428c-.119.11-.239.219-.351.336l.031-.387a2.012,2.012,0,0,0-2-2.169h-1.534v-.955a2.01,2.01,0,0,0-2.264-1.995l-3.072.389a18.167,18.167,0,0,0,1.636-1.514l5.055-5.056a17.98,17.98,0,0,0,4.206-6.4,21.51,21.51,0,0,0,29.821.075l4.136-4.137c.055-.053.115-.1.17-.156v19.38a2.011,2.011,0,0,0,2.011,2.011h11.568a2,2,0,0,0,1.629-.841l5.056-5.056a2,2,0,0,0,.841-1.629v-3.6a13.615,13.615,0,0,0,1.533.094,15.69,15.69,0,0,0,11.479-4.789l4.485-4.477c.859,5.665,5.421,9.228,12.13,9.228a15.494,15.494,0,0,0,8.307-2,2.011,2.011,0,0,0,1.805,1.124h9.295a2.008,2.008,0,0,0,1.422-.589l5.009-5.017a15,15,0,0,0,1.987,1.8,1.982,1.982,0,0,0-.408.416c-.182.127-1.32,1.442-1.32,2.1V96.5a2.012,2.012,0,0,0,1.252,1.863c4.061,1.654,9.535,1.833,11.7,1.833,6.8,0,12.4-2.284,16.152-6.224l5.055-5.056a17.945,17.945,0,0,0,4.109-6.149,21.552,21.552,0,0,0,29.615-.2l5.055-5.055a17.609,17.609,0,0,0,3.859-5.535c.125.132.247.267.374.4A16.975,16.975,0,0,0,345,77.18a14.5,14.5,0,0,0,3.083.33h0a18.97,18.97,0,0,0,9.909-3.1,16.955,16.955,0,0,0,3.27-2.626l5.056-5.055a12.278,12.278,0,0,0,3.259-4.915,11.92,11.92,0,0,0-.651-9.192,6.412,6.412,0,0,0-2.965-2.674c.032-.036.064-.07.094-.108a2.893,2.893,0,0,0,.973-3.15A111.764,111.764,0,0,0,361.893,32.9c-2.932-6.249-5.509-9.036-8.356-9.036a4.041,4.041,0,0,0-2.049.562,4.205,4.205,0,0,0-1.04.875l-5.056,5.056-.017.014a9.185,9.185,0,0,0-2.6-1.486,7.516,7.516,0,0,0-2.4-.424A4.5,4.5,0,0,0,336.827,30l-5.056,5.055a4.224,4.224,0,0,0-.79.908c-.015.022-.028.044-.042.067-1.675,2.835.429,5.205,1.559,6.478.108.121.214.24.314.357a39.149,39.149,0,0,1,3.388,4.547c.237.365.464.753.691,1.141-.009.011-1.593,1.572-1.682,1.665a5.183,5.183,0,0,0-.947,1.4c-.125.117-.974.964-1.046,1.036a20.164,20.164,0,0,0-15.17-6.377,20.432,20.432,0,0,0-14.516,5.784l-4.3,4.3V49.1a2.011,2.011,0,0,0-2.011-2.011h-9.675a2.009,2.009,0,0,0-1.636.846,2.081,2.081,0,0,0-.259.221,16.074,16.074,0,0,0-7.711-1.879,17.4,17.4,0,0,0-12.727,5.292l-5.277,5.27c-1.422-7.069-7.118-10.918-16.419-10.918a28.089,28.089,0,0,0-12.5,2.577l-.242.115a2,2,0,0,0-.762.642l-5.46,5.44a17.572,17.572,0,0,0-22.893-6.413,2.012,2.012,0,0,0-1.838-1.194H190.1a2.011,2.011,0,0,0-1.427.594l-4.689,4.71a21.178,21.178,0,0,0-29.715-.059l-4.362,4.344V49.1a2.011,2.011,0,0,0-2.011-2.011h-9.674a2.008,2.008,0,0,0-1.636.846,1.987,1.987,0,0,0-.259.221,16.077,16.077,0,0,0-7.711-1.879,17.408,17.408,0,0,0-12.5,5.077L111.26,56.2c-1.1-5.03-5.5-9.928-15.254-9.928a20.25,20.25,0,0,0-14.9,5.983l-5.057,5.056-.042.042,0-8.246A2.011,2.011,0,0,0,74,47.1H62.752a2,2,0,0,0-1.629.841c-.178.127-5.642,5.635-5.779,6.031V49.11A2.011,2.011,0,0,0,53.333,47.1H42.09a2,2,0,0,0-1.629.841c-.177.127-3.854,3.811-3.933,3.889V35.77a2.011,2.011,0,0,0-2.011-2.011H22.95a2,2,0,0,0-1.629.841l-5.056,5.055a2.005,2.005,0,0,0-.841,1.63V75.449C15.423,84,19.851,88.9,27.572,88.9a22.325,22.325,0,0,0,5.293-.686l.1-.023a2,2,0,0,0,1.16-.786l3.321-3.3c2.268,2.943,5.863,4.439,10.789,4.439A15.16,15.16,0,0,0,56.7,86.385a2.011,2.011,0,0,0,1.9,1.368H68.49a2.015,2.015,0,0,0,1.422-.589l4.6-4.6c.007-.007.013-.016.019-.023,3.41,3.845,8.839,6.01,15.76,6.01,6.233,0,11.023-.869,13.143-2.384l5.374-5.348a15,15,0,0,0,3.075,3.121,8.372,8.372,0,0,0-.867.876,2,2,0,0,0-.861,1.638V96.5a2.006,2.006,0,0,0,.867,1.647,7.383,7.383,0,0,0-3.36,2.069c-.161.145-.741.73-.875.871l-.13-1.162a2.009,2.009,0,0,0-1.446-1.709,11.153,11.153,0,0,0-3.24-.448,7.953,7.953,0,0,0-5.9,2.524l-5.056,5.056a7.432,7.432,0,0,0-2.436,5.53,7.677,7.677,0,0,0,7.872,7.641,10.515,10.515,0,0,0,3.338-.487,2,2,0,0,0,1.022-.743c.178-.127,1.154-1.109,1.254-1.222a7.893,7.893,0,0,0,5.9,2.382,10.122,10.122,0,0,0,5.24-1.273,7.361,7.361,0,0,0,.994-.98c.01-.007.019-.015.028-.022v.056a2.011,2.011,0,0,0,2.011,2.011H119.9a2,2,0,0,0,1.631-.842,2.026,2.026,0,0,0,.245-.208,2.007,2.007,0,0,0,1.761,1.05H127.2a2.006,2.006,0,0,0,1.63-.841c.177-.128,1.664-1.622,1.781-1.77a5.968,5.968,0,0,0,5.465,2.888,8,8,0,0,0,3.412-.7,19.8,19.8,0,0,0,1.838-1.682,7.919,7.919,0,0,0,5.85,2.317,10.12,10.12,0,0,0,5.24-1.273,7.359,7.359,0,0,0,.994-.98c.01-.007.019-.015.028-.022v.056a2.011,2.011,0,0,0,2.011,2.011h3.661a2.005,2.005,0,0,0,1.629-.841l5.055-5.056a2,2,0,0,0,.841-1.629v-3.443c.009-.011,2.4-2.386,2.4-2.386m-35.218-6.664a11.141,11.141,0,0,1-1.194,1.156,5.841,5.841,0,0,0-.805-.627,20.873,20.873,0,0,0,2.564-1.131c-.039.045-.071.1-.106.143a2.01,2.01,0,0,0-.46.46m-14.986,1.769a1.968,1.968,0,0,0-.174.168c-.06-.067-.114-.14-.176-.2.117.012.235.025.351.036"
        transform="translate(-5.085 -7.869)"
        fill="#ffb7c7"
      />
      <path
        id="Trazado_5704"
        data-name="Trazado 5704"
        d="M87.189,146.581a2,2,0,0,0,.841-1.629v-3.443c.009-.011.016-.025.025-.037l2.375-2.349a2.011,2.011,0,0,0,.772-1.491l.162-3.475a2.009,2.009,0,0,0-1.7-2.081,5.125,5.125,0,0,0-1-.07,5.727,5.727,0,0,0-2.164.414,2.006,2.006,0,0,0-1.124-.345c-.048,0-.1,0-.143,0l-3.29.231a2.009,2.009,0,0,0-1.385.7c-.036.042-1.241,1.232-1.339,1.34a7.207,7.207,0,0,0-5.454-2.274,7.464,7.464,0,0,0-5.577,2.44c-.16.147-1.074,1.066-1.148,1.141v-5.926a2.01,2.01,0,0,0-2.01-2.011c-.034,0-.068,0-.1,0l-3.661.186a2,2,0,0,0-1.526.839,2.019,2.019,0,0,0-.334.308,1.98,1.98,0,0,0-1.885-1.335c-.034,0-.068,0-.1,0l-3.661.186a2,2,0,0,0-1.516.826l-3.943,3.9a7.954,7.954,0,0,0-2.991-.562,7.46,7.46,0,0,0-5.566,2.43L37.9,136.343l-.04.036a5.375,5.375,0,0,0-.542-.587c.009-.012.015-.025.024-.038a2.008,2.008,0,0,0,.859-1.806l-.278-3.5a2.009,2.009,0,0,0-1.154-1.662,12.873,12.873,0,0,0-5.137-.977,8.371,8.371,0,0,0-6.382,2.462l-5.056,5.056a6.209,6.209,0,0,0-2.042,4.735,5.819,5.819,0,0,0,1.4,3.84c-.027.033-.055.064-.079.1a2,2,0,0,0-.46.46,2.009,2.009,0,0,0-.828,1.778l.278,3.661a2.011,2.011,0,0,0,1.207,1.693,14.468,14.468,0,0,0,5.78,1.162,8.685,8.685,0,0,0,6.539-2.531c.162-.146,1.153-1.136,1.263-1.25a7.576,7.576,0,0,0,6.867,3.711,10.124,10.124,0,0,0,5.24-1.273,2,2,0,0,0,.534-.52,2.01,2.01,0,0,0,.442-.437v.011a2.011,2.011,0,0,0,2.011,2.011H52a4.152,4.152,0,0,0,2.014-1.216,2,2,0,0,0,1.833,1.216H59.51a2.006,2.006,0,0,0,1.629-.841c.177-.128,1.418-1.412,1.438-1.428a7.86,7.86,0,0,0,5.992,2.477,10.125,10.125,0,0,0,5.241-1.273,7.4,7.4,0,0,0,.993-.98c.01-.007.018-.015.027-.022v.056a2.011,2.011,0,0,0,2.011,2.011H80.5a2.006,2.006,0,0,0,1.63-.841Z"
        transform="translate(-5.985 -42.111)"
        fill="#ffb7c7"
      />
      <path
        id="Trazado_5705"
        data-name="Trazado 5705"
        d="M177.278,96.64a2.011,2.011,0,0,0,.772-1.491l.162-3.475a2.01,2.01,0,0,0-1.7-2.081,5.125,5.125,0,0,0-1-.07,5.732,5.732,0,0,0-2.164.414,2,2,0,0,0-1.124-.345c-.047,0-.095,0-.143,0l-3.29.231a2.007,2.007,0,0,0-1.385.7c-.036.042-1.241,1.232-1.339,1.34a7.207,7.207,0,0,0-5.454-2.274,7.463,7.463,0,0,0-5.555,2.428c-.119.11-.239.219-.351.336l.031-.387a2.012,2.012,0,0,0-2-2.169H151.2v-.955a2.01,2.01,0,0,0-2.264-1.995l-3.072.389a18.165,18.165,0,0,0,1.636-1.514l5.055-5.056a17.98,17.98,0,0,0,4.206-6.4,21.51,21.51,0,0,0,29.821.075l4.136-4.137c.055-.053.115-.1.17-.156v19.38a2.011,2.011,0,0,0,2.011,2.011h11.568a2,2,0,0,0,1.629-.841l5.056-5.056a2,2,0,0,0,.841-1.629v-3.6a13.613,13.613,0,0,0,1.533.095A15.69,15.69,0,0,0,225,75.626l4.485-4.477c.859,5.665,5.421,9.228,12.13,9.228a15.494,15.494,0,0,0,8.307-2,2.011,2.011,0,0,0,1.805,1.124h9.295a2.008,2.008,0,0,0,1.422-.589l5.009-5.017a15,15,0,0,0,1.987,1.8,1.982,1.982,0,0,0-.408.416c-.182.127-1.32,1.442-1.32,2.1V88.254a2.012,2.012,0,0,0,1.252,1.863c4.061,1.654,9.535,1.833,11.7,1.833,6.8,0,12.4-2.284,16.152-6.224l5.055-5.056a17.946,17.946,0,0,0,4.109-6.149,21.552,21.552,0,0,0,29.615-.2l5.055-5.055a17.609,17.609,0,0,0,3.859-5.535c.125.132.247.267.374.4a16.975,16.975,0,0,0,8.355,4.814,14.5,14.5,0,0,0,3.083.33h0a18.97,18.97,0,0,0,9.909-3.1,16.955,16.955,0,0,0,3.27-2.626l5.056-5.055a12.278,12.278,0,0,0,3.259-4.915,11.92,11.92,0,0,0-.651-9.192A6.412,6.412,0,0,0,374.2,41.7c.031-.036.064-.07.094-.108a2.893,2.893,0,0,0,.973-3.15,111.763,111.763,0,0,0-5.136-13.782c-2.932-6.249-5.509-9.036-8.356-9.036a4.042,4.042,0,0,0-2.049.562,4.206,4.206,0,0,0-1.04.875l-5.056,5.056-.017.014a9.185,9.185,0,0,0-2.6-1.486,7.515,7.515,0,0,0-2.4-.424,4.5,4.5,0,0,0-3.547,1.537l-5.056,5.055a4.224,4.224,0,0,0-.79.908c-.015.022-.028.044-.042.067-1.675,2.835.429,5.205,1.559,6.478.108.121.214.24.314.357a39.149,39.149,0,0,1,3.388,4.547c.237.365.464.753.691,1.141-.009.011-1.593,1.572-1.682,1.665a5.184,5.184,0,0,0-.947,1.4c-.125.117-.974.964-1.046,1.036a20.164,20.164,0,0,0-15.17-6.377,20.432,20.432,0,0,0-14.516,5.784l-4.3,4.3V40.856a2.011,2.011,0,0,0-2.011-2.011h-9.675a2.009,2.009,0,0,0-1.636.846,2.08,2.08,0,0,0-.259.221,16.074,16.074,0,0,0-7.711-1.879,17.4,17.4,0,0,0-12.727,5.292l-5.277,5.27c-1.422-7.069-7.118-10.918-16.419-10.918a28.089,28.089,0,0,0-12.5,2.577l-.242.115a2,2,0,0,0-.762.642l-5.46,5.44A17.572,17.572,0,0,0,209.9,40.039a2.012,2.012,0,0,0-1.838-1.194h-9.724a2.011,2.011,0,0,0-1.427.594l-4.689,4.71a21.178,21.178,0,0,0-29.715-.059l-4.362,4.344V40.856a2.011,2.011,0,0,0-2.011-2.011h-9.674a2.008,2.008,0,0,0-1.636.846,1.986,1.986,0,0,0-.259.221,16.077,16.077,0,0,0-7.711-1.879,17.408,17.408,0,0,0-12.5,5.077L119.5,47.962c-1.1-5.03-5.5-9.928-15.254-9.928a20.25,20.25,0,0,0-14.9,5.983l-5.057,5.056-.042.042,0-8.246a2.011,2.011,0,0,0-2.011-2.01H70.993a2,2,0,0,0-1.629.841c-.178.127-5.642,5.635-5.779,6.031V40.869a2.011,2.011,0,0,0-2.011-2.011H50.331A2,2,0,0,0,48.7,39.7c-.177.127-3.854,3.811-3.933,3.889V27.529a2.011,2.011,0,0,0-2.011-2.011H31.191a2,2,0,0,0-1.629.841l-5.056,5.055a2.005,2.005,0,0,0-.841,1.63V67.208c0,8.547,4.428,13.449,12.149,13.449a22.326,22.326,0,0,0,5.293-.686l.1-.023a2,2,0,0,0,1.16-.786l3.321-3.3C47.95,78.807,51.545,80.3,56.471,80.3a15.16,15.16,0,0,0,8.469-2.158,2.011,2.011,0,0,0,1.9,1.368h9.886a2.015,2.015,0,0,0,1.422-.589l4.6-4.6c.007-.007.013-.016.019-.023,3.41,3.845,8.839,6.01,15.76,6.01,6.233,0,11.023-.869,13.143-2.384l5.374-5.348A15,15,0,0,0,120.12,75.7a8.373,8.373,0,0,0-.867.876,2,2,0,0,0-.861,1.638V88.254a2.006,2.006,0,0,0,.867,1.647,7.383,7.383,0,0,0-3.36,2.069c-.161.145-.741.73-.875.871l-.13-1.162a2.009,2.009,0,0,0-1.446-1.709,11.153,11.153,0,0,0-3.24-.448,7.953,7.953,0,0,0-5.9,2.524L99.255,97.1a7.432,7.432,0,0,0-2.436,5.53,7.677,7.677,0,0,0,7.872,7.641,10.515,10.515,0,0,0,3.338-.487,2.005,2.005,0,0,0,1.022-.743c.178-.127,1.154-1.109,1.254-1.222a7.893,7.893,0,0,0,5.9,2.382,10.122,10.122,0,0,0,5.24-1.273,7.363,7.363,0,0,0,.994-.98c.01-.007.019-.015.028-.022v.056a2.011,2.011,0,0,0,2.011,2.011h3.661a2,2,0,0,0,1.631-.842,2.025,2.025,0,0,0,.245-.208,2.007,2.007,0,0,0,1.761,1.05h3.661a2.006,2.006,0,0,0,1.63-.841c.177-.128,1.664-1.622,1.781-1.77a5.968,5.968,0,0,0,5.465,2.888,8,8,0,0,0,3.412-.7,19.8,19.8,0,0,0,1.838-1.682,7.919,7.919,0,0,0,5.85,2.317,10.12,10.12,0,0,0,5.24-1.273,7.363,7.363,0,0,0,.994-.98c.01-.007.019-.015.028-.022v.056a2.011,2.011,0,0,0,2.011,2.011h3.661a2.005,2.005,0,0,0,1.629-.841l5.055-5.056a2,2,0,0,0,.841-1.629V99.026c.009-.011,2.4-2.386,2.4-2.386M142.06,89.976a13047.718,13047.718,0,0,0-.919.919,2.012,2.012,0,0,0-.275.237,5.842,5.842,0,0,0-.805-.627,20.869,20.869,0,0,0,2.565-1.131c-.039.045-.071.1-.106.143a2.01,2.01,0,0,0-.46.46m-14.986,1.769a1.972,1.972,0,0,0-.174.168c-.06-.067-.114-.14-.176-.2.117.012.235.025.351.036"
        transform="translate(-7.802 -5.152)"
        fill="#6064ff"
      />
      <path
        id="Trazado_5706"
        data-name="Trazado 5706"
        d="M95.43,138.34a2,2,0,0,0,.841-1.629v-3.443c.009-.011.016-.025.025-.037l2.375-2.349a2.011,2.011,0,0,0,.772-1.491l.162-3.475a2.009,2.009,0,0,0-1.7-2.081,5.125,5.125,0,0,0-1-.07,5.726,5.726,0,0,0-2.164.414,2.006,2.006,0,0,0-1.124-.345c-.048,0-.1,0-.143,0l-3.29.231a2.009,2.009,0,0,0-1.385.7c-.036.042-1.241,1.232-1.339,1.34A7.207,7.207,0,0,0,82,123.833a7.464,7.464,0,0,0-5.577,2.44c-.16.147-1.074,1.066-1.148,1.141v-5.926a2.01,2.01,0,0,0-2.01-2.011c-.034,0-.068,0-.1,0l-3.661.186a2,2,0,0,0-1.526.839,2.02,2.02,0,0,0-.334.308,1.98,1.98,0,0,0-1.885-1.335c-.034,0-.068,0-.1,0L62,119.665a2,2,0,0,0-1.516.826l-3.943,3.9a7.954,7.954,0,0,0-2.991-.562,7.46,7.46,0,0,0-5.566,2.43L46.141,128.1l-.04.036a5.375,5.375,0,0,0-.542-.587c.009-.012.015-.025.024-.038a2.008,2.008,0,0,0,.859-1.806l-.278-3.5a2.009,2.009,0,0,0-1.154-1.662,12.873,12.873,0,0,0-5.137-.977,8.371,8.371,0,0,0-6.382,2.462l-5.056,5.056a6.209,6.209,0,0,0-2.042,4.735,5.819,5.819,0,0,0,1.4,3.84c-.027.033-.055.064-.079.1a2,2,0,0,0-.46.46A2.009,2.009,0,0,0,26.422,138l.278,3.661a2.011,2.011,0,0,0,1.207,1.693,14.468,14.468,0,0,0,5.78,1.162,8.685,8.685,0,0,0,6.539-2.531c.162-.146,1.153-1.136,1.263-1.25a7.576,7.576,0,0,0,6.867,3.711,10.124,10.124,0,0,0,5.24-1.273,85.235,85.235,0,0,0,.976-.957v.011a2.011,2.011,0,0,0,2.011,2.011h3.66a4.152,4.152,0,0,0,2.014-1.216,2,2,0,0,0,1.833,1.216h3.661a2.006,2.006,0,0,0,1.629-.841c.177-.128,1.418-1.412,1.438-1.428a7.86,7.86,0,0,0,5.992,2.477,10.124,10.124,0,0,0,5.241-1.273,7.4,7.4,0,0,0,.993-.98c.01-.007.018-.015.027-.022v.056a2.011,2.011,0,0,0,2.011,2.011h3.661a2.006,2.006,0,0,0,1.63-.841Z"
        transform="translate(-8.702 -39.394)"
        fill="#6064ff"
      />
      <path
        id="Trazado_5707"
        data-name="Trazado 5707"
        d="M186.218,87.7a2.011,2.011,0,0,0,.772-1.491l.162-3.475a2.01,2.01,0,0,0-1.7-2.081,5.125,5.125,0,0,0-1-.07,5.733,5.733,0,0,0-2.164.414,2,2,0,0,0-1.124-.345c-.047,0-.095,0-.143,0l-3.29.231a2.007,2.007,0,0,0-1.385.7c-.036.042-1.241,1.232-1.339,1.34a7.207,7.207,0,0,0-5.454-2.274,7.463,7.463,0,0,0-5.555,2.428c-.119.11-.239.219-.351.336l.031-.387a2.012,2.012,0,0,0-2-2.169h-1.534V79.9a2.01,2.01,0,0,0-2.264-1.995L154.8,78.3a18.164,18.164,0,0,0,1.636-1.514l5.055-5.056a17.981,17.981,0,0,0,4.206-6.4,21.51,21.51,0,0,0,29.821.075l4.136-4.137c.055-.053.115-.1.17-.156v19.38a2.011,2.011,0,0,0,2.011,2.011H213.4a2,2,0,0,0,1.629-.841l5.056-5.056a2,2,0,0,0,.841-1.629v-3.6a13.612,13.612,0,0,0,1.533.095,15.69,15.69,0,0,0,11.479-4.789l4.485-4.477c.859,5.665,5.421,9.228,12.13,9.228a15.494,15.494,0,0,0,8.307-2,2.011,2.011,0,0,0,1.805,1.124h9.295a2.01,2.01,0,0,0,1.422-.589l5.009-5.017a15,15,0,0,0,1.987,1.8,1.981,1.981,0,0,0-.408.416c-.182.127-1.32,1.442-1.32,2.1V79.314a2.012,2.012,0,0,0,1.252,1.863c4.061,1.654,9.535,1.833,11.7,1.833,6.8,0,12.4-2.284,16.152-6.224l5.055-5.056a17.946,17.946,0,0,0,4.11-6.148,21.552,21.552,0,0,0,29.615-.2l5.055-5.055a17.609,17.609,0,0,0,3.859-5.535c.125.132.247.267.374.4A16.975,16.975,0,0,0,362.182,60a14.5,14.5,0,0,0,3.083.33h0a18.97,18.97,0,0,0,9.909-3.1,16.957,16.957,0,0,0,3.27-2.626l5.056-5.055a12.277,12.277,0,0,0,3.259-4.915,11.92,11.92,0,0,0-.651-9.192,6.412,6.412,0,0,0-2.965-2.674c.032-.036.064-.07.094-.108a2.893,2.893,0,0,0,.973-3.15,111.757,111.757,0,0,0-5.136-13.782c-2.932-6.249-5.509-9.036-8.356-9.036a4.041,4.041,0,0,0-2.049.562,4.207,4.207,0,0,0-1.04.875l-5.056,5.056-.017.014a9.185,9.185,0,0,0-2.6-1.486,7.515,7.515,0,0,0-2.4-.424,4.5,4.5,0,0,0-3.547,1.537l-5.056,5.055a4.224,4.224,0,0,0-.79.908c-.015.022-.028.044-.042.067-1.675,2.835.429,5.205,1.559,6.478.108.121.214.24.314.357a39.154,39.154,0,0,1,3.388,4.547c.237.365.464.753.691,1.142-.009.011-1.593,1.572-1.682,1.665a5.184,5.184,0,0,0-.947,1.4c-.125.117-.974.964-1.046,1.036a20.164,20.164,0,0,0-15.17-6.377,20.432,20.432,0,0,0-14.516,5.784l-4.3,4.3V31.916a2.011,2.011,0,0,0-2.011-2.011h-9.675a2.009,2.009,0,0,0-1.636.846,2.079,2.079,0,0,0-.259.221,16.074,16.074,0,0,0-7.711-1.879,17.4,17.4,0,0,0-12.727,5.292l-5.277,5.27C275.694,32.587,270,28.739,260.7,28.739a28.09,28.09,0,0,0-12.5,2.577l-.242.115a2,2,0,0,0-.762.642l-5.46,5.44A17.572,17.572,0,0,0,218.844,31.1a2.012,2.012,0,0,0-1.838-1.194h-9.724a2.01,2.01,0,0,0-1.427.594l-4.689,4.71a21.178,21.178,0,0,0-29.715-.059l-4.362,4.344V31.916a2.011,2.011,0,0,0-2.011-2.011h-9.674a2.008,2.008,0,0,0-1.636.846,1.987,1.987,0,0,0-.259.221,16.077,16.077,0,0,0-7.711-1.879,17.408,17.408,0,0,0-12.5,5.077l-4.857,4.852c-1.1-5.03-5.5-9.928-15.254-9.928a20.25,20.25,0,0,0-14.9,5.983l-5.057,5.056-.042.042,0-8.246a2.011,2.011,0,0,0-2.011-2.01H79.933a2,2,0,0,0-1.629.841c-.178.127-5.642,5.635-5.779,6.031V31.929a2.011,2.011,0,0,0-2.011-2.011H59.271a2,2,0,0,0-1.629.841c-.177.127-3.854,3.811-3.933,3.889V18.589A2.011,2.011,0,0,0,51.7,16.578H40.131a2,2,0,0,0-1.629.841l-5.056,5.055A2.005,2.005,0,0,0,32.6,24.1V58.268c0,8.547,4.428,13.449,12.149,13.449a22.326,22.326,0,0,0,5.293-.686l.1-.023a2,2,0,0,0,1.16-.786l3.321-3.3c2.268,2.943,5.863,4.439,10.789,4.439A15.16,15.16,0,0,0,73.88,69.2a2.011,2.011,0,0,0,1.9,1.368h9.886a2.015,2.015,0,0,0,1.422-.589l4.6-4.6c.007-.007.013-.016.019-.023,3.41,3.845,8.839,6.01,15.76,6.01,6.233,0,11.023-.869,13.143-2.384l5.374-5.348a15,15,0,0,0,3.075,3.121,8.372,8.372,0,0,0-.867.876,2,2,0,0,0-.861,1.638V79.314a2.006,2.006,0,0,0,.867,1.647,7.383,7.383,0,0,0-3.36,2.069c-.161.145-.741.73-.875.871l-.13-1.162a2.009,2.009,0,0,0-1.446-1.709,11.154,11.154,0,0,0-3.24-.448,7.953,7.953,0,0,0-5.9,2.524L108.2,88.162a7.432,7.432,0,0,0-2.436,5.53,7.677,7.677,0,0,0,7.872,7.641,10.515,10.515,0,0,0,3.338-.487,2,2,0,0,0,1.022-.743c.178-.127,1.154-1.109,1.254-1.222a7.893,7.893,0,0,0,5.9,2.382,10.122,10.122,0,0,0,5.24-1.273,7.363,7.363,0,0,0,.994-.98c.01-.007.019-.015.028-.022v.056a2.011,2.011,0,0,0,2.011,2.011h3.661A4.761,4.761,0,0,0,138.96,100a2.007,2.007,0,0,0,1.761,1.05h3.661a2.006,2.006,0,0,0,1.63-.841c.177-.128,1.664-1.622,1.781-1.77a5.968,5.968,0,0,0,5.465,2.888,8,8,0,0,0,3.412-.7,19.8,19.8,0,0,0,1.838-1.682,7.919,7.919,0,0,0,5.85,2.317,10.12,10.12,0,0,0,5.24-1.273,7.361,7.361,0,0,0,.994-.98c.01-.007.019-.015.028-.022v.056a2.011,2.011,0,0,0,2.011,2.011h3.661a2.005,2.005,0,0,0,1.629-.841l5.055-5.056a2,2,0,0,0,.841-1.629V90.086c.009-.011,2.4-2.386,2.4-2.386M151,81.036a15651.427,15651.427,0,0,0-.919.919,2.015,2.015,0,0,0-.275.237,5.841,5.841,0,0,0-.805-.627,20.872,20.872,0,0,0,2.564-1.131c-.039.045-.071.1-.106.143a2.009,2.009,0,0,0-.46.46m-14.986,1.769a1.966,1.966,0,0,0-.174.168c-.06-.067-.114-.14-.176-.2.117.012.235.025.351.036"
        transform="translate(-10.75 -2.204)"
      />
      <path
        id="Trazado_5708"
        data-name="Trazado 5708"
        d="M104.37,129.4a2,2,0,0,0,.841-1.629v-3.443c.009-.011.016-.025.025-.037l2.375-2.349a2.011,2.011,0,0,0,.772-1.491l.162-3.475a2.009,2.009,0,0,0-1.7-2.081,5.125,5.125,0,0,0-1-.07,5.727,5.727,0,0,0-2.164.414,2.006,2.006,0,0,0-1.124-.345c-.048,0-.1,0-.143,0l-3.29.231a2.009,2.009,0,0,0-1.385.7c-.036.042-1.241,1.232-1.339,1.34a7.207,7.207,0,0,0-5.454-2.274,7.464,7.464,0,0,0-5.577,2.44c-.16.147-1.074,1.066-1.148,1.141v-5.926a2.01,2.01,0,0,0-2.01-2.011c-.034,0-.068,0-.1,0l-3.661.186a2,2,0,0,0-1.526.839,2.019,2.019,0,0,0-.334.308,1.98,1.98,0,0,0-1.885-1.335c-.034,0-.068,0-.1,0l-3.661.186a2,2,0,0,0-1.516.826l-3.943,3.9a7.954,7.954,0,0,0-2.991-.562,7.46,7.46,0,0,0-5.566,2.43l-1.839,1.839-.04.036a5.374,5.374,0,0,0-.542-.587c.009-.012.015-.025.024-.038a2.008,2.008,0,0,0,.859-1.806l-.278-3.5a2.009,2.009,0,0,0-1.154-1.662,12.873,12.873,0,0,0-5.137-.977,8.371,8.371,0,0,0-6.382,2.462l-5.056,5.056a6.209,6.209,0,0,0-2.042,4.735,5.819,5.819,0,0,0,1.4,3.84c-.027.033-.055.064-.079.1a2,2,0,0,0-.46.46,2.009,2.009,0,0,0-.828,1.778l.278,3.661a2.011,2.011,0,0,0,1.207,1.693,14.468,14.468,0,0,0,5.78,1.162,8.685,8.685,0,0,0,6.539-2.531c.162-.146,1.153-1.136,1.263-1.25a7.576,7.576,0,0,0,6.867,3.711,10.124,10.124,0,0,0,5.24-1.273,85.45,85.45,0,0,0,.976-.957v.011a2.011,2.011,0,0,0,2.011,2.011h3.66a4.152,4.152,0,0,0,2.014-1.216A2,2,0,0,0,73.03,135.3h3.661a2.006,2.006,0,0,0,1.629-.841c.177-.128,1.418-1.412,1.438-1.428a7.859,7.859,0,0,0,5.992,2.477,10.124,10.124,0,0,0,5.241-1.273,7.4,7.4,0,0,0,.993-.98c.01-.007.018-.015.027-.022v.056a2.011,2.011,0,0,0,2.011,2.011h3.661a2.006,2.006,0,0,0,1.63-.841Z"
        transform="translate(-11.65 -36.446)"
      />
      <path
        id="Trazado_5709"
        data-name="Trazado 5709"
        d="M273.512,38.9a28.1,28.1,0,0,0-12.5,2.577l-.241.115a2.01,2.01,0,0,0-1.146,1.815v9.616a2.011,2.011,0,0,0,2.806,1.847l.592-.255a22.809,22.809,0,0,1,9.011-2c.436,0,.814.011,1.14.031-.647.136-1.513.278-2.67.41-7.572.8-12.075,3.626-13.451,8.4a22.98,22.98,0,0,0,.3-3.716c0-10.308-7.748-18.382-17.639-18.382a17.252,17.252,0,0,0-8.057,1.9,2.011,2.011,0,0,0-1.837-1.194H220.1a2.012,2.012,0,0,0-2.011,2.025l.068,9.9v.8c-2.17-7.976-9.658-13.538-19.094-13.538-9.324,0-16.948,5.693-19.155,13.619v-10.8a2.011,2.011,0,0,0-2.011-2.011h-9.675a2.011,2.011,0,0,0-1.8,1.115,16.052,16.052,0,0,0-7.8-1.927A17.235,17.235,0,0,0,141.5,52.671c.016-.282.038-.561.038-.851,0-5.8-4.07-12.564-15.541-12.564-11.413,0-19.739,7.828-19.994,18.683l0-15.85a2.011,2.011,0,0,0-2.011-2.01H92.747a2.011,2.011,0,0,0-2.011,2.011V58.768c0,2.009-.952,3.027-2.831,3.027-1.7,0-2.567-1.018-2.567-3.027V42.091a2.012,2.012,0,0,0-2.011-2.011H72.085a2.011,2.011,0,0,0-2.011,2.011v18.98c0,9.911,4.6,14.937,13.666,14.937a15.15,15.15,0,0,0,8.468-2.158,2.011,2.011,0,0,0,1.906,1.368H104a2.012,2.012,0,0,0,2.011-2.012l0-14.193c.261,10.505,7.789,17.006,19.79,17.006,6.233,0,11.023-.869,13.143-2.385A2.01,2.01,0,0,0,139.781,72V62.659a2.01,2.01,0,0,0-1.79-2,11.264,11.264,0,0,0,3.061-5.181c-.05.576-.078,1.16-.078,1.753,0,6.582,2.7,11.8,7.24,14.755a2.012,2.012,0,0,0-2.554,1.936V83.961a2.01,2.01,0,0,0,1.253,1.862c4.061,1.654,9.535,1.833,11.7,1.833,12.735,0,21.291-8.013,21.291-19.938V62.6c2.161,8.006,9.555,13.419,19.155,13.419,9.436,0,16.924-5.561,19.094-13.537V85.138a2.011,2.011,0,0,0,2.011,2.011h11.568a2.011,2.011,0,0,0,2.011-2.011V74.244a14.392,14.392,0,0,0,7.048,1.878c7.915,0,14.036-5.262,15.939-13.082a13.357,13.357,0,0,0-.135,1.827c0,6.814,4.824,11.217,12.29,11.217a15.5,15.5,0,0,0,8.308-2A2.011,2.011,0,0,0,279,75.213h9.295A2.013,2.013,0,0,0,290.3,73.2l-.01-19.664c0-9.438-5.959-14.636-16.782-14.636"
        transform="translate(-23.105 -12.826)"
      />
      <path
        id="Trazado_5710"
        data-name="Trazado 5710"
        d="M53.667,70.382a22.321,22.321,0,0,0,5.293-.686l.1-.023A2.01,2.01,0,0,0,60.6,67.717v-9.83a2.011,2.011,0,0,0-2.011-2.011c-.06,0-.121,0-.181.009q-.227.02-.432.02a1.446,1.446,0,0,1-.781-.139,1.018,1.018,0,0,1-.084-.5V22.771A2.011,2.011,0,0,0,55.1,20.76H43.529a2.011,2.011,0,0,0-2.011,2.011V56.934c0,8.547,4.428,13.449,12.149,13.449"
        transform="translate(-13.689 -6.845)"
      />
      <path
        id="Trazado_5711"
        data-name="Trazado 5711"
        d="M507.251,34.75a6.426,6.426,0,0,0-2.986-2.685,2.969,2.969,0,0,0,.64-.633,2.921,2.921,0,0,0,.447-2.615,111.782,111.782,0,0,0-5.135-13.782C497.285,8.786,494.708,6,491.861,6a4.046,4.046,0,0,0-2.049.562c-.885.512-3.582,2.609-1.156,8.078a39.658,39.658,0,0,1,2.506,6.864c-.31-.373-.591-.748-.739-.947s-.269-.359-.383-.5c-.786-1-1.365-1.79-1.977-2.624-.483-.659-.986-1.343-1.622-2.177a13.31,13.31,0,0,0-5.339-4.231,7.5,7.5,0,0,0-2.4-.425,4.427,4.427,0,0,0-3.878,1.985c-.015.022-.028.044-.042.067-1.675,2.835.429,5.205,1.559,6.478.108.121.214.24.314.357a39.1,39.1,0,0,1,3.388,4.547q.477.732.924,1.528a5.3,5.3,0,0,0-3.315,4.093,6.116,6.116,0,0,0-2.762,1.813,5.868,5.868,0,0,0-1.232,4.647,13.625,13.625,0,0,0,.649,2.746c-3.066-6.287-9.769-10.449-17.933-10.449-8.9,0-16.246,5.186-18.816,12.55V31.231a2.011,2.011,0,0,0-2.011-2.011h-9.675a2.012,2.012,0,0,0-1.8,1.115,16.053,16.053,0,0,0-7.805-1.926c-10.056,0-17.639,7.728-17.639,17.976,0,6.582,2.7,11.8,7.24,14.756a2.011,2.011,0,0,0-2.554,1.936V73.113a2.012,2.012,0,0,0,1.252,1.863c4.061,1.654,9.535,1.833,11.7,1.833,12.735,0,21.292-8.013,21.292-19.938V52.857c2.52,7.395,9.665,12.315,18.816,12.315,11.251,0,19.735-7.9,19.735-18.382a18.3,18.3,0,0,0-.86-5.6c.113.246.227.488.341.722a26.246,26.246,0,0,0,4.9,7.069A16.974,16.974,0,0,0,488.84,53.8a14.461,14.461,0,0,0,3.083.33h0a18.971,18.971,0,0,0,9.909-3.1,13.8,13.8,0,0,0,6.069-7.082,11.917,11.917,0,0,0-.65-9.192"
        transform="translate(-131.433 -1.978)"
      />
      <path
        id="Trazado_5712"
        data-name="Trazado 5712"
        d="M110.242,114.208a5.124,5.124,0,0,0-1-.07,5.73,5.73,0,0,0-2.164.414,2,2,0,0,0-1.124-.345c-.047,0-.1,0-.143,0l-3.29.232a2.01,2.01,0,0,0-1.863,2.174l.1,1.2a7.028,7.028,0,0,0-6.417-3.611,7.434,7.434,0,0,0-6.725,4.124v-6.469a2.011,2.011,0,0,0-2.011-2.011c-.034,0-.068,0-.1,0l-3.661.186a2.006,2.006,0,0,0-1.794,1.359,2,2,0,0,0-1.951-1.547c-.034,0-.068,0-.1,0l-3.661.186a2.011,2.011,0,0,0-1.908,2.008v6a7.011,7.011,0,0,0-6.541-3.844,7.43,7.43,0,0,0-7.044,4.864,5.549,5.549,0,0,0-.952-1.155,2.012,2.012,0,0,0,.892-1.835l-.278-3.5a2.011,2.011,0,0,0-1.154-1.663,12.87,12.87,0,0,0-5.136-.976c-4.764,0-7.966,2.707-7.966,6.737a5.781,5.781,0,0,0,1.585,4.063,2.013,2.013,0,0,0-1.556,2.113l.278,3.661a2.011,2.011,0,0,0,1.207,1.693,14.467,14.467,0,0,0,5.779,1.162c3.632,0,6.437-1.6,7.605-4.118a7.536,7.536,0,0,0,7.063,4.048,10.124,10.124,0,0,0,5.241-1.273,2.011,2.011,0,0,0,.893-1.379l.082-.529v.961a2.011,2.011,0,0,0,2.011,2.011H78.1a2.005,2.005,0,0,0,1.924-1.455,2,2,0,0,0,1.923,1.455H85.6a2.011,2.011,0,0,0,2.011-2.011v-1.8a7.54,7.54,0,0,0,7.049,4.018,10.122,10.122,0,0,0,5.24-1.273,2.008,2.008,0,0,0,.893-1.379l.128-.822v1.255a2.011,2.011,0,0,0,2.011,2.011H106.6a2.011,2.011,0,0,0,2.011-2.011V122.45a1.542,1.542,0,0,1,.141-.8.624.624,0,0,1,.282-.042,1.353,1.353,0,0,1,.343.03,2.05,2.05,0,0,0,.4.04,2.011,2.011,0,0,0,2.008-1.917l.163-3.475a2.011,2.011,0,0,0-1.7-2.081"
        transform="translate(-14.589 -36.22)"
      />
      <path
        id="Trazado_5713"
        data-name="Trazado 5713"
        d="M224.835,114.995a5.123,5.123,0,0,0-1-.07,5.73,5.73,0,0,0-2.164.414,2,2,0,0,0-1.124-.345c-.047,0-.1,0-.143,0l-3.29.232a2.011,2.011,0,0,0-1.863,2.174l.1,1.2a7.027,7.027,0,0,0-6.417-3.611,7.46,7.46,0,0,0-5.91,2.832l.036-.454a2.01,2.01,0,0,0-2-2.169H199.52v-.954a2.011,2.011,0,0,0-2.011-2.011,1.991,1.991,0,0,0-.253.016l-3.66.464a2.01,2.01,0,0,0-1.759,1.995v.772l-.5.143a2.008,2.008,0,0,0-1.441,1.656,6.189,6.189,0,0,0-5.035-2.357,7.1,7.1,0,0,0-2.339.375,2,2,0,0,0-1.065-.306c-.056,0-.111,0-.168.007l-3.359.278a2.01,2.01,0,0,0-1.839,2.146l.087,1.235a7.024,7.024,0,0,0-6.448-3.666,7.445,7.445,0,0,0-6.353,3.461l-.153-1.372a2.012,2.012,0,0,0-1.446-1.71,11.153,11.153,0,0,0-3.24-.448,7.622,7.622,0,1,0,0,15.236,10.511,10.511,0,0,0,3.337-.487,2.009,2.009,0,0,0,1.394-1.692l.135-1.2a7.67,7.67,0,0,0,6.65,3.314,10.12,10.12,0,0,0,5.24-1.273,2.012,2.012,0,0,0,.894-1.379l.128-.826v1.258a2.011,2.011,0,0,0,2.011,2.011h3.661a2.011,2.011,0,0,0,1.818-1.152,2.012,2.012,0,0,0,1.819,1.152h3.66a2.011,2.011,0,0,0,2.011-2.011v-5.8a1.985,1.985,0,0,0,.545.1v1.627c0,3.868,2.481,6.367,6.321,6.367a8,8,0,0,0,3.412-.7,2.01,2.01,0,0,0,1.142-1.671l.056-.775a7.718,7.718,0,0,0,6.489,3.081,10.125,10.125,0,0,0,5.241-1.273,2.013,2.013,0,0,0,.893-1.379l.128-.826v1.258a2.011,2.011,0,0,0,2.011,2.011h3.661a2.011,2.011,0,0,0,2.011-2.011v-4.634a1.542,1.542,0,0,1,.141-.8.625.625,0,0,1,.282-.042,1.353,1.353,0,0,1,.343.03,2.051,2.051,0,0,0,.4.04,2.011,2.011,0,0,0,2.008-1.917l.163-3.475a2.011,2.011,0,0,0-1.7-2.081"
        transform="translate(-49.675 -37.006)"
      />
      <path
        id="Trazado_5714"
        data-name="Trazado 5714"
        d="M253.756,42.432c-9.81,0-17.792,7.035-17.792,16.371,0,9.877,7.915,16.371,17.792,16.371,9.81,0,17.724-6.63,17.724-16.371,0-9.607-7.915-16.371-17.724-16.371m0,22.392c-3.72,0-5.886-2.571-5.886-6.021s2.166-6.021,5.886-6.021c3.653,0,5.818,2.571,5.818,6.021s-2.165,6.021-5.818,6.021"
        transform="translate(-77.801 -13.991)"
        fill="#fff"
      />
      <path
        id="Trazado_5715"
        data-name="Trazado 5715"
        d="M313.512,42.584a14.638,14.638,0,0,0-9.4,3.179l-.49-2.469h-9.724l.068,9.911V86.354h11.568V70.464c1.23,3.147,5.489,4.862,9.059,4.862,8.659,0,14.551-7.035,14.551-16.371s-6.968-16.371-15.627-16.371m-2.03,22.392a5.7,5.7,0,0,1-5.953-6.021,5.7,5.7,0,0,1,5.953-6.021c3.585,0,5.751,2.571,5.751,6.021s-2.166,6.021-5.751,6.021"
        transform="translate(-96.901 -14.041)"
        fill="#fff"
      />
      <path
        id="Trazado_5716"
        data-name="Trazado 5716"
        d="M366.252,41.9a26.156,26.156,0,0,0-11.631,2.381l-.241.115v9.616l.591-.255a24.808,24.808,0,0,1,9.806-2.162c4.807,0,4.807,1.3,4.807,1.923,0,1.283-1.832,2.039-6.124,2.529-8.149.866-12.111,4.074-12.111,9.808,0,5.678,3.939,9.206,10.279,9.206,6.208,0,8.848-2.321,10.135-4.894l-.022,4.023h9.295l-.01-19.665c0-8.259-5.108-12.625-14.771-12.625m-1.274,24.94c-.918,0-2.461-.249-2.461-1.923,0-1.265.574-1.972,3.719-2.329a8.958,8.958,0,0,0,3.346-.948c-.029,3.115-1.872,5.2-4.6,5.2"
        transform="translate(-115.845 -13.816)"
        fill="#fff"
      />
      <path
        id="Trazado_5717"
        data-name="Trazado 5717"
        d="M158.188,52.985c0-5.412-3.924-10.553-13.53-10.553-10.352,0-18,7.171-18,17.183,0,9.81,6.9,15.56,17.792,15.56,6.563,0,10.554-.995,11.973-2.01V63.823a15.407,15.407,0,0,1-9.2,2.723c-5.8.068-8.639-2.76-9-6.187,1.556,1.827,4.736,2.909,8.659,2.977,6.5,0,11.3-3.654,11.3-10.351m-19.754,3.451a6.493,6.493,0,0,1,6.155-4.8c1.692,0,2.5.609,2.5,1.827,0,2.03-2.841,3.044-8.659,2.977"
        transform="translate(-41.763 -13.991)"
        fill="#fff"
      />
      <path
        id="Trazado_5718"
        data-name="Trazado 5718"
        d="M203.477,45.611a13.542,13.542,0,0,0-9-3.179c-8.726,0-15.628,6.7-15.628,15.965,0,9.539,6.157,15.425,14.884,15.425a12.4,12.4,0,0,0,8.456-3.247c-.2,3.247-2.638,6.426-9.335,6.426a21.913,21.913,0,0,1-9.318-1.912V85.126a31.366,31.366,0,0,0,10.941,1.684c11.7,0,19.281-7.239,19.281-17.927V43.244h-9.675Zm-6.834,18.4a5.417,5.417,0,0,1-5.818-5.615,5.822,5.822,0,1,1,5.818,5.615"
        transform="translate(-58.97 -13.991)"
        fill="#fff"
      />
      <path
        id="Trazado_5719"
        data-name="Trazado 5719"
        d="M476.025,42.432c-9.81,0-17.792,7.035-17.792,16.371,0,9.877,7.915,16.371,17.792,16.371,9.81,0,17.724-6.63,17.724-16.371,0-9.607-7.915-16.371-17.724-16.371m0,22.392c-3.72,0-5.886-2.571-5.886-6.021s2.166-6.021,5.886-6.021c3.653,0,5.818,2.571,5.818,6.021s-2.165,6.021-5.818,6.021"
        transform="translate(-151.087 -13.991)"
        fill="#fff"
      />
      <path
        id="Trazado_5720"
        data-name="Trazado 5720"
        d="M426.251,45.611a13.542,13.542,0,0,0-9-3.179c-8.726,0-15.628,6.7-15.628,15.965,0,9.539,6.157,15.425,14.884,15.425a12.4,12.4,0,0,0,8.456-3.247c-.2,3.247-2.638,6.426-9.335,6.426a21.913,21.913,0,0,1-9.318-1.912V85.126a31.368,31.368,0,0,0,10.941,1.684c11.7,0,19.281-7.239,19.281-17.927V43.244h-9.675Zm-6.834,18.4A5.417,5.417,0,0,1,413.6,58.4a5.822,5.822,0,1,1,5.818,5.615"
        transform="translate(-132.422 -13.991)"
        fill="#fff"
      />
      <path
        id="Trazado_5721"
        data-name="Trazado 5721"
        d="M93.735,43.661V60.338c0,3.714-2.5,5.038-4.841,5.038-2.823,0-4.578-1.93-4.578-5.038V43.661H73.073v18.98c0,8.336,3.363,12.927,11.656,12.927,6.627,0,9.434-2.972,10.385-5.47l-.01,4.68h9.885l-.009-31.117Z"
        transform="translate(-24.093 -14.396)"
        fill="#fff"
      />
      <path
        id="Trazado_5722"
        data-name="Trazado 5722"
        d="M56.086,56.252V23.76H44.518V57.923c0,14.7,13.355,11.192,15.057,10.784v-9.83c-2.5.225-3.489-.888-3.489-2.626"
        transform="translate(-14.678 -7.834)"
        fill="#fff"
      />
      <path
        id="Trazado_5723"
        data-name="Trazado 5723"
        d="M543.341,36.675c-2.674-5.091-22.6-3.936-21.185,1.916,1.052,4.369,10.936,3.182,13.55,2.152,0,0,.17,2.91-6.773,2.9-12.375-.039-9.378-7.35-9.378-7.35s.881-2.78,6.182-4.228c2.841-.776,10.4-1.562,14.433-.5a.932.932,0,0,0,1.13-1.177c-2.482-8.131-8.106-23.712-12.609-21.1-.618.358-2.04,1.658-.326,5.522s4.246,10.279,1.988,10.7c-1.615.3-3.207-2.195-4.024-3.234-1.427-1.818-2.173-2.93-3.616-4.822a11.343,11.343,0,0,0-4.387-3.547c-1.395-.474-3.1-.56-3.945.746-1.033,1.747.6,3.26,1.664,4.5a41.061,41.061,0,0,1,3.55,4.763,33.035,33.035,0,0,1,2.277,4.16s-4.655-.494-4.457,4.2c0,0-4.408.225-3.892,4.579a16.853,16.853,0,0,0,1.745,5.167,24.338,24.338,0,0,0,4.518,6.531,14.975,14.975,0,0,0,7.354,4.261c4.034.881,8.076-.382,11.5-2.516a11.884,11.884,0,0,0,5.228-6.018,9.934,9.934,0,0,0-.526-7.613"
        transform="translate(-169.303 -2.967)"
        fill="#fff"
      />
      <path
        id="Trazado_5724"
        data-name="Trazado 5724"
        d="M47.549,127.4l-.278-3.661a9.289,9.289,0,0,0,5.051,1.575c1.784,0,2.733-.487,2.733-1.413,0-.857-.718-1.251-3.035-1.737-3.151-.65-4.773-2.155-4.773-4.449,0-2.92,2.271-4.726,5.955-4.726a10.889,10.889,0,0,1,4.286.788l.278,3.5a9.143,9.143,0,0,0-4.565-1.205c-1.413,0-2.224.418-2.224,1.135s.509.973,2.78,1.53c3.591.881,4.958,2.2,4.958,4.8,0,2.919-2.5,4.866-6.186,4.866a12.508,12.508,0,0,1-4.982-1"
        transform="translate(-15.578 -37.255)"
        fill="#fff"
      />
      <path
        id="Trazado_5725"
        data-name="Trazado 5725"
        d="M79.1,125.814H71.892c.3,1,1.159,1.692,2.8,1.692a6.617,6.617,0,0,0,4.078-1.159l-.487,3.128a8.246,8.246,0,0,1-4.148.95c-3.545,0-5.839-2.178-5.839-5.537a5.4,5.4,0,0,1,5.515-5.538,5.07,5.07,0,0,1,5.328,5.422,9.757,9.757,0,0,1-.046,1.042m-7.136-2.178h3.707a1.75,1.75,0,0,0-1.762-1.437,1.92,1.92,0,0,0-1.946,1.437"
        transform="translate(-22.52 -39.352)"
        fill="#fff"
      />
      <path
        id="Trazado_5726"
        data-name="Trazado 5726"
        d="M89.287,128.074V113.037l3.661-.186v15.223Z"
        transform="translate(-29.439 -37.209)"
        fill="#fff"
      />
      <path
        id="Trazado_5727"
        data-name="Trazado 5727"
        d="M100.487,128.074V113.037l3.661-.186v15.223Z"
        transform="translate(-33.132 -37.209)"
        fill="#fff"
      />
      <path
        id="Trazado_5728"
        data-name="Trazado 5728"
        d="M121.552,125.814h-7.206c.3,1,1.159,1.692,2.8,1.692a6.617,6.617,0,0,0,4.078-1.159l-.487,3.128a8.246,8.246,0,0,1-4.148.95c-3.545,0-5.839-2.178-5.839-5.537a5.4,5.4,0,0,1,5.515-5.538,5.07,5.07,0,0,1,5.328,5.422,9.762,9.762,0,0,1-.046,1.042m-7.136-2.178h3.707a1.75,1.75,0,0,0-1.761-1.437,1.92,1.92,0,0,0-1.947,1.437"
        transform="translate(-36.518 -39.352)"
        fill="#fff"
      />
      <path
        id="Trazado_5729"
        data-name="Trazado 5729"
        d="M138.669,119.293l-.162,3.475a3.327,3.327,0,0,0-.741-.07c-1.414,0-2.433.857-2.433,2.849v4.634h-3.661V122.86l-.277-3.313,3.29-.231.232,1.853a3.146,3.146,0,0,1,3.059-1.923,3.246,3.246,0,0,1,.7.047"
        transform="translate(-43.323 -39.317)"
        fill="#fff"
      />
      <path
        id="Trazado_5730"
        data-name="Trazado 5730"
        d="M153.659,124.83a5.653,5.653,0,0,1,5.862-5.583,9.159,9.159,0,0,1,2.688.37l.393,3.522a5.45,5.45,0,0,0-2.526-.649c-1.575,0-2.733.835-2.733,2.34s1.135,2.34,2.733,2.34a5.681,5.681,0,0,0,2.572-.6l-.393,3.5a8.511,8.511,0,0,1-2.734.394,5.647,5.647,0,0,1-5.862-5.63"
        transform="translate(-50.664 -39.318)"
        fill="#fff"
      />
      <path
        id="Trazado_5731"
        data-name="Trazado 5731"
        d="M181.672,125.814h-7.206c.3,1,1.159,1.692,2.8,1.692a6.617,6.617,0,0,0,4.078-1.159l-.487,3.128a8.246,8.246,0,0,1-4.148.95c-3.545,0-5.839-2.178-5.839-5.537a5.4,5.4,0,0,1,5.515-5.538,5.07,5.07,0,0,1,5.328,5.422,9.762,9.762,0,0,1-.046,1.042m-7.136-2.178h3.707a1.75,1.75,0,0,0-1.761-1.437,1.92,1.92,0,0,0-1.946,1.437"
        transform="translate(-56.34 -39.352)"
        fill="#fff"
      />
      <path
        id="Trazado_5732"
        data-name="Trazado 5732"
        d="M202.775,124.02v6.163h-3.661v-5.769a1.74,1.74,0,0,0-1.784-1.876,1.781,1.781,0,0,0-1.854,1.876v5.769h-3.66v-7.321l-.232-3.267,3.359-.278.116,1.321a4,4,0,0,1,3.29-1.39c2.711,0,4.426,1.877,4.426,4.773"
        transform="translate(-63.168 -39.318)"
        fill="#fff"
      />
      <path
        id="Trazado_5733"
        data-name="Trazado 5733"
        d="M217.785,124.157a1.548,1.548,0,0,0,1.691,1.761,3.212,3.212,0,0,0,1.738-.487l-.232,3.2a6.055,6.055,0,0,1-2.548.509c-2.711,0-4.309-1.575-4.309-4.356v-3.638h-1.969v-2.595l1.969-.556V115.7l3.66-.464V118.2h3.545l-.232,2.943h-3.313Z"
        transform="translate(-69.951 -37.996)"
        fill="#fff"
      />
      <path
        id="Trazado_5734"
        data-name="Trazado 5734"
        d="M240.167,125.814h-7.206c.3,1,1.159,1.692,2.8,1.692a6.617,6.617,0,0,0,4.078-1.159l-.487,3.128a8.246,8.246,0,0,1-4.148.95c-3.545,0-5.839-2.178-5.839-5.537a5.4,5.4,0,0,1,5.515-5.538,5.07,5.07,0,0,1,5.328,5.422,9.757,9.757,0,0,1-.046,1.042m-7.136-2.178h3.707a1.75,1.75,0,0,0-1.762-1.437,1.92,1.92,0,0,0-1.946,1.437"
        transform="translate(-75.627 -39.352)"
        fill="#fff"
      />
      <path
        id="Trazado_5735"
        data-name="Trazado 5735"
        d="M257.286,119.293l-.162,3.475a3.327,3.327,0,0,0-.741-.07c-1.414,0-2.433.857-2.433,2.849v4.634h-3.661V122.86l-.278-3.313,3.29-.231.232,1.853a3.146,3.146,0,0,1,3.059-1.923,3.246,3.246,0,0,1,.7.047"
        transform="translate(-82.432 -39.317)"
        fill="#fff"
      />
    </g>
  </svg>
)
export const LuegopagoIconWhite = ({ black, login, footer }) => (
  <svg
    style={{
      fill: black ? '#000000' : '#FFFFFF',
      width: login ? '100%' : footer ? '50%' : '90%',
      marginLeft: !footer && '5%',
    }}
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 1080 326"
    xmlSpace="preserve"
  >
    <g>
      <g>
        <g>
          <g>
            <g>
              <path
                className="st0"
                d="M459.7,93c-30.3,0-55,21.7-55,50.6c0,30.5,24.4,50.6,55,50.6c30.3,0,54.7-20.5,54.7-50.6
						C514.4,113.9,490,93,459.7,93z M459.7,162.1c-11.5,0-18.2-7.9-18.2-18.6c0-10.7,6.7-18.6,18.2-18.6c11.3,0,18,7.9,18,18.6
						C477.7,154.2,471,162.1,459.7,162.1z"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M585.3,93.3c-11.1,0-21.1,3.3-29,9.8l-1.5-7.6h-30l0.2,30.6v102.4h35.7v-49.1c3.8,9.7,17,15,28,15
						c26.7,0,44.9-21.7,44.9-50.6S612,93.3,585.3,93.3z M579,162.5c-11.5,0-18.4-8.2-18.4-18.6c0-10.4,6.9-18.6,18.4-18.6
						c11.1,0,17.8,7.9,17.8,18.6C596.7,154.5,590.1,162.5,579,162.5z"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M689.6,91.9c-14,0-25.4,2.3-35.9,7.4l-0.7,0.4v29.7l1.8-0.8c10.3-4.4,20.5-6.7,30.3-6.7
						c14.8,0,14.8,4,14.8,5.9c0,4-5.7,6.3-18.9,7.8c-25.2,2.7-37.4,12.6-37.4,30.3c0,17.5,12.2,28.4,31.7,28.4
						c19.2,0,27.3-7.2,31.3-15.1l-0.1,12.4h28.7l0-60.7C735.3,105.4,719.5,91.9,689.6,91.9z M685.7,168.9c-2.8,0-7.6-0.8-7.6-5.9
						c0-3.9,1.8-6.1,11.5-7.2c3.4-0.4,7.2-1.1,10.3-2.9C699.8,162.5,694.1,168.9,685.7,168.9z"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M275.8,125.6c0-16.7-12.1-32.6-41.8-32.6c-32,0-55.6,22.1-55.6,53.1c0,30.3,21.3,48.1,55,48.1
						c20.3,0,32.6-3.1,37-6.2v-28.9c-5.4,3.9-14.2,8.2-28.4,8.4c-17.9,0.2-26.7-8.5-27.8-19.1c4.8,5.6,14.6,9,26.7,9.2
						C261,157.6,275.8,146.3,275.8,125.6z M214.8,136.2c2.9-9.8,11.3-14.8,19-14.8c5.2,0,7.7,1.9,7.7,5.6
						C241.6,133.3,232.8,136.4,214.8,136.2z"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M362.6,102.8c-7.5-6.5-17.1-9.8-27.8-9.8c-27,0-48.3,20.7-48.3,49.3c0,29.5,19,47.6,46,47.6
						c10.2,0,19.2-3.8,26.1-10c-0.6,10-8.1,19.8-28.8,19.8c-8.7,0-18.5-1.2-28.8-5.9v31c9.2,3.7,22.3,5.2,33.8,5.2
						c36.1,0,59.6-22.4,59.6-55.4V95.5h-29.9L362.6,102.8z M341.4,159.6c-11.3,0-18-7.5-18-17.3c0-9.8,7.3-17.3,18-17.3
						s18,7.5,18,17.3C359.4,152.1,352.1,159.6,341.4,159.6z"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M919.8,93c-30.3,0-55,21.7-55,50.6c0,30.5,24.4,50.6,55,50.6c30.3,0,54.7-20.5,54.7-50.6
						C974.6,113.9,950.1,93,919.8,93z M919.8,162.1c-11.5,0-18.2-7.9-18.2-18.6c0-10.7,6.7-18.6,18.2-18.6c11.3,0,18,7.9,18,18.6
						C937.8,154.2,931.1,162.1,919.8,162.1z"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M823.8,102.8c-7.5-6.5-17.1-9.8-27.8-9.8c-27,0-48.3,20.7-48.3,49.3c0,29.5,19,47.6,46,47.6
						c10.2,0,19.2-3.8,26.1-10c-0.6,10-8.1,19.8-28.8,19.8c-8.7,0-18.5-1.2-28.8-5.9v31c9.2,3.7,22.3,5.2,33.8,5.2
						c36.1,0,59.6-22.4,59.6-55.4V95.5h-29.9L823.8,102.8z M802.6,159.6c-11.3,0-18-7.5-18-17.3c0-9.8,7.3-17.3,18-17.3
						s18,7.5,18,17.3C820.6,152.1,813.3,159.6,802.6,159.6z"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M131.3,95.5V147c0,11.5-7.7,15.6-15,15.6c-8.7,0-14.1-6-14.1-15.6V95.5H67.5v58.6
						c0,25.7,10.4,39.9,36,39.9c20.5,0,29.1-9.2,32.1-16.9l0,14.5h30.5l0-96.1H131.3z"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M44.1,154.7V54.3H8.4v105.5c0,45.4,41.2,34.6,46.5,33.3v-30.4C47.2,163.5,44.1,160.1,44.1,154.7z"
              />
            </g>
          </g>
        </g>
        <g>
          <path
            className="st0"
            d="M1071.5,109.3c-8.3-15.7-69.8-12.2-65.4,5.9c3.3,13.5,33.8,9.8,41.8,6.6c0,0,0.5,9-20.9,9
				c-38.2-0.1-29-22.7-29-22.7s2.7-8.6,19.1-13.1c8.8-2.4,32.1-4.8,44.6-1.5c2.2,0.6,4.2-1.5,3.5-3.6c-7.7-25.1-25-73.2-38.9-65.2
				c-1.9,1.1-6.3,5.1-1,17.1c5.3,11.9,13.1,31.7,6.1,33.1c-5,0.9-9.9-6.8-12.4-10c-4.4-5.6-6.7-9.1-11.2-14.9c-3-4-8.7-9.3-13.5-11
				c-4.3-1.5-9.6-1.7-12.2,2.3c-3.2,5.4,1.8,10.1,5.1,13.9c4.5,5.2,7.5,9.4,11,14.7c2.7,4.1,5,8.4,7,12.8c0,0-14.4-1.5-13.8,13
				c0,0-13.6,0.7-12,14.1c0.7,5.5,3,11,5.4,16c3.6,7.4,8.2,14.3,14,20.2c6.2,6.3,14,11.3,22.7,13.2c12.5,2.7,24.9-1.2,35.5-7.8
				c7.1-4.4,13.4-10.5,16.1-18.6C1075.7,125.1,1075.2,116.2,1071.5,109.3z"
          />
        </g>
      </g>
      <g>
        <path
          className="st0"
          d="M15,283.6l-0.9-11.3c4.3,3,10.3,4.9,15.6,4.9c5.5,0,8.4-1.5,8.4-4.4c0-2.6-2.2-3.9-9.4-5.4
			c-9.7-2-14.7-6.7-14.7-13.7c0-9,7-14.6,18.4-14.6c5,0,10,0.9,13.2,2.4l0.9,10.8c-4.3-2.4-9-3.7-14.1-3.7c-4.4,0-6.9,1.3-6.9,3.5
			c0,2.2,1.6,3,8.6,4.7c11.1,2.7,15.3,6.8,15.3,14.8c0,9-7.7,15-19.1,15C25,286.7,19.8,285.6,15,283.6z"
        />
        <path
          className="st0"
          d="M91,272.2H68.7c0.9,3.1,3.6,5.2,8.7,5.2c6.6,0,9.9-1.8,12.6-3.6l-1.5,9.7c-2.6,1.7-7.5,2.9-12.8,2.9
			c-10.9,0-18-6.7-18-17.1c0-9.8,7.4-17.1,17-17.1c10.2,0,16.5,7,16.5,16.7C91.1,270.5,91,271.5,91,272.2z M68.9,265.5h11.4
			c-0.5-2.6-2.7-4.4-5.4-4.4C71.9,261,69.9,262.6,68.9,265.5z"
        />
        <path className="st0" d="M101.1,285.8v-46.4l11.3-0.6v47H101.1z" />
        <path className="st0" d="M124.3,285.8v-46.4l11.3-0.6v47H124.3z" />
        <path
          className="st0"
          d="M178.9,272.2h-22.3c0.9,3.1,3.6,5.2,8.7,5.2c6.6,0,9.9-1.8,12.6-3.6l-1.5,9.7c-2.6,1.7-7.5,2.9-12.8,2.9
			c-10.9,0-18-6.7-18-17.1c0-9.8,7.4-17.1,17-17.1c10.2,0,16.5,7,16.5,16.7C179,270.5,178.9,271.5,178.9,272.2z M156.8,265.5h11.4
			c-0.5-2.6-2.7-4.4-5.4-4.4C159.8,261,157.8,262.6,156.8,265.5z"
        />
        <path
          className="st0"
          d="M210.7,252.2l-0.5,10.7c-0.7-0.1-1.3-0.2-2.3-0.2c-4.4,0-7.5,2.6-7.5,8.8v14.3h-11.3v-22.6l-0.9-10.2
			l10.2-0.7l0.7,5.7c1.3-3.5,4.9-5.9,9.4-5.9C209.6,252,209.8,252,210.7,252.2z"
        />
        <path
          className="st0"
          d="M234.3,269.3c0-9.7,7.9-17.2,18.1-17.2c2.9,0,5.3,0.3,8.3,1.1L262,264c-2.5-1.3-5.1-2-7.8-2
			c-4.9,0-8.4,2.6-8.4,7.2c0,4.7,3.5,7.2,8.4,7.2c2.9,0,5.5-0.6,7.9-1.9l-1.2,10.8c-2.5,0.8-4.9,1.2-8.4,1.2
			C242.3,286.7,234.3,279.2,234.3,269.3z"
        />
        <path
          className="st0"
          d="M303.3,272.2h-22.3c0.9,3.1,3.6,5.2,8.7,5.2c6.6,0,9.9-1.8,12.6-3.6l-1.5,9.7c-2.6,1.7-7.5,2.9-12.8,2.9
			c-10.9,0-18-6.7-18-17.1c0-9.8,7.4-17.1,17-17.1c10.2,0,16.5,7,16.5,16.7C303.5,270.5,303.4,271.5,303.3,272.2z M281.3,265.5h11.4
			c-0.5-2.6-2.7-4.4-5.4-4.4C284.3,261,282.2,262.6,281.3,265.5z"
        />
        <path
          className="st0"
          d="M347.4,266.8v19h-11.3V268c0-3.4-2.2-5.8-5.5-5.8c-3.3,0-5.7,2.3-5.7,5.8v17.8h-11.3v-22.6l-0.7-10.1
			l10.4-0.9l0.4,4.1c2-2.6,5.4-4.3,10.2-4.3C342.1,252,347.4,257.8,347.4,266.8z"
        />
        <path
          className="st0"
          d="M372.8,271.3c0,3.6,1.9,5.4,5.2,5.4c2.2,0,4-0.6,5.4-1.5l-0.7,9.9c-1.5,0.7-4.2,1.6-7.9,1.6
			c-8.4,0-13.3-4.9-13.3-13.5V262h-6.1v-8l6.1-1.7v-7.1l11.3-1.4v9.2h10.9l-0.7,9.1h-10.2V271.3z"
        />
        <path
          className="st0"
          d="M424.4,272.2h-22.3c0.9,3.1,3.6,5.2,8.7,5.2c6.6,0,9.9-1.8,12.6-3.6l-1.5,9.7c-2.6,1.7-7.5,2.9-12.8,2.9
			c-10.9,0-18-6.7-18-17.1c0-9.8,7.4-17.1,17-17.1c10.2,0,16.5,7,16.5,16.7C424.6,270.5,424.5,271.5,424.4,272.2z M402.4,265.5h11.4
			c-0.5-2.6-2.7-4.4-5.4-4.4C405.4,261,403.3,262.6,402.4,265.5z"
        />
        <path
          className="st0"
          d="M456.3,252.2l-0.5,10.7c-0.7-0.1-1.3-0.2-2.3-0.2c-4.4,0-7.5,2.6-7.5,8.8v14.3h-11.3v-22.6l-0.9-10.2
			l10.2-0.7l0.7,5.7c1.3-3.5,4.9-5.9,9.4-5.9C455.2,252,455.3,252,456.3,252.2z"
        />
      </g>
    </g>
  </svg>
)
export const ThankImageIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="247.999"
    height="242.939"
    viewBox="0 0 247.999 242.939"
  >
    <g id="Friendship_Day-bro" data-name="Friendship Day-bro" transform="translate(-37.1 -39.321)">
      <g id="freepik--background-simple--inject-33" transform="translate(37.1 39.321)">
        <path
          id="Trazado_5682"
          data-name="Trazado 5682"
          d="M271.884,115.639s-38.74-46.366-98.75-57S101.347,93.2,81.22,119.788,38.3,156.265,37.158,194.616,51.592,252.729,81.6,266.4s60.771,20.893,90.776,25.066,53.934,1.9,65.71-22.791,6.454-36.082,20.127-47.858S302.649,155.493,271.884,115.639Z"
          transform="translate(-37.1 -57.05)"
          fill="#21bead"
        />
        <path
          id="Trazado_5683"
          data-name="Trazado 5683"
          d="M271.884,115.639s-38.74-46.366-98.75-57S101.347,93.2,81.22,119.788,38.3,156.265,37.158,194.616,51.592,252.729,81.6,266.4s60.771,20.893,90.776,25.066,53.934,1.9,65.71-22.791,6.454-36.082,20.127-47.858S302.649,155.493,271.884,115.639Z"
          transform="translate(-37.1 -57.05)"
          fill="#fff"
          opacity="0.7"
        />
      </g>
      <g id="freepik--Plant--inject-33" transform="translate(231.565 132.877)">
        <line
          id="Línea_39"
          data-name="Línea 39"
          x2="9.28"
          y2="88.942"
          transform="translate(10.174 31.178)"
          fill="none"
          stroke="#263238"
          strokeWidth="1"
        />
        <line
          id="Línea_40"
          data-name="Línea 40"
          x1="4.208"
          y1="4.446"
          transform="translate(13.755 98.658)"
          fill="none"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5684"
          data-name="Trazado 5684"
          d="M391.549,386.41a4.753,4.753,0,0,0-1.677-3.569c-1.08-.963-6.761-3.355-7.3-1.352C381.984,383.665,387.8,387.942,391.549,386.41Z"
          transform="translate(-376.517 -286.423)"
          fill="#21bead"
          stroke="#263238"
          strokeWidth="1"
        />
        <line
          id="Línea_41"
          data-name="Línea 41"
          x1="5.415"
          y1="3.372"
          transform="translate(9.617 96.615)"
          fill="none"
          stroke="#263238"
          strokeWidth="0.5"
        />
        <line
          id="Línea_42"
          data-name="Línea 42"
          x1="4.208"
          y1="4.44"
          transform="translate(14.812 108.774)"
          fill="none"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5685"
          data-name="Trazado 5685"
          d="M393.369,403.88a4.753,4.753,0,0,0-1.677-3.569c-1.079-.963-6.761-3.355-7.3-1.352C383.8,401.112,389.619,405.389,393.369,403.88Z"
          transform="translate(-377.28 -293.754)"
          fill="#21bead"
          stroke="#263238"
          strokeWidth="1"
        />
        <line
          id="Línea_43"
          data-name="Línea 43"
          x1="5.415"
          y1="3.372"
          transform="translate(10.674 106.731)"
          fill="none"
          stroke="#263238"
          strokeWidth="0.5"
        />
        <line
          id="Línea_44"
          data-name="Línea 44"
          x1="4.208"
          y1="4.44"
          transform="translate(11.178 73.975)"
          fill="none"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5686"
          data-name="Trazado 5686"
          d="M387.109,343.88a4.759,4.759,0,0,0-1.671-3.569c-1.085-.963-6.767-3.355-7.307-1.352C377.544,341.135,383.359,345.412,387.109,343.88Z"
          transform="translate(-374.653 -268.576)"
          fill="#21bead"
          stroke="#263238"
          strokeWidth="1"
        />
        <line
          id="Línea_45"
          data-name="Línea 45"
          x1="5.409"
          y1="3.372"
          transform="translate(7.046 71.932)"
          fill="none"
          stroke="#263238"
          strokeWidth="0.5"
        />
        <line
          id="Línea_46"
          data-name="Línea 46"
          x1="4.208"
          y1="4.44"
          transform="translate(12.235 84.091)"
          fill="none"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5687"
          data-name="Trazado 5687"
          d="M388.93,361.31a4.753,4.753,0,0,0-1.677-3.569c-1.079-.963-6.761-3.355-7.3-1.352C379.383,358.565,385.187,362.842,388.93,361.31Z"
          transform="translate(-375.419 -275.891)"
          fill="#21bead"
          stroke="#263238"
          strokeWidth="1"
        />
        <line
          id="Línea_47"
          data-name="Línea 47"
          x1="5.409"
          y1="3.372"
          transform="translate(8.102 82.048)"
          fill="none"
          stroke="#263238"
          strokeWidth="0.5"
        />
        <line
          id="Línea_48"
          data-name="Línea 48"
          x1="4.208"
          y1="4.446"
          transform="translate(9.461 57.539)"
          fill="none"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5688"
          data-name="Trazado 5688"
          d="M384.154,315.57A4.777,4.777,0,0,0,382.477,312c-1.079-.963-6.767-3.355-7.307-1.352C374.584,312.848,380.405,317.1,384.154,315.57Z"
          transform="translate(-373.411 -256.697)"
          fill="#21bead"
          stroke="#263238"
          strokeWidth="1"
        />
        <line
          id="Línea_49"
          data-name="Línea 49"
          x1="5.415"
          y1="3.372"
          transform="translate(5.328 55.501)"
          fill="none"
          stroke="#263238"
          strokeWidth="0.5"
        />
        <line
          id="Línea_50"
          data-name="Línea 50"
          x1="4.208"
          y1="4.446"
          transform="translate(7.743 41.039)"
          fill="none"
          stroke="#263238"
          strokeWidth="2"
        />
        <path
          id="Trazado_5689"
          data-name="Trazado 5689"
          d="M381.189,287.13a4.753,4.753,0,0,0-1.677-3.569c-1.079-.963-6.761-3.355-7.3-1.352C371.624,284.385,377.439,288.662,381.189,287.13Z"
          transform="translate(-372.169 -244.763)"
          fill="#21bead"
          stroke="#263238"
          strokeWidth="1"
        />
        <line
          id="Línea_51"
          data-name="Línea 51"
          x1="5.415"
          y1="3.372"
          transform="translate(3.605 38.996)"
          fill="none"
          stroke="#263238"
          strokeWidth="0.5"
        />
        <line
          id="Línea_52"
          data-name="Línea 52"
          y1="5.218"
          x2="3.198"
          transform="translate(17.255 91.897)"
          fill="none"
          stroke="#263238"
          strokeWidth="2"
        />
        <path
          id="Trazado_5690"
          data-name="Trazado 5690"
          d="M405.664,374.087a4.771,4.771,0,0,1,.9-3.836c.859-1.161,5.926-4.684,6.872-2.832C414.457,369.426,409.646,374.812,405.664,374.087Z"
          transform="translate(-386.187 -280.623)"
          fill="#21bead"
          stroke="#263238"
          strokeWidth="1"
        />
        <line
          id="Línea_53"
          data-name="Línea 53"
          y1="4.655"
          x2="4.875"
          transform="translate(19.478 88.809)"
          fill="none"
          stroke="#263238"
          strokeWidth="0.5"
        />
        <line
          id="Línea_54"
          data-name="Línea 54"
          y1="5.218"
          x2="3.198"
          transform="translate(14.475 65.281)"
          fill="none"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5691"
          data-name="Trazado 5691"
          d="M400.875,328.224a4.776,4.776,0,0,1,.905-3.842c.853-1.161,5.926-4.678,6.866-2.832C409.667,323.558,404.862,328.944,400.875,328.224Z"
          transform="translate(-384.177 -261.377)"
          fill="#21bead"
          stroke="#263238"
          strokeWidth="1"
        />
        <line
          id="Línea_55"
          data-name="Línea 55"
          y1="4.66"
          x2="4.875"
          transform="translate(16.698 62.187)"
          fill="none"
          stroke="#263238"
          strokeWidth="0.5"
        />
        <line
          id="Línea_56"
          data-name="Línea 56"
          y1="5.218"
          x2="3.198"
          transform="translate(13.256 53.58)"
          fill="none"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5692"
          data-name="Trazado 5692"
          d="M398.774,308.067a4.771,4.771,0,0,1,.9-3.836c.859-1.161,5.926-4.684,6.872-2.832C407.573,303.406,402.756,308.792,398.774,308.067Z"
          transform="translate(-383.295 -252.919)"
          fill="#21bead"
          stroke="#263238"
          strokeWidth="1"
        />
        <line
          id="Línea_57"
          data-name="Línea 57"
          y1="4.655"
          x2="4.875"
          transform="translate(15.479 50.493)"
          fill="none"
          stroke="#263238"
          strokeWidth="0.5"
        />
        <line
          id="Línea_58"
          data-name="Línea 58"
          y1="5.218"
          x2="3.204"
          transform="translate(11.463 36.43)"
          fill="none"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5693"
          data-name="Trazado 5693"
          d="M395.693,278.517a4.742,4.742,0,0,1,.9-3.836c.859-1.161,5.926-4.684,6.866-2.832C404.486,273.856,399.674,279.26,395.693,278.517Z"
          transform="translate(-382.001 -240.519)"
          fill="#21bead"
          stroke="#263238"
          strokeWidth="1"
        />
        <line
          id="Línea_59"
          data-name="Línea 59"
          y1="4.655"
          x2="4.869"
          transform="translate(13.691 33.343)"
          fill="none"
          stroke="#263238"
          strokeWidth="0.5"
        />
        <path
          id="Trazado_5694"
          data-name="Trazado 5694"
          d="M389.5,265.917a4.742,4.742,0,0,1,.9-3.836c.859-1.161,5.926-4.684,6.866-2.832C398.3,261.256,393.484,266.642,389.5,265.917Z"
          transform="translate(-379.404 -235.232)"
          fill="#21bead"
          stroke="#263238"
          strokeWidth="1"
        />
        <line
          id="Línea_60"
          data-name="Línea 60"
          y1="4.66"
          x2="4.869"
          transform="translate(10.099 26.024)"
          fill="none"
          stroke="#263238"
          strokeWidth="0.5"
        />
        <path
          id="Trazado_5695"
          data-name="Trazado 5695"
          d="M385.38,265.318a4.771,4.771,0,0,1-3.72-1.3c-1.074-.975-4.034-6.384-2.1-7.127C381.666,256.084,386.512,261.43,385.38,265.318Z"
          transform="translate(-375.003 -234.43)"
          fill="#21bead"
          stroke="#263238"
          strokeWidth="1"
        />
        <line
          id="Línea_61"
          data-name="Línea 61"
          x1="4.121"
          y1="5.339"
          transform="translate(6.257 25.548)"
          fill="none"
          stroke="#263238"
          strokeWidth="0.5"
        />
        <line
          id="Línea_62"
          data-name="Línea 62"
          x1="9.234"
          y2="88.948"
          transform="translate(25.427 43.43)"
          fill="none"
          stroke="#263238"
          strokeWidth="1"
        />
        <line
          id="Línea_63"
          data-name="Línea 63"
          x1="3.204"
          y1="5.218"
          transform="translate(24.266 110.196)"
          fill="none"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5696"
          data-name="Trazado 5696"
          d="M409.941,405.618a4.759,4.759,0,0,0-.905-3.836c-.853-1.161-5.926-4.678-6.866-2.832C401.148,400.964,405.959,406.344,409.941,405.618Z"
          transform="translate(-384.7 -293.856)"
          fill="#21bead"
          stroke="#263238"
          strokeWidth="1"
        />
        <line
          id="Línea_64"
          data-name="Línea 64"
          x1="4.602"
          y1="4.417"
          transform="translate(20.639 107.346)"
          fill="none"
          stroke="#263238"
          strokeWidth="0.5"
        />
        <line
          id="Línea_65"
          data-name="Línea 65"
          x1="3.204"
          y1="5.212"
          transform="translate(26.825 85.512)"
          fill="none"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5697"
          data-name="Trazado 5697"
          d="M414.356,363.088a4.771,4.771,0,0,0-.905-3.842c-.859-1.161-5.931-4.672-6.872-2.826C405.558,358.428,410.369,363.813,414.356,363.088Z"
          transform="translate(-386.55 -276.009)"
          fill="#21bead"
          stroke="#263238"
          strokeWidth="1"
        />
        <line
          id="Línea_66"
          data-name="Línea 66"
          x1="4.602"
          y1="4.417"
          transform="translate(23.204 82.663)"
          fill="none"
          stroke="#263238"
          strokeWidth="0.5"
        />
        <line
          id="Línea_67"
          data-name="Línea 67"
          x1="3.204"
          y1="5.212"
          transform="translate(25.775 95.628)"
          fill="none"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5698"
          data-name="Trazado 5698"
          d="M412.547,380.518a4.771,4.771,0,0,0-.905-3.842c-.859-1.161-5.931-4.672-6.872-2.826C403.748,375.858,408.565,381.261,412.547,380.518Z"
          transform="translate(-385.791 -283.323)"
          fill="#21bead"
          stroke="#263238"
          strokeWidth="1"
        />
        <line
          id="Línea_68"
          data-name="Línea 68"
          x1="4.602"
          y1="4.417"
          transform="translate(22.153 92.779)"
          fill="none"
          stroke="#263238"
          strokeWidth="0.5"
        />
        <line
          id="Línea_69"
          data-name="Línea 69"
          x1="3.204"
          y1="5.218"
          transform="translate(28.532 69.076)"
          fill="none"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5699"
          data-name="Trazado 5699"
          d="M417.282,334.8a4.771,4.771,0,0,0-.9-3.836c-.859-1.161-5.931-4.678-6.872-2.826C408.495,330.158,413.306,335.509,417.282,334.8Z"
          transform="translate(-387.781 -264.14)"
          fill="#21bead"
          stroke="#263238"
          strokeWidth="1"
        />
        <line
          id="Línea_70"
          data-name="Línea 70"
          x1="4.597"
          y1="4.411"
          transform="translate(24.91 66.233)"
          fill="none"
          stroke="#263238"
          strokeWidth="0.5"
        />
        <line
          id="Línea_71"
          data-name="Línea 71"
          x1="3.204"
          y1="5.212"
          transform="translate(30.244 52.576)"
          fill="none"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5700"
          data-name="Trazado 5700"
          d="M420.273,306.331a4.759,4.759,0,0,0-.905-3.836c-.859-1.161-5.931-4.678-6.872-2.826C411.457,301.676,416.269,307.062,420.273,306.331Z"
          transform="translate(-389.031 -252.193)"
          fill="#21bead"
          stroke="#263238"
          strokeWidth="1"
        />
        <line
          id="Línea_72"
          data-name="Línea 72"
          x1="4.602"
          y1="4.411"
          transform="translate(26.622 49.727)"
          fill="none"
          stroke="#263238"
          strokeWidth="0.5"
        />
        <line
          id="Línea_73"
          data-name="Línea 73"
          y1="4.451"
          x2="4.202"
          transform="translate(28.009 104.961)"
          fill="none"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5701"
          data-name="Trazado 5701"
          d="M425.47,397.276a4.753,4.753,0,0,1,1.677-3.569c1.079-.969,6.761-3.36,7.3-1.358C435.064,394.525,429.219,398.785,425.47,397.276Z"
          transform="translate(-394.536 -290.98)"
          fill="#21bead"
          stroke="#263238"
          strokeWidth="1"
        />
        <line
          id="Línea_74"
          data-name="Línea 74"
          y1="3.558"
          x2="5.728"
          transform="translate(30.934 102.738)"
          fill="none"
          stroke="#263238"
          strokeWidth="0.5"
        />
        <line
          id="Línea_75"
          data-name="Línea 75"
          y1="4.451"
          x2="4.202"
          transform="translate(30.772 78.339)"
          fill="none"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5702"
          data-name="Trazado 5702"
          d="M430.23,351.407a4.759,4.759,0,0,1,1.671-3.569c1.079-.963,6.767-3.36,7.307-1.358C439.795,348.656,433.979,352.933,430.23,351.407Z"
          transform="translate(-396.533 -271.733)"
          fill="#21bead"
          stroke="#263238"
          strokeWidth="1"
        />
        <line
          id="Línea_76"
          data-name="Línea 76"
          y1="3.552"
          x2="5.728"
          transform="translate(33.697 76.122)"
          fill="none"
          stroke="#263238"
          strokeWidth="0.5"
        />
        <line
          id="Línea_77"
          data-name="Línea 77"
          y1="4.446"
          x2="4.208"
          transform="translate(31.985 66.645)"
          fill="none"
          stroke="#263238"
          strokeWidth="2"
        />
        <path
          id="Trazado_5703"
          data-name="Trazado 5703"
          d="M432.32,331.247A4.759,4.759,0,0,1,434,327.678c1.079-.963,6.761-3.36,7.3-1.358C441.885,328.5,436.069,332.773,432.32,331.247Z"
          transform="translate(-397.41 -263.273)"
          fill="#21bead"
          stroke="#263238"
          strokeWidth="1"
        />
        <line
          id="Línea_78"
          data-name="Línea 78"
          y1="3.552"
          x2="5.728"
          transform="translate(34.91 64.422)"
          fill="none"
          stroke="#263238"
          strokeWidth="0.5"
        />
        <line
          id="Línea_79"
          data-name="Línea 79"
          y1="4.446"
          x2="4.202"
          transform="translate(33.767 49.495)"
          fill="none"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5704"
          data-name="Trazado 5704"
          d="M435.39,301.7a4.765,4.765,0,0,1,1.671-3.569c1.079-.963,6.761-3.36,7.307-1.358C444.955,298.946,439.139,303.229,435.39,301.7Z"
          transform="translate(-398.698 -250.873)"
          fill="#21bead"
          stroke="#263238"
          strokeWidth="1"
        />
        <line
          id="Línea_80"
          data-name="Línea 80"
          y1="3.552"
          x2="5.728"
          transform="translate(36.692 47.272)"
          fill="none"
          stroke="#263238"
          strokeWidth="0.5"
        />
        <path
          id="Trazado_5705"
          data-name="Trazado 5705"
          d="M431.93,288.093a4.777,4.777,0,0,1,1.671-3.575c1.079-.963,6.761-3.36,7.3-1.358C441.495,285.342,435.679,289.619,431.93,288.093Z"
          transform="translate(-397.246 -245.162)"
          fill="#21bead"
          stroke="#263238"
          strokeWidth="1"
        />
        <line
          id="Línea_81"
          data-name="Línea 81"
          y1="3.558"
          x2="5.728"
          transform="translate(34.684 39.373)"
          fill="none"
          stroke="#263238"
          strokeWidth="0.5"
        />
        <path
          id="Trazado_5706"
          data-name="Trazado 5706"
          d="M428.785,285.818a4.759,4.759,0,0,1-3.372-2.043c-.847-1.161-2.635-7.075-.58-7.406C427.055,276.016,430.7,282.249,428.785,285.818Z"
          transform="translate(-393.869 -242.632)"
          fill="#21bead"
          stroke="#263238"
          strokeWidth="1"
        />
        <line
          id="Línea_82"
          data-name="Línea 82"
          x1="2.931"
          y1="6.071"
          transform="translate(31.985 37.115)"
          fill="none"
          stroke="#263238"
          strokeWidth="0.5"
        />
        <line
          id="Línea_83"
          data-name="Línea 83"
          y2="112.482"
          transform="translate(24.08 7.209)"
          fill="none"
          stroke="#263238"
          strokeWidth="1"
        />
        <line
          id="Línea_84"
          data-name="Línea 84"
          x1="3.72"
          y1="4.858"
          transform="translate(20.447 97.921)"
          fill="none"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5707"
          data-name="Trazado 5707"
          d="M403.2,384.794a4.765,4.765,0,0,0-1.294-3.726c-.975-1.068-6.384-4.063-7.127-2.107C393.974,381.068,399.319,385.926,403.2,384.794Z"
          transform="translate(-381.623 -285.417)"
          fill="#21bead"
          stroke="#263238"
          strokeWidth="1"
        />
        <line
          id="Línea_85"
          data-name="Línea 85"
          x1="5.032"
          y1="3.918"
          transform="translate(16.547 95.46)"
          fill="none"
          stroke="#263238"
          strokeWidth="0.5"
        />
        <line
          id="Línea_86"
          data-name="Línea 86"
          x1="3.72"
          y1="4.852"
          transform="translate(20.447 76.784)"
          fill="none"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5708"
          data-name="Trazado 5708"
          d="M403.2,348.374a4.765,4.765,0,0,0-1.294-3.726c-.975-1.074-6.384-4.063-7.127-2.107C393.974,344.648,399.319,349.5,403.2,348.374Z"
          transform="translate(-381.623 -270.133)"
          fill="#21bead"
          stroke="#263238"
          strokeWidth="1"
        />
        <line
          id="Línea_87"
          data-name="Línea 87"
          x1="5.032"
          y1="3.918"
          transform="translate(16.547 74.323)"
          fill="none"
          stroke="#263238"
          strokeWidth="1"
        />
        <line
          id="Línea_88"
          data-name="Línea 88"
          x1="3.72"
          y1="4.858"
          transform="translate(20.447 51.961)"
          fill="none"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5709"
          data-name="Trazado 5709"
          d="M403.2,305.608a4.753,4.753,0,0,0-1.294-3.72c-.975-1.074-6.384-4.063-7.127-2.107C393.974,301.888,399.319,306.745,403.2,305.608Z"
          transform="translate(-381.623 -252.19)"
          fill="#21bead"
          stroke="#263238"
          strokeWidth="1"
        />
        <line
          id="Línea_89"
          data-name="Línea 89"
          x1="5.032"
          y1="3.912"
          transform="translate(16.547 49.506)"
          fill="none"
          stroke="#263238"
          strokeWidth="0.5"
        />
        <line
          id="Línea_90"
          data-name="Línea 90"
          x1="3.72"
          y1="4.858"
          transform="translate(20.447 35.444)"
          fill="none"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5710"
          data-name="Trazado 5710"
          d="M403.2,277.144a4.765,4.765,0,0,0-1.294-3.726c-.975-1.068-6.384-4.063-7.127-2.107C393.974,273.418,399.319,278.276,403.2,277.144Z"
          transform="translate(-381.623 -240.244)"
          fill="#21bead"
          stroke="#263238"
          strokeWidth="1"
        />
        <line
          id="Línea_91"
          data-name="Línea 91"
          x1="5.032"
          y1="3.918"
          transform="translate(16.547 32.983)"
          fill="none"
          stroke="#263238"
          strokeWidth="0.5"
        />
        <line
          id="Línea_92"
          data-name="Línea 92"
          x1="3.72"
          y1="4.858"
          transform="translate(20.447 18.851)"
          fill="none"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5711"
          data-name="Trazado 5711"
          d="M403.2,248.554a4.765,4.765,0,0,0-1.294-3.726c-.975-1.074-6.384-4.063-7.127-2.107C393.974,244.828,399.319,249.685,403.2,248.554Z"
          transform="translate(-381.623 -228.246)"
          fill="#21bead"
          stroke="#263238"
          strokeWidth="1"
        />
        <line
          id="Línea_93"
          data-name="Línea 93"
          x1="5.032"
          y1="3.918"
          transform="translate(16.547 16.39)"
          fill="none"
          stroke="#263238"
          strokeWidth="1"
        />
        <line
          id="Línea_94"
          data-name="Línea 94"
          y1="4.858"
          x2="3.726"
          transform="translate(24.086 104.375)"
          fill="none"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5712"
          data-name="Trazado 5712"
          d="M418.125,395.916a4.765,4.765,0,0,1,1.294-3.726c.975-1.068,6.384-4.063,7.121-2.1C427.33,392.19,422.008,397.048,418.125,395.916Z"
          transform="translate(-391.445 -290.085)"
          fill="#21bead"
          stroke="#263238"
          strokeWidth="1"
        />
        <line
          id="Línea_95"
          data-name="Línea 95"
          y1="4.126"
          x2="5.328"
          transform="translate(26.68 101.705)"
          fill="none"
          stroke="#263238"
          strokeWidth="0.5"
        />
        <line
          id="Línea_96"
          data-name="Línea 96"
          y1="4.858"
          x2="3.726"
          transform="translate(24.086 70.754)"
          fill="none"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5713"
          data-name="Trazado 5713"
          d="M418.125,337.988a4.753,4.753,0,0,1,1.294-3.72c.975-1.074,6.384-4.063,7.121-2.107C427.33,334.268,422.008,339.125,418.125,337.988Z"
          transform="translate(-391.445 -265.778)"
          fill="#21bead"
          stroke="#263238"
          strokeWidth="1"
        />
        <line
          id="Línea_97"
          data-name="Línea 97"
          y1="4.126"
          x2="5.328"
          transform="translate(26.68 68.084)"
          fill="none"
          stroke="#263238"
          strokeWidth="0.5"
        />
        <line
          id="Línea_98"
          data-name="Línea 98"
          y1="4.858"
          x2="3.726"
          transform="translate(24.086 54.161)"
          fill="none"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5714"
          data-name="Trazado 5714"
          d="M418.125,309.4a4.753,4.753,0,0,1,1.294-3.72c.975-1.074,6.384-4.063,7.121-2.107C427.33,305.678,422.008,310.512,418.125,309.4Z"
          transform="translate(-391.445 -253.78)"
          fill="#21bead"
          stroke="#263238"
          strokeWidth="1"
        />
        <line
          id="Línea_99"
          data-name="Línea 99"
          y1="4.126"
          x2="5.328"
          transform="translate(26.68 51.491)"
          fill="none"
          stroke="#263238"
          strokeWidth="0.5"
        />
        <line
          id="Línea_100"
          data-name="Línea 100"
          y1="4.858"
          x2="3.726"
          transform="translate(24.086 32.228)"
          fill="none"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5715"
          data-name="Trazado 5715"
          d="M418.125,271.608a4.753,4.753,0,0,1,1.294-3.72c.975-1.074,6.384-4.063,7.121-2.107C427.33,267.888,422.008,272.745,418.125,271.608Z"
          transform="translate(-391.445 -237.923)"
          fill="#21bead"
          stroke="#263238"
          strokeWidth="1"
        />
        <line
          id="Línea_101"
          data-name="Línea 101"
          y1="4.126"
          x2="5.328"
          transform="translate(26.68 29.559)"
          fill="none"
          stroke="#263238"
          strokeWidth="0.5"
        />
        <line
          id="Línea_102"
          data-name="Línea 102"
          y1="4.858"
          x2="3.726"
          transform="translate(24.086 14.986)"
          fill="none"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5716"
          data-name="Trazado 5716"
          d="M418.125,241.9a4.753,4.753,0,0,1,1.294-3.72c.975-1.074,6.384-4.063,7.121-2.107C427.33,238.178,422.008,243.035,418.125,241.9Z"
          transform="translate(-391.445 -225.456)"
          fill="#21bead"
          stroke="#263238"
          strokeWidth="1"
        />
        <line
          id="Línea_103"
          data-name="Línea 103"
          y1="4.126"
          x2="5.328"
          transform="translate(26.68 12.316)"
          fill="none"
          stroke="#263238"
          strokeWidth="0.5"
        />
        <path
          id="Trazado_5717"
          data-name="Trazado 5717"
          d="M413.275,228.724A4.765,4.765,0,0,1,414.57,225c.975-1.074,6.384-4.063,7.127-2.107C422.5,225,417.17,229.855,413.275,228.724Z"
          transform="translate(-389.41 -219.925)"
          fill="#21bead"
          stroke="#263238"
          strokeWidth="1"
        />
        <line
          id="Línea_104"
          data-name="Línea 104"
          y1="4.126"
          x2="5.328"
          transform="translate(23.865 4.672)"
          fill="none"
          stroke="#263238"
          strokeWidth="0.5"
        />
        <path
          id="Trazado_5718"
          data-name="Trazado 5718"
          d="M409.624,227.275a4.753,4.753,0,0,1-3.569-1.677c-.963-1.079-3.349-6.767-1.346-7.307C406.873,217.7,411.156,223.531,409.624,227.275Z"
          transform="translate(-385.497 -218.249)"
          fill="#21bead"
          stroke="#263238"
          strokeWidth="1"
        />
        <line
          id="Línea_105"
          data-name="Línea 105"
          x1="3.546"
          y1="5.734"
          transform="translate(20.58 3.291)"
          fill="none"
          stroke="#263238"
          strokeWidth="0.5"
        />
        <path
          id="Trazado_5719"
          data-name="Trazado 5719"
          d="M411.941,452.991H400.032L398.54,422.91h14.892Z"
          transform="translate(-383.235 -304.131)"
          fill="#263238"
          stroke="#263238"
          strokeWidth="1"
        />
      </g>
      <g id="freepik--character-3--inject-33" transform="translate(155.372 78.332)">
        <path
          id="Trazado_5720"
          data-name="Trazado 5720"
          d="M294.587,174.51s-14.747,3.447-15.165,4.393.94,50.312.94,52.3,2.9,3.865,3.871,3.865,29.912-.731,31.381-.94,5.125-.731,5.334-2.821S319.9,219.7,319.9,219.7l2.089-19.982s22.7,14.858,25,14.753,2.617-5.548,2.617-5.548l-7.742-36.714a44.3,44.3,0,0,0,1.776-5.751c.209-1.567-5.751-5.125-6.274-5.334s-.731-10.046-1.05-10.986a1.437,1.437,0,0,0-2.322-.522c-.546.731-.209,11.718-.209,11.718s-4.289-8.787-4.707-9.414-1.886-.946-1.567,1.045,3.97,11.294,3.97,11.294-1.567,3.482-.522,4.5,6.216,7.214,6.216,7.214l1.161,21.131s-11.2-15.09-12.658-16.425a21.369,21.369,0,0,0-5.96-3.558c-1.364-.418-14.016-3.482-14.016-3.482Z"
          transform="translate(-257.023 -134.736)"
          fill="#fff"
          stroke="#263238"
          strokeWidth="1"
        />
        <line
          id="Línea_106"
          data-name="Línea 106"
          x1="0.313"
          y2="7.974"
          transform="translate(80.976 62.368)"
          fill="#fff"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5721"
          data-name="Trazado 5721"
          d="M378.485,165.3s-2.513,6.7-1.782,7.324,1.573,1.463,2.409.522,2.513-6.175,2.4-7.115S379.141,164.462,378.485,165.3Z"
          transform="translate(-297.823 -141.321)"
          fill="#fff"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5722"
          data-name="Trazado 5722"
          d="M383.73,166.84a9.954,9.954,0,0,1,2.409,1.468c.731.731.418,1.463-.418,3.761s-2.2,3.482-3.035,2.722a2.409,2.409,0,0,1-.836-1.671Z"
          transform="translate(-300.038 -142.132)"
          fill="#fff"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5723"
          data-name="Trazado 5723"
          d="M373.691,183.533s-6.7-5.862-6.8-7.115,6.28-6.9,7.22-6.692.836,1.776.1,2.821-2.2,3.767-2.2,3.767,2.409.418,3.035,2.2a14.693,14.693,0,0,1,.313,4.916"
          transform="translate(-293.76 -143.341)"
          fill="#fff"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5724"
          data-name="Trazado 5724"
          d="M268.346,260.587l-4.933-7.2a1.075,1.075,0,0,0-.232,0L254.353,227.8l9.06-4.266-.128-23.18s-3.337,4.527-4.8,6.123c-.685.749-17.191,18.392-17.591,20.655s14.126,23.319,14.393,23.72c.2.3,2.223,3.668,3.7,5.5l-.1.1,1.6,5.461a1.433,1.433,0,0,0-1.463,1.468c0,1.463,1.6,2,2.53,2.664a2.664,2.664,0,0,0,2.53.534,6.256,6.256,0,0,0,1.869-1.468l.929-.4a2.9,2.9,0,0,0,1.335-1.6l.4-.667C269.013,261.782,268.346,260.587,268.346,260.587Z"
          transform="translate(-240.886 -156.194)"
          fill="#fff"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5725"
          data-name="Trazado 5725"
          d="M360.322,456.31l1.863,1.741s7.922,5.467,8.323,6a1.614,1.614,0,0,1-.133,1.863,3.284,3.284,0,0,1-1.329,1.068h-16.79s-.667-.534-.4-2.53.58-4.933.58-4.933Z"
          transform="translate(-287.425 -263.601)"
          fill="#fff"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5726"
          data-name="Trazado 5726"
          d="M370.374,472.458a2.784,2.784,0,0,0,.261-.528H351.79c0,1.236.464,1.6.464,1.6h16.79A3.285,3.285,0,0,0,370.374,472.458Z"
          transform="translate(-287.424 -270.156)"
          fill="#fff"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5727"
          data-name="Trazado 5727"
          d="M282.69,290.36l1.341,53.94,3.6,39.309-.534,1.2-.133,3.064a8.614,8.614,0,0,0,3.07.4c2.13,0,6.384,1.463,6.384,1.463s1.2-7.864,1.463-11.607,2.931-50.075,2.931-50.075l1.741-16.924,1.6-.4,9.327,48.212,9.994,30.911,7.864-3.2s.4-2.4.4-3.064a14.814,14.814,0,0,0-.934-2.9l-3.6-42.907-6.262-47.144Z"
          transform="translate(-258.428 -193.964)"
          fill="#263238"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5728"
          data-name="Trazado 5728"
          d="M285.777,455.847l-2.664,4.4s-4.933,3.865-5.328,4.794a1.782,1.782,0,0,0,.267,1.741h15.856l.4-7.6S288.441,455.714,285.777,455.847Z"
          transform="translate(-256.321 -263.406)"
          fill="#fff"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5729"
          data-name="Trazado 5729"
          d="M293.992,471.92h-16.25a1.828,1.828,0,0,0,.308,1.6H293.9Z"
          transform="translate(-256.323 -270.152)"
          fill="#fff"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5730"
          data-name="Trazado 5730"
          d="M325.655,198.34a21.369,21.369,0,0,0-5.96-3.558c-1.364-.418-14.016-3.482-14.016-3.482l-11.091.842s-14.747,3.447-15.165,4.393.94,50.313.94,52.3,2.9,3.865,3.871,3.865,29.912-.731,31.381-.94,5.125-.731,5.334-2.821-1.045-11.607-1.045-11.607l2.089-19.982s4.33,2.832,9.39,6.013l4.939-11.288C333.043,207.713,326.734,199.338,325.655,198.34Z"
          transform="translate(-257.023 -152.396)"
          fill="#21bead"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5731"
          data-name="Trazado 5731"
          d="M264.236,206.493c-.366.4-5.154,5.525-9.646,10.6l7.464,9.808,7.11-3.349-.128-23.18S265.7,204.9,264.236,206.493Z"
          transform="translate(-246.637 -156.202)"
          fill="#21bead"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5732"
          data-name="Trazado 5732"
          d="M353.515,214.88l-.685,12.391,2.925-9.965"
          transform="translate(-287.861 -162.291)"
          fill="none"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5733"
          data-name="Trazado 5733"
          d="M306.414,186.008s-2.867,2.281-3.035,3.122a14.4,14.4,0,0,0-.168,2.2s3.378,16.628,3.883,16.21,4.811-6.843,5.659-8.021a2.908,2.908,0,0,1,2.954-1.161c.424.279,8.021,8.357,8.439,7.005s-2.026-14.1-3.964-17.307S307.853,184.406,306.414,186.008Z"
          transform="translate(-267.039 -149.797)"
          fill="#fff"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5734"
          data-name="Trazado 5734"
          d="M305.68,179.53l1.689,9.373s5.908,13.592,8.613,12.664,4.643-14.689,4.724-15.026-.25-5.659-.25-5.659.418,1.521-5.49.76A41.687,41.687,0,0,1,305.68,179.53Z"
          transform="translate(-268.075 -147.457)"
          fill="#fff"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5735"
          data-name="Trazado 5735"
          d="M307.282,188.421c2.084.377,6.042.737,8.473-1.225a16.32,16.32,0,0,0,4.515-5.868c-.406.377-1.631.783-5.3.313a41.688,41.688,0,0,1-9.286-2.113Z"
          transform="translate(-268.075 -147.457)"
          fill="#263238"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5736"
          data-name="Trazado 5736"
          d="M317.048,150.681s.876,4.858-.162,7.411-2.948,6.384-4.643,7.092-4.306.157-7.017-1.039a29.157,29.157,0,0,1-5.334-3.268,4.643,4.643,0,0,1-3.511-1.271c-1.59-1.515-3.267-3.03-2.7-4.7a6.279,6.279,0,0,1,.952-2.072v-2.873a48.924,48.924,0,0,1-1.59-6.535c-.157-1.892,5.258-8.044,9.24-9s8.05,1.991,9.483,3.482,4.864,3.587,4.945,4.382S317.048,150.681,317.048,150.681Z"
          transform="translate(-262.769 -128.451)"
          fill="#fff"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5737"
          data-name="Trazado 5737"
          d="M334.41,161.917s.952-1.277,1.671-.8,1.434,3.024.319,4.539a10.3,10.3,0,0,1-1.741,1.991A51.979,51.979,0,0,0,334.41,161.917Z"
          transform="translate(-280.131 -139.687)"
          fill="#fff"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5738"
          data-name="Trazado 5738"
          d="M320.63,156.39a16.254,16.254,0,0,0,.238,3.186c.238.395,2.548,1.358,2.321,1.991s-2.629,1.2-2.629,1.2"
          transform="translate(-274.319 -137.747)"
          fill="none"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5739"
          data-name="Trazado 5739"
          d="M311.75,170.913a20.141,20.141,0,0,0,4.643,1.2c1.457,0,3.825-2.391,4.225-2.948"
          transform="translate(-270.622 -143.105)"
          fill="none"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5740"
          data-name="Trazado 5740"
          d="M309.121,159.353c.174.708.041,1.346-.3,1.434s-.766-.418-.94-1.12-.041-1.346.3-1.434S308.947,158.674,309.121,159.353Z"
          transform="translate(-268.968 -138.516)"
          fill="#263238"
        />
        <path
          id="Trazado_5741"
          data-name="Trazado 5741"
          d="M324.6,157.233c.18.708.046,1.346-.3,1.434s-.76-.418-.94-1.12-.041-1.346.3-1.434S324.425,156.531,324.6,157.233Z"
          transform="translate(-275.463 -137.626)"
          fill="#263238"
        />
        <path
          id="Trazado_5742"
          data-name="Trazado 5742"
          d="M303.79,155.1a5.67,5.67,0,0,1,4.144-1.59"
          transform="translate(-267.282 -136.536)"
          fill="none"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5743"
          data-name="Trazado 5743"
          d="M321.5,151.974a3.035,3.035,0,0,1,3.906-.163"
          transform="translate(-274.714 -135.56)"
          fill="none"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5744"
          data-name="Trazado 5744"
          d="M300.834,134.147s-2.629,5.577-4.463,7.33l-1.834,1.741s1.915,7.092,1.671,7.545-.633.638-.8,0-.319-1.2-.8-1.352-1.915-.8-1.915-.8l-2.629-6.7s-2.147-2.321-1.59-4.3a34.322,34.322,0,0,1,2.467-5.38s-1.114-.395-.638-1.277,5.421-.876,5.421-.876.476-2.7,1.991-3.1,1.515.157,1.515.157,5.659-2.948,8.926-2.867,13.145,8.764,12.188,9.959-4.382,2-4.382,2-.081,9.959-.482,10.116l-.395.163-1.515-8.706S303.544,136.219,300.834,134.147Z"
          transform="translate(-260.82 -124.267)"
          fill="#263238"
          stroke="#263238"
          strokeWidth="1"
        />
      </g>
      <g id="freepik--character-1--inject-33" transform="translate(61.418 74.983)">
        <path
          id="Trazado_5745"
          data-name="Trazado 5745"
          d="M177.319,452l1.091,3.18s9.443,5.7,9.576,7.2a6.077,6.077,0,0,1-.406,2.739H163.64a21.58,21.58,0,0,1,.081-6.732,12.379,12.379,0,0,0,.464-4.1Z"
          transform="translate(-114.418 -258.443)"
          fill="#fff"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5746"
          data-name="Trazado 5746"
          d="M163.49,471.524c.07,1.033.186,1.741.186,1.741h23.94a6.384,6.384,0,0,0,.418-1.915Z"
          transform="translate(-114.454 -266.563)"
          fill="#fff"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5747"
          data-name="Trazado 5747"
          d="M192.55,245.665l-5.31,22,4.324,5.508s9.425-16.831,10.168-18.328,3.32-3.79-.035-12.078c-1.741-4.231-3.006-5.519-3.006-5.519"
          transform="translate(-124.42 -168.328)"
          fill="#21bead"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5748"
          data-name="Trazado 5748"
          d="M183.012,289.66,180.33,291.6s-3.575,6.256-3.128,7.15a2.565,2.565,0,0,0,1.341,1.2l2.089,2.147s2.084.83,3.273.238,3.43-7.156,3.43-7.156Z"
          transform="translate(-120.192 -190.321)"
          fill="#a3a3a3"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5749"
          data-name="Trazado 5749"
          d="M112.223,286.882s-.818,4.243-1.23,6.964,4.556,41.206,4.556,43.377-.824,8.491-1.079,11.915.917,22.159.917,22.159l.279,6.018s4.509,1.915,8.206,1.1,6.152-1.782,6.291-2.188,0-7.545,0-7.545.546-24.376,1.1-26.807,3.279-30.795,3.279-30.795,2.6,34.346,2.739,34.759-.139,1.1.133,8.206,3.83,25.536,3.83,25.536a19.263,19.263,0,0,0,6.291-.139c2.461-.685,6.964-2.461,7.115-3.006a42.264,42.264,0,0,0,.412-5.473c0-1.776-1.642-7.348-1.642-8.706s-.139-38.456.133-44.747-.958-25.856-.958-26.813-.412-12.4-.412-12.4-3.6,7.8-13.993,5.746-24.248-6.494-24.248-6.494Z"
          transform="translate(-92.415 -185.239)"
          fill="#263238"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5750"
          data-name="Trazado 5750"
          d="M136.767,188.839,126.1,191.572l4.422,55.635a36.29,36.29,0,0,0,16,2c8.758-.958,12.246-5.752,12.246-5.752s-2.844-50.243-3.8-52.158-6.7-2.873-7.8-3.279S136.767,188.839,136.767,188.839Z"
          transform="translate(-98.764 -147.636)"
          fill="#fff"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5751"
          data-name="Trazado 5751"
          d="M141,173.93s.958,9.031.958,10.946-.412,4.643,3.279,7.249,8.891,2.188,10.534-1.776.685-14.91.685-14.91a7.168,7.168,0,0,1-6.32,2.594C146.032,177.627,141,173.93,141,173.93Z"
          transform="translate(-105.017 -141.758)"
          fill="#a3a3a3"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5752"
          data-name="Trazado 5752"
          d="M150.135,178.272c-3.18-.319-6.924-2.606-8.456-3.616L141,174.5c.168,1.625.923,8.915.923,10.615v.8a16.094,16.094,0,0,0,8.247-2.9c4.254-3.059,5.148-5.572,5.148-5.572l-2.861.7A7.446,7.446,0,0,1,150.135,178.272Z"
          transform="translate(-105.017 -141.997)"
          fill="#263238"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5753"
          data-name="Trazado 5753"
          d="M173.176,151.3s2.739-1.091,2.873,1.5-3.279,6.3-3.279,6.3Z"
          transform="translate(-118.348 -132.164)"
          fill="#a3a3a3"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5754"
          data-name="Trazado 5754"
          d="M137.563,119.706s-6.158,2.9-7.115,7.388,1.509,12.316,1.509,12.316-2.467-1.509-3.146.958,1.091,5.061,2.188,5.467a4.643,4.643,0,0,0,2.322.139l2.5,5.606s7.934,5.473,10.667,4.927,6.018-4.376,7.249-6.018,1.509-18.195,1.642-20.383-.818-6.964-3.964-9.164S140.714,117.384,137.563,119.706Z"
          transform="translate(-99.839 -118.496)"
          fill="#a3a3a3"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5755"
          data-name="Trazado 5755"
          d="M152.524,120.943c-3.151-2.194-10.673-3.558-13.819-1.236,0,0-6.158,2.9-7.115,7.388S133.1,139.41,133.1,139.41h0c.458.528.975.923,1.114.284.273-1.23-.133-3.146-.273-5.339s.818-1.915.958-4.782-.273-4.788,2.188-6.7,5.746.958,9.031,1.364,5.746-2.461,7.249-1.364a7.026,7.026,0,0,1,2.322,6.018c-.139,2.6-.273,2.594.273,4.788.139.58.261,1.033.366,1.422.087-2.414.139-4.33.18-4.98C156.628,127.919,155.67,123.131,152.524,120.943Z"
          transform="translate(-100.976 -118.497)"
          fill="#263238"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5756"
          data-name="Trazado 5756"
          d="M148,151.353c.116.9-.151,1.677-.58,1.741s-.905-.627-1.021-1.526.157-1.677.58-1.741S147.9,150.454,148,151.353Z"
          transform="translate(-107.272 -131.642)"
          fill="#263238"
        />
        <path
          id="Trazado_5757"
          data-name="Trazado 5757"
          d="M164.035,150.947c.041.905-.3,1.654-.754,1.671s-.847-.7-.882-1.6.3-1.66.749-1.677S164,150.042,164.035,150.947Z"
          transform="translate(-113.995 -131.439)"
          fill="#263238"
        />
        <path
          id="Trazado_5758"
          data-name="Trazado 5758"
          d="M155.56,155.98c.546,1.1,3.558.273,4.515-.685s-1.37-3.964-1.509-5.606,1.915-3.418,1.915-3.418"
          transform="translate(-111.127 -130.151)"
          fill="none"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5759"
          data-name="Trazado 5759"
          d="M158.221,167.408a8.315,8.315,0,0,1-6.431-.818"
          transform="translate(-109.545 -138.678)"
          fill="none"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5760"
          data-name="Trazado 5760"
          d="M143.3,146.939a5.523,5.523,0,0,1,5.612-.546"
          transform="translate(-105.982 -129.995)"
          fill="none"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5761"
          data-name="Trazado 5761"
          d="M169.818,146.909a3.622,3.622,0,0,0-3.418-1.37"
          transform="translate(-115.675 -129.827)"
          fill="none"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5762"
          data-name="Trazado 5762"
          d="M128.952,188.088s4.515,37.869,6.018,46.215,3.418,10.807,2.9,13.929-3.285,12.722-4.515,14.364-5.334-4.109-9.164-8.212-7.388-3.691-9.576-3.83-3.558-.133-3.558-.133a28.739,28.739,0,0,1,.273-4.242c.273-1.091,1.915-7.661,2.055-8.067s-2.617-45.664-2.205-46.482,9.181-2.745,10.139-3.151S127.855,185.227,128.952,188.088Z"
          transform="translate(-92.452 -147.169)"
          fill="#21bead"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5763"
          data-name="Trazado 5763"
          d="M119.35,289.32s9.559-.656,12.6,4.341"
          transform="translate(-95.932 -190.166)"
          fill="none"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5764"
          data-name="Trazado 5764"
          d="M138.45,298.23a12.768,12.768,0,0,1,1.515,2.658"
          transform="translate(-103.947 -193.917)"
          fill="none"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5765"
          data-name="Trazado 5765"
          d="M132.45,292.7a11.138,11.138,0,0,1,2.635,2.182"
          transform="translate(-101.429 -191.597)"
          fill="none"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5766"
          data-name="Trazado 5766"
          d="M136.334,182.543s-1.37-1.37-2.461-.551-5.223,4.382-5.223,4.382,2.049,17.916,3.146,16.552,3.558-5.473,3.97-5.612,2.594,3.418,2.594,3.418Z"
          transform="translate(-99.835 -145.031)"
          fill="#21bead"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5767"
          data-name="Trazado 5767"
          d="M193.846,222.136a27.492,27.492,0,0,0-1.161-2.577c-1.5-3.006-11.706-26.558-14.44-29.019s-9.715-2.461-9.715-2.461,3.97,27.2,3.83,37.184-1.915,35.7-1.642,36.656,4.243-.818,6.3-2.461,2.594-1.915,2.734-2.734-.818-27.632-.818-28.589V215.851s5.438,15.513,6.123,15.513"
          transform="translate(-116.569 -147.695)"
          fill="#21bead"
          stroke="#263238"
          strokeWidth="1"
        />
        <line
          id="Línea_107"
          data-name="Línea 107"
          x1="0.708"
          y1="9.28"
          transform="translate(61.63 58.875)"
          fill="#21bead"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5768"
          data-name="Trazado 5768"
          d="M168.29,182.546a1.41,1.41,0,0,1,1.776.406c.824.958,2.9,3.83,2.9,3.83s3.285,10.261,3.146,11.607-2.734-1.37-3.418-1.23-2.055,2.049-2.055,2.049l-2.321-12.188Z"
          transform="translate(-116.469 -145.307)"
          fill="#21bead"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5769"
          data-name="Trazado 5769"
          d="M102.081,192.94s-6.024,1.288-7.255,2.519S79,233.09,79,234.593s17.069,24.718,17.069,24.718l7.121-6.558L93.237,234.46l8.317-19.234"
          transform="translate(-79 -149.735)"
          fill="#21bead"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5770"
          data-name="Trazado 5770"
          d="M116.253,296s2.049,1.23,3.006,1.915,2.734,3.83,3.418,4.237,1.1,1.915-.406,2.055-3.146-2.055-3.558-2.461-7.377,4.956-7.377,4.956l-1.207-5Z"
          transform="translate(-92.063 -192.982)"
          fill="#a3a3a3"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5771"
          data-name="Trazado 5771"
          d="M161.22,442.812s.435,5.334.708,6.152,4.643.58,6.674.685a16.18,16.18,0,0,0,7.156-1.109,3.035,3.035,0,0,0,1.84-2.658,18.886,18.886,0,0,0-.238-5c-.546-1.642-1.5-1.509-2.461-.685s-3.83,1.88-8.479,2.02S161.9,441.854,161.22,442.812Z"
          transform="translate(-113.502 -253.243)"
          fill="#a3a3a3"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5772"
          data-name="Trazado 5772"
          d="M114.135,450.16l-1.346,5.978s-6.616,3.732-7.435,4.968a5.662,5.662,0,0,0-.546,3.279h23.145s.958.139,1.091-1.5-1.509-11.352-1.509-11.352Z"
          transform="translate(-89.812 -257.671)"
          fill="#fff"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5773"
          data-name="Trazado 5773"
          d="M104.814,473.189h23.145s.958.139,1.091-1.5a4.21,4.21,0,0,0,0-.546H104.906A6.965,6.965,0,0,0,104.814,473.189Z"
          transform="translate(-89.817 -266.475)"
          fill="#fff"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5774"
          data-name="Trazado 5774"
          d="M132.88,444.289s.308,6.558.174,7.243-4.643,2.322-8.206,1.782-7.115-.824-8.328-1.909-.447-6.018-.174-6.964,3.418.958,6.837,1.1,7.545-.546,8.758-1.5S132.88,444.289,132.88,444.289Z"
          transform="translate(-94.466 -254.946)"
          fill="#a3a3a3"
          stroke="#263238"
          strokeWidth="1"
        />
      </g>
      <g id="freepik--character-2--inject-33" transform="translate(114.903 88.961)">
        <path
          id="Trazado_5775"
          data-name="Trazado 5775"
          d="M263.646,173.561a14.666,14.666,0,0,1,5.705,4.713c2.409,3.61,3.622,9.762.876,13.383s-3.4,3.622-2.85,4.5,3.4-.441,3.4-.441.435,2.745-1.538,3.622-8.125,3.07-11.956.11-2.855-9.982-.551-13.929,2.525-4.829,2.745-5.485S261.342,173.23,263.646,173.561Z"
          transform="translate(-206.217 -155.575)"
          fill="#263238"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5776"
          data-name="Trazado 5776"
          d="M229.59,317.566s1.457,25.769,2.554,32.936,2.676,13.859,3.767,20.418,1.457,20.052,1.457,21.88.731,2.792-2.792,6.077-8.874,5.345-8.508,6.193,4.01,1.706,8.386,1.341,8.746-.487,8.99-1.1a27.578,27.578,0,0,0,1.219-8.99c0-5.223,2.188-20.174,2.792-27.829s-1.457-15.8-.847-18.351,1.457-33.186,1.457-36.563-19.564.488-19.564.488Z"
          transform="translate(-194.192 -213.755)"
          fill="#263238"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5777"
          data-name="Trazado 5777"
          d="M237.367,455.457l-.11.041a9.007,9.007,0,0,1-2.681,3.482c-3.529,3.279-8.874,5.345-8.508,6.193s4.01,1.706,8.386,1.341,8.746-.488,8.99-1.1a27.578,27.578,0,0,0,1.219-8.99v-.987a7.87,7.87,0,0,1-2.937,1.109A11.277,11.277,0,0,1,237.367,455.457Z"
          transform="translate(-194.192 -273.865)"
          fill="#21bead"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5778"
          data-name="Trazado 5778"
          d="M243.444,471.192a13.927,13.927,0,0,0,.58-2c-4.132.923-11.747,2.037-13.674,1.741a12.591,12.591,0,0,1-3.378-1c-.633.43-.981.76-.876,1,.366.853,4.01,1.706,8.386,1.341S243.212,471.8,243.444,471.192Z"
          transform="translate(-194.204 -279.635)"
          fill="#fff"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5779"
          data-name="Trazado 5779"
          d="M189.764,307.42s-8.265,35-8.99,39.013-.853,5.839-.488,6.686,43.394,35.072,43.394,35.072l3.157-5.711s-12.281-15.873-17.144-20.748-13.61-14.341-13.61-14.341l13.732-33.3Z"
          transform="translate(-174.905 -211.752)"
          fill="#263238"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5780"
          data-name="Trazado 5780"
          d="M252.246,442.461s-.122,7.545-.366,8.99a14.01,14.01,0,0,1-1.944,4.863c-.853,1.213-3.163,2.432-.609,2.432a26,26,0,0,0,6.564-.853c1.944-.487,3.279-6.564,5.589-9.356s4.01-5.589,4.01-7.052S255.4,436.75,255.4,436.75Z"
          transform="translate(-203.47 -266.022)"
          fill="#21bead"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5781"
          data-name="Trazado 5781"
          d="M265.464,443.555c0-.482-1.12-1.161-2.612-1.875a22.729,22.729,0,0,1-2.734,6.964c-1.579,2.67-2.9,8.508-5.711,10.209a9,9,0,0,1-5.8.871c-.621.627-.859,1.074.685,1.074a26,26,0,0,0,6.564-.853c1.944-.487,3.279-6.564,5.589-9.356S265.464,445.017,265.464,443.555Z"
          transform="translate(-203.456 -268.091)"
          fill="#fff"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5782"
          data-name="Trazado 5782"
          d="M193.031,310.371l-.731,4.718s10.157,5.966,18.415,7.411a63.04,63.04,0,0,0,18.421-.244,33.489,33.489,0,0,0,5.937-2.13l.418-9.814s-23.006,3.482-32.605.789S193.031,310.371,193.031,310.371Z"
          transform="translate(-180.03 -212.701)"
          fill="#21bead"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5783"
          data-name="Trazado 5783"
          d="M210.71,187.715l-1.6,8.206a16.59,16.59,0,0,1-7.052-2.426,25.91,25.91,0,0,0-12.153-4.864c-4.985-.488-15.554-1.822-15.554-1.822s13.732,11.665,14.1,12.153,5.432,26.906,5.432,26.906-9.373,32.367-9.739,33.221,3.772,3.279,3.772,3.279,14.283,7.005,27.486,6.2c5.49-.337,12.716-2.461,13.2-4.063s-.662-12.327-.662-12.327l-1.561-24.051s2.066-9.112,2.188-9.6,12.153,17.864,12.153,17.864,4.132.975,6.442-.366,3.157-7.411,2.432-9.6-15.56-22.605-17.411-23.94-11.665-4.254-11.665-4.254l.4-8.735Z"
          transform="translate(-172.497 -161.14)"
          fill="#fff"
        />
        <path
          id="Trazado_5784"
          data-name="Trazado 5784"
          d="M199.593,280.77l-.923,3.186a75.592,75.592,0,0,0,28.52,6.117,55.13,55.13,0,0,0,10.795-1.045l-.215-3.285C222.494,288.9,207.515,284.1,199.593,280.77Z"
          transform="translate(-182.703 -200.569)"
          fill="#21bead"
        />
        <path
          id="Trazado_5785"
          data-name="Trazado 5785"
          d="M225.22,275.019c6.21,0,10.493-.58,14.068-1.892l-.226-3.413c-3.935,1.689-8.868,2.234-17.156,2.008-5.664-.151-12.9-3.836-17.736-6.732-.29,1-.58,2.089-.94,3.233,5.13,3,12.484,6.581,18.572,6.75C223.015,275,224.147,275.019,225.22,275.019Z"
          transform="translate(-184.616 -193.947)"
          fill="#21bead"
        />
        <path
          id="Trazado_5786"
          data-name="Trazado 5786"
          d="M222.86,256.706a29.661,29.661,0,0,1-15.67-6.326c.261,1.346.418,2.165.418,2.165s-.2.667-.528,1.817a33.534,33.534,0,0,0,15.391,5.572,78.152,78.152,0,0,0,9.158.58,39.328,39.328,0,0,0,8.781-.853l-.215-3.3C237.137,257.159,231.786,257.757,222.86,256.706Z"
          transform="translate(-186.232 -187.816)"
          fill="#21bead"
        />
        <path
          id="Trazado_5787"
          data-name="Trazado 5787"
          d="M282.17,259.307c.65.987,1.259,1.9,1.788,2.71a30.026,30.026,0,0,1,13.349-3.2c.134-1.259-1.526-2.9-1.741-3.714C290.736,255.041,285.774,257.183,282.17,259.307Z"
          transform="translate(-217.742 -189.796)"
          fill="#21bead"
        />
        <path
          id="Trazado_5788"
          data-name="Trazado 5788"
          d="M223.932,218.142a26.956,26.956,0,0,0,5.049.458c5.067,0,10.894-1.242,17.411-3.7,1.683-.638,3.238-1.294,4.643-1.921-.685-.923-1.352-1.822-2-2.681-6.512,2.867-16.378,6.21-24.463,4.643-6.587-1.265-11.729-8.706-14.875-14.678a79.248,79.248,0,0,1-4.161-9.483,21.243,21.243,0,0,0-3.72-.778C203.962,196.535,211.385,215.728,223.932,218.142Z"
          transform="translate(-184.024 -162.479)"
          fill="#21bead"
        />
        <path
          id="Trazado_5789"
          data-name="Trazado 5789"
          d="M215.57,235.192a27.684,27.684,0,0,0,10.65,1.921,51.264,51.264,0,0,0,12.345-1.7c.325-1.41.633-2.763.818-3.575-7.62,2.1-16.007,3.07-22.6.354-5.8-2.385-11.369-8.537-16.163-15.461.441,2.136.958,4.724,1.474,7.359C206.244,229.075,210.8,233.224,215.57,235.192Z"
          transform="translate(-183.521 -173.696)"
          fill="#21bead"
        />
        <path
          id="Trazado_5790"
          data-name="Trazado 5790"
          d="M224.485,314.842a49.8,49.8,0,0,0,11.3-1.19c.041-.8,0-2-.075-3.326-14.324,3.627-34.172-1.55-43.528-4.486-.5,1.671-.842,2.809-.952,3.122a146.327,146.327,0,0,0,14.509,3.767,94.6,94.6,0,0,0,18.746,2.113Z"
          transform="translate(-179.581 -211.089)"
          fill="#21bead"
        />
        <path
          id="Trazado_5791"
          data-name="Trazado 5791"
          d="M195.387,295.21l-.917,3.134a131.3,131.3,0,0,0,14.567,3.529,94.7,94.7,0,0,0,16.831,1.648,59.586,59.586,0,0,0,10.957-.952c-.1-1.23-.209-2.385-.3-3.268C221.73,302.151,204.11,297.851,195.387,295.21Z"
          transform="translate(-180.94 -206.628)"
          fill="#21bead"
        />
        <path
          id="Trazado_5792"
          data-name="Trazado 5792"
          d="M178.2,189.215c1.927,1.642,4.573,3.9,6.837,5.85-1.474-2.6-2.8-5.119-3.958-7.423l-3.889-.482Q177.66,188.152,178.2,189.215Z"
          transform="translate(-173.689 -161.287)"
          fill="#21bead"
        />
        <path
          id="Trazado_5793"
          data-name="Trazado 5793"
          d="M288.469,244.33a49.912,49.912,0,0,0-11.979,5.519c.58.894,1.213,1.811,1.817,2.71a44.89,44.89,0,0,1,12.1-5.38C289.839,246.326,289.189,245.369,288.469,244.33Z"
          transform="translate(-215.358 -185.277)"
          fill="#21bead"
        />
        <path
          id="Trazado_5794"
          data-name="Trazado 5794"
          d="M268.62,239.086c.441.58,1.161,1.579,1.985,2.8,1.062-.319,2.142-.662,3.244-1.039,3.482-1.2,6.616-2.513,9.187-3.691-.633-.882-1.283-1.793-1.938-2.7A94.543,94.543,0,0,1,268.62,239.086Z"
          transform="translate(-212.056 -181.136)"
          fill="#21bead"
        />
        <path
          id="Trazado_5795"
          data-name="Trazado 5795"
          d="M210.71,187.715l-1.6,8.206a16.59,16.59,0,0,1-7.052-2.426,25.91,25.91,0,0,0-12.153-4.864c-4.985-.488-15.554-1.822-15.554-1.822s13.732,11.665,14.1,12.153,5.432,26.906,5.432,26.906-9.373,32.367-9.739,33.221,3.772,3.279,3.772,3.279,14.283,7.005,27.486,6.2c5.49-.337,12.716-2.461,13.2-4.063s-.662-12.327-.662-12.327l-1.561-24.051s2.066-9.112,2.188-9.6,12.153,17.864,12.153,17.864,4.132.975,6.442-.366,3.157-7.411,2.432-9.6-15.56-22.605-17.411-23.94-11.665-4.254-11.665-4.254l.4-8.735Z"
          transform="translate(-172.497 -161.14)"
          fill="none"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5796"
          data-name="Trazado 5796"
          d="M254.39,207.383l-.157.128a22.565,22.565,0,0,1-11.9,4.01,25.648,25.648,0,0,1-3.482,0,20.162,20.162,0,0,1-12.112-4.568,22.01,22.01,0,0,1-1.909-1.915,24.008,24.008,0,0,1-2.623-3.558,29.094,29.094,0,0,1-3.482-8.624c.7.424,1.364.859,1.956,1.277a14.178,14.178,0,0,0,4.643,2l.325.075a16.659,16.659,0,0,0,2.072.354l1.613-8.195,10.22,1.782-.4,8.735s9.866,2.9,11.671,4.254A35.131,35.131,0,0,1,254.39,207.383Z"
          transform="translate(-191.116 -161.795)"
          fill="#fff"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5797"
          data-name="Trazado 5797"
          d="M246.049,192.369l-3.482-2.838-6.651-1.161-1.486,7.6a7.538,7.538,0,0,0,4.782.58,28.1,28.1,0,0,0,6.79-3.517Z"
          transform="translate(-197.709 -161.795)"
          fill="#263238"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5798"
          data-name="Trazado 5798"
          d="M227.867,201.606l.331.041v.035l-.824,8.827a24.013,24.013,0,0,1-2.623-3.558l1.3-5.572Z"
          transform="translate(-193.647 -167.254)"
          fill="#21bead"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5799"
          data-name="Trazado 5799"
          d="M258.281,208.683l-1.4,11.027a25.648,25.648,0,0,1-3.482,0l2.171-11.84Z"
          transform="translate(-205.669 -169.978)"
          fill="#21bead"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5800"
          data-name="Trazado 5800"
          d="M233.4,157.314s-1.538,10.749-.987,12.942,5.154,8.665,8.125,8.555,8.555-2.739,9.541-4.6,4.167-9.866,4.167-9.866.441-4.718-.221-7.243a7.438,7.438,0,0,0-5.92-5.485C245.147,151.284,235.025,152.6,233.4,157.314Z"
          transform="translate(-196.812 -146.351)"
          fill="#fff"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5801"
          data-name="Trazado 5801"
          d="M247.108,151.019s-1.648,2.194-9.866,3.482-9.541-3.616-9.327-4.277,2.194-5.595,9.547-7.237,13.053,1.973,15.467,5.92a12.671,12.671,0,0,1,.876,10.534,11.683,11.683,0,0,1-1.973,3.291s-.331-.221-.992-2.194S245.158,155.627,247.108,151.019Z"
          transform="translate(-194.966 -142.58)"
          fill="#263238"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5802"
          data-name="Trazado 5802"
          d="M231.269,166.272s-.992-3.732-2.414-.221,2.084,5.374,2.084,5.374Z"
          transform="translate(-195.227 -151.798)"
          fill="#fff"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5803"
          data-name="Trazado 5803"
          d="M266.744,177s1.973-1.428,2.525.656-2.855,4.063-3.622,4.388a3.419,3.419,0,0,1-1.207.331Z"
          transform="translate(-210.302 -156.826)"
          fill="#fff"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5804"
          data-name="Trazado 5804"
          d="M240.82,167.975s2.519-1.312,3.947.772"
          transform="translate(-200.39 -153.066)"
          fill="none"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5805"
          data-name="Trazado 5805"
          d="M255.94,171.631s2.084-1.317,3.4,1.312"
          transform="translate(-206.735 -154.632)"
          fill="none"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5806"
          data-name="Trazado 5806"
          d="M248.678,170.16a6.222,6.222,0,0,1-1.1,2.635c-.876,1.1-.662,1.741,0,2.084s1.973-.221,1.973-.221"
          transform="translate(-202.984 -154.154)"
          fill="none"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5807"
          data-name="Trazado 5807"
          d="M240.06,180a11.933,11.933,0,0,0,3.947,2.525c1.753.441,5.485,0,6.256-.58"
          transform="translate(-200.071 -158.283)"
          fill="none"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5808"
          data-name="Trazado 5808"
          d="M240.63,163.018a6.018,6.018,0,0,1,4.5-1.207"
          transform="translate(-200.31 -150.627)"
          fill="none"
          stroke="#263238"
          strokeLinecap="round"
          strokeWidth="2"
        />
        <path
          id="Trazado_5809"
          data-name="Trazado 5809"
          d="M256.88,164.49a3.952,3.952,0,0,1,3.622,3.076"
          transform="translate(-207.129 -151.774)"
          fill="none"
          stroke="#263238"
          strokeLinecap="round"
          strokeWidth="2"
        />
        <path
          id="Trazado_5810"
          data-name="Trazado 5810"
          d="M190.126,187.982c1.671,2.281,2.321,4.643-.58,6.384-1.219.731-3.772.58-7.173-.975s-8.874-7.655-10.447-9.6-.488-5.1,1.1-6.32c3.952-3.041,9.414,1.6,11.7,4.6C185.8,183.519,188.477,185.713,190.126,187.982Z"
          transform="translate(-171.158 -156.805)"
          fill="#fff"
        />
        <path
          id="Trazado_5811"
          data-name="Trazado 5811"
          d="M193.7,190.81c-.894-.94-1.822-1.828-2.565-2.6l-.29.128c-2.548,1.225-4.869,3.674-6.924,7.289a23.288,23.288,0,0,0,2.6,2.014C189.468,192.267,192.272,191.048,193.7,190.81Z"
          transform="translate(-176.513 -161.728)"
          fill="#21bead"
        />
        <path
          id="Trazado_5812"
          data-name="Trazado 5812"
          d="M180.734,178.63a20.94,20.94,0,0,0-7.464,6.639c.58.656,1.341,1.538,2.246,2.5a17.972,17.972,0,0,1,8.125-6.964,15.955,15.955,0,0,0-2.908-2.176Z"
          transform="translate(-172.044 -157.708)"
          fill="#21bead"
        />
        <path
          id="Trazado_5813"
          data-name="Trazado 5813"
          d="M190.126,187.982c1.671,2.281,2.321,4.643-.58,6.384-1.219.731-3.772.58-7.173-.975s-8.874-7.655-10.447-9.6-.488-5.1,1.1-6.32c3.952-3.041,9.414,1.6,11.7,4.6C185.8,183.519,188.477,185.713,190.126,187.982Z"
          transform="translate(-171.158 -156.805)"
          fill="none"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5814"
          data-name="Trazado 5814"
          d="M201.389,199.79a10.6,10.6,0,0,0-3.767,2.066c-1.335,1.335-1.7,1.7-1.219,2.321s1.341,2.554,2.8,3.157,4.643-1.822,5.1-2.792a2.38,2.38,0,0,0-.116-2.554A22.84,22.84,0,0,0,201.389,199.79Z"
          transform="translate(-181.667 -166.587)"
          fill="#21bead"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5815"
          data-name="Trazado 5815"
          d="M204.481,206.033s-3.523,2.188-4.01,2.9,1.341,5.711,1.341,5.711l.725,2.066s-1.091-1.091-1.579-.609.366,2.322.58,2.676,1.457,2.554,2.321,2.432,4.614-.488,5.467-1.1a11.665,11.665,0,0,0,2.9-3.767c.226-.865-3.035-6.077-4.37-8.021S205.456,205.789,204.481,206.033Z"
          transform="translate(-183.423 -169.185)"
          fill="#fff"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5816"
          data-name="Trazado 5816"
          d="M255.038,290.88s-2.8,2.676-3.279,3.767.725,3.279.969,4.742a4.1,4.1,0,0,0,2.9,3.035c1.457.487,4.858,2.188,5.955.975s2.548-3.407,2.322-4.864-2.322-2.792-2.322-2.792A18.13,18.13,0,0,1,260,294.159c-.482-.58-1.822-.847-2.066-1.213A26.858,26.858,0,0,0,255.038,290.88Z"
          transform="translate(-204.933 -204.811)"
          fill="#fff"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5817"
          data-name="Trazado 5817"
          d="M261.47,297.37a4.643,4.643,0,0,1,1.457,2.321,15.963,15.963,0,0,1,.366,3.279s2.188-3.645,2.9-2.548-.238,4.01-.969,4.37l-.731.366"
          transform="translate(-209.055 -207.534)"
          fill="#fff"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5818"
          data-name="Trazado 5818"
          d="M260.16,287.11s-2.554,1.213-2.676,2.188,1.213,3.767,2.322,3.767,4.376-2.322,4.376-2.322Z"
          transform="translate(-207.38 -203.229)"
          fill="#21bead"
          stroke="#263238"
          strokeWidth="1"
        />
        <path
          id="Trazado_5819"
          data-name="Trazado 5819"
          d="M278.845,260.841s-16.407,9.866-16.767,11.909,1.579,3.889,2.792,4.376,17.742-6.93,21.63-8.63,4.864-4.132,3.894-7.777-4.411-7.829-4.411-7.829"
          transform="translate(-209.292 -188.869)"
          fill="#fff"
        />
        <path
          id="Trazado_5820"
          data-name="Trazado 5820"
          d="M279.158,272.24c-1.19.754-2.472,1.584-3.738,2.42a14.746,14.746,0,0,1,9.623,5.061c1.079-.464,2.118-.923,3.064-1.335A17.173,17.173,0,0,0,279.158,272.24Z"
          transform="translate(-214.909 -196.989)"
          fill="#21bead"
        />
        <path
          id="Trazado_5821"
          data-name="Trazado 5821"
          d="M270.4,287.265c.917-.342,1.95-.749,3.053-1.2a31.34,31.34,0,0,0-4.643-6.46c-.975.685-1.88,1.341-2.641,1.938A29.436,29.436,0,0,1,270.4,287.265Z"
          transform="translate(-211.028 -200.082)"
          fill="#21bead"
        />
        <path
          id="Trazado_5822"
          data-name="Trazado 5822"
          d="M301.611,268.008a23.55,23.55,0,0,0-10.244-4.388l-1.637,1.741s-.679.406-1.741,1.068c4.063.441,8.909,1.648,12.275,4.718A4.788,4.788,0,0,0,301.611,268.008Z"
          transform="translate(-220.184 -193.372)"
          fill="#21bead"
        />
        <path
          id="Trazado_5823"
          data-name="Trazado 5823"
          d="M297.95,255.255l-4.33,4.817a30.811,30.811,0,0,1,8.473-1.254,2.728,2.728,0,0,0-.435-1.509c-.511-.853-1.021-1.608-1.451-2.2a16.325,16.325,0,0,0-2.258.145Z"
          transform="translate(-222.546 -189.801)"
          fill="#21bead"
        />
        <path
          id="Trazado_5824"
          data-name="Trazado 5824"
          d="M278.845,260.841s-16.407,9.866-16.767,11.909,1.579,3.889,2.792,4.376,17.742-6.93,21.63-8.63,4.864-4.132,3.894-7.777-4.411-7.829-4.411-7.829"
          transform="translate(-209.292 -188.869)"
          fill="none"
          stroke="#263238"
          strokeWidth="1"
        />
      </g>
      <g id="freepik--Floor--inject-33" transform="translate(53.414 281.737)">
        <line
          id="Línea_108"
          data-name="Línea 108"
          x2="212.834"
          fill="none"
          stroke="#263238"
          strokeWidth="1"
        />
      </g>
    </g>
  </svg>
)
export const LuegopagoSmall = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="110.874"
    height="21.874"
    viewBox="0 0 110.874 21.874"
  >
    <g transform="translate(0 -4.622)">
      <rect width="3.576" height="13.538" transform="translate(0 7.392)" fill="#0d0c0e" />
      <path
        d="M212.077,280.435v6.019a5.307,5.307,0,1,1-10.614,0v-6.019h3.575v6.019a1.731,1.731,0,0,0,3.462,0v-6.019Z"
        transform="translate(-196.559 -270.637)"
        fill="#0d0c0e"
      />
      <path
        d="M244.486,287.072h-7.462a2.03,2.03,0,0,0,1.745.906,2.053,2.053,0,0,0,1.528-.651l2.528,2.538a5.716,5.716,0,1,1,1.66-4.038Zm-3.981-2.491a2.138,2.138,0,0,0-3.481,0Z"
        transform="translate(-216.204 -270.435)"
        fill="#0d0c0e"
      />
      <path
        d="M278.238,280.258V291.22a5.733,5.733,0,0,1-5.717,5.727v-3.585a2.142,2.142,0,0,0,2.142-2.142v-.057a5.726,5.726,0,1,1,0-10.6v-.3ZM272.521,288a2.142,2.142,0,1,0-1.519-.623,2.087,2.087,0,0,0,1.519.623"
        transform="translate(-237.202 -270.451)"
        fill="#0d0c0e"
      />
      <path
        d="M302.252,289.9a5.7,5.7,0,1,1,4.047,1.679,5.513,5.513,0,0,1-4.047-1.679m2.528-5.557a2.038,2.038,0,0,0-.632,1.509A2.159,2.159,0,0,0,306.3,288a2.042,2.042,0,0,0,1.509-.632,2.072,2.072,0,0,0,.632-1.519,2.158,2.158,0,0,0-2.141-2.141,2.071,2.071,0,0,0-1.519.632"
        transform="translate(-258.215 -270.451)"
        fill="#0d0c0e"
      />
      <path
        d="M340.1,280.161a5.722,5.722,0,1,1-2.151,11.028v3.4h-3.575v-14.32h3.575v.3a5.742,5.742,0,0,1,2.151-.415m0,7.858a2.142,2.142,0,1,0-1.519-.623,2.088,2.088,0,0,0,1.519.623"
        transform="translate(-279.243 -270.467)"
        fill="#0d0c0e"
      />
      <path
        d="M379.593,280.2v11.151h-3.575v-.236a5.721,5.721,0,1,1,0-10.613v-.3Zm-5.717,7.755a2.042,2.042,0,0,0,1.509-.632,2.074,2.074,0,0,0,.632-1.519,2.159,2.159,0,0,0-2.142-2.141,2.072,2.072,0,0,0-1.519.632,2.042,2.042,0,0,0-.632,1.509,2.157,2.157,0,0,0,2.151,2.151"
        transform="translate(-300.255 -270.42)"
        fill="#0d0c0e"
      />
      <path
        d="M463.551,305.157h0c-.124.031-.251.059-.376.082a.759.759,0,0,0-.3,1.367.751.751,0,0,0,.435.139.8.8,0,0,0,.141-.013c.156-.029.313-.063.467-.1a.759.759,0,0,0-.367-1.473"
        transform="translate(-358.985 -286.003)"
        fill="#0d0c0e"
      />
      <path
        d="M476.6,280.485a.756.756,0,0,0-.007.581c.048.119.092.24.132.362a.751.751,0,0,0,.283.381.759.759,0,0,0,1.158-.858c-.049-.151-.105-.3-.164-.449a.759.759,0,0,0-1.4-.017"
        transform="translate(-367.683 -270.382)"
        fill="#0d0c0e"
      />
      <path
        d="M469.229,302.7h0c-.107.071-.217.139-.328.2a.759.759,0,1,0,.757,1.315q.207-.119.407-.251a.759.759,0,1,0-.837-1.266"
        transform="translate(-362.697 -284.412)"
        fill="#0d0c0e"
      />
      <path
        d="M479.381,286.977a.759.759,0,1,0-1.516.06c0,.127.006.257,0,.384a.76.76,0,0,0,.743.776h.017a.759.759,0,0,0,.758-.743c0-.159,0-.319,0-.477"
        transform="translate(-368.509 -274.254)"
        fill="#0d0c0e"
      />
      <path
        d="M474.9,298.365h0a.759.759,0,0,0-1.063.152c-.077.1-.158.2-.24.3a.759.759,0,0,0,.085,1.069l.056.043a.754.754,0,0,0,1.015-.129c.1-.121.2-.246.3-.373a.76.76,0,0,0-.151-1.063"
        transform="translate(-365.74 -281.697)"
        fill="#0d0c0e"
      />
      <path
        d="M477.776,292.585a.759.759,0,0,0-.951.5c-.038.122-.08.245-.127.365a.759.759,0,0,0,1.419.54c.056-.148.108-.3.156-.45a.76.76,0,0,0-.5-.951"
        transform="translate(-367.753 -278.174)"
        fill="#0d0c0e"
      />
      <path
        d="M427.634,271.5l2.1-.188a1.058,1.058,0,0,0,.935-1.353l-.563-2.031a.886.886,0,0,0-1.633-.275l-.1.146a8.407,8.407,0,0,0-5.515-.933c-.2.036-.406.078-.626.134l-.042.01a8.26,8.26,0,0,0-4.607,3.078l-.043.053-.115.159c-.061.088-.122.177-.2.3a8.357,8.357,0,0,0-1.194,2.983h-5.512v2.986h3.462a3.966,3.966,0,0,1-1.471,1.844,4.032,4.032,0,1,1-2.3-7.352,3.945,3.945,0,0,1,2.477.848l3.043-3.043a8.325,8.325,0,1,0,.373,12.114,8.843,8.843,0,0,0,1.092-1.321,8.387,8.387,0,0,0,1.145,1.431l.04.04a8.569,8.569,0,0,0,1.065.889,8.334,8.334,0,0,0,3.351,1.4,1.331,1.331,0,1,0,.47-2.621,5.7,5.7,0,0,1-1.377-.432l-.049-.026c-.1-.047-.2-.1-.312-.158a5.881,5.881,0,0,1-.549-.343A5.74,5.74,0,0,1,426.837,270l-.046.066a.9.9,0,0,0-.075,1,.917.917,0,0,0,.909.427"
        transform="translate(-321.247 -262.121)"
        fill="#0d0c0e"
      />
    </g>
  </svg>
)
export const SistecreditoSmall = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="90.321"
    height="13.756"
    viewBox="0 0 90.321 13.756"
  >
    <g transform="translate(-683.433 -969.401)">
      <g transform="translate(683.433 969.401)">
        <path
          d="M684.9,979.174a2.647,2.647,0,0,0,2.639,2.664,2.591,2.591,0,0,0,2.645-2.523c0-1.855-1.591-2.261-3.112-2.772-1.083-.315-3.384-.993-3.384-3.488a3.665,3.665,0,0,1,3.929-3.655,3.56,3.56,0,0,1,3.751,3.416h-1.464a2.38,2.38,0,0,0-4.747.108c-.012,1.611,1.276,2.01,3.279,2.676,1.245.486,3.218,1.188,3.218,3.62a3.85,3.85,0,0,1-4.09,3.875,3.9,3.9,0,0,1-4.132-3.922Z"
          transform="translate(-683.433 -969.401)"
          fill="#1d428a"
        />
        <path
          d="M718.685,970.324H720v1.833h-1.315Zm0,3.6H720v9.615h-1.315Z"
          transform="translate(-709.588 -970.086)"
          fill="#1d428a"
        />
        <path
          d="M732.272,985.934a1.494,1.494,0,0,0-1.644-1.586,1.514,1.514,0,0,0-1.662,1.545c.036.912.732,1.3,1.887,1.627,1.391.381,2.924.773,3,2.833a3,3,0,0,1-3.185,3.047,3.08,3.08,0,0,1-3.281-3h1.309a1.879,1.879,0,0,0,1.983,1.9,1.768,1.768,0,0,0,1.858-1.8c-.024-1.1-.743-1.544-2.4-2.014-1.38-.411-2.451-.964-2.486-2.494a2.761,2.761,0,0,1,2.989-2.749,2.722,2.722,0,0,1,2.93,2.684Z"
          transform="translate(-716.041 -979.676)"
          fill="#1d428a"
        />
        <path
          d="M754.046,974.983h-1.881v-1.056h1.881v-3.6h1.315v3.6h2.1v1.056h-2.1v8.559h-1.315Z"
          transform="translate(-734.428 -970.086)"
          fill="#1d428a"
        />
        <path
          d="M771.246,988.7A3.658,3.658,0,0,0,775,992.256a3.536,3.536,0,0,0,3.293-1.98h1.375a5.173,5.173,0,0,1-1.944,2.345,5.043,5.043,0,0,1-2.735.774,4.966,4.966,0,0,1-5.067-5.048,5.046,5.046,0,1,1,10.068.355Zm7.443-1.056a3.645,3.645,0,0,0-3.7-3.256,3.606,3.606,0,0,0-3.716,3.256Z"
          transform="translate(-747.6 -979.676)"
          fill="#1d428a"
        />
      </g>
      <path
        d="M819.084,990.575a2.86,2.86,0,0,1-2.888-3.016,3.172,3.172,0,0,1,.808-2.176,2.691,2.691,0,0,1,2.084-.84,2.757,2.757,0,0,1,2.642,1.756h2.385a5.152,5.152,0,1,0,.009,2.6h-2.4A2.78,2.78,0,0,1,819.084,990.575Z"
        transform="translate(-96.753 -9.609)"
        fill="#78be20"
      />
      <path
        d="M861.117,984.709v-2.356a2.818,2.818,0,0,0-2.722,1.595v-1.282h-2.211v9.8h2.345V987.18A2.17,2.17,0,0,1,861,984.709Z"
        transform="translate(-128.172 -9.609)"
        fill="#78be20"
      />
      <path
        d="M878.9,982.353a5.207,5.207,0,0,0,.036,10.413,4.887,4.887,0,0,0,2.788-.848,5.57,5.57,0,0,0,1.989-2.465H881.3a2.561,2.561,0,0,1-2.362,1.323,2.7,2.7,0,0,1-2.834-2.427h7.883a5.331,5.331,0,0,0-1.432-4.5A5.049,5.049,0,0,0,878.9,982.353Zm-2.763,4.193a2.848,2.848,0,0,1,5.548,0Z"
        transform="translate(-141.211 -9.609)"
        fill="#78be20"
      />
      <path
        d="M922.4,973.567V975a3.824,3.824,0,0,0-3.289-1.568,5.214,5.214,0,0,0,.04,10.413,3.585,3.585,0,0,0,3.355-1.716v1.417h2.238V970.324H922.4Zm-.7,7.19a3.055,3.055,0,0,1-2.173.893,2.918,2.918,0,0,1-2.995-3.025v-.018a2.926,2.926,0,0,1,3.008-2.989,2.967,2.967,0,0,1,2.124.844,3.129,3.129,0,0,1,.036,4.294Z"
        transform="translate(-171.205 -0.685)"
        fill="#78be20"
      />
      <rect width="2.344" height="2.094" transform="translate(754.783 969.639)" fill="#78be20" />
      <rect width="2.344" height="9.802" transform="translate(754.783 973.056)" fill="#78be20" />
      <path
        d="M975.651,973.74h-1.678v-3.417h-2.344v3.417h-1.62v1.8h1.62v8h2.344v-8h1.678Z"
        transform="translate(-212.622 -0.685)"
        fill="#78be20"
      />
      <path
        d="M1000.9,987.542l-2.424-1.7-.809,1.091h0l-.817,1.1.864-.1a2.9,2.9,0,0,1-5.783-.328v-.018a2.909,2.909,0,0,1,2.9-3,2.86,2.86,0,0,1,2.706,1.9l.856-1.154,1.543,1.085a5.045,5.045,0,0,0-5.105-4,5.1,5.1,0,0,0-5.245,5.176v.018a5.245,5.245,0,0,0,10.489.044Z"
        transform="translate(-227.149 -9.648)"
        fill="#78be20"
      />
      <ellipse
        cx="1.317"
        cy="1.319"
        rx="1.317"
        ry="1.319"
        transform="translate(736.37 969.639)"
        fill="#78be20"
      />
    </g>
  </svg>
)

export const ExclamationIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
      <path
        d="M24 0C10.6875 0 0 10.7812 0 24C0 37.3125 10.6875 48 24 48C37.2188 48 48 37.3125 48 24C48 10.7812 37.2188 0 24 0ZM24 43.5C13.2188 43.5 4.5 34.7812 4.5 24C4.5 13.3125 13.2188 4.5 24 4.5C34.6875 4.5 43.5 13.3125 43.5 24C43.5 34.7812 34.6875 43.5 24 43.5ZM24 28.5C25.2188 28.5 26.25 27.5625 26.25 26.25V14.25C26.25 13.0312 25.2188 12 24 12C22.6875 12 21.75 13.0312 21.75 14.25V26.25C21.75 27.5625 22.6875 28.5 24 28.5ZM24 31.6875C22.3125 31.6875 21 33 21 34.5938C21 36.1875 22.3125 37.5 24 37.5C25.5938 37.5 26.9062 36.1875 26.9062 34.5938C26.9062 33 25.5938 31.6875 24 31.6875Z"
        fill="black"
      />
    </svg>
  )
}
export const CardActivationIcon = () => (
  <svg
    aria-hidden="true"
    focusable="false"
    data-prefix="fas"
    data-icon="credit-card"
    className="svg-inline--fa fa-credit-card"
    role="img"
    style={{ width: '21.5px' }}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 576 512"
  >
    <path
      fill="currentColor"
      d="M0 96C0 78.3 14.3 64 32 64H544c17.7 0 32 14.3 32 32V128H0V96zM0 160H576V416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V160zm64 96a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm64 0a16 16 0 1 0 0 32 16 16 0 1 0 0-32z"
    />
  </svg>
)
